// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%2332325d%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27><path fill=%27#fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27#fff%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27><path stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23292b2c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
:root {
  --blue: #5e72e4;
  --indigo: #5603ad;
  --purple: #8965e0;
  --pink: #f3a4b5;
  --red: #f5365c;
  --orange: #fb6340;
  --yellow: #ffd600;
  --green: #2dce89;
  --teal: #11cdef;
  --cyan: #2bffc6;
  --white: #fff;
  --gray: #8898aa;
  --gray-dark: #32325d;
  --light: #ced4da;
  --lighter: #e9ecef;
  --primary: #5e72e4;
  --secondary: #f7fafc;
  --success: #2dce89;
  --info: #11cdef;
  --warning: #fb6340;
  --danger: #f5365c;
  --light: #adb5bd;
  --dark: #212529;
  --default: #172b4d;
  --white: #fff;
  --neutral: #fff;
  --darker: black;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: Open Sans, sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  text-align: left;
  background-color: #f8f9fe;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #5e72e4;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #233dd2;
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #8898aa;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  color: #32325d;
}

h1, .h1 {
  font-size: 1.625rem;
}

h2, .h2 {
  font-size: 1.25rem;
}

h3, .h3 {
  font-size: 1.0625rem;
}

h4, .h4 {
  font-size: 0.9375rem;
}

h5, .h5 {
  font-size: 0.8125rem;
}

h6, .h6 {
  font-size: 0.625rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-2 {
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-3 {
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-4 {
  font-size: 1.6275rem;
  font-weight: 600;
  line-height: 1.5;
}

hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8898aa;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f8f9fe;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #8898aa;
}

code {
  font-size: 87.5%;
  color: #f3a4b5;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #525f7f;
  background-color: transparent;
}
.table th,
.table td {
  padding: 1rem;
  vertical-align: top;
  border-top: 1px solid #e9ecef;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
}
.table tbody + tbody {
  border-top: 2px solid #e9ecef;
}

.table-sm th,
.table-sm td {
  padding: 0.5rem;
}

.table-bordered {
  border: 1px solid #e9ecef;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #e9ecef;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #525f7f;
  background-color: #f6f9fc;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #d2d8f7;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #abb6f1;
}

.table-hover .table-primary:hover {
  background-color: #bcc5f3;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #bcc5f3;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #fdfefe;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #fbfcfd;
}

.table-hover .table-secondary:hover {
  background-color: #ecf6f6;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #ecf6f6;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c4f1de;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #92e6c2;
}

.table-hover .table-success:hover {
  background-color: #afecd2;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #afecd2;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bcf1fb;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #83e5f7;
}

.table-hover .table-info:hover {
  background-color: #a4ecfa;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #a4ecfa;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fed3ca;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #fdae9c;
}

.table-hover .table-warning:hover {
  background-color: #febeb1;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #febeb1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fcc7d1;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #fa96aa;
}

.table-hover .table-danger:hover {
  background-color: #fbafbd;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #fbafbd;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #e8eaed;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #d4d9dd;
}

.table-hover .table-light:hover {
  background-color: #dadde2;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #dadde2;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c1c2c3;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #8c8e90;
}

.table-hover .table-dark:hover {
  background-color: #b4b5b6;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b4b5b6;
}

.table-default,
.table-default > th,
.table-default > td {
  background-color: #bec4cd;
}
.table-default th,
.table-default td,
.table-default thead th,
.table-default tbody + tbody {
  border-color: #8691a2;
}

.table-hover .table-default:hover {
  background-color: #b0b7c2;
}
.table-hover .table-default:hover > td,
.table-hover .table-default:hover > th {
  background-color: #b0b7c2;
}

.table-white,
.table-white > th,
.table-white > td {
  background-color: white;
}
.table-white th,
.table-white td,
.table-white thead th,
.table-white tbody + tbody {
  border-color: white;
}

.table-hover .table-white:hover {
  background-color: #f2f2f2;
}
.table-hover .table-white:hover > td,
.table-hover .table-white:hover > th {
  background-color: #f2f2f2;
}

.table-neutral,
.table-neutral > th,
.table-neutral > td {
  background-color: white;
}
.table-neutral th,
.table-neutral td,
.table-neutral thead th,
.table-neutral tbody + tbody {
  border-color: white;
}

.table-hover .table-neutral:hover {
  background-color: #f2f2f2;
}
.table-hover .table-neutral:hover > td,
.table-hover .table-neutral:hover > th {
  background-color: #f2f2f2;
}

.table-darker,
.table-darker > th,
.table-darker > td {
  background-color: #b8b8b8;
}
.table-darker th,
.table-darker td,
.table-darker thead th,
.table-darker tbody + tbody {
  border-color: #7a7a7a;
}

.table-hover .table-darker:hover {
  background-color: #ababab;
}
.table-hover .table-darker:hover > td,
.table-hover .table-darker:hover > th {
  background-color: #ababab;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #f6f9fc;
}

.table-hover .table-active:hover {
  background-color: #e3ecf6;
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: #e3ecf6;
}

.table .thead-dark th {
  color: #f8f9fe;
  background-color: #172b4d;
  border-color: #1f3a68;
}
.table .thead-light th {
  color: #8898aa;
  background-color: #f6f9fc;
  border-color: #e9ecef;
}

.table-dark {
  color: #f8f9fe;
  background-color: #172b4d;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #1f3a68;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #f8f9fe;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none, none;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  -webkit-appearance: none;
          appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}
select.form-control:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.625rem + 1px);
  padding-bottom: calc(0.625rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.625rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #8898aa;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #2dce89;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(45, 206, 137, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #2dce89;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #2dce89;
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #2dce89;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #2dce89;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: #93e7c3;
  border-color: #93e7c3;
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: #54daa1;
  border-color: #93e7c3;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(45, 206, 137, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #2dce89;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #fb6340;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(251, 99, 64, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #fb6340;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #fb6340;
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #fb6340;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #fb6340;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: #fec9bd;
  border-color: #fec9bd;
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: #fc8c72;
  border-color: #fec9bd;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #fb6340;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  color: #525f7f;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #525f7f;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-primary:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(94, 114, 228, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #324cdd;
  border-color: #5e72e4;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(247, 250, 252, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: #d2e3ee;
  border-color: #f7fafc;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-success:hover {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(45, 206, 137, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #24a46d;
  border-color: #2dce89;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-info:hover {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(17, 205, 239, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #0da5c0;
  border-color: #11cdef;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-warning {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(251, 99, 64, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #fa3a0e;
  border-color: #fb6340;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(245, 54, 92, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #ec0c38;
  border-color: #f5365c;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-light {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #fff;
  background-color: #919ca6;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #0a0c0d;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-default {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-default:hover {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-default:focus, .btn-default.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(23, 43, 77, 0.5);
}
.btn-default.disabled, .btn-default:disabled {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {
  color: #fff;
  background-color: #0b1526;
  border-color: #172b4d;
}
.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-white {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-white:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}
.btn-white:focus, .btn-white.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-white.disabled, .btn-white:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}
.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-neutral {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-neutral:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}
.btn-neutral:focus, .btn-neutral.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-neutral.disabled, .btn-neutral:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}
.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-darker {
  color: #fff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:focus, .btn-darker.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-darker.disabled, .btn-darker:disabled {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-primary {
  color: #5e72e4;
  background-color: transparent;
  background-image: none;
  border-color: #5e72e4;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #5e72e4;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-outline-secondary {
  color: #f7fafc;
  background-color: transparent;
  background-image: none;
  border-color: #f7fafc;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #f7fafc;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-outline-success {
  color: #2dce89;
  background-color: transparent;
  background-image: none;
  border-color: #2dce89;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #2dce89;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-outline-info {
  color: #11cdef;
  background-color: transparent;
  background-image: none;
  border-color: #11cdef;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #11cdef;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-outline-warning {
  color: #fb6340;
  background-color: transparent;
  background-image: none;
  border-color: #fb6340;
}
.btn-outline-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #fb6340;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-outline-danger {
  color: #f5365c;
  background-color: transparent;
  background-image: none;
  border-color: #f5365c;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f5365c;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-outline-light {
  color: #adb5bd;
  background-color: transparent;
  background-image: none;
  border-color: #adb5bd;
}
.btn-outline-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #adb5bd;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-default {
  color: #172b4d;
  background-color: transparent;
  background-image: none;
  border-color: #172b4d;
}
.btn-outline-default:hover {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-outline-default:focus, .btn-outline-default.focus {
  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);
}
.btn-outline-default.disabled, .btn-outline-default:disabled {
  color: #172b4d;
  background-color: transparent;
}
.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-outline-white {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-white:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-white:focus, .btn-outline-white.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-white.disabled, .btn-outline-white:disabled {
  color: #fff;
  background-color: transparent;
}
.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-neutral:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-neutral:focus, .btn-outline-neutral.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {
  color: #fff;
  background-color: transparent;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-darker {
  color: black;
  background-color: transparent;
  background-image: none;
  border-color: black;
}
.btn-outline-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:focus, .btn-outline-darker.focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-outline-darker.disabled, .btn-outline-darker:disabled {
  color: black;
  background-color: transparent;
}
.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #5e72e4;
  text-decoration: none;
}
.btn-link:hover {
  color: #233dd2;
  text-decoration: none;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #8898aa;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.375rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.4375rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #5e72e4;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #8898aa;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.625rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1.75rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 3rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1.25rem;
  height: 1.375rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #5e72e4;
  background-color: #5e72e4;
  box-shadow: none;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none, none;
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgba(50, 151, 211, 0.25);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: none;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #8898aa;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #cad1d7;
  box-shadow: none;
}
.custom-control-label::after {
  position: absolute;
  top: 0.125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #5e72e4;
  background-color: #5e72e4;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-switch {
  padding-left: 3.9375rem;
}
.custom-switch .custom-control-label::before {
  left: -3.9375rem;
  width: 2.1875rem;
  pointer-events: all;
  border-radius: 0.625rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.125rem + 2px);
  left: calc(-3.9375rem + 2px);
  width: calc(1.25rem - 4px);
  height: calc(1.25rem - 4px);
  background-color: #cad1d7;
  border-radius: 0.625rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.9375rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 1.75rem 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  -webkit-appearance: none;
          appearance: none;
}
.custom-select:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #5e72e4;
}
.custom-select:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #8898aa;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgba(50, 151, 211, 0.25);
  box-shadow: none;
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: none;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: 0.625rem 0.75rem;
  line-height: 1.5;
  color: #8898aa;
  content: "Browse";
  background-color: #fff;
  border-left: inherit;
  border-radius: 0 0.375rem 0.375rem 0;
}

.custom-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #f7f8fe;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #f7f8fe;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #f7f8fe;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.25rem 0.75rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #8898aa;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #8898aa;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #f8f9fe;
  border-color: #dee2e6 #dee2e6 #f8f9fe;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.375rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #5e72e4;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.0625rem;
  padding-bottom: 0.0625rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: transparent;
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-text a {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.25rem;
}

.card-subtitle {
  margin-top: -0.625rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.card-header:first-child {
  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.card-footer {
  padding: 1.25rem 1.5rem;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.25rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.25rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.375rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #8898aa;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #8898aa;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.375rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #8898aa;
  text-decoration: none;
  background-color: #dee2e6;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.page-item.disabled .page-link {
  color: #8898aa;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4375rem;
  border-bottom-right-radius: 0.4375rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.badge {
  display: inline-block;
  padding: 0.35rem 0.375rem;
  font-size: 66%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.875em;
  padding-left: 0.875em;
  border-radius: 10rem;
}

.badge-primary {
  color: #2643e9;
  background-color: rgba(203, 210, 246, 0.5);
}
.badge-primary[href]:hover, .badge-primary[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #324cdd;
}

.badge-secondary {
  color: #cfe3f1;
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-secondary[href]:hover, .badge-secondary[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #d2e3ee;
}

.badge-success {
  color: #1aae6f;
  background-color: rgba(147, 231, 195, 0.5);
}
.badge-success[href]:hover, .badge-success[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #24a46d;
}

.badge-info {
  color: #03acca;
  background-color: rgba(136, 230, 247, 0.5);
}
.badge-info[href]:hover, .badge-info[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0da5c0;
}

.badge-warning {
  color: #ff3709;
  background-color: rgba(254, 201, 189, 0.5);
}
.badge-warning[href]:hover, .badge-warning[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #fa3a0e;
}

.badge-danger {
  color: #f80031;
  background-color: rgba(251, 175, 190, 0.5);
}
.badge-danger[href]:hover, .badge-danger[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #ec0c38;
}

.badge-light {
  color: #879cb0;
  background-color: rgba(244, 245, 246, 0.5);
}
.badge-light[href]:hover, .badge-light[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #919ca6;
}

.badge-dark {
  color: #090c0e;
  background-color: rgba(90, 101, 112, 0.5);
}
.badge-dark[href]:hover, .badge-dark[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0a0c0d;
}

.badge-default {
  color: #091428;
  background-color: rgba(52, 98, 175, 0.5);
}
.badge-default[href]:hover, .badge-default[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0b1526;
}

.badge-white {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-white[href]:hover, .badge-white[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #e6e6e6;
}

.badge-neutral {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-neutral[href]:hover, .badge-neutral[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #e6e6e6;
}

.badge-darker {
  color: black;
  background-color: rgba(57, 64, 71, 0.5);
}
.badge-darker[href]:hover, .badge-darker[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: black;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.4375rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 4.5rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1.5rem;
  color: inherit;
}

.alert-primary {
  color: #fff;
  background-color: #7889e8;
  border-color: #7889e8;
}
.alert-primary hr {
  border-top-color: #6276e4;
}
.alert-primary .alert-link {
  color: #324cdd;
}

.alert-secondary {
  color: #212529;
  background-color: #f8fbfc;
  border-color: #f8fbfc;
}
.alert-secondary hr {
  border-top-color: #e6f1f4;
}
.alert-secondary .alert-link {
  color: #d2e3ee;
}

.alert-success {
  color: #fff;
  background-color: #4fd69c;
  border-color: #4fd69c;
}
.alert-success hr {
  border-top-color: #3ad190;
}
.alert-success .alert-link {
  color: #24a46d;
}

.alert-info {
  color: #fff;
  background-color: #37d5f2;
  border-color: #37d5f2;
}
.alert-info hr {
  border-top-color: #1fd0f0;
}
.alert-info .alert-link {
  color: #0da5c0;
}

.alert-warning {
  color: #fff;
  background-color: #fc7c5f;
  border-color: #fc7c5f;
}
.alert-warning hr {
  border-top-color: #fc6846;
}
.alert-warning .alert-link {
  color: #fa3a0e;
}

.alert-danger {
  color: #fff;
  background-color: #f75676;
  border-color: #f75676;
}
.alert-danger hr {
  border-top-color: #f63e62;
}
.alert-danger .alert-link {
  color: #ec0c38;
}

.alert-light {
  color: #fff;
  background-color: #bac1c8;
  border-color: #bac1c8;
}
.alert-light hr {
  border-top-color: #acb4bd;
}
.alert-light .alert-link {
  color: #919ca6;
}

.alert-dark {
  color: #fff;
  background-color: #45484b;
  border-color: #45484b;
}
.alert-dark hr {
  border-top-color: #393b3e;
}
.alert-dark .alert-link {
  color: #0a0c0d;
}

.alert-default {
  color: #fff;
  background-color: #3c4d69;
  border-color: #3c4d69;
}
.alert-default hr {
  border-top-color: #334159;
}
.alert-default .alert-link {
  color: #0b1526;
}

.alert-white {
  color: #212529;
  background-color: white;
  border-color: white;
}
.alert-white hr {
  border-top-color: #f2f2f2;
}
.alert-white .alert-link {
  color: #e6e6e6;
}

.alert-neutral {
  color: #212529;
  background-color: white;
  border-color: white;
}
.alert-neutral hr {
  border-top-color: #f2f2f2;
}
.alert-neutral .alert-link {
  color: #e6e6e6;
}

.alert-darker {
  color: #fff;
  background-color: #292929;
  border-color: #292929;
}
.alert-darker hr {
  border-top-color: #1c1c1c;
}
.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.375rem;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #5e72e4;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.375rem;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}
.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  background-color: #fff;
  border: 1px solid #e9ecef;
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #8898aa;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.375rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #313b77;
  background-color: #d2d8f7;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #313b77;
  background-color: #bcc5f3;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #313b77;
  border-color: #313b77;
}

.list-group-item-secondary {
  color: #808283;
  background-color: #fdfefe;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #808283;
  background-color: #ecf6f6;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #808283;
  border-color: #808283;
}

.list-group-item-success {
  color: #176b47;
  background-color: #c4f1de;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #176b47;
  background-color: #afecd2;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #176b47;
  border-color: #176b47;
}

.list-group-item-info {
  color: #096b7c;
  background-color: #bcf1fb;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #096b7c;
  background-color: #a4ecfa;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #096b7c;
  border-color: #096b7c;
}

.list-group-item-warning {
  color: #833321;
  background-color: #fed3ca;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #833321;
  background-color: #febeb1;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #833321;
  border-color: #833321;
}

.list-group-item-danger {
  color: #7f1c30;
  background-color: #fcc7d1;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #7f1c30;
  background-color: #fbafbd;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #7f1c30;
  border-color: #7f1c30;
}

.list-group-item-light {
  color: #5a5e62;
  background-color: #e8eaed;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #5a5e62;
  background-color: #dadde2;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #5a5e62;
  border-color: #5a5e62;
}

.list-group-item-dark {
  color: #111315;
  background-color: #c1c2c3;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #111315;
  background-color: #b4b5b6;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #111315;
  border-color: #111315;
}

.list-group-item-default {
  color: #0c1628;
  background-color: #bec4cd;
}
.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {
  color: #0c1628;
  background-color: #b0b7c2;
}
.list-group-item-default.list-group-item-action.active {
  color: #fff;
  background-color: #0c1628;
  border-color: #0c1628;
}

.list-group-item-white {
  color: #858585;
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}
.list-group-item-white.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-neutral {
  color: #858585;
  background-color: white;
}
.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}
.list-group-item-neutral.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-darker {
  color: black;
  background-color: #b8b8b8;
}
.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {
  color: black;
  background-color: #ababab;
}
.list-group-item-darker.list-group-item-action.active {
  color: #fff;
  background-color: black;
  border-color: black;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
}
.close:hover {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: -webkit-min-content;
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.2);
  border-radius: 0.4375rem;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.16;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem;
  border-bottom: 0 solid #e9ecef;
  border-top-left-radius: 0.4375rem;
  border-top-right-radius: 0.4375rem;
}
.modal-header .close {
  padding: 1.25rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.1;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 1.25rem;
  border-top: 0 solid #e9ecef;
  border-bottom-right-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: -webkit-min-content;
    height: min-content;
  }
  .modal-content {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  }
  .modal-sm {
    max-width: 380px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.375rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.4375rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 0.75rem;
  margin: 0 0.4375rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.75rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.75rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: transparent;
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.75rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4375rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: transparent;
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.75rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.75rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: transparent;
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1.5rem;
  margin-left: -0.75rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.75rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4375rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: transparent;
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.95rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #32325d;
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
  border-top-left-radius: calc(0.4375rem - 1px);
  border-top-right-radius: calc(0.4375rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.95rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #5e72e4 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #324cdd !important;
}

.bg-secondary {
  background-color: #f7fafc !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #d2e3ee !important;
}

.bg-success {
  background-color: #2dce89 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #24a46d !important;
}

.bg-info {
  background-color: #11cdef !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0da5c0 !important;
}

.bg-warning {
  background-color: #fb6340 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #fa3a0e !important;
}

.bg-danger {
  background-color: #f5365c !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #ec0c38 !important;
}

.bg-light {
  background-color: #adb5bd !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #919ca6 !important;
}

.bg-dark {
  background-color: #212529 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #0a0c0d !important;
}

.bg-default {
  background-color: #172b4d !important;
}

a.bg-default:hover, a.bg-default:focus,
button.bg-default:hover,
button.bg-default:focus {
  background-color: #0b1526 !important;
}

.bg-white {
  background-color: #fff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-neutral {
  background-color: #fff !important;
}

a.bg-neutral:hover, a.bg-neutral:focus,
button.bg-neutral:hover,
button.bg-neutral:focus {
  background-color: #e6e6e6 !important;
}

.bg-darker {
  background-color: black !important;
}

a.bg-darker:hover, a.bg-darker:focus,
button.bg-darker:hover,
button.bg-darker:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #e9ecef !important;
}

.border-top {
  border-top: 1px solid #e9ecef !important;
}

.border-right {
  border-right: 1px solid #e9ecef !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.border-left {
  border-left: 1px solid #e9ecef !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #5e72e4 !important;
}

.border-secondary {
  border-color: #f7fafc !important;
}

.border-success {
  border-color: #2dce89 !important;
}

.border-info {
  border-color: #11cdef !important;
}

.border-warning {
  border-color: #fb6340 !important;
}

.border-danger {
  border-color: #f5365c !important;
}

.border-light {
  border-color: #adb5bd !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-default {
  border-color: #172b4d !important;
}

.border-white {
  border-color: #fff !important;
}

.border-neutral {
  border-color: #fff !important;
}

.border-darker {
  border-color: black !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.25rem !important;
}

.rounded {
  border-radius: 0.375rem !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-right-radius: 0.375rem !important;
}

.rounded-right {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-left {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-lg {
  border-radius: 0.4375rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sticky-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow, .card-profile-image img {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.m--9 {
  margin: -10rem !important;
}

.mt--9,
.my--9 {
  margin-top: -10rem !important;
}

.mr--9,
.mx--9 {
  margin-right: -10rem !important;
}

.mb--9,
.my--9 {
  margin-bottom: -10rem !important;
}

.ml--9,
.mx--9 {
  margin-left: -10rem !important;
}

.m--8 {
  margin: -8rem !important;
}

.mt--8,
.my--8 {
  margin-top: -8rem !important;
}

.mr--8,
.mx--8 {
  margin-right: -8rem !important;
}

.mb--8,
.my--8 {
  margin-bottom: -8rem !important;
}

.ml--8,
.mx--8 {
  margin-left: -8rem !important;
}

.m--7 {
  margin: -6rem !important;
}

.mt--7,
.my--7 {
  margin-top: -6rem !important;
}

.mr--7,
.mx--7 {
  margin-right: -6rem !important;
}

.mb--7,
.my--7 {
  margin-bottom: -6rem !important;
}

.ml--7,
.mx--7 {
  margin-left: -6rem !important;
}

.m--6 {
  margin: -4.5rem !important;
}

.mt--6,
.my--6 {
  margin-top: -4.5rem !important;
}

.mr--6,
.mx--6 {
  margin-right: -4.5rem !important;
}

.mb--6,
.my--6 {
  margin-bottom: -4.5rem !important;
}

.ml--6,
.mx--6 {
  margin-left: -4.5rem !important;
}

.m--5 {
  margin: -3rem !important;
}

.mt--5,
.my--5 {
  margin-top: -3rem !important;
}

.mr--5,
.mx--5 {
  margin-right: -3rem !important;
}

.mb--5,
.my--5 {
  margin-bottom: -3rem !important;
}

.ml--5,
.mx--5 {
  margin-left: -3rem !important;
}

.m--4 {
  margin: -1.5rem !important;
}

.mt--4,
.my--4 {
  margin-top: -1.5rem !important;
}

.mr--4,
.mx--4 {
  margin-right: -1.5rem !important;
}

.mb--4,
.my--4 {
  margin-bottom: -1.5rem !important;
}

.ml--4,
.mx--4 {
  margin-left: -1.5rem !important;
}

.m--3 {
  margin: -1rem !important;
}

.mt--3,
.my--3 {
  margin-top: -1rem !important;
}

.mr--3,
.mx--3 {
  margin-right: -1rem !important;
}

.mb--3,
.my--3 {
  margin-bottom: -1rem !important;
}

.ml--3,
.mx--3 {
  margin-left: -1rem !important;
}

.m--2 {
  margin: -0.5rem !important;
}

.mt--2,
.my--2 {
  margin-top: -0.5rem !important;
}

.mr--2,
.mx--2 {
  margin-right: -0.5rem !important;
}

.mb--2,
.my--2 {
  margin-bottom: -0.5rem !important;
}

.ml--2,
.mx--2 {
  margin-left: -0.5rem !important;
}

.m--1 {
  margin: -0.25rem !important;
}

.mt--1,
.my--1 {
  margin-top: -0.25rem !important;
}

.mr--1,
.mx--1 {
  margin-right: -0.25rem !important;
}

.mb--1,
.my--1 {
  margin-bottom: -0.25rem !important;
}

.ml--1,
.mx--1 {
  margin-left: -0.25rem !important;
}

.m-6 {
  margin: 4.5rem !important;
}

.mt-6,
.my-6 {
  margin-top: 4.5rem !important;
}

.mr-6,
.mx-6 {
  margin-right: 4.5rem !important;
}

.mb-6,
.my-6 {
  margin-bottom: 4.5rem !important;
}

.ml-6,
.mx-6 {
  margin-left: 4.5rem !important;
}

.m-7 {
  margin: 6rem !important;
}

.mt-7,
.my-7 {
  margin-top: 6rem !important;
}

.mr-7,
.mx-7 {
  margin-right: 6rem !important;
}

.mb-7,
.my-7 {
  margin-bottom: 6rem !important;
}

.ml-7,
.mx-7 {
  margin-left: 6rem !important;
}

.m-8 {
  margin: 8rem !important;
}

.mt-8,
.my-8 {
  margin-top: 8rem !important;
}

.mr-8,
.mx-8 {
  margin-right: 8rem !important;
}

.mb-8,
.my-8 {
  margin-bottom: 8rem !important;
}

.ml-8,
.mx-8 {
  margin-left: 8rem !important;
}

.m-9 {
  margin: 10rem !important;
}

.mt-9,
.my-9 {
  margin-top: 10rem !important;
}

.mr-9,
.mx-9 {
  margin-right: 10rem !important;
}

.mb-9,
.my-9 {
  margin-bottom: 10rem !important;
}

.ml-9,
.mx-9 {
  margin-left: 10rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.p--9 {
  padding: -10rem !important;
}

.pt--9,
.py--9 {
  padding-top: -10rem !important;
}

.pr--9,
.px--9 {
  padding-right: -10rem !important;
}

.pb--9,
.py--9 {
  padding-bottom: -10rem !important;
}

.pl--9,
.px--9 {
  padding-left: -10rem !important;
}

.p--8 {
  padding: -8rem !important;
}

.pt--8,
.py--8 {
  padding-top: -8rem !important;
}

.pr--8,
.px--8 {
  padding-right: -8rem !important;
}

.pb--8,
.py--8 {
  padding-bottom: -8rem !important;
}

.pl--8,
.px--8 {
  padding-left: -8rem !important;
}

.p--7 {
  padding: -6rem !important;
}

.pt--7,
.py--7 {
  padding-top: -6rem !important;
}

.pr--7,
.px--7 {
  padding-right: -6rem !important;
}

.pb--7,
.py--7 {
  padding-bottom: -6rem !important;
}

.pl--7,
.px--7 {
  padding-left: -6rem !important;
}

.p--6 {
  padding: -4.5rem !important;
}

.pt--6,
.py--6 {
  padding-top: -4.5rem !important;
}

.pr--6,
.px--6 {
  padding-right: -4.5rem !important;
}

.pb--6,
.py--6 {
  padding-bottom: -4.5rem !important;
}

.pl--6,
.px--6 {
  padding-left: -4.5rem !important;
}

.p--5 {
  padding: -3rem !important;
}

.pt--5,
.py--5 {
  padding-top: -3rem !important;
}

.pr--5,
.px--5 {
  padding-right: -3rem !important;
}

.pb--5,
.py--5 {
  padding-bottom: -3rem !important;
}

.pl--5,
.px--5 {
  padding-left: -3rem !important;
}

.p--4 {
  padding: -1.5rem !important;
}

.pt--4,
.py--4 {
  padding-top: -1.5rem !important;
}

.pr--4,
.px--4 {
  padding-right: -1.5rem !important;
}

.pb--4,
.py--4 {
  padding-bottom: -1.5rem !important;
}

.pl--4,
.px--4 {
  padding-left: -1.5rem !important;
}

.p--3 {
  padding: -1rem !important;
}

.pt--3,
.py--3 {
  padding-top: -1rem !important;
}

.pr--3,
.px--3 {
  padding-right: -1rem !important;
}

.pb--3,
.py--3 {
  padding-bottom: -1rem !important;
}

.pl--3,
.px--3 {
  padding-left: -1rem !important;
}

.p--2 {
  padding: -0.5rem !important;
}

.pt--2,
.py--2 {
  padding-top: -0.5rem !important;
}

.pr--2,
.px--2 {
  padding-right: -0.5rem !important;
}

.pb--2,
.py--2 {
  padding-bottom: -0.5rem !important;
}

.pl--2,
.px--2 {
  padding-left: -0.5rem !important;
}

.p--1 {
  padding: -0.25rem !important;
}

.pt--1,
.py--1 {
  padding-top: -0.25rem !important;
}

.pr--1,
.px--1 {
  padding-right: -0.25rem !important;
}

.pb--1,
.py--1 {
  padding-bottom: -0.25rem !important;
}

.pl--1,
.px--1 {
  padding-left: -0.25rem !important;
}

.p-6 {
  padding: 4.5rem !important;
}

.pt-6,
.py-6 {
  padding-top: 4.5rem !important;
}

.pr-6,
.px-6 {
  padding-right: 4.5rem !important;
}

.pb-6,
.py-6 {
  padding-bottom: 4.5rem !important;
}

.pl-6,
.px-6 {
  padding-left: 4.5rem !important;
}

.p-7 {
  padding: 6rem !important;
}

.pt-7,
.py-7 {
  padding-top: 6rem !important;
}

.pr-7,
.px-7 {
  padding-right: 6rem !important;
}

.pb-7,
.py-7 {
  padding-bottom: 6rem !important;
}

.pl-7,
.px-7 {
  padding-left: 6rem !important;
}

.p-8 {
  padding: 8rem !important;
}

.pt-8,
.py-8 {
  padding-top: 8rem !important;
}

.pr-8,
.px-8 {
  padding-right: 8rem !important;
}

.pb-8,
.py-8 {
  padding-bottom: 8rem !important;
}

.pl-8,
.px-8 {
  padding-left: 8rem !important;
}

.p-9 {
  padding: 10rem !important;
}

.pt-9,
.py-9 {
  padding-top: 10rem !important;
}

.pr-9,
.px-9 {
  padding-right: 10rem !important;
}

.pb-9,
.py-9 {
  padding-bottom: 10rem !important;
}

.pl-9,
.px-9 {
  padding-left: 10rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-n-9 {
  margin: 10rem !important;
}

.mt-n-9,
.my-n-9 {
  margin-top: 10rem !important;
}

.mr-n-9,
.mx-n-9 {
  margin-right: 10rem !important;
}

.mb-n-9,
.my-n-9 {
  margin-bottom: 10rem !important;
}

.ml-n-9,
.mx-n-9 {
  margin-left: 10rem !important;
}

.m-n-8 {
  margin: 8rem !important;
}

.mt-n-8,
.my-n-8 {
  margin-top: 8rem !important;
}

.mr-n-8,
.mx-n-8 {
  margin-right: 8rem !important;
}

.mb-n-8,
.my-n-8 {
  margin-bottom: 8rem !important;
}

.ml-n-8,
.mx-n-8 {
  margin-left: 8rem !important;
}

.m-n-7 {
  margin: 6rem !important;
}

.mt-n-7,
.my-n-7 {
  margin-top: 6rem !important;
}

.mr-n-7,
.mx-n-7 {
  margin-right: 6rem !important;
}

.mb-n-7,
.my-n-7 {
  margin-bottom: 6rem !important;
}

.ml-n-7,
.mx-n-7 {
  margin-left: 6rem !important;
}

.m-n-6 {
  margin: 4.5rem !important;
}

.mt-n-6,
.my-n-6 {
  margin-top: 4.5rem !important;
}

.mr-n-6,
.mx-n-6 {
  margin-right: 4.5rem !important;
}

.mb-n-6,
.my-n-6 {
  margin-bottom: 4.5rem !important;
}

.ml-n-6,
.mx-n-6 {
  margin-left: 4.5rem !important;
}

.m-n-5 {
  margin: 3rem !important;
}

.mt-n-5,
.my-n-5 {
  margin-top: 3rem !important;
}

.mr-n-5,
.mx-n-5 {
  margin-right: 3rem !important;
}

.mb-n-5,
.my-n-5 {
  margin-bottom: 3rem !important;
}

.ml-n-5,
.mx-n-5 {
  margin-left: 3rem !important;
}

.m-n-4 {
  margin: 1.5rem !important;
}

.mt-n-4,
.my-n-4 {
  margin-top: 1.5rem !important;
}

.mr-n-4,
.mx-n-4 {
  margin-right: 1.5rem !important;
}

.mb-n-4,
.my-n-4 {
  margin-bottom: 1.5rem !important;
}

.ml-n-4,
.mx-n-4 {
  margin-left: 1.5rem !important;
}

.m-n-3 {
  margin: 1rem !important;
}

.mt-n-3,
.my-n-3 {
  margin-top: 1rem !important;
}

.mr-n-3,
.mx-n-3 {
  margin-right: 1rem !important;
}

.mb-n-3,
.my-n-3 {
  margin-bottom: 1rem !important;
}

.ml-n-3,
.mx-n-3 {
  margin-left: 1rem !important;
}

.m-n-2 {
  margin: 0.5rem !important;
}

.mt-n-2,
.my-n-2 {
  margin-top: 0.5rem !important;
}

.mr-n-2,
.mx-n-2 {
  margin-right: 0.5rem !important;
}

.mb-n-2,
.my-n-2 {
  margin-bottom: 0.5rem !important;
}

.ml-n-2,
.mx-n-2 {
  margin-left: 0.5rem !important;
}

.m-n-1 {
  margin: 0.25rem !important;
}

.mt-n-1,
.my-n-1 {
  margin-top: 0.25rem !important;
}

.mr-n-1,
.mx-n-1 {
  margin-right: 0.25rem !important;
}

.mb-n-1,
.my-n-1 {
  margin-bottom: 0.25rem !important;
}

.ml-n-1,
.mx-n-1 {
  margin-left: 0.25rem !important;
}

.m-n6 {
  margin: -4.5rem !important;
}

.mt-n6,
.my-n6 {
  margin-top: -4.5rem !important;
}

.mr-n6,
.mx-n6 {
  margin-right: -4.5rem !important;
}

.mb-n6,
.my-n6 {
  margin-bottom: -4.5rem !important;
}

.ml-n6,
.mx-n6 {
  margin-left: -4.5rem !important;
}

.m-n7 {
  margin: -6rem !important;
}

.mt-n7,
.my-n7 {
  margin-top: -6rem !important;
}

.mr-n7,
.mx-n7 {
  margin-right: -6rem !important;
}

.mb-n7,
.my-n7 {
  margin-bottom: -6rem !important;
}

.ml-n7,
.mx-n7 {
  margin-left: -6rem !important;
}

.m-n8 {
  margin: -8rem !important;
}

.mt-n8,
.my-n8 {
  margin-top: -8rem !important;
}

.mr-n8,
.mx-n8 {
  margin-right: -8rem !important;
}

.mb-n8,
.my-n8 {
  margin-bottom: -8rem !important;
}

.ml-n8,
.mx-n8 {
  margin-left: -8rem !important;
}

.m-n9 {
  margin: -10rem !important;
}

.mt-n9,
.my-n9 {
  margin-top: -10rem !important;
}

.mr-n9,
.mx-n9 {
  margin-right: -10rem !important;
}

.mb-n9,
.my-n9 {
  margin-bottom: -10rem !important;
}

.ml-n9,
.mx-n9 {
  margin-left: -10rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .m-sm--9 {
    margin: -10rem !important;
  }
  .mt-sm--9,
  .my-sm--9 {
    margin-top: -10rem !important;
  }
  .mr-sm--9,
  .mx-sm--9 {
    margin-right: -10rem !important;
  }
  .mb-sm--9,
  .my-sm--9 {
    margin-bottom: -10rem !important;
  }
  .ml-sm--9,
  .mx-sm--9 {
    margin-left: -10rem !important;
  }
  .m-sm--8 {
    margin: -8rem !important;
  }
  .mt-sm--8,
  .my-sm--8 {
    margin-top: -8rem !important;
  }
  .mr-sm--8,
  .mx-sm--8 {
    margin-right: -8rem !important;
  }
  .mb-sm--8,
  .my-sm--8 {
    margin-bottom: -8rem !important;
  }
  .ml-sm--8,
  .mx-sm--8 {
    margin-left: -8rem !important;
  }
  .m-sm--7 {
    margin: -6rem !important;
  }
  .mt-sm--7,
  .my-sm--7 {
    margin-top: -6rem !important;
  }
  .mr-sm--7,
  .mx-sm--7 {
    margin-right: -6rem !important;
  }
  .mb-sm--7,
  .my-sm--7 {
    margin-bottom: -6rem !important;
  }
  .ml-sm--7,
  .mx-sm--7 {
    margin-left: -6rem !important;
  }
  .m-sm--6 {
    margin: -4.5rem !important;
  }
  .mt-sm--6,
  .my-sm--6 {
    margin-top: -4.5rem !important;
  }
  .mr-sm--6,
  .mx-sm--6 {
    margin-right: -4.5rem !important;
  }
  .mb-sm--6,
  .my-sm--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm--6,
  .mx-sm--6 {
    margin-left: -4.5rem !important;
  }
  .m-sm--5 {
    margin: -3rem !important;
  }
  .mt-sm--5,
  .my-sm--5 {
    margin-top: -3rem !important;
  }
  .mr-sm--5,
  .mx-sm--5 {
    margin-right: -3rem !important;
  }
  .mb-sm--5,
  .my-sm--5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm--5,
  .mx-sm--5 {
    margin-left: -3rem !important;
  }
  .m-sm--4 {
    margin: -1.5rem !important;
  }
  .mt-sm--4,
  .my-sm--4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm--4,
  .mx-sm--4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm--4,
  .my-sm--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm--4,
  .mx-sm--4 {
    margin-left: -1.5rem !important;
  }
  .m-sm--3 {
    margin: -1rem !important;
  }
  .mt-sm--3,
  .my-sm--3 {
    margin-top: -1rem !important;
  }
  .mr-sm--3,
  .mx-sm--3 {
    margin-right: -1rem !important;
  }
  .mb-sm--3,
  .my-sm--3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm--3,
  .mx-sm--3 {
    margin-left: -1rem !important;
  }
  .m-sm--2 {
    margin: -0.5rem !important;
  }
  .mt-sm--2,
  .my-sm--2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm--2,
  .mx-sm--2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm--2,
  .my-sm--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm--2,
  .mx-sm--2 {
    margin-left: -0.5rem !important;
  }
  .m-sm--1 {
    margin: -0.25rem !important;
  }
  .mt-sm--1,
  .my-sm--1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm--1,
  .mx-sm--1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm--1,
  .my-sm--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm--1,
  .mx-sm--1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-6 {
    margin: 4.5rem !important;
  }
  .mt-sm-6,
  .my-sm-6 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-6,
  .mx-sm-6 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-6,
  .my-sm-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-6,
  .mx-sm-6 {
    margin-left: 4.5rem !important;
  }
  .m-sm-7 {
    margin: 6rem !important;
  }
  .mt-sm-7,
  .my-sm-7 {
    margin-top: 6rem !important;
  }
  .mr-sm-7,
  .mx-sm-7 {
    margin-right: 6rem !important;
  }
  .mb-sm-7,
  .my-sm-7 {
    margin-bottom: 6rem !important;
  }
  .ml-sm-7,
  .mx-sm-7 {
    margin-left: 6rem !important;
  }
  .m-sm-8 {
    margin: 8rem !important;
  }
  .mt-sm-8,
  .my-sm-8 {
    margin-top: 8rem !important;
  }
  .mr-sm-8,
  .mx-sm-8 {
    margin-right: 8rem !important;
  }
  .mb-sm-8,
  .my-sm-8 {
    margin-bottom: 8rem !important;
  }
  .ml-sm-8,
  .mx-sm-8 {
    margin-left: 8rem !important;
  }
  .m-sm-9 {
    margin: 10rem !important;
  }
  .mt-sm-9,
  .my-sm-9 {
    margin-top: 10rem !important;
  }
  .mr-sm-9,
  .mx-sm-9 {
    margin-right: 10rem !important;
  }
  .mb-sm-9,
  .my-sm-9 {
    margin-bottom: 10rem !important;
  }
  .ml-sm-9,
  .mx-sm-9 {
    margin-left: 10rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .p-sm--9 {
    padding: -10rem !important;
  }
  .pt-sm--9,
  .py-sm--9 {
    padding-top: -10rem !important;
  }
  .pr-sm--9,
  .px-sm--9 {
    padding-right: -10rem !important;
  }
  .pb-sm--9,
  .py-sm--9 {
    padding-bottom: -10rem !important;
  }
  .pl-sm--9,
  .px-sm--9 {
    padding-left: -10rem !important;
  }
  .p-sm--8 {
    padding: -8rem !important;
  }
  .pt-sm--8,
  .py-sm--8 {
    padding-top: -8rem !important;
  }
  .pr-sm--8,
  .px-sm--8 {
    padding-right: -8rem !important;
  }
  .pb-sm--8,
  .py-sm--8 {
    padding-bottom: -8rem !important;
  }
  .pl-sm--8,
  .px-sm--8 {
    padding-left: -8rem !important;
  }
  .p-sm--7 {
    padding: -6rem !important;
  }
  .pt-sm--7,
  .py-sm--7 {
    padding-top: -6rem !important;
  }
  .pr-sm--7,
  .px-sm--7 {
    padding-right: -6rem !important;
  }
  .pb-sm--7,
  .py-sm--7 {
    padding-bottom: -6rem !important;
  }
  .pl-sm--7,
  .px-sm--7 {
    padding-left: -6rem !important;
  }
  .p-sm--6 {
    padding: -4.5rem !important;
  }
  .pt-sm--6,
  .py-sm--6 {
    padding-top: -4.5rem !important;
  }
  .pr-sm--6,
  .px-sm--6 {
    padding-right: -4.5rem !important;
  }
  .pb-sm--6,
  .py-sm--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-sm--6,
  .px-sm--6 {
    padding-left: -4.5rem !important;
  }
  .p-sm--5 {
    padding: -3rem !important;
  }
  .pt-sm--5,
  .py-sm--5 {
    padding-top: -3rem !important;
  }
  .pr-sm--5,
  .px-sm--5 {
    padding-right: -3rem !important;
  }
  .pb-sm--5,
  .py-sm--5 {
    padding-bottom: -3rem !important;
  }
  .pl-sm--5,
  .px-sm--5 {
    padding-left: -3rem !important;
  }
  .p-sm--4 {
    padding: -1.5rem !important;
  }
  .pt-sm--4,
  .py-sm--4 {
    padding-top: -1.5rem !important;
  }
  .pr-sm--4,
  .px-sm--4 {
    padding-right: -1.5rem !important;
  }
  .pb-sm--4,
  .py-sm--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-sm--4,
  .px-sm--4 {
    padding-left: -1.5rem !important;
  }
  .p-sm--3 {
    padding: -1rem !important;
  }
  .pt-sm--3,
  .py-sm--3 {
    padding-top: -1rem !important;
  }
  .pr-sm--3,
  .px-sm--3 {
    padding-right: -1rem !important;
  }
  .pb-sm--3,
  .py-sm--3 {
    padding-bottom: -1rem !important;
  }
  .pl-sm--3,
  .px-sm--3 {
    padding-left: -1rem !important;
  }
  .p-sm--2 {
    padding: -0.5rem !important;
  }
  .pt-sm--2,
  .py-sm--2 {
    padding-top: -0.5rem !important;
  }
  .pr-sm--2,
  .px-sm--2 {
    padding-right: -0.5rem !important;
  }
  .pb-sm--2,
  .py-sm--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-sm--2,
  .px-sm--2 {
    padding-left: -0.5rem !important;
  }
  .p-sm--1 {
    padding: -0.25rem !important;
  }
  .pt-sm--1,
  .py-sm--1 {
    padding-top: -0.25rem !important;
  }
  .pr-sm--1,
  .px-sm--1 {
    padding-right: -0.25rem !important;
  }
  .pb-sm--1,
  .py-sm--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-sm--1,
  .px-sm--1 {
    padding-left: -0.25rem !important;
  }
  .p-sm-6 {
    padding: 4.5rem !important;
  }
  .pt-sm-6,
  .py-sm-6 {
    padding-top: 4.5rem !important;
  }
  .pr-sm-6,
  .px-sm-6 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-6,
  .py-sm-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-sm-6,
  .px-sm-6 {
    padding-left: 4.5rem !important;
  }
  .p-sm-7 {
    padding: 6rem !important;
  }
  .pt-sm-7,
  .py-sm-7 {
    padding-top: 6rem !important;
  }
  .pr-sm-7,
  .px-sm-7 {
    padding-right: 6rem !important;
  }
  .pb-sm-7,
  .py-sm-7 {
    padding-bottom: 6rem !important;
  }
  .pl-sm-7,
  .px-sm-7 {
    padding-left: 6rem !important;
  }
  .p-sm-8 {
    padding: 8rem !important;
  }
  .pt-sm-8,
  .py-sm-8 {
    padding-top: 8rem !important;
  }
  .pr-sm-8,
  .px-sm-8 {
    padding-right: 8rem !important;
  }
  .pb-sm-8,
  .py-sm-8 {
    padding-bottom: 8rem !important;
  }
  .pl-sm-8,
  .px-sm-8 {
    padding-left: 8rem !important;
  }
  .p-sm-9 {
    padding: 10rem !important;
  }
  .pt-sm-9,
  .py-sm-9 {
    padding-top: 10rem !important;
  }
  .pr-sm-9,
  .px-sm-9 {
    padding-right: 10rem !important;
  }
  .pb-sm-9,
  .py-sm-9 {
    padding-bottom: 10rem !important;
  }
  .pl-sm-9,
  .px-sm-9 {
    padding-left: 10rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-n-9 {
    margin: 10rem !important;
  }
  .mt-sm-n-9,
  .my-sm-n-9 {
    margin-top: 10rem !important;
  }
  .mr-sm-n-9,
  .mx-sm-n-9 {
    margin-right: 10rem !important;
  }
  .mb-sm-n-9,
  .my-sm-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-sm-n-9,
  .mx-sm-n-9 {
    margin-left: 10rem !important;
  }
  .m-sm-n-8 {
    margin: 8rem !important;
  }
  .mt-sm-n-8,
  .my-sm-n-8 {
    margin-top: 8rem !important;
  }
  .mr-sm-n-8,
  .mx-sm-n-8 {
    margin-right: 8rem !important;
  }
  .mb-sm-n-8,
  .my-sm-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-sm-n-8,
  .mx-sm-n-8 {
    margin-left: 8rem !important;
  }
  .m-sm-n-7 {
    margin: 6rem !important;
  }
  .mt-sm-n-7,
  .my-sm-n-7 {
    margin-top: 6rem !important;
  }
  .mr-sm-n-7,
  .mx-sm-n-7 {
    margin-right: 6rem !important;
  }
  .mb-sm-n-7,
  .my-sm-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-sm-n-7,
  .mx-sm-n-7 {
    margin-left: 6rem !important;
  }
  .m-sm-n-6 {
    margin: 4.5rem !important;
  }
  .mt-sm-n-6,
  .my-sm-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-n-6,
  .mx-sm-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-n-6,
  .my-sm-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-n-6,
  .mx-sm-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-sm-n-5 {
    margin: 3rem !important;
  }
  .mt-sm-n-5,
  .my-sm-n-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-n-5,
  .mx-sm-n-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-n-5,
  .my-sm-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-n-5,
  .mx-sm-n-5 {
    margin-left: 3rem !important;
  }
  .m-sm-n-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-n-4,
  .my-sm-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-n-4,
  .mx-sm-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-n-4,
  .my-sm-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-n-4,
  .mx-sm-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-n-3 {
    margin: 1rem !important;
  }
  .mt-sm-n-3,
  .my-sm-n-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-n-3,
  .mx-sm-n-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-n-3,
  .my-sm-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-n-3,
  .mx-sm-n-3 {
    margin-left: 1rem !important;
  }
  .m-sm-n-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-n-2,
  .my-sm-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-n-2,
  .mx-sm-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-n-2,
  .my-sm-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-n-2,
  .mx-sm-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-n-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-n-1,
  .my-sm-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-n-1,
  .mx-sm-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-n-1,
  .my-sm-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-n-1,
  .mx-sm-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-n6 {
    margin: -4.5rem !important;
  }
  .mt-sm-n6,
  .my-sm-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-sm-n6,
  .mx-sm-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n6,
  .my-sm-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm-n6,
  .mx-sm-n6 {
    margin-left: -4.5rem !important;
  }
  .m-sm-n7 {
    margin: -6rem !important;
  }
  .mt-sm-n7,
  .my-sm-n7 {
    margin-top: -6rem !important;
  }
  .mr-sm-n7,
  .mx-sm-n7 {
    margin-right: -6rem !important;
  }
  .mb-sm-n7,
  .my-sm-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-sm-n7,
  .mx-sm-n7 {
    margin-left: -6rem !important;
  }
  .m-sm-n8 {
    margin: -8rem !important;
  }
  .mt-sm-n8,
  .my-sm-n8 {
    margin-top: -8rem !important;
  }
  .mr-sm-n8,
  .mx-sm-n8 {
    margin-right: -8rem !important;
  }
  .mb-sm-n8,
  .my-sm-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-sm-n8,
  .mx-sm-n8 {
    margin-left: -8rem !important;
  }
  .m-sm-n9 {
    margin: -10rem !important;
  }
  .mt-sm-n9,
  .my-sm-n9 {
    margin-top: -10rem !important;
  }
  .mr-sm-n9,
  .mx-sm-n9 {
    margin-right: -10rem !important;
  }
  .mb-sm-n9,
  .my-sm-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-sm-n9,
  .mx-sm-n9 {
    margin-left: -10rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .m-md--9 {
    margin: -10rem !important;
  }
  .mt-md--9,
  .my-md--9 {
    margin-top: -10rem !important;
  }
  .mr-md--9,
  .mx-md--9 {
    margin-right: -10rem !important;
  }
  .mb-md--9,
  .my-md--9 {
    margin-bottom: -10rem !important;
  }
  .ml-md--9,
  .mx-md--9 {
    margin-left: -10rem !important;
  }
  .m-md--8 {
    margin: -8rem !important;
  }
  .mt-md--8,
  .my-md--8 {
    margin-top: -8rem !important;
  }
  .mr-md--8,
  .mx-md--8 {
    margin-right: -8rem !important;
  }
  .mb-md--8,
  .my-md--8 {
    margin-bottom: -8rem !important;
  }
  .ml-md--8,
  .mx-md--8 {
    margin-left: -8rem !important;
  }
  .m-md--7 {
    margin: -6rem !important;
  }
  .mt-md--7,
  .my-md--7 {
    margin-top: -6rem !important;
  }
  .mr-md--7,
  .mx-md--7 {
    margin-right: -6rem !important;
  }
  .mb-md--7,
  .my-md--7 {
    margin-bottom: -6rem !important;
  }
  .ml-md--7,
  .mx-md--7 {
    margin-left: -6rem !important;
  }
  .m-md--6 {
    margin: -4.5rem !important;
  }
  .mt-md--6,
  .my-md--6 {
    margin-top: -4.5rem !important;
  }
  .mr-md--6,
  .mx-md--6 {
    margin-right: -4.5rem !important;
  }
  .mb-md--6,
  .my-md--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md--6,
  .mx-md--6 {
    margin-left: -4.5rem !important;
  }
  .m-md--5 {
    margin: -3rem !important;
  }
  .mt-md--5,
  .my-md--5 {
    margin-top: -3rem !important;
  }
  .mr-md--5,
  .mx-md--5 {
    margin-right: -3rem !important;
  }
  .mb-md--5,
  .my-md--5 {
    margin-bottom: -3rem !important;
  }
  .ml-md--5,
  .mx-md--5 {
    margin-left: -3rem !important;
  }
  .m-md--4 {
    margin: -1.5rem !important;
  }
  .mt-md--4,
  .my-md--4 {
    margin-top: -1.5rem !important;
  }
  .mr-md--4,
  .mx-md--4 {
    margin-right: -1.5rem !important;
  }
  .mb-md--4,
  .my-md--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md--4,
  .mx-md--4 {
    margin-left: -1.5rem !important;
  }
  .m-md--3 {
    margin: -1rem !important;
  }
  .mt-md--3,
  .my-md--3 {
    margin-top: -1rem !important;
  }
  .mr-md--3,
  .mx-md--3 {
    margin-right: -1rem !important;
  }
  .mb-md--3,
  .my-md--3 {
    margin-bottom: -1rem !important;
  }
  .ml-md--3,
  .mx-md--3 {
    margin-left: -1rem !important;
  }
  .m-md--2 {
    margin: -0.5rem !important;
  }
  .mt-md--2,
  .my-md--2 {
    margin-top: -0.5rem !important;
  }
  .mr-md--2,
  .mx-md--2 {
    margin-right: -0.5rem !important;
  }
  .mb-md--2,
  .my-md--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md--2,
  .mx-md--2 {
    margin-left: -0.5rem !important;
  }
  .m-md--1 {
    margin: -0.25rem !important;
  }
  .mt-md--1,
  .my-md--1 {
    margin-top: -0.25rem !important;
  }
  .mr-md--1,
  .mx-md--1 {
    margin-right: -0.25rem !important;
  }
  .mb-md--1,
  .my-md--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md--1,
  .mx-md--1 {
    margin-left: -0.25rem !important;
  }
  .m-md-6 {
    margin: 4.5rem !important;
  }
  .mt-md-6,
  .my-md-6 {
    margin-top: 4.5rem !important;
  }
  .mr-md-6,
  .mx-md-6 {
    margin-right: 4.5rem !important;
  }
  .mb-md-6,
  .my-md-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-6,
  .mx-md-6 {
    margin-left: 4.5rem !important;
  }
  .m-md-7 {
    margin: 6rem !important;
  }
  .mt-md-7,
  .my-md-7 {
    margin-top: 6rem !important;
  }
  .mr-md-7,
  .mx-md-7 {
    margin-right: 6rem !important;
  }
  .mb-md-7,
  .my-md-7 {
    margin-bottom: 6rem !important;
  }
  .ml-md-7,
  .mx-md-7 {
    margin-left: 6rem !important;
  }
  .m-md-8 {
    margin: 8rem !important;
  }
  .mt-md-8,
  .my-md-8 {
    margin-top: 8rem !important;
  }
  .mr-md-8,
  .mx-md-8 {
    margin-right: 8rem !important;
  }
  .mb-md-8,
  .my-md-8 {
    margin-bottom: 8rem !important;
  }
  .ml-md-8,
  .mx-md-8 {
    margin-left: 8rem !important;
  }
  .m-md-9 {
    margin: 10rem !important;
  }
  .mt-md-9,
  .my-md-9 {
    margin-top: 10rem !important;
  }
  .mr-md-9,
  .mx-md-9 {
    margin-right: 10rem !important;
  }
  .mb-md-9,
  .my-md-9 {
    margin-bottom: 10rem !important;
  }
  .ml-md-9,
  .mx-md-9 {
    margin-left: 10rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .p-md--9 {
    padding: -10rem !important;
  }
  .pt-md--9,
  .py-md--9 {
    padding-top: -10rem !important;
  }
  .pr-md--9,
  .px-md--9 {
    padding-right: -10rem !important;
  }
  .pb-md--9,
  .py-md--9 {
    padding-bottom: -10rem !important;
  }
  .pl-md--9,
  .px-md--9 {
    padding-left: -10rem !important;
  }
  .p-md--8 {
    padding: -8rem !important;
  }
  .pt-md--8,
  .py-md--8 {
    padding-top: -8rem !important;
  }
  .pr-md--8,
  .px-md--8 {
    padding-right: -8rem !important;
  }
  .pb-md--8,
  .py-md--8 {
    padding-bottom: -8rem !important;
  }
  .pl-md--8,
  .px-md--8 {
    padding-left: -8rem !important;
  }
  .p-md--7 {
    padding: -6rem !important;
  }
  .pt-md--7,
  .py-md--7 {
    padding-top: -6rem !important;
  }
  .pr-md--7,
  .px-md--7 {
    padding-right: -6rem !important;
  }
  .pb-md--7,
  .py-md--7 {
    padding-bottom: -6rem !important;
  }
  .pl-md--7,
  .px-md--7 {
    padding-left: -6rem !important;
  }
  .p-md--6 {
    padding: -4.5rem !important;
  }
  .pt-md--6,
  .py-md--6 {
    padding-top: -4.5rem !important;
  }
  .pr-md--6,
  .px-md--6 {
    padding-right: -4.5rem !important;
  }
  .pb-md--6,
  .py-md--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-md--6,
  .px-md--6 {
    padding-left: -4.5rem !important;
  }
  .p-md--5 {
    padding: -3rem !important;
  }
  .pt-md--5,
  .py-md--5 {
    padding-top: -3rem !important;
  }
  .pr-md--5,
  .px-md--5 {
    padding-right: -3rem !important;
  }
  .pb-md--5,
  .py-md--5 {
    padding-bottom: -3rem !important;
  }
  .pl-md--5,
  .px-md--5 {
    padding-left: -3rem !important;
  }
  .p-md--4 {
    padding: -1.5rem !important;
  }
  .pt-md--4,
  .py-md--4 {
    padding-top: -1.5rem !important;
  }
  .pr-md--4,
  .px-md--4 {
    padding-right: -1.5rem !important;
  }
  .pb-md--4,
  .py-md--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-md--4,
  .px-md--4 {
    padding-left: -1.5rem !important;
  }
  .p-md--3 {
    padding: -1rem !important;
  }
  .pt-md--3,
  .py-md--3 {
    padding-top: -1rem !important;
  }
  .pr-md--3,
  .px-md--3 {
    padding-right: -1rem !important;
  }
  .pb-md--3,
  .py-md--3 {
    padding-bottom: -1rem !important;
  }
  .pl-md--3,
  .px-md--3 {
    padding-left: -1rem !important;
  }
  .p-md--2 {
    padding: -0.5rem !important;
  }
  .pt-md--2,
  .py-md--2 {
    padding-top: -0.5rem !important;
  }
  .pr-md--2,
  .px-md--2 {
    padding-right: -0.5rem !important;
  }
  .pb-md--2,
  .py-md--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-md--2,
  .px-md--2 {
    padding-left: -0.5rem !important;
  }
  .p-md--1 {
    padding: -0.25rem !important;
  }
  .pt-md--1,
  .py-md--1 {
    padding-top: -0.25rem !important;
  }
  .pr-md--1,
  .px-md--1 {
    padding-right: -0.25rem !important;
  }
  .pb-md--1,
  .py-md--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-md--1,
  .px-md--1 {
    padding-left: -0.25rem !important;
  }
  .p-md-6 {
    padding: 4.5rem !important;
  }
  .pt-md-6,
  .py-md-6 {
    padding-top: 4.5rem !important;
  }
  .pr-md-6,
  .px-md-6 {
    padding-right: 4.5rem !important;
  }
  .pb-md-6,
  .py-md-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-md-6,
  .px-md-6 {
    padding-left: 4.5rem !important;
  }
  .p-md-7 {
    padding: 6rem !important;
  }
  .pt-md-7,
  .py-md-7 {
    padding-top: 6rem !important;
  }
  .pr-md-7,
  .px-md-7 {
    padding-right: 6rem !important;
  }
  .pb-md-7,
  .py-md-7 {
    padding-bottom: 6rem !important;
  }
  .pl-md-7,
  .px-md-7 {
    padding-left: 6rem !important;
  }
  .p-md-8 {
    padding: 8rem !important;
  }
  .pt-md-8,
  .py-md-8 {
    padding-top: 8rem !important;
  }
  .pr-md-8,
  .px-md-8 {
    padding-right: 8rem !important;
  }
  .pb-md-8,
  .py-md-8 {
    padding-bottom: 8rem !important;
  }
  .pl-md-8,
  .px-md-8 {
    padding-left: 8rem !important;
  }
  .p-md-9 {
    padding: 10rem !important;
  }
  .pt-md-9,
  .py-md-9 {
    padding-top: 10rem !important;
  }
  .pr-md-9,
  .px-md-9 {
    padding-right: 10rem !important;
  }
  .pb-md-9,
  .py-md-9 {
    padding-bottom: 10rem !important;
  }
  .pl-md-9,
  .px-md-9 {
    padding-left: 10rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-n-9 {
    margin: 10rem !important;
  }
  .mt-md-n-9,
  .my-md-n-9 {
    margin-top: 10rem !important;
  }
  .mr-md-n-9,
  .mx-md-n-9 {
    margin-right: 10rem !important;
  }
  .mb-md-n-9,
  .my-md-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-md-n-9,
  .mx-md-n-9 {
    margin-left: 10rem !important;
  }
  .m-md-n-8 {
    margin: 8rem !important;
  }
  .mt-md-n-8,
  .my-md-n-8 {
    margin-top: 8rem !important;
  }
  .mr-md-n-8,
  .mx-md-n-8 {
    margin-right: 8rem !important;
  }
  .mb-md-n-8,
  .my-md-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-md-n-8,
  .mx-md-n-8 {
    margin-left: 8rem !important;
  }
  .m-md-n-7 {
    margin: 6rem !important;
  }
  .mt-md-n-7,
  .my-md-n-7 {
    margin-top: 6rem !important;
  }
  .mr-md-n-7,
  .mx-md-n-7 {
    margin-right: 6rem !important;
  }
  .mb-md-n-7,
  .my-md-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-md-n-7,
  .mx-md-n-7 {
    margin-left: 6rem !important;
  }
  .m-md-n-6 {
    margin: 4.5rem !important;
  }
  .mt-md-n-6,
  .my-md-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-md-n-6,
  .mx-md-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-md-n-6,
  .my-md-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-n-6,
  .mx-md-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-md-n-5 {
    margin: 3rem !important;
  }
  .mt-md-n-5,
  .my-md-n-5 {
    margin-top: 3rem !important;
  }
  .mr-md-n-5,
  .mx-md-n-5 {
    margin-right: 3rem !important;
  }
  .mb-md-n-5,
  .my-md-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-n-5,
  .mx-md-n-5 {
    margin-left: 3rem !important;
  }
  .m-md-n-4 {
    margin: 1.5rem !important;
  }
  .mt-md-n-4,
  .my-md-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-n-4,
  .mx-md-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-n-4,
  .my-md-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-n-4,
  .mx-md-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-n-3 {
    margin: 1rem !important;
  }
  .mt-md-n-3,
  .my-md-n-3 {
    margin-top: 1rem !important;
  }
  .mr-md-n-3,
  .mx-md-n-3 {
    margin-right: 1rem !important;
  }
  .mb-md-n-3,
  .my-md-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-n-3,
  .mx-md-n-3 {
    margin-left: 1rem !important;
  }
  .m-md-n-2 {
    margin: 0.5rem !important;
  }
  .mt-md-n-2,
  .my-md-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-n-2,
  .mx-md-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-n-2,
  .my-md-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-n-2,
  .mx-md-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-n-1 {
    margin: 0.25rem !important;
  }
  .mt-md-n-1,
  .my-md-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-n-1,
  .mx-md-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-n-1,
  .my-md-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-n-1,
  .mx-md-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-n6 {
    margin: -4.5rem !important;
  }
  .mt-md-n6,
  .my-md-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-md-n6,
  .mx-md-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n6,
  .my-md-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md-n6,
  .mx-md-n6 {
    margin-left: -4.5rem !important;
  }
  .m-md-n7 {
    margin: -6rem !important;
  }
  .mt-md-n7,
  .my-md-n7 {
    margin-top: -6rem !important;
  }
  .mr-md-n7,
  .mx-md-n7 {
    margin-right: -6rem !important;
  }
  .mb-md-n7,
  .my-md-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-md-n7,
  .mx-md-n7 {
    margin-left: -6rem !important;
  }
  .m-md-n8 {
    margin: -8rem !important;
  }
  .mt-md-n8,
  .my-md-n8 {
    margin-top: -8rem !important;
  }
  .mr-md-n8,
  .mx-md-n8 {
    margin-right: -8rem !important;
  }
  .mb-md-n8,
  .my-md-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-md-n8,
  .mx-md-n8 {
    margin-left: -8rem !important;
  }
  .m-md-n9 {
    margin: -10rem !important;
  }
  .mt-md-n9,
  .my-md-n9 {
    margin-top: -10rem !important;
  }
  .mr-md-n9,
  .mx-md-n9 {
    margin-right: -10rem !important;
  }
  .mb-md-n9,
  .my-md-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-md-n9,
  .mx-md-n9 {
    margin-left: -10rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .m-lg--9 {
    margin: -10rem !important;
  }
  .mt-lg--9,
  .my-lg--9 {
    margin-top: -10rem !important;
  }
  .mr-lg--9,
  .mx-lg--9 {
    margin-right: -10rem !important;
  }
  .mb-lg--9,
  .my-lg--9 {
    margin-bottom: -10rem !important;
  }
  .ml-lg--9,
  .mx-lg--9 {
    margin-left: -10rem !important;
  }
  .m-lg--8 {
    margin: -8rem !important;
  }
  .mt-lg--8,
  .my-lg--8 {
    margin-top: -8rem !important;
  }
  .mr-lg--8,
  .mx-lg--8 {
    margin-right: -8rem !important;
  }
  .mb-lg--8,
  .my-lg--8 {
    margin-bottom: -8rem !important;
  }
  .ml-lg--8,
  .mx-lg--8 {
    margin-left: -8rem !important;
  }
  .m-lg--7 {
    margin: -6rem !important;
  }
  .mt-lg--7,
  .my-lg--7 {
    margin-top: -6rem !important;
  }
  .mr-lg--7,
  .mx-lg--7 {
    margin-right: -6rem !important;
  }
  .mb-lg--7,
  .my-lg--7 {
    margin-bottom: -6rem !important;
  }
  .ml-lg--7,
  .mx-lg--7 {
    margin-left: -6rem !important;
  }
  .m-lg--6 {
    margin: -4.5rem !important;
  }
  .mt-lg--6,
  .my-lg--6 {
    margin-top: -4.5rem !important;
  }
  .mr-lg--6,
  .mx-lg--6 {
    margin-right: -4.5rem !important;
  }
  .mb-lg--6,
  .my-lg--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg--6,
  .mx-lg--6 {
    margin-left: -4.5rem !important;
  }
  .m-lg--5 {
    margin: -3rem !important;
  }
  .mt-lg--5,
  .my-lg--5 {
    margin-top: -3rem !important;
  }
  .mr-lg--5,
  .mx-lg--5 {
    margin-right: -3rem !important;
  }
  .mb-lg--5,
  .my-lg--5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg--5,
  .mx-lg--5 {
    margin-left: -3rem !important;
  }
  .m-lg--4 {
    margin: -1.5rem !important;
  }
  .mt-lg--4,
  .my-lg--4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg--4,
  .mx-lg--4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg--4,
  .my-lg--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg--4,
  .mx-lg--4 {
    margin-left: -1.5rem !important;
  }
  .m-lg--3 {
    margin: -1rem !important;
  }
  .mt-lg--3,
  .my-lg--3 {
    margin-top: -1rem !important;
  }
  .mr-lg--3,
  .mx-lg--3 {
    margin-right: -1rem !important;
  }
  .mb-lg--3,
  .my-lg--3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg--3,
  .mx-lg--3 {
    margin-left: -1rem !important;
  }
  .m-lg--2 {
    margin: -0.5rem !important;
  }
  .mt-lg--2,
  .my-lg--2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg--2,
  .mx-lg--2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg--2,
  .my-lg--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg--2,
  .mx-lg--2 {
    margin-left: -0.5rem !important;
  }
  .m-lg--1 {
    margin: -0.25rem !important;
  }
  .mt-lg--1,
  .my-lg--1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg--1,
  .mx-lg--1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg--1,
  .my-lg--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg--1,
  .mx-lg--1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-6 {
    margin: 4.5rem !important;
  }
  .mt-lg-6,
  .my-lg-6 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-6,
  .mx-lg-6 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-6,
  .my-lg-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-6,
  .mx-lg-6 {
    margin-left: 4.5rem !important;
  }
  .m-lg-7 {
    margin: 6rem !important;
  }
  .mt-lg-7,
  .my-lg-7 {
    margin-top: 6rem !important;
  }
  .mr-lg-7,
  .mx-lg-7 {
    margin-right: 6rem !important;
  }
  .mb-lg-7,
  .my-lg-7 {
    margin-bottom: 6rem !important;
  }
  .ml-lg-7,
  .mx-lg-7 {
    margin-left: 6rem !important;
  }
  .m-lg-8 {
    margin: 8rem !important;
  }
  .mt-lg-8,
  .my-lg-8 {
    margin-top: 8rem !important;
  }
  .mr-lg-8,
  .mx-lg-8 {
    margin-right: 8rem !important;
  }
  .mb-lg-8,
  .my-lg-8 {
    margin-bottom: 8rem !important;
  }
  .ml-lg-8,
  .mx-lg-8 {
    margin-left: 8rem !important;
  }
  .m-lg-9 {
    margin: 10rem !important;
  }
  .mt-lg-9,
  .my-lg-9 {
    margin-top: 10rem !important;
  }
  .mr-lg-9,
  .mx-lg-9 {
    margin-right: 10rem !important;
  }
  .mb-lg-9,
  .my-lg-9 {
    margin-bottom: 10rem !important;
  }
  .ml-lg-9,
  .mx-lg-9 {
    margin-left: 10rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .p-lg--9 {
    padding: -10rem !important;
  }
  .pt-lg--9,
  .py-lg--9 {
    padding-top: -10rem !important;
  }
  .pr-lg--9,
  .px-lg--9 {
    padding-right: -10rem !important;
  }
  .pb-lg--9,
  .py-lg--9 {
    padding-bottom: -10rem !important;
  }
  .pl-lg--9,
  .px-lg--9 {
    padding-left: -10rem !important;
  }
  .p-lg--8 {
    padding: -8rem !important;
  }
  .pt-lg--8,
  .py-lg--8 {
    padding-top: -8rem !important;
  }
  .pr-lg--8,
  .px-lg--8 {
    padding-right: -8rem !important;
  }
  .pb-lg--8,
  .py-lg--8 {
    padding-bottom: -8rem !important;
  }
  .pl-lg--8,
  .px-lg--8 {
    padding-left: -8rem !important;
  }
  .p-lg--7 {
    padding: -6rem !important;
  }
  .pt-lg--7,
  .py-lg--7 {
    padding-top: -6rem !important;
  }
  .pr-lg--7,
  .px-lg--7 {
    padding-right: -6rem !important;
  }
  .pb-lg--7,
  .py-lg--7 {
    padding-bottom: -6rem !important;
  }
  .pl-lg--7,
  .px-lg--7 {
    padding-left: -6rem !important;
  }
  .p-lg--6 {
    padding: -4.5rem !important;
  }
  .pt-lg--6,
  .py-lg--6 {
    padding-top: -4.5rem !important;
  }
  .pr-lg--6,
  .px-lg--6 {
    padding-right: -4.5rem !important;
  }
  .pb-lg--6,
  .py-lg--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-lg--6,
  .px-lg--6 {
    padding-left: -4.5rem !important;
  }
  .p-lg--5 {
    padding: -3rem !important;
  }
  .pt-lg--5,
  .py-lg--5 {
    padding-top: -3rem !important;
  }
  .pr-lg--5,
  .px-lg--5 {
    padding-right: -3rem !important;
  }
  .pb-lg--5,
  .py-lg--5 {
    padding-bottom: -3rem !important;
  }
  .pl-lg--5,
  .px-lg--5 {
    padding-left: -3rem !important;
  }
  .p-lg--4 {
    padding: -1.5rem !important;
  }
  .pt-lg--4,
  .py-lg--4 {
    padding-top: -1.5rem !important;
  }
  .pr-lg--4,
  .px-lg--4 {
    padding-right: -1.5rem !important;
  }
  .pb-lg--4,
  .py-lg--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-lg--4,
  .px-lg--4 {
    padding-left: -1.5rem !important;
  }
  .p-lg--3 {
    padding: -1rem !important;
  }
  .pt-lg--3,
  .py-lg--3 {
    padding-top: -1rem !important;
  }
  .pr-lg--3,
  .px-lg--3 {
    padding-right: -1rem !important;
  }
  .pb-lg--3,
  .py-lg--3 {
    padding-bottom: -1rem !important;
  }
  .pl-lg--3,
  .px-lg--3 {
    padding-left: -1rem !important;
  }
  .p-lg--2 {
    padding: -0.5rem !important;
  }
  .pt-lg--2,
  .py-lg--2 {
    padding-top: -0.5rem !important;
  }
  .pr-lg--2,
  .px-lg--2 {
    padding-right: -0.5rem !important;
  }
  .pb-lg--2,
  .py-lg--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-lg--2,
  .px-lg--2 {
    padding-left: -0.5rem !important;
  }
  .p-lg--1 {
    padding: -0.25rem !important;
  }
  .pt-lg--1,
  .py-lg--1 {
    padding-top: -0.25rem !important;
  }
  .pr-lg--1,
  .px-lg--1 {
    padding-right: -0.25rem !important;
  }
  .pb-lg--1,
  .py-lg--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-lg--1,
  .px-lg--1 {
    padding-left: -0.25rem !important;
  }
  .p-lg-6 {
    padding: 4.5rem !important;
  }
  .pt-lg-6,
  .py-lg-6 {
    padding-top: 4.5rem !important;
  }
  .pr-lg-6,
  .px-lg-6 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-6,
  .py-lg-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-lg-6,
  .px-lg-6 {
    padding-left: 4.5rem !important;
  }
  .p-lg-7 {
    padding: 6rem !important;
  }
  .pt-lg-7,
  .py-lg-7 {
    padding-top: 6rem !important;
  }
  .pr-lg-7,
  .px-lg-7 {
    padding-right: 6rem !important;
  }
  .pb-lg-7,
  .py-lg-7 {
    padding-bottom: 6rem !important;
  }
  .pl-lg-7,
  .px-lg-7 {
    padding-left: 6rem !important;
  }
  .p-lg-8 {
    padding: 8rem !important;
  }
  .pt-lg-8,
  .py-lg-8 {
    padding-top: 8rem !important;
  }
  .pr-lg-8,
  .px-lg-8 {
    padding-right: 8rem !important;
  }
  .pb-lg-8,
  .py-lg-8 {
    padding-bottom: 8rem !important;
  }
  .pl-lg-8,
  .px-lg-8 {
    padding-left: 8rem !important;
  }
  .p-lg-9 {
    padding: 10rem !important;
  }
  .pt-lg-9,
  .py-lg-9 {
    padding-top: 10rem !important;
  }
  .pr-lg-9,
  .px-lg-9 {
    padding-right: 10rem !important;
  }
  .pb-lg-9,
  .py-lg-9 {
    padding-bottom: 10rem !important;
  }
  .pl-lg-9,
  .px-lg-9 {
    padding-left: 10rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-n-9 {
    margin: 10rem !important;
  }
  .mt-lg-n-9,
  .my-lg-n-9 {
    margin-top: 10rem !important;
  }
  .mr-lg-n-9,
  .mx-lg-n-9 {
    margin-right: 10rem !important;
  }
  .mb-lg-n-9,
  .my-lg-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-lg-n-9,
  .mx-lg-n-9 {
    margin-left: 10rem !important;
  }
  .m-lg-n-8 {
    margin: 8rem !important;
  }
  .mt-lg-n-8,
  .my-lg-n-8 {
    margin-top: 8rem !important;
  }
  .mr-lg-n-8,
  .mx-lg-n-8 {
    margin-right: 8rem !important;
  }
  .mb-lg-n-8,
  .my-lg-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-lg-n-8,
  .mx-lg-n-8 {
    margin-left: 8rem !important;
  }
  .m-lg-n-7 {
    margin: 6rem !important;
  }
  .mt-lg-n-7,
  .my-lg-n-7 {
    margin-top: 6rem !important;
  }
  .mr-lg-n-7,
  .mx-lg-n-7 {
    margin-right: 6rem !important;
  }
  .mb-lg-n-7,
  .my-lg-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-lg-n-7,
  .mx-lg-n-7 {
    margin-left: 6rem !important;
  }
  .m-lg-n-6 {
    margin: 4.5rem !important;
  }
  .mt-lg-n-6,
  .my-lg-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-n-6,
  .mx-lg-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-n-6,
  .my-lg-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-n-6,
  .mx-lg-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-lg-n-5 {
    margin: 3rem !important;
  }
  .mt-lg-n-5,
  .my-lg-n-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-n-5,
  .mx-lg-n-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-n-5,
  .my-lg-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-n-5,
  .mx-lg-n-5 {
    margin-left: 3rem !important;
  }
  .m-lg-n-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-n-4,
  .my-lg-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-n-4,
  .mx-lg-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-n-4,
  .my-lg-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-n-4,
  .mx-lg-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-n-3 {
    margin: 1rem !important;
  }
  .mt-lg-n-3,
  .my-lg-n-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-n-3,
  .mx-lg-n-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-n-3,
  .my-lg-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-n-3,
  .mx-lg-n-3 {
    margin-left: 1rem !important;
  }
  .m-lg-n-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-n-2,
  .my-lg-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-n-2,
  .mx-lg-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-n-2,
  .my-lg-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-n-2,
  .mx-lg-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-n-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-n-1,
  .my-lg-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-n-1,
  .mx-lg-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-n-1,
  .my-lg-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-n-1,
  .mx-lg-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-n6 {
    margin: -4.5rem !important;
  }
  .mt-lg-n6,
  .my-lg-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-lg-n6,
  .mx-lg-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n6,
  .my-lg-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg-n6,
  .mx-lg-n6 {
    margin-left: -4.5rem !important;
  }
  .m-lg-n7 {
    margin: -6rem !important;
  }
  .mt-lg-n7,
  .my-lg-n7 {
    margin-top: -6rem !important;
  }
  .mr-lg-n7,
  .mx-lg-n7 {
    margin-right: -6rem !important;
  }
  .mb-lg-n7,
  .my-lg-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-lg-n7,
  .mx-lg-n7 {
    margin-left: -6rem !important;
  }
  .m-lg-n8 {
    margin: -8rem !important;
  }
  .mt-lg-n8,
  .my-lg-n8 {
    margin-top: -8rem !important;
  }
  .mr-lg-n8,
  .mx-lg-n8 {
    margin-right: -8rem !important;
  }
  .mb-lg-n8,
  .my-lg-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-lg-n8,
  .mx-lg-n8 {
    margin-left: -8rem !important;
  }
  .m-lg-n9 {
    margin: -10rem !important;
  }
  .mt-lg-n9,
  .my-lg-n9 {
    margin-top: -10rem !important;
  }
  .mr-lg-n9,
  .mx-lg-n9 {
    margin-right: -10rem !important;
  }
  .mb-lg-n9,
  .my-lg-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-lg-n9,
  .mx-lg-n9 {
    margin-left: -10rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .m-xl--9 {
    margin: -10rem !important;
  }
  .mt-xl--9,
  .my-xl--9 {
    margin-top: -10rem !important;
  }
  .mr-xl--9,
  .mx-xl--9 {
    margin-right: -10rem !important;
  }
  .mb-xl--9,
  .my-xl--9 {
    margin-bottom: -10rem !important;
  }
  .ml-xl--9,
  .mx-xl--9 {
    margin-left: -10rem !important;
  }
  .m-xl--8 {
    margin: -8rem !important;
  }
  .mt-xl--8,
  .my-xl--8 {
    margin-top: -8rem !important;
  }
  .mr-xl--8,
  .mx-xl--8 {
    margin-right: -8rem !important;
  }
  .mb-xl--8,
  .my-xl--8 {
    margin-bottom: -8rem !important;
  }
  .ml-xl--8,
  .mx-xl--8 {
    margin-left: -8rem !important;
  }
  .m-xl--7 {
    margin: -6rem !important;
  }
  .mt-xl--7,
  .my-xl--7 {
    margin-top: -6rem !important;
  }
  .mr-xl--7,
  .mx-xl--7 {
    margin-right: -6rem !important;
  }
  .mb-xl--7,
  .my-xl--7 {
    margin-bottom: -6rem !important;
  }
  .ml-xl--7,
  .mx-xl--7 {
    margin-left: -6rem !important;
  }
  .m-xl--6 {
    margin: -4.5rem !important;
  }
  .mt-xl--6,
  .my-xl--6 {
    margin-top: -4.5rem !important;
  }
  .mr-xl--6,
  .mx-xl--6 {
    margin-right: -4.5rem !important;
  }
  .mb-xl--6,
  .my-xl--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl--6,
  .mx-xl--6 {
    margin-left: -4.5rem !important;
  }
  .m-xl--5 {
    margin: -3rem !important;
  }
  .mt-xl--5,
  .my-xl--5 {
    margin-top: -3rem !important;
  }
  .mr-xl--5,
  .mx-xl--5 {
    margin-right: -3rem !important;
  }
  .mb-xl--5,
  .my-xl--5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl--5,
  .mx-xl--5 {
    margin-left: -3rem !important;
  }
  .m-xl--4 {
    margin: -1.5rem !important;
  }
  .mt-xl--4,
  .my-xl--4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl--4,
  .mx-xl--4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl--4,
  .my-xl--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl--4,
  .mx-xl--4 {
    margin-left: -1.5rem !important;
  }
  .m-xl--3 {
    margin: -1rem !important;
  }
  .mt-xl--3,
  .my-xl--3 {
    margin-top: -1rem !important;
  }
  .mr-xl--3,
  .mx-xl--3 {
    margin-right: -1rem !important;
  }
  .mb-xl--3,
  .my-xl--3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl--3,
  .mx-xl--3 {
    margin-left: -1rem !important;
  }
  .m-xl--2 {
    margin: -0.5rem !important;
  }
  .mt-xl--2,
  .my-xl--2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl--2,
  .mx-xl--2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl--2,
  .my-xl--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl--2,
  .mx-xl--2 {
    margin-left: -0.5rem !important;
  }
  .m-xl--1 {
    margin: -0.25rem !important;
  }
  .mt-xl--1,
  .my-xl--1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl--1,
  .mx-xl--1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl--1,
  .my-xl--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl--1,
  .mx-xl--1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-6 {
    margin: 4.5rem !important;
  }
  .mt-xl-6,
  .my-xl-6 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-6,
  .mx-xl-6 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-6,
  .my-xl-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-6,
  .mx-xl-6 {
    margin-left: 4.5rem !important;
  }
  .m-xl-7 {
    margin: 6rem !important;
  }
  .mt-xl-7,
  .my-xl-7 {
    margin-top: 6rem !important;
  }
  .mr-xl-7,
  .mx-xl-7 {
    margin-right: 6rem !important;
  }
  .mb-xl-7,
  .my-xl-7 {
    margin-bottom: 6rem !important;
  }
  .ml-xl-7,
  .mx-xl-7 {
    margin-left: 6rem !important;
  }
  .m-xl-8 {
    margin: 8rem !important;
  }
  .mt-xl-8,
  .my-xl-8 {
    margin-top: 8rem !important;
  }
  .mr-xl-8,
  .mx-xl-8 {
    margin-right: 8rem !important;
  }
  .mb-xl-8,
  .my-xl-8 {
    margin-bottom: 8rem !important;
  }
  .ml-xl-8,
  .mx-xl-8 {
    margin-left: 8rem !important;
  }
  .m-xl-9 {
    margin: 10rem !important;
  }
  .mt-xl-9,
  .my-xl-9 {
    margin-top: 10rem !important;
  }
  .mr-xl-9,
  .mx-xl-9 {
    margin-right: 10rem !important;
  }
  .mb-xl-9,
  .my-xl-9 {
    margin-bottom: 10rem !important;
  }
  .ml-xl-9,
  .mx-xl-9 {
    margin-left: 10rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .p-xl--9 {
    padding: -10rem !important;
  }
  .pt-xl--9,
  .py-xl--9 {
    padding-top: -10rem !important;
  }
  .pr-xl--9,
  .px-xl--9 {
    padding-right: -10rem !important;
  }
  .pb-xl--9,
  .py-xl--9 {
    padding-bottom: -10rem !important;
  }
  .pl-xl--9,
  .px-xl--9 {
    padding-left: -10rem !important;
  }
  .p-xl--8 {
    padding: -8rem !important;
  }
  .pt-xl--8,
  .py-xl--8 {
    padding-top: -8rem !important;
  }
  .pr-xl--8,
  .px-xl--8 {
    padding-right: -8rem !important;
  }
  .pb-xl--8,
  .py-xl--8 {
    padding-bottom: -8rem !important;
  }
  .pl-xl--8,
  .px-xl--8 {
    padding-left: -8rem !important;
  }
  .p-xl--7 {
    padding: -6rem !important;
  }
  .pt-xl--7,
  .py-xl--7 {
    padding-top: -6rem !important;
  }
  .pr-xl--7,
  .px-xl--7 {
    padding-right: -6rem !important;
  }
  .pb-xl--7,
  .py-xl--7 {
    padding-bottom: -6rem !important;
  }
  .pl-xl--7,
  .px-xl--7 {
    padding-left: -6rem !important;
  }
  .p-xl--6 {
    padding: -4.5rem !important;
  }
  .pt-xl--6,
  .py-xl--6 {
    padding-top: -4.5rem !important;
  }
  .pr-xl--6,
  .px-xl--6 {
    padding-right: -4.5rem !important;
  }
  .pb-xl--6,
  .py-xl--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-xl--6,
  .px-xl--6 {
    padding-left: -4.5rem !important;
  }
  .p-xl--5 {
    padding: -3rem !important;
  }
  .pt-xl--5,
  .py-xl--5 {
    padding-top: -3rem !important;
  }
  .pr-xl--5,
  .px-xl--5 {
    padding-right: -3rem !important;
  }
  .pb-xl--5,
  .py-xl--5 {
    padding-bottom: -3rem !important;
  }
  .pl-xl--5,
  .px-xl--5 {
    padding-left: -3rem !important;
  }
  .p-xl--4 {
    padding: -1.5rem !important;
  }
  .pt-xl--4,
  .py-xl--4 {
    padding-top: -1.5rem !important;
  }
  .pr-xl--4,
  .px-xl--4 {
    padding-right: -1.5rem !important;
  }
  .pb-xl--4,
  .py-xl--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-xl--4,
  .px-xl--4 {
    padding-left: -1.5rem !important;
  }
  .p-xl--3 {
    padding: -1rem !important;
  }
  .pt-xl--3,
  .py-xl--3 {
    padding-top: -1rem !important;
  }
  .pr-xl--3,
  .px-xl--3 {
    padding-right: -1rem !important;
  }
  .pb-xl--3,
  .py-xl--3 {
    padding-bottom: -1rem !important;
  }
  .pl-xl--3,
  .px-xl--3 {
    padding-left: -1rem !important;
  }
  .p-xl--2 {
    padding: -0.5rem !important;
  }
  .pt-xl--2,
  .py-xl--2 {
    padding-top: -0.5rem !important;
  }
  .pr-xl--2,
  .px-xl--2 {
    padding-right: -0.5rem !important;
  }
  .pb-xl--2,
  .py-xl--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-xl--2,
  .px-xl--2 {
    padding-left: -0.5rem !important;
  }
  .p-xl--1 {
    padding: -0.25rem !important;
  }
  .pt-xl--1,
  .py-xl--1 {
    padding-top: -0.25rem !important;
  }
  .pr-xl--1,
  .px-xl--1 {
    padding-right: -0.25rem !important;
  }
  .pb-xl--1,
  .py-xl--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-xl--1,
  .px-xl--1 {
    padding-left: -0.25rem !important;
  }
  .p-xl-6 {
    padding: 4.5rem !important;
  }
  .pt-xl-6,
  .py-xl-6 {
    padding-top: 4.5rem !important;
  }
  .pr-xl-6,
  .px-xl-6 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-6,
  .py-xl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-xl-6,
  .px-xl-6 {
    padding-left: 4.5rem !important;
  }
  .p-xl-7 {
    padding: 6rem !important;
  }
  .pt-xl-7,
  .py-xl-7 {
    padding-top: 6rem !important;
  }
  .pr-xl-7,
  .px-xl-7 {
    padding-right: 6rem !important;
  }
  .pb-xl-7,
  .py-xl-7 {
    padding-bottom: 6rem !important;
  }
  .pl-xl-7,
  .px-xl-7 {
    padding-left: 6rem !important;
  }
  .p-xl-8 {
    padding: 8rem !important;
  }
  .pt-xl-8,
  .py-xl-8 {
    padding-top: 8rem !important;
  }
  .pr-xl-8,
  .px-xl-8 {
    padding-right: 8rem !important;
  }
  .pb-xl-8,
  .py-xl-8 {
    padding-bottom: 8rem !important;
  }
  .pl-xl-8,
  .px-xl-8 {
    padding-left: 8rem !important;
  }
  .p-xl-9 {
    padding: 10rem !important;
  }
  .pt-xl-9,
  .py-xl-9 {
    padding-top: 10rem !important;
  }
  .pr-xl-9,
  .px-xl-9 {
    padding-right: 10rem !important;
  }
  .pb-xl-9,
  .py-xl-9 {
    padding-bottom: 10rem !important;
  }
  .pl-xl-9,
  .px-xl-9 {
    padding-left: 10rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-n-9 {
    margin: 10rem !important;
  }
  .mt-xl-n-9,
  .my-xl-n-9 {
    margin-top: 10rem !important;
  }
  .mr-xl-n-9,
  .mx-xl-n-9 {
    margin-right: 10rem !important;
  }
  .mb-xl-n-9,
  .my-xl-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-xl-n-9,
  .mx-xl-n-9 {
    margin-left: 10rem !important;
  }
  .m-xl-n-8 {
    margin: 8rem !important;
  }
  .mt-xl-n-8,
  .my-xl-n-8 {
    margin-top: 8rem !important;
  }
  .mr-xl-n-8,
  .mx-xl-n-8 {
    margin-right: 8rem !important;
  }
  .mb-xl-n-8,
  .my-xl-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-xl-n-8,
  .mx-xl-n-8 {
    margin-left: 8rem !important;
  }
  .m-xl-n-7 {
    margin: 6rem !important;
  }
  .mt-xl-n-7,
  .my-xl-n-7 {
    margin-top: 6rem !important;
  }
  .mr-xl-n-7,
  .mx-xl-n-7 {
    margin-right: 6rem !important;
  }
  .mb-xl-n-7,
  .my-xl-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-xl-n-7,
  .mx-xl-n-7 {
    margin-left: 6rem !important;
  }
  .m-xl-n-6 {
    margin: 4.5rem !important;
  }
  .mt-xl-n-6,
  .my-xl-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-n-6,
  .mx-xl-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-n-6,
  .my-xl-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-n-6,
  .mx-xl-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-xl-n-5 {
    margin: 3rem !important;
  }
  .mt-xl-n-5,
  .my-xl-n-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-n-5,
  .mx-xl-n-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-n-5,
  .my-xl-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-n-5,
  .mx-xl-n-5 {
    margin-left: 3rem !important;
  }
  .m-xl-n-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-n-4,
  .my-xl-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-n-4,
  .mx-xl-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-n-4,
  .my-xl-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-n-4,
  .mx-xl-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-n-3 {
    margin: 1rem !important;
  }
  .mt-xl-n-3,
  .my-xl-n-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-n-3,
  .mx-xl-n-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-n-3,
  .my-xl-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-n-3,
  .mx-xl-n-3 {
    margin-left: 1rem !important;
  }
  .m-xl-n-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-n-2,
  .my-xl-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-n-2,
  .mx-xl-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-n-2,
  .my-xl-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-n-2,
  .mx-xl-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-n-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-n-1,
  .my-xl-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-n-1,
  .mx-xl-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-n-1,
  .my-xl-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-n-1,
  .mx-xl-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-n6 {
    margin: -4.5rem !important;
  }
  .mt-xl-n6,
  .my-xl-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-xl-n6,
  .mx-xl-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n6,
  .my-xl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl-n6,
  .mx-xl-n6 {
    margin-left: -4.5rem !important;
  }
  .m-xl-n7 {
    margin: -6rem !important;
  }
  .mt-xl-n7,
  .my-xl-n7 {
    margin-top: -6rem !important;
  }
  .mr-xl-n7,
  .mx-xl-n7 {
    margin-right: -6rem !important;
  }
  .mb-xl-n7,
  .my-xl-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-xl-n7,
  .mx-xl-n7 {
    margin-left: -6rem !important;
  }
  .m-xl-n8 {
    margin: -8rem !important;
  }
  .mt-xl-n8,
  .my-xl-n8 {
    margin-top: -8rem !important;
  }
  .mr-xl-n8,
  .mx-xl-n8 {
    margin-right: -8rem !important;
  }
  .mb-xl-n8,
  .my-xl-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-xl-n8,
  .mx-xl-n8 {
    margin-left: -8rem !important;
  }
  .m-xl-n9 {
    margin: -10rem !important;
  }
  .mt-xl-n9,
  .my-xl-n9 {
    margin-top: -10rem !important;
  }
  .mr-xl-n9,
  .mx-xl-n9 {
    margin-right: -10rem !important;
  }
  .mb-xl-n9,
  .my-xl-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-xl-n9,
  .mx-xl-n9 {
    margin-left: -10rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #5e72e4 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #233dd2 !important;
}

.text-secondary {
  color: #f7fafc !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #bfd7e7 !important;
}

.text-success {
  color: #2dce89 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #1f8f5f !important;
}

.text-info {
  color: #11cdef !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0b90a8 !important;
}

.text-warning {
  color: #fb6340 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #ea3005 !important;
}

.text-danger {
  color: #f5365c !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #d40b33 !important;
}

.text-light {
  color: #adb5bd !important;
}

a.text-light:hover, a.text-light:focus {
  color: #838f9b !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: black !important;
}

.text-default {
  color: #172b4d !important;
}

a.text-default:hover, a.text-default:focus {
  color: #050a12 !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover, a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-neutral {
  color: #fff !important;
}

a.text-neutral:hover, a.text-neutral:focus {
  color: #d9d9d9 !important;
}

.text-darker {
  color: black !important;
}

a.text-darker:hover, a.text-darker:focus {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #8898aa !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #e9ecef;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #e9ecef;
  }
}
iframe {
  border: 0;
}

figcaption,
figure,
main {
  display: block;
}

main {
  overflow: hidden;
}

.bg-blue {
  background-color: #5e72e4 !important;
}

a.bg-blue:hover, a.bg-blue:focus,
button.bg-blue:hover,
button.bg-blue:focus {
  background-color: #324cdd !important;
}

.bg-indigo {
  background-color: #5603ad !important;
}

a.bg-indigo:hover, a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  background-color: #3d027b !important;
}

.bg-purple {
  background-color: #8965e0 !important;
}

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  background-color: #683bd7 !important;
}

.bg-pink {
  background-color: #f3a4b5 !important;
}

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  background-color: #ed7790 !important;
}

.bg-red {
  background-color: #f5365c !important;
}

a.bg-red:hover, a.bg-red:focus,
button.bg-red:hover,
button.bg-red:focus {
  background-color: #ec0c38 !important;
}

.bg-orange {
  background-color: #fb6340 !important;
}

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  background-color: #fa3a0e !important;
}

.bg-yellow {
  background-color: #ffd600 !important;
}

a.bg-yellow:hover, a.bg-yellow:focus,
button.bg-yellow:hover,
button.bg-yellow:focus {
  background-color: #ccab00 !important;
}

.bg-green {
  background-color: #2dce89 !important;
}

a.bg-green:hover, a.bg-green:focus,
button.bg-green:hover,
button.bg-green:focus {
  background-color: #24a46d !important;
}

.bg-teal {
  background-color: #11cdef !important;
}

a.bg-teal:hover, a.bg-teal:focus,
button.bg-teal:hover,
button.bg-teal:focus {
  background-color: #0da5c0 !important;
}

.bg-cyan {
  background-color: #2bffc6 !important;
}

a.bg-cyan:hover, a.bg-cyan:focus,
button.bg-cyan:hover,
button.bg-cyan:focus {
  background-color: #00f7b5 !important;
}

.bg-white {
  background-color: #fff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-gray {
  background-color: #8898aa !important;
}

a.bg-gray:hover, a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  background-color: #6a7e95 !important;
}

.bg-gray-dark {
  background-color: #32325d !important;
}

a.bg-gray-dark:hover, a.bg-gray-dark:focus,
button.bg-gray-dark:hover,
button.bg-gray-dark:focus {
  background-color: #20203c !important;
}

.bg-light {
  background-color: #ced4da !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #b1bbc4 !important;
}

.bg-lighter {
  background-color: #e9ecef !important;
}

a.bg-lighter:hover, a.bg-lighter:focus,
button.bg-lighter:hover,
button.bg-lighter:focus {
  background-color: #cbd3da !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.bg-gradient-blue {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-indigo {
  background: linear-gradient(87deg, #5603ad 0, #9d03ad 100%) !important;
}

.bg-gradient-purple {
  background: linear-gradient(87deg, #8965e0 0, #bc65e0 100%) !important;
}

.bg-gradient-pink {
  background: linear-gradient(87deg, #f3a4b5 0, #f3b4a4 100%) !important;
}

.bg-gradient-red {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-orange {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-yellow {
  background: linear-gradient(87deg, #ffd600 0, #beff00 100%) !important;
}

.bg-gradient-green {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-teal {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-cyan {
  background: linear-gradient(87deg, #2bffc6 0, #2be0ff 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-gray {
  background: linear-gradient(87deg, #8898aa 0, #888aaa 100%) !important;
}

.bg-gradient-gray-dark {
  background: linear-gradient(87deg, #32325d 0, #44325d 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #ced4da 0, #cecfda 100%) !important;
}

.bg-gradient-lighter {
  background: linear-gradient(87deg, #e9ecef 0, #e9eaef 100%) !important;
}

.bg-translucent-primary {
  background-color: rgba(63, 87, 223, 0.6) !important;
}

a.bg-translucent-primary:hover, a.bg-translucent-primary:focus,
button.bg-translucent-primary:hover,
button.bg-translucent-primary:focus {
  background-color: rgba(42, 68, 219, 0.6) !important;
}

.bg-translucent-secondary {
  background-color: rgba(221, 234, 242, 0.6) !important;
}

a.bg-translucent-secondary:hover, a.bg-translucent-secondary:focus,
button.bg-translucent-secondary:hover,
button.bg-translucent-secondary:focus {
  background-color: rgba(202, 222, 235, 0.6) !important;
}

.bg-translucent-success {
  background-color: rgba(39, 177, 118, 0.6) !important;
}

a.bg-translucent-success:hover, a.bg-translucent-success:focus,
button.bg-translucent-success:hover,
button.bg-translucent-success:focus {
  background-color: rgba(34, 156, 104, 0.6) !important;
}

.bg-translucent-info {
  background-color: rgba(14, 177, 206, 0.6) !important;
}

a.bg-translucent-info:hover, a.bg-translucent-info:focus,
button.bg-translucent-info:hover,
button.bg-translucent-info:focus {
  background-color: rgba(12, 156, 183, 0.6) !important;
}

.bg-translucent-warning {
  background-color: rgba(250, 70, 29, 0.6) !important;
}

a.bg-translucent-warning:hover, a.bg-translucent-warning:focus,
button.bg-translucent-warning:hover,
button.bg-translucent-warning:focus {
  background-color: rgba(249, 51, 5, 0.6) !important;
}

.bg-translucent-danger {
  background-color: rgba(243, 20, 64, 0.6) !important;
}

a.bg-translucent-danger:hover, a.bg-translucent-danger:focus,
button.bg-translucent-danger:hover,
button.bg-translucent-danger:focus {
  background-color: rgba(227, 11, 54, 0.6) !important;
}

.bg-translucent-light {
  background-color: rgba(153, 163, 173, 0.6) !important;
}

a.bg-translucent-light:hover, a.bg-translucent-light:focus,
button.bg-translucent-light:hover,
button.bg-translucent-light:focus {
  background-color: rgba(139, 150, 162, 0.6) !important;
}

.bg-translucent-dark {
  background-color: rgba(17, 19, 21, 0.6) !important;
}

a.bg-translucent-dark:hover, a.bg-translucent-dark:focus,
button.bg-translucent-dark:hover,
button.bg-translucent-dark:focus {
  background-color: rgba(6, 6, 7, 0.6) !important;
}

.bg-translucent-default {
  background-color: rgba(15, 28, 50, 0.6) !important;
}

a.bg-translucent-default:hover, a.bg-translucent-default:focus,
button.bg-translucent-default:hover,
button.bg-translucent-default:focus {
  background-color: rgba(9, 17, 30, 0.6) !important;
}

.bg-translucent-white {
  background-color: rgba(237, 237, 237, 0.6) !important;
}

a.bg-translucent-white:hover, a.bg-translucent-white:focus,
button.bg-translucent-white:hover,
button.bg-translucent-white:focus {
  background-color: rgba(224, 224, 224, 0.6) !important;
}

.bg-translucent-neutral {
  background-color: rgba(237, 237, 237, 0.6) !important;
}

a.bg-translucent-neutral:hover, a.bg-translucent-neutral:focus,
button.bg-translucent-neutral:hover,
button.bg-translucent-neutral:focus {
  background-color: rgba(224, 224, 224, 0.6) !important;
}

.bg-translucent-darker {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

a.bg-translucent-darker:hover, a.bg-translucent-darker:focus,
button.bg-translucent-darker:hover,
button.bg-translucent-darker:focus {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.section-primary {
  background-color: #f8f9fe !important;
}

a.section-primary:hover, a.section-primary:focus,
button.section-primary:hover,
button.section-primary:focus {
  background-color: #cbd3f8 !important;
}

.section-secondary {
  background-color: #f7fafc !important;
}

a.section-secondary:hover, a.section-secondary:focus,
button.section-secondary:hover,
button.section-secondary:focus {
  background-color: #d2e3ee !important;
}

.section-light {
  background-color: #ced4da !important;
}

a.section-light:hover, a.section-light:focus,
button.section-light:hover,
button.section-light:focus {
  background-color: #b1bbc4 !important;
}

.section-dark {
  background-color: #212529 !important;
}

a.section-dark:hover, a.section-dark:focus,
button.section-dark:hover,
button.section-dark:focus {
  background-color: #0a0c0d !important;
}

.section-darker {
  background-color: black !important;
}

a.section-darker:hover, a.section-darker:focus,
button.section-darker:hover,
button.section-darker:focus {
  background-color: black !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.fill-primary {
  fill: #5e72e4;
}

.stroke-primary {
  stroke: #5e72e4;
}

.fill-secondary {
  fill: #f7fafc;
}

.stroke-secondary {
  stroke: #f7fafc;
}

.fill-success {
  fill: #2dce89;
}

.stroke-success {
  stroke: #2dce89;
}

.fill-info {
  fill: #11cdef;
}

.stroke-info {
  stroke: #11cdef;
}

.fill-warning {
  fill: #fb6340;
}

.stroke-warning {
  stroke: #fb6340;
}

.fill-danger {
  fill: #f5365c;
}

.stroke-danger {
  stroke: #f5365c;
}

.fill-light {
  fill: #adb5bd;
}

.stroke-light {
  stroke: #adb5bd;
}

.fill-dark {
  fill: #212529;
}

.stroke-dark {
  stroke: #212529;
}

.fill-default {
  fill: #172b4d;
}

.stroke-default {
  stroke: #172b4d;
}

.fill-white {
  fill: #fff;
}

.stroke-white {
  stroke: #fff;
}

.fill-neutral {
  fill: #fff;
}

.stroke-neutral {
  stroke: #fff;
}

.fill-darker {
  fill: black;
}

.stroke-darker {
  stroke: black;
}

.fill-opacity-8 {
  fill-opacity: 0.8;
}

.floating {
  animation: floating 3s ease infinite;
  will-change: transform;
}
.floating:hover {
  animation-play-state: paused;
}

.floating-lg {
  animation: floating-lg 3s ease infinite;
}

.floating-sm {
  animation: floating-sm 3s ease infinite;
}

@keyframes floating-lg {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(15px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating-sm {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.floatfix:before, .floatfix:after {
  content: "";
  display: table;
}
.floatfix:after {
  clear: both;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-8 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-1 {
  top: 0.25rem;
}

.right-1 {
  right: 0.25rem;
}

.bottom-1 {
  bottom: 0.25rem;
}

.left-1 {
  left: 0.25rem;
}

.top-2 {
  top: 0.5rem;
}

.right-2 {
  right: 0.5rem;
}

.bottom-2 {
  bottom: 0.5rem;
}

.left-2 {
  left: 0.5rem;
}

.top-3 {
  top: 1rem;
}

.right-3 {
  right: 1rem;
}

.bottom-3 {
  bottom: 1rem;
}

.left-3 {
  left: 1rem;
}

.top-4 {
  top: 1.5rem;
}

.right-4 {
  right: 1.5rem;
}

.bottom-4 {
  bottom: 1.5rem;
}

.left-4 {
  left: 1.5rem;
}

.top-5 {
  top: 3rem;
}

.right-5 {
  right: 3rem;
}

.bottom-5 {
  bottom: 3rem;
}

.left-5 {
  left: 3rem;
}

.top--9 {
  top: -10rem;
}

.right--9 {
  right: -10rem;
}

.bottom--9 {
  bottom: -10rem;
}

.left--9 {
  left: -10rem;
}

.top--8 {
  top: -8rem;
}

.right--8 {
  right: -8rem;
}

.bottom--8 {
  bottom: -8rem;
}

.left--8 {
  left: -8rem;
}

.top--7 {
  top: -6rem;
}

.right--7 {
  right: -6rem;
}

.bottom--7 {
  bottom: -6rem;
}

.left--7 {
  left: -6rem;
}

.top--6 {
  top: -4.5rem;
}

.right--6 {
  right: -4.5rem;
}

.bottom--6 {
  bottom: -4.5rem;
}

.left--6 {
  left: -4.5rem;
}

.top--5 {
  top: -3rem;
}

.right--5 {
  right: -3rem;
}

.bottom--5 {
  bottom: -3rem;
}

.left--5 {
  left: -3rem;
}

.top--4 {
  top: -1.5rem;
}

.right--4 {
  right: -1.5rem;
}

.bottom--4 {
  bottom: -1.5rem;
}

.left--4 {
  left: -1.5rem;
}

.top--3 {
  top: -1rem;
}

.right--3 {
  right: -1rem;
}

.bottom--3 {
  bottom: -1rem;
}

.left--3 {
  left: -1rem;
}

.top--2 {
  top: -0.5rem;
}

.right--2 {
  right: -0.5rem;
}

.bottom--2 {
  bottom: -0.5rem;
}

.left--2 {
  left: -0.5rem;
}

.top--1 {
  top: -0.25rem;
}

.right--1 {
  right: -0.25rem;
}

.bottom--1 {
  bottom: -0.25rem;
}

.left--1 {
  left: -0.25rem;
}

.top-6 {
  top: 4.5rem;
}

.right-6 {
  right: 4.5rem;
}

.bottom-6 {
  bottom: 4.5rem;
}

.left-6 {
  left: 4.5rem;
}

.top-7 {
  top: 6rem;
}

.right-7 {
  right: 6rem;
}

.bottom-7 {
  bottom: 6rem;
}

.left-7 {
  left: 6rem;
}

.top-8 {
  top: 8rem;
}

.right-8 {
  right: 8rem;
}

.bottom-8 {
  bottom: 8rem;
}

.left-8 {
  left: 8rem;
}

.top-9 {
  top: 10rem;
}

.right-9 {
  right: 10rem;
}

.bottom-9 {
  bottom: 10rem;
}

.left-9 {
  left: 10rem;
}

.center {
  left: 50%;
  transform: translateX(-50%);
}

.h-100vh {
  height: 100vh !important;
}

.row.row-grid > [class*=col-] + [class*=col-] {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .row.row-grid > [class*=col-lg-] + [class*=col-lg-] {
    margin-top: 0;
  }
}
@media (min-width: 768px) {
  .row.row-grid > [class*=col-md-] + [class*=col-md-] {
    margin-top: 0;
  }
}
@media (min-width: 576px) {
  .row.row-grid > [class*=col-sm-] + [class*=col-sm-] {
    margin-top: 0;
  }
}
.row-grid + .row-grid {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .mt--100 {
    margin-top: -100px !important;
  }
  .mr--100 {
    margin-right: -100px !important;
  }
  .mb--100 {
    margin-bottom: -100px !important;
  }
  .ml--100 {
    margin-left: -100px !important;
  }
  .mt--150 {
    margin-top: -150px !important;
  }
  .mb--150 {
    margin-bottom: -150px !important;
  }
  .mt--200 {
    margin-top: -200px !important;
  }
  .mb--200 {
    margin-bottom: -200px !important;
  }
  .mt--300 {
    margin-top: -300px !important;
  }
  .mb--300 {
    margin-bottom: -300px !important;
  }
  .pt-100 {
    padding-top: 100px !important;
  }
  .pb-100 {
    padding-bottom: 100px !important;
  }
  .pt-150 {
    padding-top: 150px !important;
  }
  .pb-150 {
    padding-bottom: 150px !important;
  }
  .pt-200 {
    padding-top: 200px !important;
  }
  .pb-200 {
    padding-bottom: 200px !important;
  }
  .pt-250 {
    padding-top: 250px !important;
  }
  .pb-250 {
    padding-bottom: 250px !important;
  }
  .pt-300 {
    padding-top: 300px !important;
  }
  .pb-300 {
    padding-bottom: 300px !important;
  }
}
[class*=shadow] {
  transition: all 0.15s ease;
}

.shadow-sm--hover:hover {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow--hover:hover {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg--hover:hover {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none--hover:hover {
  box-shadow: none !important;
}

.font-weight-300 {
  font-weight: 300 !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.text-underline {
  text-decoration: underline;
}

.text-through {
  text-decoration: line-through;
}

.text-xs {
  font-size: 0.75rem !important;
}

.text-sm {
  font-size: 0.875rem !important;
}

.text-lg {
  font-size: 1.25rem !important;
}

.text-xl {
  font-size: 1.5rem !important;
}

.lh-100 {
  line-height: 1;
}

.lh-110 {
  line-height: 1.1;
}

.lh-120 {
  line-height: 1.2;
}

.lh-130 {
  line-height: 1.3;
}

.lh-140 {
  line-height: 1.4;
}

.lh-150 {
  line-height: 1.5;
}

.lh-160 {
  line-height: 1.6;
}

.lh-170 {
  line-height: 1.7;
}

.lh-180 {
  line-height: 1.8;
}

.ls-1 {
  letter-spacing: 0.0625rem;
}

.ls-15 {
  letter-spacing: 0.09375rem;
}

.ls-2 {
  letter-spacing: 0.125rem;
}

.text-blue {
  color: #5e72e4 !important;
}

a.text-blue:hover, a.text-blue:focus {
  color: #233dd2 !important;
}

.text-indigo {
  color: #5603ad !important;
}

a.text-indigo:hover, a.text-indigo:focus {
  color: #310262 !important;
}

.text-purple {
  color: #8965e0 !important;
}

a.text-purple:hover, a.text-purple:focus {
  color: #5a2acf !important;
}

.text-pink {
  color: #f3a4b5 !important;
}

a.text-pink:hover, a.text-pink:focus {
  color: #ea607e !important;
}

.text-red {
  color: #f5365c !important;
}

a.text-red:hover, a.text-red:focus {
  color: #d40b33 !important;
}

.text-orange {
  color: #fb6340 !important;
}

a.text-orange:hover, a.text-orange:focus {
  color: #ea3005 !important;
}

.text-yellow {
  color: #ffd600 !important;
}

a.text-yellow:hover, a.text-yellow:focus {
  color: #b39600 !important;
}

.text-green {
  color: #2dce89 !important;
}

a.text-green:hover, a.text-green:focus {
  color: #1f8f5f !important;
}

.text-teal {
  color: #11cdef !important;
}

a.text-teal:hover, a.text-teal:focus {
  color: #0b90a8 !important;
}

.text-cyan {
  color: #2bffc6 !important;
}

a.text-cyan:hover, a.text-cyan:focus {
  color: #00dea2 !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover, a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-gray {
  color: #8898aa !important;
}

a.text-gray:hover, a.text-gray:focus {
  color: #607286 !important;
}

.text-gray-dark {
  color: #32325d !important;
}

a.text-gray-dark:hover, a.text-gray-dark:focus {
  color: #17172b !important;
}

.text-light {
  color: #ced4da !important;
}

a.text-light:hover, a.text-light:focus {
  color: #a2aeb9 !important;
}

.text-lighter {
  color: #e9ecef !important;
}

a.text-lighter:hover, a.text-lighter:focus {
  color: #bdc6cf !important;
}

@media (min-width: 992px) {
  .transform-perspective-right {
    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);
  }
  .transform-perspective-left {
    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);
  }
}
.alert {
  font-size: 0.875rem;
}

.alert-heading {
  font-weight: 600;
  font-size: 0.9375rem;
  margin-top: 0.15rem;
}

.alert-icon {
  font-size: 1.25rem;
  margin-right: 1.25rem;
  display: inline-block;
  vertical-align: middle;
}
.alert-icon i.ni {
  position: relative;
  top: 1px;
}

.alert-text {
  display: inline-block;
  vertical-align: middle;
}

[class*=alert-] .alert-link {
  color: #fff;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);
}

.alert-dismissible .close {
  top: 50%;
  right: 1.5rem;
  padding: 0;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}
.alert-dismissible .close:hover, .alert-dismissible .close:focus {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1 !important;
}
@media (max-width: 575.98px) {
  .alert-dismissible .close {
    top: 1rem;
    right: 0.5rem;
  }
}
.alert-dismissible .close > span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}
.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.9);
}

.avatar {
  color: #fff;
  background-color: #adb5bd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  border-radius: 50%;
  height: 48px;
  width: 48px;
}
.avatar img {
  width: 100%;
  border-radius: 50%;
}
.avatar + .avatar-content {
  display: inline-block;
  margin-left: 0.75rem;
}

.avatar-lg {
  width: 58px;
  height: 58px;
  font-size: 0.875rem;
}

.avatar-sm {
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.avatar-group .avatar {
  position: relative;
  z-index: 2;
  border: 2px solid #fff;
}
.avatar-group .avatar:hover {
  z-index: 3;
}
.avatar-group .avatar + .avatar {
  margin-left: -1rem;
}

.badge {
  text-transform: uppercase;
}
.badge a {
  color: #fff;
}

.badge-md {
  padding: 0.65em 1em;
}

.badge-lg {
  padding: 0.85em 1.375em;
}

.badge-inline {
  margin-right: 0.625rem;
}
.badge-inline + span {
  top: 2px;
  position: relative;
}
.badge-inline + span > a {
  text-decoration: underline;
}

.btn .badge:not(:first-child) {
  margin-left: 0.5rem;
}
.btn .badge:not(:last-child) {
  margin-right: 0.5rem;
}

.badge-circle {
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  font-size: 0.875rem;
}

.badge-dot {
  padding-left: 0;
  padding-right: 0;
  background: transparent;
  font-weight: 400;
  font-size: 0.875rem;
  text-transform: none;
}
.badge-dot strong {
  color: #32325d;
}
.badge-dot i {
  display: inline-block;
  vertical-align: middle;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  margin-right: 0.375rem;
}
.badge-dot.badge-md i {
  width: 0.5rem;
  height: 0.5rem;
}
.badge-dot.badge-lg i {
  width: 0.625rem;
  height: 0.625rem;
}

.btn {
  position: relative;
  text-transform: none;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  font-size: 0.875rem;
  will-change: transform;
}
.btn:hover {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.btn:not(:last-child) {
  margin-right: 0.5rem;
}
.btn i:not(:first-child),
.btn svg:not(:first-child) {
  margin-left: 0.5rem;
}
.btn i:not(:last-child),
.btn svg:not(:last-child) {
  margin-right: 0.5rem;
}

.btn-group .btn,
.input-group .btn {
  margin-right: 0;
  transform: translateY(0);
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 0.75rem;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
}

[class*=btn-outline-] {
  border-width: 1px;
}

.btn-outline-secondary {
  color: #4385b1;
}

.btn-inner--icon i:not(.fa) {
  position: relative;
  top: 2px;
}

.btn-link {
  font-weight: 600;
  box-shadow: none;
}
.btn-link:hover {
  box-shadow: none;
  transform: none;
}

.btn-neutral {
  color: #5e72e4;
}

.btn-icon .btn-inner--icon img {
  width: 20px;
}
.btn-icon .btn-inner--text:not(:first-child) {
  margin-left: 0.75em;
}
.btn-icon .btn-inner--text:not(:last-child) {
  margin-right: 0.75em;
}

.btn-icon-only {
  width: 2.375rem;
  height: 2.375rem;
  padding: 0;
}

a.btn-icon-only {
  line-height: 2.5;
}

.btn-icon-only.btn-sm, .btn-group-sm > .btn-icon-only.btn {
  width: 2rem;
  height: 2rem;
}

.btn-icon-clipboard {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}
.btn-icon-clipboard:hover {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
}
.btn-icon-clipboard > div {
  align-items: center;
  display: flex;
}
.btn-icon-clipboard i {
  box-sizing: content-box;
  color: #5e72e4;
  vertical-align: middle;
  font-size: 1.5rem;
}
.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.btn-facebook {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-facebook:hover {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}
.btn-facebook:focus, .btn-facebook.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 89, 153, 0.5);
}
.btn-facebook.disabled, .btn-facebook:disabled {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}
.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {
  color: #fff;
  background-color: #2d4474;
  border-color: #3b5999;
}
.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);
}

.btn-twitter {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-twitter:hover {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}
.btn-twitter:focus, .btn-twitter.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(29, 161, 242, 0.5);
}
.btn-twitter.disabled, .btn-twitter:disabled {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}
.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {
  color: #fff;
  background-color: #0c85d0;
  border-color: #1da1f2;
}
.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);
}

.btn-google-plus {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-google-plus:hover {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google-plus:focus, .btn-google-plus.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(221, 75, 57, 0.5);
}
.btn-google-plus.disabled, .btn-google-plus:disabled {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google-plus:not(:disabled):not(.disabled):active, .btn-google-plus:not(:disabled):not(.disabled).active, .show > .btn-google-plus.dropdown-toggle {
  color: #fff;
  background-color: #c23321;
  border-color: #dd4b39;
}
.btn-google-plus:not(:disabled):not(.disabled):active:focus, .btn-google-plus:not(:disabled):not(.disabled).active:focus, .show > .btn-google-plus.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);
}

.btn-instagram {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-instagram:hover {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}
.btn-instagram:focus, .btn-instagram.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(228, 64, 95, 0.5);
}
.btn-instagram.disabled, .btn-instagram:disabled {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}
.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {
  color: #fff;
  background-color: #d31e40;
  border-color: #e4405f;
}
.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);
}

.btn-pinterest {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-pinterest:hover {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}
.btn-pinterest:focus, .btn-pinterest.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(189, 8, 28, 0.5);
}
.btn-pinterest.disabled, .btn-pinterest:disabled {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}
.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {
  color: #fff;
  background-color: #8c0615;
  border-color: #bd081c;
}
.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);
}

.btn-youtube {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-youtube:hover {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}
.btn-youtube:focus, .btn-youtube.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(205, 32, 31, 0.5);
}
.btn-youtube.disabled, .btn-youtube:disabled {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}
.btn-youtube:not(:disabled):not(.disabled):active, .btn-youtube:not(:disabled):not(.disabled).active, .show > .btn-youtube.dropdown-toggle {
  color: #fff;
  background-color: #a11918;
  border-color: #cd201f;
}
.btn-youtube:not(:disabled):not(.disabled):active:focus, .btn-youtube:not(:disabled):not(.disabled).active:focus, .show > .btn-youtube.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);
}

.btn-slack {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-slack:hover {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}
.btn-slack:focus, .btn-slack.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 175, 133, 0.5);
}
.btn-slack.disabled, .btn-slack:disabled {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}
.btn-slack:not(:disabled):not(.disabled):active, .btn-slack:not(:disabled):not(.disabled).active, .show > .btn-slack.dropdown-toggle {
  color: #fff;
  background-color: #2d8968;
  border-color: #3aaf85;
}
.btn-slack:not(:disabled):not(.disabled):active:focus, .btn-slack:not(:disabled):not(.disabled).active:focus, .show > .btn-slack.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);
}

.btn-dribbble {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dribbble:hover {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-dribbble:focus, .btn-dribbble.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(234, 76, 137, 0.5);
}
.btn-dribbble.disabled, .btn-dribbble:disabled {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-dribbble:not(:disabled):not(.disabled):active, .btn-dribbble:not(:disabled):not(.disabled).active, .show > .btn-dribbble.dropdown-toggle {
  color: #fff;
  background-color: #e51e6b;
  border-color: #ea4c89;
}
.btn-dribbble:not(:disabled):not(.disabled):active:focus, .btn-dribbble:not(:disabled):not(.disabled).active:focus, .show > .btn-dribbble.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);
}

.btn-github {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-github:hover {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}
.btn-github:focus, .btn-github.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(34, 34, 34, 0.5);
}
.btn-github.disabled, .btn-github:disabled {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}
.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {
  color: #fff;
  background-color: #090909;
  border-color: #222222;
}
.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);
}

.card-translucent {
  background-color: rgba(18, 91, 152, 0.08);
}

.card-profile-image {
  position: relative;
}
.card-profile-image img {
  max-width: 180px;
  border-radius: 0.375rem;
  transform: translate(-50%, -30%);
  position: absolute;
  left: 50%;
  transition: all 0.15s ease;
}
.card-profile-image img:hover {
  transform: translate(-50%, -33%);
}

.card-profile-stats {
  padding: 1rem 0;
}
.card-profile-stats > div {
  text-align: center;
  margin-right: 1rem;
  padding: 0.875rem;
}
.card-profile-stats > div:last-child {
  margin-right: 0;
}
.card-profile-stats > div .heading {
  font-size: 1.1rem;
  font-weight: bold;
  display: block;
}
.card-profile-stats > div .description {
  font-size: 0.875rem;
  color: #adb5bd;
}

.card-profile-actions {
  padding: 0.875rem;
}

.card-lift--hover:hover {
  transform: translateY(-20px);
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .card-lift--hover:hover {
    transition: none;
  }
}

.card-stats .card-body {
  padding: 1rem 1.5rem;
}
.card-stats .card-status-bullet {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.chart {
  position: relative;
  height: 350px;
}

.chart-sm {
  height: 230px;
}

.chart-legend {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  font-size: 0.875rem;
  text-align: center;
  color: #8898aa;
}

.chart-legend-item {
  display: inline-flex;
  align-items: center;
}
.chart-legend-item + .chart-legend-item {
  margin-left: 1rem;
}

.chart-legend-indicator {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.375rem;
  border-radius: 50%;
}

#chart-tooltip {
  z-index: 0;
}
#chart-tooltip .arrow {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateX(-0.5rem);
}

.chart-info-overlay {
  position: absolute;
  top: 0;
  left: 5%;
  max-width: 350px;
  padding: 20px;
  z-index: 1;
}

.close {
  transition: all 0.15s ease;
}
.close > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  font-size: 1.25rem;
  display: block;
  transition: all 0.15s ease;
}
.close:hover, .close:focus {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.9);
  outline: none;
}
.close:hover span:not(.sr-only), .close:focus span:not(.sr-only) {
  background-color: transparent;
}

.main-content {
  position: relative;
}
.main-content .navbar-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
@media (min-width: 768px) {
  .main-content .container-fluid, .main-content .container-sm, .main-content .container-md, .main-content .container-lg, .main-content .container-xl {
    padding-left: 39px !important;
    padding-right: 39px !important;
  }
}

.navbar-vertical.navbar-expand-xs.fixed-left + .main-content {
  margin-left: 250px;
}
.navbar-vertical.navbar-expand-xs.fixed-right + .main-content {
  margin-right: 250px;
}
@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-sm.fixed-right + .main-content {
    margin-right: 250px;
  }
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-md.fixed-right + .main-content {
    margin-right: 250px;
  }
}
@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-lg.fixed-right + .main-content {
    margin-right: 250px;
  }
}
@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-xl.fixed-right + .main-content {
    margin-right: 250px;
  }
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5e72e4;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-control-label::before {
  border: 1px solid #cad1d7;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.custom-control-label span {
  position: relative;
  top: 2px;
}

.custom-control-label {
  margin-bottom: 0;
}

.custom-control-alternative .custom-control-label::before {
  border: 0;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}
.custom-control-alternative .custom-control-input:checked ~ .custom-control-label::before {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.custom-control-alternative .custom-control-input:active ~ .custom-control-label::before, .custom-control-alternative .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5e72e4;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-radio .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5e72e4;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-radio .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 1.5rem;
}
.custom-toggle input {
  display: none;
}
.custom-toggle input:checked + .custom-toggle-slider {
  border: 1px solid #5e72e4;
}
.custom-toggle input:checked + .custom-toggle-slider:before {
  background: #5e72e4;
  transform: translateX(1.625rem);
}
.custom-toggle input:disabled + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider:before {
  background-color: #8a98eb;
}

.custom-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #cad1d7;
  border-radius: 34px !important;
  background-color: transparent;
}
.custom-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  border-radius: 50% !important;
  background-color: #e9ecef;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.dropdown,
.dropup,
.dropright,
.dropleft {
  display: inline-block;
}

.dropdown-menu {
  min-width: 12rem;
}
.dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}
.dropdown-menu .dropdown-item > i,
.dropdown-menu .dropdown-item > svg {
  margin-right: 1rem;
  font-size: 1rem;
  vertical-align: -17%;
}

.dropdown-header {
  padding-left: 1rem;
  padding-right: 1rem;
  color: #f6f9fc;
  font-size: 0.625rem;
  text-transform: uppercase;
  font-weight: 700;
}

.dropdown-menu a.media > div:first-child {
  line-height: 1;
}
.dropdown-menu a.media p {
  color: #8898aa;
}
.dropdown-menu a.media:hover .heading,
.dropdown-menu a.media:hover p {
  color: #172b4d !important;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4375rem;
}

.dropdown-menu-lg {
  min-width: 260px;
  border-radius: 0.4375rem;
}

.dropdown-menu-xl {
  min-width: 450px;
  border-radius: 0.4375rem;
}

.footer {
  background: #f7fafc;
  padding: 2.5rem 0;
}
.footer .col-footer .heading {
  color: #8898aa;
  letter-spacing: 0;
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 1rem;
}
.footer .nav .nav-item .nav-link,
.footer .footer-link {
  color: #8898aa !important;
}
.footer .nav .nav-item .nav-link:hover,
.footer .footer-link:hover {
  color: #525f7f !important;
}
.footer .list-unstyled li a {
  display: inline-block;
  padding: 0.125rem 0;
  color: #8898aa;
  font-size: 0.85rem;
}
.footer .list-unstyled li a:hover {
  color: #525f7f;
}
.footer .copyright {
  font-size: 0.875rem;
}

.footer-dark .col-footer .heading {
  color: #fff;
}

.nav-footer .nav-link {
  font-size: 0.875rem;
}
.nav-footer .nav-item:last-child .nav-link {
  padding-right: 0;
}

.footer.has-cards {
  overflow: hidden;
  padding-top: 500px;
  margin-top: -420px;
  position: relative;
  background: transparent;
  pointer-events: none;
}
.footer.has-cards:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 600px;
  height: 2000px;
  background: #f7fafc;
  transform: skew(0, -8deg);
}
.footer.has-cards .container {
  pointer-events: auto;
  position: relative;
}

.form-control-label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}

.form-control {
  font-size: 0.875rem;
}
.form-control:focus::placeholder {
  color: #adb5bd;
}

textarea[resize=none] {
  resize: none !important;
}

textarea[resize=both] {
  resize: both !important;
}

textarea[resize=vertical] {
  resize: vertical !important;
}

textarea[resize=horizontal] {
  resize: horizontal !important;
}

.form-control-muted {
  background-color: #F7FAFE;
  border-color: #F7FAFE;
  box-shadow: none;
}
.form-control-muted:focus {
  background-color: #fcfdff;
}

.form-control-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.form-control-alternative:focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.form-control-lg {
  font-size: 1rem;
}

.has-success,
.has-danger {
  position: relative;
}
.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 2px;
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.has-success:after {
  content: "\\ea26";
  color: daken(#2dce89, 18%);
  background-color: #69deac;
}
.has-success .form-control {
  background-color: #fff;
}
.has-success .form-control:focus {
  border-color: rgba(50, 151, 211, 0.25);
}
.has-success .form-control::placeholder {
  color: #2dce89;
}

.has-danger:after {
  content: "\\ea53";
  color: daken(#fb6340, 18%);
  background-color: #fda08b;
}
.has-danger .form-control {
  background-color: #fff;
}
.has-danger .form-control:focus {
  border-color: rgba(50, 151, 211, 0.25);
}
.has-danger .form-control::placeholder {
  color: #fb6340;
}

.input-group {
  box-shadow: none;
  border-radius: 0.375rem;
  transition: all 0.15s ease;
}
.input-group .form-control {
  box-shadow: none;
}
.input-group .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}
.input-group .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.focused .input-group {
  box-shadow: none;
}
.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
}
.focused .form-control {
  border-color: rgba(50, 151, 211, 0.25);
}

.header {
  position: relative;
}

.icon {
  width: 3rem;
  height: 3rem;
}
.icon i, .icon svg {
  font-size: 2.25rem;
}
.icon + .icon-text {
  padding-left: 1rem;
  width: calc(100% - 3rem - 1);
}

.icon-xl {
  width: 5rem;
  height: 5rem;
}
.icon-xl i, .icon-xl svg {
  font-size: 4.25rem;
}
.icon-xl + .icon-text {
  width: calc(100% - 5rem - 1);
}

.icon-lg {
  width: 4rem;
  height: 4rem;
}
.icon-lg i, .icon-lg svg {
  font-size: 3.25rem;
}
.icon-lg + .icon-text {
  width: calc(100% - 4rem - 1);
}

.icon-sm {
  width: 2rem;
  height: 2rem;
}
.icon-sm i, .icon-sm svg {
  font-size: 1.25rem;
}
.icon-sm + .icon-text {
  width: calc(100% - 2rem - 1);
}

.icon-shape {
  padding: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.icon-shape i, .icon-shape svg {
  font-size: 1.25rem;
}
.icon-shape.icon-lg i, .icon-shape.icon-lg svg {
  font-size: 1.625rem;
}
.icon-shape.icon-sm i, .icon-shape.icon-sm svg {
  font-size: 0.875rem;
}
.icon-shape svg {
  width: 30px;
  height: 30px;
}

.icon-shape-primary {
  color: #2643e9;
  background-color: rgba(138, 152, 235, 0.5);
}

.icon-shape-secondary {
  color: #cfe3f1;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-success {
  color: #1aae6f;
  background-color: rgba(84, 218, 161, 0.5);
}

.icon-shape-info {
  color: #03acca;
  background-color: rgba(65, 215, 242, 0.5);
}

.icon-shape-warning {
  color: #ff3709;
  background-color: rgba(252, 140, 114, 0.5);
}

.icon-shape-danger {
  color: #f80031;
  background-color: rgba(247, 103, 131, 0.5);
}

.icon-shape-light {
  color: #879cb0;
  background-color: rgba(201, 207, 212, 0.5);
}

.icon-shape-dark {
  color: #090c0e;
  background-color: rgba(56, 63, 69, 0.5);
}

.icon-shape-default {
  color: #091428;
  background-color: rgba(35, 65, 116, 0.5);
}

.icon-shape-white {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-neutral {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-darker {
  color: black;
  background-color: rgba(23, 26, 28, 0.5);
}

.input-group {
  box-shadow: none;
  border-radius: 0.375rem;
  transition: all 0.15s ease;
}
.input-group .form-control {
  box-shadow: none;
}
.input-group .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}
.input-group .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.focused .input-group {
  box-shadow: none;
}
.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
}
.focused .form-control {
  border-color: rgba(50, 151, 211, 0.25);
}

.list-group-space .list-group-item {
  margin-bottom: 1.5rem;
  border-radius: 0.375rem;
}

.list-group-img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  vertical-align: top;
  margin: -0.1rem 1.2rem 0 -0.2rem;
}

.list-group-content {
  flex: 1 1;
  min-width: 0;
}
.list-group-content > p {
  color: #adb5bd;
  line-height: 1.5;
  margin: 0.2rem 0 0;
}

.list-group-heading {
  font-size: 1rem;
  color: #32325d;
}
.list-group-heading > small {
  float: right;
  color: #adb5bd;
  font-weight: 500;
}

.map-canvas {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 0.375rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .mask {
    transition: none;
  }
}

.modal-fluid .modal-dialog {
  margin-top: 0;
  margin-bottom: 0;
}
.modal-fluid .modal-content {
  border-radius: 0;
}

.modal-primary .modal-title {
  color: #fff;
}
.modal-primary .modal-header,
.modal-primary .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-primary .modal-content {
  background-color: #5e72e4;
  color: #fff;
}
.modal-primary .modal-content .heading {
  color: #fff;
}
.modal-primary .close > span:not(.sr-only) {
  color: #fff;
}

.modal-secondary .modal-title {
  color: #212529;
}
.modal-secondary .modal-header,
.modal-secondary .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-secondary .modal-content {
  background-color: #f7fafc;
  color: #212529;
}
.modal-secondary .modal-content .heading {
  color: #212529;
}
.modal-secondary .close > span:not(.sr-only) {
  color: #fff;
}

.modal-success .modal-title {
  color: #fff;
}
.modal-success .modal-header,
.modal-success .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-success .modal-content {
  background-color: #2dce89;
  color: #fff;
}
.modal-success .modal-content .heading {
  color: #fff;
}
.modal-success .close > span:not(.sr-only) {
  color: #fff;
}

.modal-info .modal-title {
  color: #fff;
}
.modal-info .modal-header,
.modal-info .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-info .modal-content {
  background-color: #11cdef;
  color: #fff;
}
.modal-info .modal-content .heading {
  color: #fff;
}
.modal-info .close > span:not(.sr-only) {
  color: #fff;
}

.modal-warning .modal-title {
  color: #fff;
}
.modal-warning .modal-header,
.modal-warning .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-warning .modal-content {
  background-color: #fb6340;
  color: #fff;
}
.modal-warning .modal-content .heading {
  color: #fff;
}
.modal-warning .close > span:not(.sr-only) {
  color: #fff;
}

.modal-danger .modal-title {
  color: #fff;
}
.modal-danger .modal-header,
.modal-danger .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-danger .modal-content {
  background-color: #f5365c;
  color: #fff;
}
.modal-danger .modal-content .heading {
  color: #fff;
}
.modal-danger .close > span:not(.sr-only) {
  color: #fff;
}

.modal-light .modal-title {
  color: #fff;
}
.modal-light .modal-header,
.modal-light .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-light .modal-content {
  background-color: #adb5bd;
  color: #fff;
}
.modal-light .modal-content .heading {
  color: #fff;
}
.modal-light .close > span:not(.sr-only) {
  color: #fff;
}

.modal-dark .modal-title {
  color: #fff;
}
.modal-dark .modal-header,
.modal-dark .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-dark .modal-content {
  background-color: #212529;
  color: #fff;
}
.modal-dark .modal-content .heading {
  color: #fff;
}
.modal-dark .close > span:not(.sr-only) {
  color: #fff;
}

.modal-default .modal-title {
  color: #fff;
}
.modal-default .modal-header,
.modal-default .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-default .modal-content {
  background-color: #172b4d;
  color: #fff;
}
.modal-default .modal-content .heading {
  color: #fff;
}
.modal-default .close > span:not(.sr-only) {
  color: #fff;
}

.modal-white .modal-title {
  color: #212529;
}
.modal-white .modal-header,
.modal-white .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-white .modal-content {
  background-color: #fff;
  color: #212529;
}
.modal-white .modal-content .heading {
  color: #212529;
}
.modal-white .close > span:not(.sr-only) {
  color: #fff;
}

.modal-neutral .modal-title {
  color: #212529;
}
.modal-neutral .modal-header,
.modal-neutral .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-neutral .modal-content {
  background-color: #fff;
  color: #212529;
}
.modal-neutral .modal-content .heading {
  color: #212529;
}
.modal-neutral .close > span:not(.sr-only) {
  color: #fff;
}

.modal-darker .modal-title {
  color: #fff;
}
.modal-darker .modal-header,
.modal-darker .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-darker .modal-content {
  background-color: black;
  color: #fff;
}
.modal-darker .modal-content .heading {
  color: #fff;
}
.modal-darker .close > span:not(.sr-only) {
  color: #fff;
}

.nav-wrapper {
  padding: 1rem 0;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.nav-wrapper + .card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.nav-link {
  color: #525f7f;
}
.nav-link:hover {
  color: #5e72e4;
}
.nav-link i.ni {
  position: relative;
  top: 2px;
}

@media (min-width: 992px) {
  .nav-item.active-pro {
    position: absolute;
    width: 100%;
    bottom: 10px;
    background: #f6f9fc;
  }
}
.nav-pills .nav-item:not(:last-child) {
  padding-right: 1rem;
}
.nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #5e72e4;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  transition: all 0.15s ease;
}
.nav-pills .nav-link:hover {
  color: #485fe0;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #5e72e4;
}
@media (max-width: 575.98px) {
  .nav-pills .nav-item {
    margin-bottom: 1rem;
  }
}

@media (max-width: 767.98px) {
  .nav-pills:not(.nav-pills-circle) .nav-item {
    padding-right: 0;
  }
}
.nav-pills-circle .nav-link {
  text-align: center;
  height: 60px;
  width: 60px;
  padding: 0;
  line-height: 60px;
  border-radius: 50%;
}
.nav-pills-circle .nav-link-icon i, .nav-pills-circle .nav-link-icon svg {
  font-size: 1rem;
}

.navbar-horizontal .navbar-nav .nav-link {
  font-size: 0.9rem;
  font-weight: 400;
  text-transform: normal;
  letter-spacing: 0;
  transition: all 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-horizontal .navbar-nav .nav-link {
    transition: none;
  }
}
.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {
  margin-left: 0.25rem;
}
.navbar-horizontal .navbar-brand {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.05px;
}
.navbar-horizontal .navbar-brand img {
  height: 30px;
}
.navbar-horizontal .navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-horizontal .navbar-light .navbar-brand {
  color: #32325d;
}
.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {
  margin-bottom: 1.5rem;
}
@media (min-width: 992px) {
  .navbar-horizontal .navbar-nav .nav-item {
    margin-right: 0.5rem;
  }
  .navbar-horizontal .navbar-nav .nav-item [data-toggle=dropdown]::after {
    transition: all 0.15s ease;
  }
  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle=dropdown]::after {
    transform: rotate(180deg);
  }
  .navbar-horizontal .navbar-nav .nav-link {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-radius: 0.375rem;
  }
  .navbar-horizontal .navbar-nav .nav-link i {
    margin-right: 0.625rem;
  }
  .navbar-horizontal .navbar-nav .nav-link-icon {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    font-size: 1rem;
    border-radius: 0.375rem;
  }
  .navbar-horizontal .navbar-nav .nav-link-icon i {
    margin-right: 0;
  }
}
.navbar-horizontal .navbar-transparent {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  background-color: transparent;
  border: 0;
  box-shadow: none;
}
.navbar-horizontal .navbar-transparent .navbar-brand {
  color: rgb(255, 255, 255);
}
.navbar-horizontal .navbar-transparent .navbar-toggler {
  color: rgb(255, 255, 255);
}
.navbar-horizontal .navbar-transparent .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
@media (min-width: 768px) {
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.95);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:hover, .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.65);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .show > .nav-link,
  .navbar-horizontal .navbar-transparent .navbar-nav .active > .nav-link,
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.show,
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.active {
    color: rgba(255, 255, 255, 0.65);
  }
  .navbar-horizontal .navbar-transparent .navbar-brand {
    color: rgba(255, 255, 255, 0.95);
  }
  .navbar-horizontal .navbar-transparent .navbar-brand:hover, .navbar-horizontal .navbar-transparent .navbar-brand:focus {
    color: rgba(255, 255, 255, 0.95);
  }
}

.navbar-vertical {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}
.navbar-vertical .navbar {
  border-width: 0 0 1px 0;
  border-style: solid;
}
.navbar-vertical .navbar-light {
  background-color: transparent;
  border-color: #f6f9fc;
}
.navbar-vertical .navbar-brand {
  margin-right: 0;
}
.navbar-vertical .navbar-brand-img,
.navbar-vertical .navbar-brand > img {
  max-width: 100%;
  max-height: 2rem;
}
@media (min-width: 768px) {
  .navbar-vertical .navbar-collapse {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .navbar-vertical .navbar-collapse:before {
    content: "";
    display: block;
    margin: 1rem -1rem;
  }
}
.navbar-vertical .navbar-nav {
  margin-left: -1rem;
  margin-right: -1rem;
}
.navbar-vertical .navbar-nav .nav-link {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.9rem;
}
.navbar-vertical .navbar-nav .nav-link.active {
  position: relative;
}
.navbar-vertical .navbar-nav .nav-link.active:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.25rem;
  bottom: 0.25rem;
  border-left: 2px solid #5e72e4;
}
.navbar-vertical .navbar-nav .nav-link > i {
  min-width: 2.25rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
}
.navbar-vertical .navbar-nav .nav-link .dropdown-menu {
  border: none;
}
.navbar-vertical .navbar-nav .nav-link .dropdown-menu .dropdown-menu {
  margin-left: 0.75rem;
}
.navbar-vertical .navbar-nav .nav-link {
  display: flex;
  align-items: center;
}
.navbar-vertical .navbar-nav .nav-link[data-toggle=collapse]:after {
  display: inline-block;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  content: "\\f105";
  margin-left: auto;
  color: #8898aa;
  transition: all 0.15s ease;
}
.navbar-vertical .navbar-nav .nav-link[data-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(90deg);
}
.navbar-vertical .navbar-nav .nav .nav-link {
  padding-left: 3.25rem;
}
.navbar-vertical .navbar-nav .nav .nav .nav-link {
  padding-left: 3.75rem;
}
.navbar-vertical .navbar-heading {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.navbar-vertical.navbar-expand-xs {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: 250px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  overflow-y: auto;
}
.navbar-vertical.navbar-expand-xs > [class*=container] {
  flex-direction: column;
  align-items: stretch;
  min-height: 100%;
  padding-left: 0;
  padding-right: 0;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-xs > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
.navbar-vertical.navbar-expand-xs.fixed-left {
  left: 0;
  border-width: 0 1px 0 0;
}
.navbar-vertical.navbar-expand-xs.fixed-right {
  right: 0;
  border-width: 0 0 0 1px;
}
.navbar-vertical.navbar-expand-xs .navbar-collapse {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-collapse > * {
  min-width: 100%;
}
.navbar-vertical.navbar-expand-xs .navbar-nav {
  flex-direction: column;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
  padding: 0.65rem 1.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link.active:before {
  top: 0.25rem;
  bottom: 0.25rem;
  left: 0;
  right: auto;
  border-left: 2px solid #5e72e4;
  border-bottom: 0;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link {
  padding-left: 3.75rem;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav .nav-link {
  padding-left: 4.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-brand {
  display: block;
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.navbar-vertical.navbar-expand-xs .navbar-brand-img {
  max-height: 2.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-user {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-top: 1rem;
  padding-bottom: 0rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-top: 1px solid #e9ecef;
}
.navbar-vertical.navbar-expand-xs .navbar-user .dropup .dropdown-menu {
  left: 50%;
  transform: translateX(-50%);
}
@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-sm > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 576px) and (-ms-high-contrast: none), (min-width: 576px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-sm > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-sm.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-sm .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-brand-img {
    max-height: 2.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-sm .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-md > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 768px) and (-ms-high-contrast: none), (min-width: 768px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-md > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-md.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-md .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-brand-img {
    max-height: 2.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-md .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-lg > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 992px) and (-ms-high-contrast: none), (min-width: 992px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-lg > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-lg.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-lg .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-brand-img {
    max-height: 2.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-lg .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-xl > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 1200px) and (-ms-high-contrast: none), (min-width: 1200px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-xl > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-xl.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-xl .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-brand-img {
    max-height: 2.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-xl .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}

.navbar-search .input-group {
  border-radius: 2rem;
  border: 2px solid;
  background-color: transparent;
}
.navbar-search .input-group .input-group-text {
  background-color: transparent;
  padding-left: 1rem;
}
.navbar-search .form-control {
  width: 270px;
  background-color: transparent;
}

.navbar-search-dark .input-group {
  border-color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .input-group-text {
  color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .form-control {
  color: rgba(255, 255, 255, 0.9);
}
.navbar-search-dark .form-control::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .focused .input-group {
  border-color: rgba(255, 255, 255, 0.9);
}

.navbar-search-light .input-group {
  border-color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .input-group-text {
  color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .form-control {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-search-light .form-control::placeholder {
  color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .focused .input-group {
  border-color: rgba(0, 0, 0, 0.9);
}

@media (min-width: 768px) {
  .navbar .dropdown-menu {
    opacity: 0;
    pointer-events: none;
    margin: 0;
  }
  .navbar .dropdown-menu-arrow:before {
    background: #fff;
    box-shadow: none;
    content: "";
    display: block;
    height: 12px;
    width: 12px;
    left: 20px;
    position: absolute;
    bottom: 100%;
    transform: rotate(-45deg) translateY(12px);
    z-index: -5;
    border-radius: 2px;
  }
  .navbar .dropdown-menu-right:before {
    right: 20px;
    left: auto;
  }
  .navbar:not(.navbar-nav-hover) .dropdown-menu.show {
    opacity: 1;
    pointer-events: auto;
    animation: show-navbar-dropdown 0.25s ease forwards;
  }
  .navbar:not(.navbar-nav-hover) .dropdown-menu.close {
    display: block;
    animation: hide-navbar-dropdown 0.15s ease backwards;
  }
  .navbar.navbar-nav-hover .dropdown-menu {
    opacity: 0;
    display: block;
    pointer-events: none;
    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  }
  .navbar.navbar-nav-hover .nav-item.dropdown:hover > .dropdown-menu {
    display: block;
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    transform: translate(0, 0);
    animation: none;
  }
  .navbar .dropdown-menu-inner {
    position: relative;
    padding: 1rem;
  }
  @keyframes show-navbar-dropdown {
    0% {
      opacity: 0;
      transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
      transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes hide-navbar-dropdown {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translate(0, 10px);
    }
  }
}
.navbar-collapse-header {
  display: none;
}

@media (max-width: 767.98px) {
  .navbar-nav .nav-link {
    padding: 0.625rem 0;
    color: #172b4d !important;
  }
  .navbar-nav .dropdown-menu {
    box-shadow: none;
    min-width: auto;
  }
  .navbar-nav .dropdown-menu .media svg {
    width: 30px;
  }
  .navbar-collapse {
    width: calc(100% - 1.4rem);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    margin: 0.7rem;
    overflow-y: auto;
    height: auto !important;
    opacity: 0;
  }
  .navbar-collapse .navbar-toggler {
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    display: inline-block;
    padding: 0;
  }
  .navbar-collapse .navbar-toggler span {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    opacity: 1;
    background: #283448;
  }
  .navbar-collapse .navbar-toggler :nth-child(1) {
    transform: rotate(135deg);
  }
  .navbar-collapse .navbar-toggler :nth-child(2) {
    transform: rotate(-135deg);
  }
  .navbar-collapse .navbar-collapse-header {
    display: block;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .navbar-collapse .collapse-brand img {
    height: 36px;
  }
  .navbar-collapse .collapse-close {
    text-align: right;
  }
  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    padding: 1.5rem;
    border-radius: 0.375rem;
    background: #FFF;
    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
    animation: show-navbar-collapse 0.2s ease forwards;
  }
  .navbar-collapse.collapsing-out {
    animation: hide-navbar-collapse 0.2s ease forwards;
  }
}
@keyframes show-navbar-collapse {
  0% {
    opacity: 0;
    transform: scale(0.95);
    transform-origin: 100% 0;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes hide-navbar-collapse {
  from {
    opacity: 1;
    transform: scale(1);
    transform-origin: 100% 0;
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}
.page-item.active .page-link {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.page-item .page-link,
.page-item span {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 3px;
  border-radius: 50% !important;
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.pagination-lg .page-item .page-link,
.pagination-lg .page-item span {
  width: 46px;
  height: 46px;
  line-height: 46px;
}

.pagination-sm .page-item .page-link,
.pagination-sm .page-item span {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.popover {
  border: 0;
}

.popover-header {
  font-weight: 600;
}

.popover-primary {
  background-color: #5e72e4;
}
.popover-primary .popover-header {
  background-color: #5e72e4;
  color: #fff;
}
.popover-primary .popover-body {
  color: #fff;
}
.popover-primary .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-primary.bs-popover-top .arrow::after, .popover-primary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #5e72e4;
}
.popover-primary.bs-popover-right .arrow::after, .popover-primary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #5e72e4;
}
.popover-primary.bs-popover-bottom .arrow::after, .popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #5e72e4;
}
.popover-primary.bs-popover-left .arrow::after, .popover-primary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #5e72e4;
}

.popover-secondary {
  background-color: #f7fafc;
}
.popover-secondary .popover-header {
  background-color: #f7fafc;
  color: #212529;
}
.popover-secondary .popover-body {
  color: #212529;
}
.popover-secondary .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-secondary.bs-popover-top .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f7fafc;
}
.popover-secondary.bs-popover-right .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f7fafc;
}
.popover-secondary.bs-popover-bottom .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f7fafc;
}
.popover-secondary.bs-popover-left .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f7fafc;
}

.popover-success {
  background-color: #2dce89;
}
.popover-success .popover-header {
  background-color: #2dce89;
  color: #fff;
}
.popover-success .popover-body {
  color: #fff;
}
.popover-success .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-success.bs-popover-top .arrow::after, .popover-success.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #2dce89;
}
.popover-success.bs-popover-right .arrow::after, .popover-success.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #2dce89;
}
.popover-success.bs-popover-bottom .arrow::after, .popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #2dce89;
}
.popover-success.bs-popover-left .arrow::after, .popover-success.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #2dce89;
}

.popover-info {
  background-color: #11cdef;
}
.popover-info .popover-header {
  background-color: #11cdef;
  color: #fff;
}
.popover-info .popover-body {
  color: #fff;
}
.popover-info .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-info.bs-popover-top .arrow::after, .popover-info.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #11cdef;
}
.popover-info.bs-popover-right .arrow::after, .popover-info.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #11cdef;
}
.popover-info.bs-popover-bottom .arrow::after, .popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #11cdef;
}
.popover-info.bs-popover-left .arrow::after, .popover-info.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #11cdef;
}

.popover-warning {
  background-color: #fb6340;
}
.popover-warning .popover-header {
  background-color: #fb6340;
  color: #fff;
}
.popover-warning .popover-body {
  color: #fff;
}
.popover-warning .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-warning.bs-popover-top .arrow::after, .popover-warning.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fb6340;
}
.popover-warning.bs-popover-right .arrow::after, .popover-warning.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fb6340;
}
.popover-warning.bs-popover-bottom .arrow::after, .popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fb6340;
}
.popover-warning.bs-popover-left .arrow::after, .popover-warning.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fb6340;
}

.popover-danger {
  background-color: #f5365c;
}
.popover-danger .popover-header {
  background-color: #f5365c;
  color: #fff;
}
.popover-danger .popover-body {
  color: #fff;
}
.popover-danger .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-danger.bs-popover-top .arrow::after, .popover-danger.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f5365c;
}
.popover-danger.bs-popover-right .arrow::after, .popover-danger.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f5365c;
}
.popover-danger.bs-popover-bottom .arrow::after, .popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f5365c;
}
.popover-danger.bs-popover-left .arrow::after, .popover-danger.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f5365c;
}

.popover-light {
  background-color: #adb5bd;
}
.popover-light .popover-header {
  background-color: #adb5bd;
  color: #fff;
}
.popover-light .popover-body {
  color: #fff;
}
.popover-light .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-light.bs-popover-top .arrow::after, .popover-light.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #adb5bd;
}
.popover-light.bs-popover-right .arrow::after, .popover-light.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #adb5bd;
}
.popover-light.bs-popover-bottom .arrow::after, .popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #adb5bd;
}
.popover-light.bs-popover-left .arrow::after, .popover-light.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #adb5bd;
}

.popover-dark {
  background-color: #212529;
}
.popover-dark .popover-header {
  background-color: #212529;
  color: #fff;
}
.popover-dark .popover-body {
  color: #fff;
}
.popover-dark .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-dark.bs-popover-top .arrow::after, .popover-dark.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #212529;
}
.popover-dark.bs-popover-right .arrow::after, .popover-dark.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #212529;
}
.popover-dark.bs-popover-bottom .arrow::after, .popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #212529;
}
.popover-dark.bs-popover-left .arrow::after, .popover-dark.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #212529;
}

.popover-default {
  background-color: #172b4d;
}
.popover-default .popover-header {
  background-color: #172b4d;
  color: #fff;
}
.popover-default .popover-body {
  color: #fff;
}
.popover-default .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-default.bs-popover-top .arrow::after, .popover-default.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #172b4d;
}
.popover-default.bs-popover-right .arrow::after, .popover-default.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #172b4d;
}
.popover-default.bs-popover-bottom .arrow::after, .popover-default.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #172b4d;
}
.popover-default.bs-popover-left .arrow::after, .popover-default.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #172b4d;
}

.popover-white {
  background-color: #fff;
}
.popover-white .popover-header {
  background-color: #fff;
  color: #212529;
}
.popover-white .popover-body {
  color: #212529;
}
.popover-white .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-white.bs-popover-top .arrow::after, .popover-white.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fff;
}
.popover-white.bs-popover-right .arrow::after, .popover-white.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fff;
}
.popover-white.bs-popover-bottom .arrow::after, .popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fff;
}
.popover-white.bs-popover-left .arrow::after, .popover-white.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fff;
}

.popover-neutral {
  background-color: #fff;
}
.popover-neutral .popover-header {
  background-color: #fff;
  color: #212529;
}
.popover-neutral .popover-body {
  color: #212529;
}
.popover-neutral .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-neutral.bs-popover-top .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fff;
}
.popover-neutral.bs-popover-right .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fff;
}
.popover-neutral.bs-popover-bottom .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fff;
}
.popover-neutral.bs-popover-left .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fff;
}

.popover-darker {
  background-color: black;
}
.popover-darker .popover-header {
  background-color: black;
  color: #fff;
}
.popover-darker .popover-body {
  color: #fff;
}
.popover-darker .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-darker.bs-popover-top .arrow::after, .popover-darker.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: black;
}
.popover-darker.bs-popover-right .arrow::after, .popover-darker.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: black;
}
.popover-darker.bs-popover-bottom .arrow::after, .popover-darker.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: black;
}
.popover-darker.bs-popover-left .arrow::after, .popover-darker.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: black;
}

.progress-wrapper {
  position: relative;
  padding-top: 1.5rem;
}

.progress {
  height: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.progress .sr-only {
  width: auto;
  height: 20px;
  margin: 0 0 0 30px;
  left: 0;
  clip: auto;
  line-height: 20px;
  font-size: 13px;
}

.progress-heading {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px;
  padding: 0;
}

.progress-bar {
  box-shadow: none;
  border-radius: 0;
  height: auto;
}

.progress-info {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.progress-label span {
  display: inline-block;
  color: #5e72e4;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  background: rgba(94, 114, 228, 0.1);
  padding: 0.25rem 1rem;
  border-radius: 30px;
}

.progress-percentage {
  text-align: right;
}
.progress-percentage span {
  display: inline-block;
  color: #8898aa;
  font-size: 0.875rem;
  font-weight: 600;
}

.separator {
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  width: 100%;
  height: 150px;
  transform: translateZ(0);
  overflow: hidden;
  pointer-events: none;
}
.separator svg {
  position: absolute;
  pointer-events: none;
}

.separator-top {
  top: 0;
  bottom: auto;
}
.separator-top svg {
  top: 0;
}

.separator-bottom {
  top: auto;
  bottom: 0;
}
.separator-bottom svg {
  bottom: 0;
}

.separator-inverse {
  transform: rotate(180deg);
}

.separator-skew {
  height: 60px;
}
@media (min-width: 1200px) {
  .separator-skew {
    height: 70px;
  }
}

.table thead th {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid #e9ecef;
}
.table th {
  font-weight: 600;
}
.table td .progress {
  height: 3px;
  width: 120px;
  margin: 0;
}
.table td,
.table th {
  font-size: 0.8125rem;
  white-space: nowrap;
}
.table.align-items-center td,
.table.align-items-center th {
  vertical-align: middle;
}
.table .thead-dark th {
  background-color: #1c345d;
  color: #4d7bca;
}
.table .thead-light th {
  background-color: #f6f9fc;
  color: #8898aa;
}

.table-hover tr {
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .table-hover tr {
    transition: none;
  }
}

.table-flush td,
.table-flush th {
  border-left: 0;
  border-right: 0;
}
.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
  border-top: 0;
}
.table-flush tbody tr:last-child td,
.table-flush tbody tr:last-child th {
  border-bottom: 0;
}

.card .table {
  margin-bottom: 0;
}
.card .table td,
.card .table th {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

p {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.7;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.7;
  margin-top: 1.5rem;
}
.lead + .btn-wrapper {
  margin-top: 3rem;
}

.description {
  font-size: 0.875rem;
}

.heading {
  letter-spacing: 0.025em;
  font-size: 0.95rem;
  text-transform: uppercase;
  font-weight: 600;
}

.heading-small {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.heading-title {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}

.heading-section {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}
.heading-section img {
  display: block;
  width: 72px;
  height: 72px;
  margin-bottom: 1.5rem;
}
.heading-section.text-center img {
  margin-left: auto;
  margin-right: auto;
}

.display-1 span,
.display-2 span,
.display-3 span,
.display-4 span {
  display: block;
  font-weight: 300;
}

article h4:not(:first-child),
article h5:not(:first-child) {
  margin-top: 3rem;
}
article h4, article h5 {
  margin-bottom: 1.5rem;
}
article figure {
  margin: 3rem 0;
}
article h5 + figure {
  margin-top: 0;
}

.datepicker {
  border-radius: 0.375rem;
  direction: ltr;
}
.datepicker-inline {
  width: 220px;
}
.datepicker-rtl {
  direction: rtl;
}
.datepicker-rtl.dropdown-menu {
  left: auto;
}
.datepicker-rtl table tr td span {
  float: right;
}
.datepicker-dropdown {
  top: 0;
  left: 0;
  padding: 20px 22px;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}
.datepicker-dropdown.datepicker-orient-left:before {
  left: 6px;
}
.datepicker-dropdown.datepicker-orient-left:after {
  left: 7px;
}
.datepicker-dropdown.datepicker-orient-right:before {
  right: 6px;
}
.datepicker-dropdown.datepicker-orient-right:after {
  right: 7px;
}
.datepicker-dropdown.datepicker-orient-bottom:before {
  top: -7px;
}
.datepicker-dropdown.datepicker-orient-bottom:after {
  top: -6px;
}
.datepicker-dropdown.datepicker-orient-top:before {
  bottom: -7px;
  border-bottom: 0;
  border-top: 7px solid white;
}
.datepicker-dropdown.datepicker-orient-top:after {
  bottom: -6px;
  border-bottom: 0;
  border-top: 6px solid #fff;
}
.datepicker table {
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.datepicker table tr td {
  border-radius: 50%;
}
.datepicker table tr th {
  border-radius: 0.375rem;
  font-weight: 500;
}
.datepicker table tr td,
.datepicker table tr th {
  transition: all 0.15s ease;
  width: 36px;
  height: 36px;
  border: none;
  text-align: center;
  font-size: 0.875rem;
}
.table-striped .datepicker table tr td,
.table-striped .datepicker table tr th {
  background-color: transparent;
}
.datepicker table tr td.old, .datepicker table tr td.new {
  color: #adb5bd;
}
.datepicker table tr td.day:hover, .datepicker table tr td.focused {
  background: white;
  cursor: pointer;
}
.datepicker table tr td.disabled, .datepicker table tr td.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}
.datepicker table tr td.highlighted {
  border-radius: 0;
}
.datepicker table tr td.highlighted.focused {
  background: #5e72e4;
}
.datepicker table tr td.highlighted.disabled, .datepicker table tr td.highlighted.disabled:active {
  background: #5e72e4;
  color: #ced4da;
}
.datepicker table tr td.today {
  background: white;
}
.datepicker table tr td.today.focused {
  background: white;
}
.datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:active {
  background: white;
  color: #8898aa;
}
.datepicker table tr td.range {
  background: #5e72e4;
  color: #fff;
  border-radius: 0;
}
.datepicker table tr td.range.focused {
  background: #3b53de;
}
.datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:active, .datepicker table tr td.range.day.disabled:hover {
  background: #324cdd;
  color: #8a98eb;
}
.datepicker table tr td.range.highlighted.focused {
  background: #cbd3da;
}
.datepicker table tr td.range.highlighted.disabled, .datepicker table tr td.range.highlighted.disabled:active {
  background: #e9ecef;
  color: #dee2e6;
}
.datepicker table tr td.range.today.disabled, .datepicker table tr td.range.today.disabled:active {
  background: #5e72e4;
  color: #fff;
}
.datepicker table tr td.day.range-start {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.datepicker table tr td.day.range-end {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.datepicker table tr td.day.range-start.range-end {
  border-radius: 50%;
}
.datepicker table tr td.selected, .datepicker table tr td.selected.highlighted, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.highlighted:hover, .datepicker table tr td.day.range:hover {
  background: #5e72e4;
  color: #fff;
}
.datepicker table tr td.active, .datepicker table tr td.active.highlighted, .datepicker table tr td.active:hover, .datepicker table tr td.active.highlighted:hover {
  background: #5e72e4;
  color: #fff;
  box-shadow: none;
}
.datepicker table tr td span {
  display: block;
  width: 23%;
  height: 54px;
  line-height: 54px;
  float: left;
  margin: 1%;
  cursor: pointer;
  border-radius: 4px;
}
.datepicker table tr td span:hover, .datepicker table tr td span.focused {
  background: #e9ecef;
}
.datepicker table tr td span.disabled, .datepicker table tr td span.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}
.datepicker table tr td span.active, .datepicker table tr td span.active:hover, .datepicker table tr td span.active.disabled, .datepicker table tr td span.active.disabled:hover {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}
.datepicker table tr td span.old, .datepicker table tr td span.new {
  color: #8898aa;
}
.datepicker .datepicker-switch {
  width: 145px;
}
.datepicker .datepicker-switch,
.datepicker .prev,
.datepicker .next,
.datepicker tfoot tr th {
  cursor: pointer;
}
.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
  background: #e9ecef;
}
.datepicker .prev.disabled,
.datepicker .next.disabled {
  visibility: hidden;
}
.datepicker .cw {
  font-size: 10px;
  width: 12px;
  padding: 0 2px 0 5px;
  vertical-align: middle;
}

/*! nouislider - 14.0.1 - 6/21/2019 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 18px;
}

.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  left: -17px;
  top: -6px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -17px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #FAFAFA;
  border-radius: 4px;
  border: 1px solid #D3D3D3;
  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: #E8E7E6;
  left: 14px;
  top: 6px;
}

.noUi-handle:after {
  left: 17px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-target {
  background: #eceeef;
  border-radius: 5px;
  border: 0;
  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);
  margin: 15px 0;
  cursor: pointer;
}

.noUi-horizontal {
  height: 5px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -10px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-connect {
  background: #5e72e4;
  box-shadow: none;
}

.noUi-handle:after, .noUi-handle:before {
  content: none;
}
.noUi-handle:focus {
  outline: none;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  top: -5px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  box-shadow: none;
  cursor: pointer;
  background-color: #5e72e4;
  border: 0;
  transition: box-shadow 0.15s, transform 0.15s;
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
  box-shadow: 0px 0px 0px 2px #5e72e4;
}

.input-slider--cyan .noUi-connect {
  background: #2bffc6;
}

/* Disabled state */
[disabled] .noUi-connect,
[disabled].noUi-connect {
  background: #b2b2b2;
}

[disabled] .noUi-handle,
[disabled].noUi-origin {
  cursor: not-allowed;
}

/* Range slider value labels */
.range-slider-value {
  font-size: 0.75rem;
  font-weight: 500;
  background-color: rgba(33, 37, 41, 0.7);
  color: #fff;
  border-radius: 10px;
  padding: 0.4em 0.8em 0.3em 0.85em;
}

.range-slider-wrapper .upper-info {
  font-weight: 400;
  margin-bottom: 5px;
}

.input-slider-value-output {
  background: #333;
  color: #fff;
  padding: 4px 8px;
  position: relative;
  top: 12px;
  font-size: 11px;
  border-radius: 2px;
}

.input-slider-value-output:after {
  bottom: 100%;
  left: 10px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #333;
  border-width: 4px;
  margin-left: -4px;
}

.input-slider-value-output.left:after {
  left: 10px;
  right: auto;
}

.input-slider-value-output.right:after {
  right: 10px;
  left: auto;
}

.scrollbar-inner {
  height: 100%;
}
.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}
.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}
.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}
.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}
.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}
.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.ct-navbar {
  background-color: #5e72e4;
  box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
@media (max-width: 991.98px) {
  .ct-navbar {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .ct-navbar .navbar-nav-scroll {
    max-width: 100%;
    height: 2.5rem;
    margin-top: 0.25rem;
    overflow: hidden;
    font-size: 0.875rem;
  }
  .ct-navbar .navbar-nav-scroll .navbar-nav {
    padding-bottom: 2rem;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
}
@media (min-width: 768px) {
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .ct-navbar {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 1071;
    }
  }
}
.ct-navbar .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: rgba(255, 255, 255, 0.9) !important;
}
.ct-navbar .navbar-nav .nav-link.active, .ct-navbar .navbar-nav .nav-link:hover {
  color: #fff !important;
  background-color: transparent !important;
}
.ct-navbar .navbar-nav .nav-link.active {
  font-weight: 500;
}
.ct-navbar .navbar-nav-svg {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-top;
}
.ct-navbar .dropdown-menu {
  font-size: 0.875rem;
}
.ct-navbar .dropdown-item.active {
  font-weight: 500;
  color: #212529;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: 0.4rem 0.87rem;
  background-size: 0.75rem 0.75rem;
  padding-left: 25px;
}

.github-corner {
  position: fixed;
  right: 0;
  z-index: 1080;
}
.github-corner:hover .octo-arm {
  animation: octocat-wave 560ms ease-in-out;
}
.github-corner svg {
  fill: #fff;
  color: #5e72e4;
}

@keyframes octocat-wave {
  0%, 100% {
    transform: rotate(0);
  }
  20%, 60% {
    transform: rotate(-25deg);
  }
  40%, 80% {
    transform: rotate(10deg);
  }
}
.ct-clipboard {
  position: relative;
  display: none;
  float: right;
}
.ct-clipboard + .highlight {
  margin-top: 0;
}

.btn-clipboard {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  display: block;
  padding: 0.25rem 0.5rem;
  font-size: 75%;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  border-radius: 0.25rem;
  color: #fff;
  background-color: #5e72e4;
}
.btn-clipboard:hover {
  color: #fff;
  background-color: #324cdd;
}

@media (min-width: 768px) {
  .ct-clipboard {
    display: block;
  }
}
.ct-example-row .row > .col span,
.ct-example-row .row > [class^=col-] span {
  display: block;
  padding: 0.75rem;
  color: rgb(57, 63, 73);
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  margin: 1rem 0;
}
.ct-example-row .no-gutters > .col span,
.ct-example-row .no-gutters > [class^=col-] span {
  border-radius: 0;
}
.ct-example-row .flex-items-top,
.ct-example-row .flex-items-middle,
.ct-example-row .flex-items-bottom {
  min-height: 6rem;
  background-color: rgba(255, 0, 0, 0.1);
}

.ct-example-row-flex-cols .row {
  min-height: 10rem;
  background-color: rgba(255, 0, 0, 0.1);
}
.ct-example-row-flex-cols .row + .row {
  margin-top: 1rem;
}

.ct-highlight {
  background-color: rgba(94, 114, 228, 0.15);
  border: 1px solid rgba(94, 114, 228, 0.15);
}

.example-container {
  width: 800px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.example-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.example-content-main {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  .example-content-main {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-main {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
}

.example-content-secondary {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  .example-content-secondary {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-secondary {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
}

.ct-example-container {
  min-width: 16rem;
  max-width: 25rem;
  margin-right: auto;
  margin-left: auto;
}

.ct-example-container-header {
  height: 3rem;
  margin-bottom: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
}

.ct-example-container-sidebar {
  float: right;
  width: 4rem;
  height: 8rem;
  background-color: #cbd2f6;
  border-radius: 0.25rem;
}

.ct-example-container-body {
  height: 8rem;
  margin-right: 4.5rem;
  background-color: #cbd2f6;
  border-radius: 0.25rem;
}

.ct-example-container-fluid {
  max-width: none;
}

.ct-example {
  position: relative;
  margin: 1rem -calc(15px) 0;
}
.ct-example::after {
  display: block;
  clear: both;
  content: "";
}
@media (min-width: 576px) {
  .ct-example {
    margin-right: 0;
    margin-left: 0;
  }
}
.ct-example + .highlight,
.ct-example + .clipboard + .highlight {
  margin-top: 0;
}
.ct-example + p {
  margin-top: 2rem;
}
.ct-example .pos-f-t {
  position: relative;
  margin: -1rem;
}
@media (min-width: 576px) {
  .ct-example .pos-f-t {
    margin: -1.5rem;
  }
}
.ct-example .custom-file-input:lang(es) ~ .custom-file-label::after {
  content: "Elegir";
}
.ct-example > .form-control + .form-control {
  margin-top: 0.5rem;
}
.ct-example > .nav + .nav,
.ct-example > .alert + .alert,
.ct-example > .navbar + .navbar,
.ct-example > .progress + .progress,
.ct-example > .progress + .btn,
.ct-example .badge,
.ct-example .btn {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ct-example .btn-group {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ct-example .btn-group .btn {
  margin: 0;
}
.ct-example .alert {
  margin: 0;
}
.ct-example .alert + .alert {
  margin-top: 1.25rem;
}
.ct-example .badge {
  margin-right: 0.5rem;
}
.ct-example > .dropdown-menu:first-child {
  position: static;
  display: block;
}
.ct-example > .form-group:last-child {
  margin-bottom: 0;
}
.ct-example > .close {
  float: none;
}

.ct-example-type .table .type-info {
  color: #999;
  vertical-align: middle;
}
.ct-example-type .table td {
  padding: 1rem 0;
  border-color: #eee;
}
.ct-example-type .table tr:first-child td {
  border-top: 0;
}
.ct-example-type h1,
.ct-example-type h2,
.ct-example-type h3,
.ct-example-type h4,
.ct-example-type h5,
.ct-example-type h6 {
  margin-top: 0;
  margin-bottom: 0;
}

.ct-example-bg-classes p {
  padding: 1rem;
}

.ct-example > img + img {
  margin-left: 0.5rem;
}

.ct-example > .btn-group {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.ct-example > .btn-toolbar + .btn-toolbar {
  margin-top: 0.5rem;
}

.ct-example-control-sizing select,
.ct-example-control-sizing input[type=text] + input[type=text] {
  margin-top: 0.5rem;
}

.ct-example-form .input-group {
  margin-bottom: 0.5rem;
}

.ct-example > textarea.form-control {
  resize: vertical;
}

.ct-example > .list-group {
  max-width: 400px;
}

.ct-example .fixed-top,
.ct-example .sticky-top {
  position: static;
  margin: -1rem -1rem 1rem;
}
.ct-example .fixed-bottom {
  position: static;
  margin: 1rem -1rem -1rem;
}
@media (min-width: 576px) {
  .ct-example .fixed-top,
  .ct-example .sticky-top {
    margin: -1.5rem -1.5rem 1rem;
  }
  .ct-example .fixed-bottom {
    margin: 1rem -1.5rem -1.5rem;
  }
}

.ct-example .pagination {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.modal {
  z-index: 1072;
}
.modal .tooltip,
.modal .popover {
  z-index: 1073;
}

.modal-backdrop {
  z-index: 1071;
}

.ct-example-modal {
  background-color: #fafafa;
}
.ct-example-modal .modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}
.ct-example-modal .modal-dialog {
  left: auto;
  margin-right: auto;
  margin-left: auto;
}

.ct-example-tabs .nav-tabs {
  margin-bottom: 1rem;
}

.ct-example-popover-static {
  padding-bottom: 1.5rem;
  background-color: #f9f9f9;
}
.ct-example-popover-static .popover {
  position: relative;
  display: block;
  float: left;
  width: 260px;
  margin: 1.25rem;
}

.tooltip-demo a {
  white-space: nowrap;
}

.ct-example-tooltip-static .tooltip {
  position: relative;
  display: inline-block;
  margin: 10px 20px;
  opacity: 1;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 350px;
  overflow: auto;
}

.ct-example-border-utils [class^=border] {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #f5f5f5;
}

.ct-example-border-utils-0 [class^=border] {
  border: 1px solid #e9ecef;
}

.highlight {
  padding: 0;
  margin-top: 1rem;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
@media (min-width: 576px) {
  .highlight {
    padding: 0;
  }
}

.ct-content .highlight {
  margin-right: -calc(15px);
  margin-left: -calc(15px);
}
@media (min-width: 576px) {
  .ct-content .highlight {
    margin-right: 0;
    margin-left: 0;
  }
}

.ct-example {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}
.ct-example .tab-content .tab-example-result {
  background-color: #f5f7f9;
  border: 1px solid #e6ecf1;
  padding: 1.25rem;
  border-radius: 0.25rem;
}
.ct-example .nav-tabs-code {
  margin-bottom: 0.375rem;
}
.ct-example .nav-tabs-code .nav-link {
  font-size: 0.875rem;
}
.ct-example .nav-tabs-code .nav-link:active, .ct-example .nav-tabs-code .nav-link.active {
  color: #5e72e4;
}

.icon-examples {
  margin-top: 1rem;
}

.btn-icon-clipboard {
  margin: 0px;
  padding: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  color: rgb(57, 63, 73);
  background-color: rgb(248, 249, 250);
  border-radius: 4px;
  border: 0px none;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}
.btn-icon-clipboard:hover {
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;
}
.btn-icon-clipboard > div {
  align-items: center;
  display: flex;
}
.btn-icon-clipboard i {
  box-sizing: content-box;
  color: rgb(57, 63, 73);
  vertical-align: middle;
  font-size: 1.5rem;
}
.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgb(57, 63, 73);
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

code[class*=language-],
pre[class*=language-] {
  font-family: Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace;
  font-size: 14px;
  line-height: 1.375;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  tab-size: 4;
  -webkit-hyphens: none;
  hyphens: none;
  background: #f5f7ff;
  color: #5e6687;
  border-radius: 0.25rem;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #dfe2f1;
}

/* Code blocks */
pre[class*=language-] {
  padding: 1.25rem;
  margin: 0;
  overflow: auto;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #898ea4;
}

.token.punctuation {
  color: #5e6687;
}

.token.namespace {
  opacity: 0.7;
}

.token.operator,
.token.boolean,
.token.number {
  color: #c76b29;
}

.token.property {
  color: #c08b30;
}

.token.tag {
  color: #3d8fd1;
}

.token.string {
  color: #22a2c9;
}

.token.selector {
  color: #6679cc;
}

.token.attr-name {
  color: #c76b29;
}

.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #22a2c9;
}

.token.attr-value,
.token.keyword,
.token.control,
.token.directive,
.token.unit {
  color: #ac9739;
}

.token.statement,
.token.regex,
.token.atrule {
  color: #22a2c9;
}

.token.placeholder,
.token.variable {
  color: #3d8fd1;
}

.token.deleted {
  text-decoration: line-through;
}

.token.inserted {
  border-bottom: 1px dotted #202746;
  text-decoration: none;
}

.token.italic {
  font-style: italic;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.important {
  color: #c94922;
}

.token.entity {
  cursor: help;
}

pre > code.highlight {
  outline: 0.4em solid #c94922;
  outline-offset: 0.4em;
}

/* overrides color-values for the Line Numbers plugin
 * http://prismjs.com/plugins/line-numbers/
 */
.line-numbers .line-numbers-rows {
  border-right-color: #dfe2f1;
}

.line-numbers-rows > span:before {
  color: #979db4;
}

/* overrides color-values for the Line Highlight plugin
 * http://prismjs.com/plugins/line-highlight/
 */
.line-highlight {
  background: rgba(107, 115, 148, 0.2);
  background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));
}

.docs {
  background: #FFF;
}
.docs h6 {
  font-size: 1rem;
  font-weight: 600;
}

.ct-content {
  order: 1;
}
.ct-content > h2[id],
.ct-content > h3[id],
.ct-content > h4[id] {
  pointer-events: none;
}
.ct-content > h2[id] > div,
.ct-content > h2[id] > a,
.ct-content > h3[id] > div,
.ct-content > h3[id] > a,
.ct-content > h4[id] > div,
.ct-content > h4[id] > a {
  pointer-events: auto;
}
.ct-content > h2[id]::before,
.ct-content > h3[id]::before,
.ct-content > h4[id]::before {
  display: block;
  height: 6rem;
  margin-top: -6rem;
  visibility: hidden;
  content: "";
}
.ct-content > table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
}
@media (max-width: 991.98px) {
  .ct-content > table {
    display: block;
    overflow-x: auto;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .ct-content > table.table-bordered {
    border: 0;
  }
}
.ct-content > table > thead > tr > th,
.ct-content > table > thead > tr > td,
.ct-content > table > tbody > tr > th,
.ct-content > table > tbody > tr > td,
.ct-content > table > tfoot > tr > th,
.ct-content > table > tfoot > tr > td {
  padding: 1rem;
  vertical-align: top;
  border: 1px solid #e9ecef;
}
.ct-content > table > thead > tr > th > p:last-child,
.ct-content > table > thead > tr > td > p:last-child,
.ct-content > table > tbody > tr > th > p:last-child,
.ct-content > table > tbody > tr > td > p:last-child,
.ct-content > table > tfoot > tr > th > p:last-child,
.ct-content > table > tfoot > tr > td > p:last-child {
  margin-bottom: 0;
}
.ct-content > table td:first-child > code {
  white-space: nowrap;
}

.ct-content > h2:not(:first-child) {
  margin-top: 3rem;
  font-size: 1.5rem;
  font-weight: 600;
}
.ct-content > h3 {
  margin-top: 2.5rem;
  font-size: 1.25rem;
  font-weight: 600;
}
.ct-content > ul li,
.ct-content > ol li {
  margin-bottom: 0.25rem;
}
@media (min-width: 992px) {
  .ct-content > ul,
  .ct-content > ol,
  .ct-content > p {
    max-width: 80%;
  }
}

.ct-page-title {
  padding-left: 1.25rem;
  border-left: 2px solid #5e72e4;
  margin-bottom: 1.5rem;
}

.ct-title {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 300;
}
@media (min-width: 576px) {
  .ct-title {
    font-size: 1.5rem;
    font-weight: 600;
  }
}

.ct-lead {
  color: rgb(59, 69, 78);
  font-weight: 500;
}
@media (min-width: 576px) {
  .ct-lead {
    max-width: 80%;
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }
}

.ct-text-purple {
  color: #5e72e4;
}

.ct-text-purple-bright {
  color: #9da9f2;
}

.ct-tabs-example .nav-link i {
  margin-right: 5px;
}

.color-swatch {
  margin: 1rem 0;
  border-radius: 0.25rem;
  background-color: #F4F5F7;
}

.color-swatch:after {
  content: " ";
  display: table;
  clear: both;
}

.color-swatch-header {
  position: relative;
  height: 0;
  padding-bottom: 50%;
  border-radius: 0.25rem 0.25rem 0 0;
  border: 1px solid transparent;
}

.color-swatch-header.is-light {
  border-color: #C1C7D0;
}

.color-swatch-header .pass-fail {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.color-swatch-header .pass-fail-item-wrap {
  position: relative;
  float: left;
  left: 50%;
  transform: translateX(-50%);
}

.color-swatch-header .pass-fail-item-group {
  display: inline-block;
  padding: 0 5px;
}

.color-swatch-header .pass-fail-item {
  float: left;
  display: inline-block;
  text-align: center;
  padding: 2px;
}

.color-swatch-header .pass-fail-item.white .example {
  color: #fff;
}

.color-swatch-header .pass-fail-item.small .example {
  font-size: 10px;
}

.color-swatch-header .pass-fail-item .lozenge {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  background: #000;
  color: #fff;
  padding: 2px 4px;
  line-height: 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.color-swatch-body {
  position: relative;
  left: 50%;
  float: left;
  padding: 10px 0;
  transform: translateX(-50%);
}

.color-swatch-body .prop-item-wrap {
  float: left;
  padding: 0 15px;
  min-width: 65px;
}

.color-swatch-body .prop-item {
  padding: 15px 0;
}

.color-swatch-body .prop-item .label {
  font-size: 11px;
  color: #62748C;
  text-transform: uppercase;
  line-height: 16px;
}

.color-swatch-body .prop-item .value {
  font-size: 14px;
}

.table-colors {
  font-weight: 600;
  font-size: 16px;
  width: 100%;
}

.table-colors td,
.table-colors:first-child td,
.table-colors td:first-child,
.table-colors:first-child td:first-child,
.table-colors td:last-child,
.table-colors:first-child td:last-child {
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.table-colors tr:last-child td,
.table-colors:first-child tr:last-child td {
  border-bottom: none;
}

.table-colors td:nth-child(1),
.table-colors:first-child td:nth-child(1) {
  line-height: 40px;
}

.table-colors .swatch,
.table-colors:first-child .swatch {
  float: left;
  height: 40px;
  width: 40px;
  margin-right: 20px;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid transparent;
}

.table-colors .swatch.is-light,
.table-colors:first-child .swatch.is-light {
  border-color: #C1C7D0;
}

.table-colors .lozenge,
.table-colors:first-child .lozenge {
  float: left;
  margin: 5px 10px 0 0;
  font-size: 10px;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600;
  background: #97A0AF;
  color: #042A53;
  padding: 2px 4px;
  line-height: 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.ct-toc {
  order: 2;
  padding-top: 2rem;
  padding-bottom: 1.5rem;
  font-size: 0.875rem;
}
@supports ((position: -webkit-sticky) or (position: sticky)) {
  .ct-toc {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    height: calc(100vh - 4rem);
    overflow-y: auto;
  }
}

.section-nav {
  padding-left: 0;
  border-left: 1px solid #eee;
}
.section-nav ul {
  padding-left: 1rem;
}
.section-nav ul ul {
  display: none;
}

.toc-entry {
  display: block;
  font-size: 1rem;
}
.toc-entry a {
  display: block;
  padding: 0.125rem 1.5rem;
  color: #99979c;
  font-size: 90%;
}
.toc-entry a:hover {
  color: #5e72e4;
  text-decoration: none;
}

.ct-sidebar {
  order: 0;
  border-bottom: 1px solid #e6ecf1;
  background-color: #f5f7f9;
}
@media (min-width: 768px) {
  .ct-sidebar {
    border-right: 1px solid #e6ecf1;
  }
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .ct-sidebar {
      position: -webkit-sticky;
      position: sticky;
      top: 4rem;
      z-index: 1000;
      height: calc(100vh - 4rem);
    }
  }
}
@media (min-width: 1200px) {
  .ct-sidebar {
    flex: 0 1 320px;
  }
}

.ct-links {
  padding-top: 2rem;
  padding-bottom: 1rem;
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 768px) {
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .ct-links {
      max-height: calc(100vh - 5rem);
      overflow-y: auto;
    }
  }
}
@media (min-width: 768px) {
  .ct-links {
    display: block !important;
  }
}

.ct-search {
  position: relative;
  padding: 1rem 15px;
  margin-right: -15px;
  margin-left: -15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.ct-search .form-control:focus {
  border-color: #9da9f2;
  box-shadow: 0 0 0 3px rgba(157, 169, 242, 0.25);
}

.ct-search-docs-toggle {
  line-height: 1;
  color: #212529;
}

.ct-sidenav {
  display: none;
}

.ct-toc-link {
  display: block;
  padding: 0.25rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: #0d2b3e;
}
.ct-toc-link:hover {
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
}

.ct-toc-item.active {
  margin-bottom: 1rem;
}
.ct-toc-item.active:not(:first-child) {
  margin-top: 1rem;
}
.ct-toc-item.active > .ct-toc-link {
  color: rgba(0, 0, 0, 0.85);
}
.ct-toc-item.active > .ct-toc-link:hover {
  background-color: transparent;
}
.ct-toc-item.active > .ct-sidenav {
  display: block;
}

.ct-sidebar .nav > li > a {
  display: block;
  padding: 0.25rem 1.5rem;
  font-size: 84%;
  color: #4c555a;
}

.ct-sidebar .nav > li > a:hover {
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
  background-color: transparent;
}

.ct-sidebar .nav > .active > a {
  font-weight: 500;
  color: #0099e5;
  background-color: transparent;
  padding-left: 2rem;
  position: relative;
}
.ct-sidebar .nav > .active > a:before {
  content: "";
  position: absolute;
  height: 16px;
  width: 2px;
  background-color: #0099e5;
  top: 50%;
  left: 1.5rem;
  transform: translateY(-50%);
}

.ct-sidebar .nav > .active:hover > a {
  color: #0099e5;
}

.scrollbar-inner {
  height: 100%;
}
.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}
.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}
.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}
.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}
.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}
.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.ct-footer {
  font-size: 85%;
  text-align: center;
  background-color: #f7f7f7;
}
.ct-footer a {
  font-weight: 500;
  color: #525f7f;
}
.ct-footer a:hover, .ct-footer a:focus {
  color: #5e72e4;
}
.ct-footer p {
  margin-bottom: 0;
}
@media (min-width: 576px) {
  .ct-footer {
    text-align: left;
  }
}

.ct-footer-links {
  padding-left: 0;
  margin-bottom: 1rem;
}
.ct-footer-links li {
  display: inline-block;
}
.ct-footer-links li + li {
  margin-left: 1rem;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  padding: 20px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.375rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  visibility: hidden;
  position: relative;
}
.rdtPicker .rdtTimeToggle:before {
  visibility: visible;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal normal 1em/1 "Nucleo";
  font-size: 18px;
  content: "\\ea5e";
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #fff !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover, .rdtDay.start-date, .rdtDay.end-date, .rdtDay.middle-date, .rdtDay.start-date:hover, .rdtDay.end-date:hover, .rdtDay.middle-date:hover {
  background-color: #11cdef !important;
  color: #fff !important;
}
.rdtDay.start-date {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rdtDay.middle-date {
  border-radius: 0;
}
.rdtDay.end-date {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rdtDays tr .dow {
  text-align: center;
  font-size: 12px;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
  font-weight: 300;
  font-size: 0.875rem;
  width: 20px;
  height: 20px;
}
.rdtDays tr .rdtDay {
  color: #525f7f;
  font-size: 0.875rem;
}
.rdtDays tr .rdtDay.rdtOld, .rdtDays tr .rdtDay.rdtNew {
  color: #adb5bd;
  font-weight: 300;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover,
.rdtPicker .rdtTimeToggle:hover:before {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker tr .dow {
  width: 14.2857%;
  border-bottom: none;
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  font-weight: 500;
  border-radius: 0.375rem;
}

.rdtPicker th.rdtSwitch {
  font-weight: 500;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  width: 145px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #525f7f;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #11cdef;
  border-radius: 50%;
  border: 1px solid #11cdef;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #adb5bd;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive, .rdtMonths .rdtMonth.start-date, .rdtMonths .rdtMonth.end-date, .rdtMonths .rdtMonth.middle-date,
.rdtMonths .rdtYear.rdtActive,
.rdtMonths .rdtYear.start-date,
.rdtMonths .rdtYear.end-date,
.rdtMonths .rdtYear.middle-date,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtMonth.start-date,
.rdtYears .rdtMonth.end-date,
.rdtYears .rdtMonth.middle-date,
.rdtYears .rdtYear.rdtActive,
.rdtYears .rdtYear.start-date,
.rdtYears .rdtYear.end-date,
.rdtYears .rdtYear.middle-date {
  background-color: #11cdef !important;
  color: #fff;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .rdt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.form-group .rdt {
  width: 1%;
  margin-bottom: 0;
  flex: 1 1 auto;
}

.btn .btn-inner--icon {
  margin-right: 4px;
}

.btn + .btn {
  margin-left: 4px;
}

button:focus, :focus {
  outline: none;
}

@keyframes show-navbar-dropdown {
  0% {
    opacity: 0;
    transition: visibility 0.25s, opacity 0.25s;
  }
  100% {
    opacity: 1;
  }
}
.navbar .collapsing .navbar-toggler {
  pointer-events: none;
}

.navbar .nav-item .nav-link-icon.nav-link i {
  margin-right: 4px;
}

.table .avatar-group .avatar {
  margin-right: 4px;
}
.table .badge i {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/argon-dashboard-react.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/argon-dashboard/custom/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/argon-dashboard/custom/_reboot.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_backgrounds.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_floating.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_helper.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_image.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_opacity.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_overflow.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_position.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_sizing.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_spacing.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_shadows.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_text.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_transform.scss","webpack://./src/assets/scss/argon-dashboard/custom/alerts/_alert.scss","webpack://./src/assets/scss/argon-dashboard/custom/alerts/_alert-dismissible.scss","webpack://./src/assets/scss/argon-dashboard/custom/avatars/_avatar.scss","webpack://./src/assets/scss/argon-dashboard/custom/avatars/_avatar-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge-circle.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge-dot.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button-icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button-brand.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-profile.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-animations.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-stats.scss","webpack://./src/assets/scss/argon-dashboard/custom/charts/_chart.scss","webpack://./src/assets/scss/argon-dashboard/custom/close/_close.scss","webpack://./src/assets/scss/argon-dashboard/custom/_content.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-form.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-control.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-checkbox.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-radio.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-toggle.scss","webpack://./src/assets/scss/argon-dashboard/custom/dropdowns/_dropdown.scss","webpack://./src/assets/scss/argon-dashboard/custom/footers/_footer.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_form.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_form-validation.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_input-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/headers/_header.scss","webpack://./src/assets/scss/argon-dashboard/custom/icons/_icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/icons/_icon-shape.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/list-groups/_list-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/maps/_map.scss","webpack://./src/assets/scss/argon-dashboard/custom/masks/_mask.scss","webpack://./src/assets/scss/argon-dashboard/custom/modals/_modal.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_modals.scss","webpack://./src/assets/scss/argon-dashboard/custom/navs/_nav.scss","webpack://./src/assets/scss/argon-dashboard/custom/navs/_nav-pills.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-vertical.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-search.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-dropdown.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-collapse.scss","webpack://./src/assets/scss/argon-dashboard/custom/paginations/_pagination.scss","webpack://./src/assets/scss/argon-dashboard/custom/popovers/_popover.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_popover.scss","webpack://./src/assets/scss/argon-dashboard/custom/progresses/_progress.scss","webpack://./src/assets/scss/argon-dashboard/custom/separators/_separator.scss","webpack://./src/assets/scss/argon-dashboard/custom/tables/_table.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_type.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_heading.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_display.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_article.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_bootstrap-datepicker.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_nouislider.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_scrollbar.scss","webpack://./src/assets/scss/argon-dashboard/docs/_nav.scss","webpack://./src/assets/scss/argon-dashboard/docs/_variables.scss","webpack://./src/assets/scss/argon-dashboard/docs/_clipboard-js.scss","webpack://./src/assets/scss/argon-dashboard/docs/_component-examples.scss","webpack://./src/assets/scss/argon-dashboard/docs/_prism.scss","webpack://./src/assets/scss/argon-dashboard/docs/_content.scss","webpack://./src/assets/scss/argon-dashboard/docs/_sidebar.scss","webpack://./src/assets/scss/argon-dashboard/docs/_footer.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/_buttons.scss","webpack://./src/assets/scss/react/_mixins.scss","webpack://./src/assets/scss/react/_navbar-dropdown.scss","webpack://./src/assets/scss/react/_navbar.scss","webpack://./src/assets/scss/react/_tables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;;CAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,kBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,aAAA;EAAA,eAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,+CAAA;EACA,6GAAA;ADoCF;;AEnCA;;;EAGE,sBAAA;AFsCF;;AEnCA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AFsCF;;AEhCA;EACE,cAAA;AFmCF;;AEzBA;EACE,SAAA;EACA,kCC8SuB;ECzKnB,eAAA;EFnIJ,gBCsT4B;EDrT5B,gBC0T4B;EDzT5B,cCCS;EDAT,gBAAA;EACA,yBCqLQ;AHzJV;;AEhBA;EACE,qBAAA;AFmBF;;AEVA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AFaF;;AEAA;EACE,aAAA;EACA,qBC2R4B;AHxR9B;;AEIA;EACE,aAAA;EACA,mBGoF0B;ALrF5B;;AEYA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;UAAA,8BAAA;AFTF;;AEYA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AFTF;;AEYA;;;EAGE,aAAA;EACA,mBAAA;AFTF;;AEYA;;;;EAIE,gBAAA;AFTF;;AEYA;EACE,gBCyN4B;AHlO9B;;AEYA;EACE,qBAAA;EACA,cAAA;AFTF;;AEYA;EACE,gBAAA;AFTF;;AEYA;;EAEE,mBGqI4B;AL9I9B;;AEYA;EEII,cAAA;AJZJ;;AEiBA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AFdF;;AEiBA;EAAM,eAAA;AFbN;;AEcA;EAAM,WAAA;AFVN;;AEiBA;EACE,cCrFc;EDsFd,qBCkE0B;EDjE1B,6BAAA;AFdF;AMlKE;EJmLE,cC+DwB;ED9DxB,qBC+DwB;AH7E5B;;AEuBA;EACE,cAAA;EACA,qBAAA;AFpBF;AM3KE;EJkME,cAAA;EACA,qBAAA;AFpBJ;;AE6BA;;;;EAIE,iGG0D4B;EDlH1B,cAAA;AJ+BJ;;AE6BA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AF/BF;;AEuCA;EAEE,gBAAA;AFrCF;;AE6CA;EACE,sBAAA;EACA,kBAAA;AF1CF;;AE6CA;EAGE,gBAAA;EACA,sBAAA;AF5CF;;AEoDA;EACE,yBAAA;AFjDF;;AEoDA;EACE,iBC6K4B;ED5K5B,oBC4K4B;ED3K5B,cChOS;EDiOT,gBAAA;EACA,oBAAA;AFjDF;;AEwDA;EAEE,mBAAA;EACA,gCAAA;AFtDF;;AE8DA;EAEE,qBAAA;EACA,qBG4JsC;ALxNxC;;AEkEA;EAEE,gBAAA;AFhEF;;AEwEA;EACE,UAAA;AFrEF;;AEwEA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AFrEF;;AEwEA;;EAEE,iBAAA;AFrEF;;AEwEA;;EAEE,oBAAA;AFrEF;;AE2EA;EACE,eAAA;AFxEF;;AE8EA;EACE,iBAAA;AF3EF;;AEkFA;;;;EAIE,0BAAA;AF/EF;;AEwFI;;;;EACE,eAAA;AFlFN;;AEwFA;;;;EAIE,UAAA;EACA,kBAAA;AFrFF;;AEwFA;;EAEE,sBAAA;EACA,UAAA;AFrFF;;AEyFA;EACE,cAAA;EAEA,gBAAA;AFvFF;;AE0FA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AF7FF;;AEkGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AF/FF;;AEkGA;EACE,wBAAA;AF/FF;;AEmGA;;EAEE,YAAA;AFhGF;;AEmGA;EAKE,oBAAA;EACA,wBAAA;AFpGF;;AE2GA;EACE,wBAAA;AFxGF;;AEgHA;EACE,aAAA;EACA,0BAAA;AF7GF;;AEoHA;EACE,qBAAA;AFjHF;;AEoHA;EACE,kBAAA;EACA,eAAA;AFjHF;;AEoHA;EACE,aAAA;AFjHF;;AEsHA;EACE,wBAAA;AFnHF;;AOzWA;;EAEE,qBJgX4B;EI/W5B,oBJgX4B;EI/W5B,gBJ8V4B;EI7V5B,gBJgX4B;EI/W5B,cJyCS;AHmUX;;AOzWA;EHqKM,mBAAA;AJwMN;;AO5WA;EHoKM,kBAAA;AJ4MN;;AO/WA;EHmKM,oBAAA;AJgNN;;AOlXA;EHkKM,oBAAA;AJoNN;;AOrXA;EHiKM,oBAAA;AJwNN;;AOxXA;EHgKM,mBAAA;AJ4NN;;AO1XA;EH8JM,kBAAA;EG5JJ,gBJqY4B;AHR9B;;AOzXA;EHwJM,iBAAA;EGtJJ,gBJ0U4B;EIzU5B,gBJ4V4B;AHgC9B;;AO1XA;EHmJM,kBAAA;EGjJJ,gBJqU4B;EIpU5B,gBJuV4B;AHsC9B;;AO3XA;EH8IM,oBAAA;EG5IJ,gBJgU4B;EI/T5B,gBJkV4B;AH4C9B;;AO5XA;EHyIM,oBAAA;EGvIJ,gBJ2T4B;EI1T5B,gBJ6U4B;AHkD9B;;AOvXA;EACE,gBJ0X4B;EIzX5B,mBJyX4B;EIxX5B,SAAA;EACA,wCAAA;AP0XF;;AOlXA;;EHkGI,cAAA;EG/FF,gBJkS4B;AHmF9B;;AOlXA;;EAEE,cJ+V4B;EI9V5B,yBJoW4B;AHiB9B;;AO7WA;EC/EE,eAAA;EACA,gBAAA;ARgcF;;AO7WA;ECpFE,eAAA;EACA,gBAAA;ARqcF;;AO/WA;EACE,qBAAA;APkXF;AOhXE;EACE,oBJ8U0B;AHoC9B;;AOxWA;EH2DI,cAAA;EGzDF,yBAAA;AP2WF;;AOvWA;EACE,mBJuKO;ECnGH,kBAAA;AJuSN;;AOvWA;EACE,cAAA;EH+CE,cAAA;EG7CF,cJpES;AH8aX;AOxWE;EACE,aAAA;AP0WJ;;AS7dA;ECIE,eAAA;EAGA,YAAA;AV2dF;;AS5dA;EACE,gBJqgCkC;EIpgClC,yBN2NQ;EM1NR,yBAAA;EEEE,uBAAA;ECFE,0CHEJ;ECPA,eAAA;EAGA,YAAA;AVqeF;;ASvdA;EAEE,qBAAA;ATydF;;AStdA;EACE,qBAAA;EACA,cAAA;ATydF;;AStdA;EL8HI,cAAA;EK5HF,cNWS;AH8cX;;AahgBA;ETmKI,gBAAA;ESjKF,cVsEQ;EUrER,qBAAA;AbmgBF;AahgBE;EACE,cAAA;AbkgBJ;;Aa7fA;EACE,sBAAA;ETsJE,gBAAA;ESpJF,WV6BS;EU5BT,yBVqCS;EQpCP,sBAAA;ECFE,iDCGJ;AbggBF;Aa9fE;EACE,UAAA;ET8IA,eAAA;ES5IA,gBVgV0B;ESxVxB,gBCSF;AbggBJ;;Aa3fA;EACE,cAAA;ETqIE,gBAAA;ESnIF,cVqBS;AHyeX;Aa3fE;ETgIE,kBAAA;ES9HA,cAAA;EACA,kBAAA;Ab6fJ;;AaxfA;EACE,iBRikCkC;EQhkClC,kBAAA;Ab2fF;;AcniBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Af6iBF;;AgB1fI;EFzCE;IACE,gBT8Le;ELyWrB;AACF;AgBhgBI;EFzCE;IACE,gBT8Le;EL8WrB;AACF;AgBrgBI;EFzCE;IACE,gBT8Le;ELmXrB;AACF;AgB1gBI;EFzCE;IACE,iBT8Le;ELwXrB;AACF;Ac3hBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AfikBF;;Ac3hBE;EACE,eAAA;EACA,cAAA;Ad8hBJ;Ac5hBI;;EAEE,gBAAA;EACA,eAAA;Ad8hBN;;AiBplBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AjB4lBJ;;AiBtkBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AjBykBR;;Ae7iBE;EACE,cAAA;EACA,eAAA;AfgjBJ;;AeljBE;EACE,aAAA;EACA,cAAA;AfqjBJ;;AevjBE;EACE,wBAAA;EACA,yBAAA;Af0jBJ;;Ae5jBE;EACE,aAAA;EACA,cAAA;Af+jBJ;;AejkBE;EACE,aAAA;EACA,cAAA;AfokBJ;;AetkBE;EACE,wBAAA;EACA,yBAAA;AfykBJ;;AiB5lBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;Af+lBF;;AiB5lBU;EFbR,qBAAA;EAIA,sBAAA;Af0mBF;;AiBjmBU;EFbR,sBAAA;EAIA,uBAAA;Af+mBF;;AiBtmBU;EFbR,aAAA;EAIA,cAAA;AfonBF;;AiB3mBU;EFbR,sBAAA;EAIA,uBAAA;AfynBF;;AiBhnBU;EFbR,sBAAA;EAIA,uBAAA;Af8nBF;;AiBrnBU;EFbR,aAAA;EAIA,cAAA;AfmoBF;;AiB1nBU;EFbR,sBAAA;EAIA,uBAAA;AfwoBF;;AiB/nBU;EFbR,sBAAA;EAIA,uBAAA;Af6oBF;;AiBpoBU;EFbR,aAAA;EAIA,cAAA;AfkpBF;;AiBzoBU;EFbR,sBAAA;EAIA,uBAAA;AfupBF;;AiB9oBU;EFbR,sBAAA;EAIA,uBAAA;Af4pBF;;AiBnpBU;EFbR,cAAA;EAIA,eAAA;AfiqBF;;AiBlpBM;EAAwB,SAAA;AjBspB9B;;AiBppBM;EAAuB,SAAA;AjBwpB7B;;AiBrpBQ;EAAwB,QADb;AjB0pBnB;;AiBzpBQ;EAAwB,QADb;AjB8pBnB;;AiB7pBQ;EAAwB,QADb;AjBkqBnB;;AiBjqBQ;EAAwB,QADb;AjBsqBnB;;AiBrqBQ;EAAwB,QADb;AjB0qBnB;;AiBzqBQ;EAAwB,QADb;AjB8qBnB;;AiB7qBQ;EAAwB,QADb;AjBkrBnB;;AiBjrBQ;EAAwB,QADb;AjBsrBnB;;AiBrrBQ;EAAwB,QADb;AjB0rBnB;;AiBzrBQ;EAAwB,QADb;AjB8rBnB;;AiB7rBQ;EAAwB,SADb;AjBksBnB;;AiBjsBQ;EAAwB,SADb;AjBssBnB;;AiBrsBQ;EAAwB,SADb;AjB0sBnB;;AiBlsBY;EFhBV,wBAAA;AfstBF;;AiBtsBY;EFhBV,yBAAA;Af0tBF;;AiB1sBY;EFhBV,gBAAA;Af8tBF;;AiB9sBY;EFhBV,yBAAA;AfkuBF;;AiBltBY;EFhBV,yBAAA;AfsuBF;;AiBttBY;EFhBV,gBAAA;Af0uBF;;AiB1tBY;EFhBV,yBAAA;Af8uBF;;AiB9tBY;EFhBV,yBAAA;AfkvBF;;AiBluBY;EFhBV,gBAAA;AfsvBF;;AiBtuBY;EFhBV,yBAAA;Af0vBF;;AiB1uBY;EFhBV,yBAAA;Af8vBF;;AgBzvBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBwxBN;Ee5vBA;IACE,cAAA;IACA,eAAA;Ef8vBF;EehwBA;IACE,aAAA;IACA,cAAA;EfkwBF;EepwBA;IACE,wBAAA;IACA,yBAAA;EfswBF;EexwBA;IACE,aAAA;IACA,cAAA;Ef0wBF;Ee5wBA;IACE,aAAA;IACA,cAAA;Ef8wBF;EehxBA;IACE,wBAAA;IACA,yBAAA;EfkxBF;EiBryBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfuyBA;EiBpyBQ;IFbR,qBAAA;IAIA,sBAAA;EfizBA;EiBxyBQ;IFbR,sBAAA;IAIA,uBAAA;EfqzBA;EiB5yBQ;IFbR,aAAA;IAIA,cAAA;EfyzBA;EiBhzBQ;IFbR,sBAAA;IAIA,uBAAA;Ef6zBA;EiBpzBQ;IFbR,sBAAA;IAIA,uBAAA;Efi0BA;EiBxzBQ;IFbR,aAAA;IAIA,cAAA;Efq0BA;EiB5zBQ;IFbR,sBAAA;IAIA,uBAAA;Efy0BA;EiBh0BQ;IFbR,sBAAA;IAIA,uBAAA;Ef60BA;EiBp0BQ;IFbR,aAAA;IAIA,cAAA;Efi1BA;EiBx0BQ;IFbR,sBAAA;IAIA,uBAAA;Efq1BA;EiB50BQ;IFbR,sBAAA;IAIA,uBAAA;Efy1BA;EiBh1BQ;IFbR,cAAA;IAIA,eAAA;Ef61BA;EiB90BI;IAAwB,SAAA;EjBi1B5B;EiB/0BI;IAAuB,SAAA;EjBk1B3B;EiB/0BM;IAAwB,QADb;EjBm1BjB;EiBl1BM;IAAwB,QADb;EjBs1BjB;EiBr1BM;IAAwB,QADb;EjBy1BjB;EiBx1BM;IAAwB,QADb;EjB41BjB;EiB31BM;IAAwB,QADb;EjB+1BjB;EiB91BM;IAAwB,QADb;EjBk2BjB;EiBj2BM;IAAwB,QADb;EjBq2BjB;EiBp2BM;IAAwB,QADb;EjBw2BjB;EiBv2BM;IAAwB,QADb;EjB22BjB;EiB12BM;IAAwB,QADb;EjB82BjB;EiB72BM;IAAwB,SADb;EjBi3BjB;EiBh3BM;IAAwB,SADb;EjBo3BjB;EiBn3BM;IAAwB,SADb;EjBu3BjB;EiB/2BU;IFhBV,cAAA;Efk4BA;EiBl3BU;IFhBV,wBAAA;Efq4BA;EiBr3BU;IFhBV,yBAAA;Efw4BA;EiBx3BU;IFhBV,gBAAA;Ef24BA;EiB33BU;IFhBV,yBAAA;Ef84BA;EiB93BU;IFhBV,yBAAA;Efi5BA;EiBj4BU;IFhBV,gBAAA;Efo5BA;EiBp4BU;IFhBV,yBAAA;Efu5BA;EiBv4BU;IFhBV,yBAAA;Ef05BA;EiB14BU;IFhBV,gBAAA;Ef65BA;EiB74BU;IFhBV,yBAAA;Efg6BA;EiBh5BU;IFhBV,yBAAA;Efm6BA;AACF;AgB/5BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB67BN;Eej6BA;IACE,cAAA;IACA,eAAA;Efm6BF;Eer6BA;IACE,aAAA;IACA,cAAA;Efu6BF;Eez6BA;IACE,wBAAA;IACA,yBAAA;Ef26BF;Ee76BA;IACE,aAAA;IACA,cAAA;Ef+6BF;Eej7BA;IACE,aAAA;IACA,cAAA;Efm7BF;Eer7BA;IACE,wBAAA;IACA,yBAAA;Efu7BF;EiB18BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ef48BA;EiBz8BQ;IFbR,qBAAA;IAIA,sBAAA;Efs9BA;EiB78BQ;IFbR,sBAAA;IAIA,uBAAA;Ef09BA;EiBj9BQ;IFbR,aAAA;IAIA,cAAA;Ef89BA;EiBr9BQ;IFbR,sBAAA;IAIA,uBAAA;Efk+BA;EiBz9BQ;IFbR,sBAAA;IAIA,uBAAA;Efs+BA;EiB79BQ;IFbR,aAAA;IAIA,cAAA;Ef0+BA;EiBj+BQ;IFbR,sBAAA;IAIA,uBAAA;Ef8+BA;EiBr+BQ;IFbR,sBAAA;IAIA,uBAAA;Efk/BA;EiBz+BQ;IFbR,aAAA;IAIA,cAAA;Efs/BA;EiB7+BQ;IFbR,sBAAA;IAIA,uBAAA;Ef0/BA;EiBj/BQ;IFbR,sBAAA;IAIA,uBAAA;Ef8/BA;EiBr/BQ;IFbR,cAAA;IAIA,eAAA;EfkgCA;EiBn/BI;IAAwB,SAAA;EjBs/B5B;EiBp/BI;IAAuB,SAAA;EjBu/B3B;EiBp/BM;IAAwB,QADb;EjBw/BjB;EiBv/BM;IAAwB,QADb;EjB2/BjB;EiB1/BM;IAAwB,QADb;EjB8/BjB;EiB7/BM;IAAwB,QADb;EjBigCjB;EiBhgCM;IAAwB,QADb;EjBogCjB;EiBngCM;IAAwB,QADb;EjBugCjB;EiBtgCM;IAAwB,QADb;EjB0gCjB;EiBzgCM;IAAwB,QADb;EjB6gCjB;EiB5gCM;IAAwB,QADb;EjBghCjB;EiB/gCM;IAAwB,QADb;EjBmhCjB;EiBlhCM;IAAwB,SADb;EjBshCjB;EiBrhCM;IAAwB,SADb;EjByhCjB;EiBxhCM;IAAwB,SADb;EjB4hCjB;EiBphCU;IFhBV,cAAA;EfuiCA;EiBvhCU;IFhBV,wBAAA;Ef0iCA;EiB1hCU;IFhBV,yBAAA;Ef6iCA;EiB7hCU;IFhBV,gBAAA;EfgjCA;EiBhiCU;IFhBV,yBAAA;EfmjCA;EiBniCU;IFhBV,yBAAA;EfsjCA;EiBtiCU;IFhBV,gBAAA;EfyjCA;EiBziCU;IFhBV,yBAAA;Ef4jCA;EiB5iCU;IFhBV,yBAAA;Ef+jCA;EiB/iCU;IFhBV,gBAAA;EfkkCA;EiBljCU;IFhBV,yBAAA;EfqkCA;EiBrjCU;IFhBV,yBAAA;EfwkCA;AACF;AgBpkCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBkmCN;EetkCA;IACE,cAAA;IACA,eAAA;EfwkCF;Ee1kCA;IACE,aAAA;IACA,cAAA;Ef4kCF;Ee9kCA;IACE,wBAAA;IACA,yBAAA;EfglCF;EellCA;IACE,aAAA;IACA,cAAA;EfolCF;EetlCA;IACE,aAAA;IACA,cAAA;EfwlCF;Ee1lCA;IACE,wBAAA;IACA,yBAAA;Ef4lCF;EiB/mCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfinCA;EiB9mCQ;IFbR,qBAAA;IAIA,sBAAA;Ef2nCA;EiBlnCQ;IFbR,sBAAA;IAIA,uBAAA;Ef+nCA;EiBtnCQ;IFbR,aAAA;IAIA,cAAA;EfmoCA;EiB1nCQ;IFbR,sBAAA;IAIA,uBAAA;EfuoCA;EiB9nCQ;IFbR,sBAAA;IAIA,uBAAA;Ef2oCA;EiBloCQ;IFbR,aAAA;IAIA,cAAA;Ef+oCA;EiBtoCQ;IFbR,sBAAA;IAIA,uBAAA;EfmpCA;EiB1oCQ;IFbR,sBAAA;IAIA,uBAAA;EfupCA;EiB9oCQ;IFbR,aAAA;IAIA,cAAA;Ef2pCA;EiBlpCQ;IFbR,sBAAA;IAIA,uBAAA;Ef+pCA;EiBtpCQ;IFbR,sBAAA;IAIA,uBAAA;EfmqCA;EiB1pCQ;IFbR,cAAA;IAIA,eAAA;EfuqCA;EiBxpCI;IAAwB,SAAA;EjB2pC5B;EiBzpCI;IAAuB,SAAA;EjB4pC3B;EiBzpCM;IAAwB,QADb;EjB6pCjB;EiB5pCM;IAAwB,QADb;EjBgqCjB;EiB/pCM;IAAwB,QADb;EjBmqCjB;EiBlqCM;IAAwB,QADb;EjBsqCjB;EiBrqCM;IAAwB,QADb;EjByqCjB;EiBxqCM;IAAwB,QADb;EjB4qCjB;EiB3qCM;IAAwB,QADb;EjB+qCjB;EiB9qCM;IAAwB,QADb;EjBkrCjB;EiBjrCM;IAAwB,QADb;EjBqrCjB;EiBprCM;IAAwB,QADb;EjBwrCjB;EiBvrCM;IAAwB,SADb;EjB2rCjB;EiB1rCM;IAAwB,SADb;EjB8rCjB;EiB7rCM;IAAwB,SADb;EjBisCjB;EiBzrCU;IFhBV,cAAA;Ef4sCA;EiB5rCU;IFhBV,wBAAA;Ef+sCA;EiB/rCU;IFhBV,yBAAA;EfktCA;EiBlsCU;IFhBV,gBAAA;EfqtCA;EiBrsCU;IFhBV,yBAAA;EfwtCA;EiBxsCU;IFhBV,yBAAA;Ef2tCA;EiB3sCU;IFhBV,gBAAA;Ef8tCA;EiB9sCU;IFhBV,yBAAA;EfiuCA;EiBjtCU;IFhBV,yBAAA;EfouCA;EiBptCU;IFhBV,gBAAA;EfuuCA;EiBvtCU;IFhBV,yBAAA;Ef0uCA;EiB1tCU;IFhBV,yBAAA;Ef6uCA;AACF;AgBzuCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBuwCN;Ee3uCA;IACE,cAAA;IACA,eAAA;Ef6uCF;Ee/uCA;IACE,aAAA;IACA,cAAA;EfivCF;EenvCA;IACE,wBAAA;IACA,yBAAA;EfqvCF;EevvCA;IACE,aAAA;IACA,cAAA;EfyvCF;Ee3vCA;IACE,aAAA;IACA,cAAA;Ef6vCF;Ee/vCA;IACE,wBAAA;IACA,yBAAA;EfiwCF;EiBpxCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfsxCA;EiBnxCQ;IFbR,qBAAA;IAIA,sBAAA;EfgyCA;EiBvxCQ;IFbR,sBAAA;IAIA,uBAAA;EfoyCA;EiB3xCQ;IFbR,aAAA;IAIA,cAAA;EfwyCA;EiB/xCQ;IFbR,sBAAA;IAIA,uBAAA;Ef4yCA;EiBnyCQ;IFbR,sBAAA;IAIA,uBAAA;EfgzCA;EiBvyCQ;IFbR,aAAA;IAIA,cAAA;EfozCA;EiB3yCQ;IFbR,sBAAA;IAIA,uBAAA;EfwzCA;EiB/yCQ;IFbR,sBAAA;IAIA,uBAAA;Ef4zCA;EiBnzCQ;IFbR,aAAA;IAIA,cAAA;Efg0CA;EiBvzCQ;IFbR,sBAAA;IAIA,uBAAA;Efo0CA;EiB3zCQ;IFbR,sBAAA;IAIA,uBAAA;Efw0CA;EiB/zCQ;IFbR,cAAA;IAIA,eAAA;Ef40CA;EiB7zCI;IAAwB,SAAA;EjBg0C5B;EiB9zCI;IAAuB,SAAA;EjBi0C3B;EiB9zCM;IAAwB,QADb;EjBk0CjB;EiBj0CM;IAAwB,QADb;EjBq0CjB;EiBp0CM;IAAwB,QADb;EjBw0CjB;EiBv0CM;IAAwB,QADb;EjB20CjB;EiB10CM;IAAwB,QADb;EjB80CjB;EiB70CM;IAAwB,QADb;EjBi1CjB;EiBh1CM;IAAwB,QADb;EjBo1CjB;EiBn1CM;IAAwB,QADb;EjBu1CjB;EiBt1CM;IAAwB,QADb;EjB01CjB;EiBz1CM;IAAwB,QADb;EjB61CjB;EiB51CM;IAAwB,SADb;EjBg2CjB;EiB/1CM;IAAwB,SADb;EjBm2CjB;EiBl2CM;IAAwB,SADb;EjBs2CjB;EiB91CU;IFhBV,cAAA;Efi3CA;EiBj2CU;IFhBV,wBAAA;Efo3CA;EiBp2CU;IFhBV,yBAAA;Efu3CA;EiBv2CU;IFhBV,gBAAA;Ef03CA;EiB12CU;IFhBV,yBAAA;Ef63CA;EiB72CU;IFhBV,yBAAA;Efg4CA;EiBh3CU;IFhBV,gBAAA;Efm4CA;EiBn3CU;IFhBV,yBAAA;Efs4CA;EiBt3CU;IFhBV,yBAAA;Efy4CA;EiBz3CU;IFhBV,gBAAA;Ef44CA;EiB53CU;IFhBV,yBAAA;Ef+4CA;EiB/3CU;IFhBV,yBAAA;Efk5CA;AACF;AkBt8CA;EACE,WAAA;EACA,mBfiRO;EehRP,cf6CS;Ee5CT,6Bfyb4B;AH+gC9B;AkBt8CE;;EAEE,afkb0B;Eejb1B,mBAAA;EACA,6BAAA;AlBw8CJ;AkBr8CE;EACE,sBAAA;EACA,gCAAA;AlBu8CJ;AkBp8CE;EACE,6BAAA;AlBs8CJ;;AkB57CE;;EAEE,ef4Z0B;AHmiC9B;;AkBt7CA;EACE,yBAAA;AlBy7CF;AkBv7CE;;EAEE,yBAAA;AlBy7CJ;AkBr7CI;;EAEE,wBAAA;AlBu7CN;;AkBj7CE;;;;EAIE,SAAA;AlBo7CJ;;AkB36CE;EACE,qCfuX0B;AHujC9B;;AM7+CE;EY2EI,cfnCK;EeoCL,yBf1CK;AHg9CX;;AmBx/CI;;;EAGE,yBD2F+B;AlBg6CrC;AmBv/CM;;;;EAIE,qBDmFyE;AlBs6CjF;;AM9/CE;EaiBM,yBAJe;AnBq/CvB;AmB/+CQ;;EAEE,yBARa;AnBy/CvB;;AmB5gDI;;;EAGE,yBD2F+B;AlBo7CrC;AmB3gDM;;;;EAIE,qBDmFyE;AlB07CjF;;AMlhDE;EaiBM,yBAJe;AnBygDvB;AmBngDQ;;EAEE,yBARa;AnB6gDvB;;AmBhiDI;;;EAGE,yBD2F+B;AlBw8CrC;AmB/hDM;;;;EAIE,qBDmFyE;AlB88CjF;;AMtiDE;EaiBM,yBAJe;AnB6hDvB;AmBvhDQ;;EAEE,yBARa;AnBiiDvB;;AmBpjDI;;;EAGE,yBD2F+B;AlB49CrC;AmBnjDM;;;;EAIE,qBDmFyE;AlBk+CjF;;AM1jDE;EaiBM,yBAJe;AnBijDvB;AmB3iDQ;;EAEE,yBARa;AnBqjDvB;;AmBxkDI;;;EAGE,yBD2F+B;AlBg/CrC;AmBvkDM;;;;EAIE,qBDmFyE;AlBs/CjF;;AM9kDE;EaiBM,yBAJe;AnBqkDvB;AmB/jDQ;;EAEE,yBARa;AnBykDvB;;AmB5lDI;;;EAGE,yBD2F+B;AlBogDrC;AmB3lDM;;;;EAIE,qBDmFyE;AlB0gDjF;;AMlmDE;EaiBM,yBAJe;AnBylDvB;AmBnlDQ;;EAEE,yBARa;AnB6lDvB;;AmBhnDI;;;EAGE,yBD2F+B;AlBwhDrC;AmB/mDM;;;;EAIE,qBDmFyE;AlB8hDjF;;AMtnDE;EaiBM,yBAJe;AnB6mDvB;AmBvmDQ;;EAEE,yBARa;AnBinDvB;;AmBpoDI;;;EAGE,yBD2F+B;AlB4iDrC;AmBnoDM;;;;EAIE,qBDmFyE;AlBkjDjF;;AM1oDE;EaiBM,yBAJe;AnBioDvB;AmB3nDQ;;EAEE,yBARa;AnBqoDvB;;AmBxpDI;;;EAGE,yBD2F+B;AlBgkDrC;AmBvpDM;;;;EAIE,qBDmFyE;AlBskDjF;;AM9pDE;EaiBM,yBAJe;AnBqpDvB;AmB/oDQ;;EAEE,yBARa;AnBypDvB;;AmB5qDI;;;EAGE,uBD2F+B;AlBolDrC;AmB3qDM;;;;EAIE,mBDmFyE;AlB0lDjF;;AMlrDE;EaiBM,yBAJe;AnByqDvB;AmBnqDQ;;EAEE,yBARa;AnB6qDvB;;AmBhsDI;;;EAGE,uBD2F+B;AlBwmDrC;AmB/rDM;;;;EAIE,mBDmFyE;AlB8mDjF;;AMtsDE;EaiBM,yBAJe;AnB6rDvB;AmBvrDQ;;EAEE,yBARa;AnBisDvB;;AmBptDI;;;EAGE,yBD2F+B;AlB4nDrC;AmBntDM;;;;EAIE,qBDmFyE;AlBkoDjF;;AM1tDE;EaiBM,yBAJe;AnBitDvB;AmB3sDQ;;EAEE,yBARa;AnBqtDvB;;AmBxuDI;;;EAGE,yBhBqCK;AHssDX;;AMxuDE;EaiBM,yBAJe;AnB+tDvB;AmBztDQ;;EAEE,yBARa;AnBmuDvB;;AkB3oDI;EACE,cfwHI;EevHJ,yBfiWwB;EehWxB,qBfmWwB;AH2yC9B;AkBzoDI;EACE,cfvEK;EewEL,yBf7EK;Ee8EL,qBf7EK;AHwtDX;;AkBtoDA;EACE,cfwGQ;EevGR,yBfiV4B;AHwzC9B;AkBvoDE;;;EAGE,qBf+U0B;AH0zC9B;AkBtoDE;EACE,SAAA;AlBwoDJ;AkBpoDI;EACE,2CfoUwB;AHk0C9B;AM3wDE;EY4IM,cfkFE;EejFF,4Cf6TsB;AHq0C9B;;AgBltDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBonDN;EkBjnDM;IACE,SAAA;ElBmnDR;AACF;AgB9tDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB+nDN;EkB5nDM;IACE,SAAA;ElB8nDR;AACF;AgBzuDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB0oDN;EkBvoDM;IACE,SAAA;ElByoDR;AACF;AgBpvDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBqpDN;EkBlpDM;IACE,SAAA;ElBopDR;AACF;AkB9pDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AlB+pDR;AkB5pDQ;EACE,SAAA;AlB8pDV;;AoB30DA;EACE,cAAA;EACA,WAAA;EACA,mCf2esC;Ee1etC,yBAAA;EhB0KI,mBAAA;EgBvKJ,gBjB0V4B;EiBzV5B,gBjB+V4B;EiB9V5B,cjBoCS;EiBnCT,sBjB6BS;EiB5BT,4BAAA;EACA,yBAAA;ETAE,uBAAA;ECFE,gBQOJ;ECPI,2DDQJ;ApB00DF;AqB90DM;EDdN;ICeQ,gBAAA;ErBi1DN;AACF;AoB50DE;EACE,6BAAA;EACA,SAAA;ApB80DJ;AsB12DE;EACE,cnBiDO;EmBhDP,sBnB0CO;EmBzCP,sCnBijBoC;EmBhjBpC,UAAA;EAGE,sBAAA;AtB02DN;AoB90DE;EACE,cjBaO;EiBXP,UAAA;ApB+0DJ;AoBv0DE;EAEE,yBjBFO;EiBIP,UAAA;ApBu0DJ;;AoB/zDE;;;;EACE,wBAAA;UAAA,gBAAA;ApBq0DJ;;AoB/zDE;EACE,kBAAA;EACA,0BAAA;ApBk0DJ;AoB/zDE;EAME,cjB1BO;EiB2BP,sBjBjCO;AH61DX;;AoBvzDA;;EAEE,cAAA;EACA,WAAA;ApB0zDF;;AoBhzDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EhBiEE,kBAAA;EgB/DF,gBjBwQ4B;AH2iD9B;;AoBhzDA;EACE,iCAAA;EACA,oCAAA;EhB0EI,mBAAA;EgBxEJ,gBjBiN6B;AHkmD/B;;AoBhzDA;EACE,gCAAA;EACA,mCAAA;EhBmEI,kBAAA;EgBjEJ,gBjB2M6B;AHwmD/B;;AoB1yDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EhBoDI,mBAAA;EgBlDJ,gBjB2O4B;EiB1O5B,cjB/ES;EiBgFT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApB6yDF;AoB3yDE;EAEE,gBAAA;EACA,eAAA;ApB4yDJ;;AoBhyDA;EACE,kCf6VsC;Ee5VtC,uBAAA;EhB2BI,kBAAA;EgBzBJ,gBjBmK6B;EQ5S3B,sBAAA;AX66DJ;;AoBhyDA;EACE,mCfsVsC;EerVtC,sBAAA;EhBmBI,mBAAA;EgBjBJ,gBjB0J6B;EQ3S3B,wBAAA;AXq7DJ;;AoB9xDE;EAEE,YAAA;ApBgyDJ;;AoB5xDA;EACE,YAAA;ApB+xDF;;AoBvxDA;EACE,qBjBsZsC;AHo4CxC;;AoBvxDA;EACE,cAAA;EACA,mBf4TsC;AL89CxC;;AoBlxDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApBqxDF;AoBnxDE;;EAEE,kBAAA;EACA,iBAAA;ApBqxDJ;;AoB5wDA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;AL8+CxC;;AoB5wDA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;ApB+wDF;AoB5wDE;EAEE,cjBnLO;AHg8DX;;AoBzwDA;EACE,gBAAA;ApB4wDF;;AoBzwDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;AL8/CxC;AoBzwDE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;ApB2wDJ;;AsBn/DE;EACE,aAAA;EACA,WAAA;EACA,mBjBseoC;EiBrepC,cnB0Y0B;EmBzY1B,cFgPqC;ApBswDzC;;AsBn/DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,yCAAA;EACA,qBAAA;AtBs/DJ;;AsBj/DI;;;EAEE,qBF0NmC;ApB2xDzC;AsBn/DM;;;EACE,qBFuNiC;ApBgyDzC;AsBn/DM;;;;;;;EAEE,cAAA;AtB0/DR;;AsBl/DM;EACE,cFwMiC;ApB6yDzC;AsBl/DM;;;EAEE,cAAA;AtBq/DR;;AsB7+DM;EACE,cF0LiC;ApBszDzC;AsB9+DQ;EACE,yBAAA;EACA,qBAAA;AtBg/DV;AsB5+DM;;;EAEE,cAAA;AtB++DR;AsB3+DQ;ECpFJ,yBDqF2B;EACrB,qBAAA;AtB6+DV;AsBx+DQ;EACE,+DAAA;AtB0+DV;;AsBh+DM;EACE,qBFyJiC;ApB00DzC;AsBj+DQ;EAAY,qBAAA;AtBo+DpB;AsBj+DM;;;EAEE,cAAA;AtBo+DR;AsBh+DQ;EACE,4CAAA;AtBk+DV;;AsB1kEE;EACE,aAAA;EACA,WAAA;EACA,mBjBseoC;EiBrepC,cnB0Y0B;EmBzY1B,cFgPqC;ApB61DzC;;AsB1kEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wCAAA;EACA,qBAAA;AtB6kEJ;;AsBxkEI;;;EAEE,qBF0NmC;ApBk3DzC;AsB1kEM;;;EACE,qBFuNiC;ApBu3DzC;AsB1kEM;;;;;;;EAEE,cAAA;AtBilER;;AsBzkEM;EACE,cFwMiC;ApBo4DzC;AsBzkEM;;;EAEE,cAAA;AtB4kER;;AsBpkEM;EACE,cF0LiC;ApB64DzC;AsBrkEQ;EACE,yBAAA;EACA,qBAAA;AtBukEV;AsBnkEM;;;EAEE,cAAA;AtBskER;AsBlkEQ;ECpFJ,yBDqF2B;EACrB,qBAAA;AtBokEV;AsB/jEQ;EACE,8DAAA;AtBikEV;;AsBvjEM;EACE,qBFyJiC;ApBi6DzC;AsBxjEQ;EAAY,qBAAA;AtB2jEpB;AsBxjEM;;;EAEE,cAAA;AtB2jER;AsBvjEQ;EACE,2CAAA;AtByjEV;;AoBh6DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApBm6DF;AoB95DE;EACE,WAAA;ApBg6DJ;AgB/nEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EpB85DJ;EoB15DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EpB45DJ;EoBx5DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EpB05DJ;EoBt5DE;IACE,qBAAA;EpBw5DJ;EoBr5DE;;IAEE,WAAA;EpBu5DJ;EoBl5DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EpBo5DJ;EoBl5DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;EpBo5DJ;EoBj5DE;IACE,mBAAA;IACA,uBAAA;EpBm5DJ;EoBj5DE;IACE,gBAAA;EpBm5DJ;AACF;;AwBruEA;EACE,qBAAA;EAEA,gBrB4f4B;EqB3f5B,crB0CS;EqBzCT,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EC8EE,yBAAA;EACA,mBtBkZ0B;EsBjZ1B,gBtB4Q0B;EsB1QtB,uBtBgOsB;EkBnTxB,qIGGJ;AxBwuEF;AqBvuEM;EGdN;IHeQ,gBAAA;ErB0uEN;AACF;AMpvEE;EkBUE,crB8BO;EqB7BP,qBAAA;AxB6uEJ;AwB1uEE;EAEE,UAAA;EACA,2ErB+e0B;AH4vD9B;AwBvuEE;EAEE,anBkZ0B;EOraxB,gBYoBF;AxBwuEJ;AwBruEE;EACE,eAAA;AxBuuEJ;AwBruEI;EZ1BE,gBY4BA;AxBsuEN;AwBpuEM;EZ9BA,2EALa;AZ0wEnB;;AwB/tEA;;EAEE,oBAAA;AxBkuEF;;AwBztEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzB6xEJ;AMrxEE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBsyEvG;AyB1xEI;EAIQ,4GAAA;AzByxEZ;AyBnxEI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALkuEf;AyBjxEI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBmzE1L;AyB5wEQ;EAGQ,iDAAA;AzB4wEhB;;AwBrvEE;EChEE,cAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzByzEJ;AMjzEE;EmBLM,cAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBk0EvG;AyBtzEI;EAIQ,6GAAA;AzBqzEZ;AyB/yEI;EAEI,cAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;AL8vEf;AyB7yEI;EAGI,cAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB+0E1L;AyBxyEQ;EAGQ,kDAAA;AzBwyEhB;;AwBjxEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBq1EJ;AM70EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB81EvG;AyBl1EI;EAIQ,4GAAA;AzBi1EZ;AyB30EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;AL0xEf;AyBz0EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB22E1L;AyBp0EQ;EAGQ,iDAAA;AzBo0EhB;;AwB7yEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBi3EJ;AMz2EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB03EvG;AyB92EI;EAIQ,4GAAA;AzB62EZ;AyBv2EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALszEf;AyBr2EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBu4E1L;AyBh2EQ;EAGQ,iDAAA;AzBg2EhB;;AwBz0EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzB64EJ;AMr4EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBs5EvG;AyB14EI;EAIQ,2GAAA;AzBy4EZ;AyBn4EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALk1Ef;AyBj4EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBm6E1L;AyB53EQ;EAGQ,gDAAA;AzB43EhB;;AwBr2EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBy6EJ;AMj6EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBk7EvG;AyBt6EI;EAIQ,2GAAA;AzBq6EZ;AyB/5EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;AL82Ef;AyB75EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB+7E1L;AyBx5EQ;EAGQ,gDAAA;AzBw5EhB;;AwBj4EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBq8EJ;AM77EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB88EvG;AyBl8EI;EAIQ,6GAAA;AzBi8EZ;AyB37EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;AL04Ef;AyBz7EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB29E1L;AyBp7EQ;EAGQ,kDAAA;AzBo7EhB;;AwB75EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBi+EJ;AMz9EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB0+EvG;AyB99EI;EAIQ,0GAAA;AzB69EZ;AyBv9EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALs6Ef;AyBr9EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBu/E1L;AyBh9EQ;EAGQ,+CAAA;AzBg9EhB;;AwBz7EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzB6/EJ;AMr/EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBsgFvG;AyB1/EI;EAIQ,0GAAA;AzBy/EZ;AyBn/EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALk8Ef;AyBj/EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBmhF1L;AyB5+EQ;EAGQ,+CAAA;AzB4+EhB;;AwBr9EE;EChEE,cAAA;EFKA,sBlBsEW;EoBzEX,kBpByEW;EO5DT,2EaZF;AzByhFJ;AMjhFE;EmBLM,cAAA;EFDJ,uBEN2D;EASvD,mBAT+F;AzBkiFvG;AyBthFI;EAIQ,6GAAA;AzBqhFZ;AyB/gFI;EAEI,cAAA;EACA,sBpBmDO;EoBlDP,kBpBkDO;AL89Ef;AyB7gFI;EAGI,cAAA;EACA,yBAjCwI;EAqCxI,mBArCkL;AzB+iF1L;AyBxgFQ;EAGQ,kDAAA;AzBwgFhB;;AwBj/EE;EChEE,cAAA;EFKA,sBlBsEW;EoBzEX,kBpByEW;EO5DT,2EaZF;AzBqjFJ;AM7iFE;EmBLM,cAAA;EFDJ,uBEN2D;EASvD,mBAT+F;AzB8jFvG;AyBljFI;EAIQ,6GAAA;AzBijFZ;AyB3iFI;EAEI,cAAA;EACA,sBpBmDO;EoBlDP,kBpBkDO;AL0/Ef;AyBziFI;EAGI,cAAA;EACA,yBAjCwI;EAqCxI,mBArCkL;AzB2kF1L;AyBpiFQ;EAGQ,kDAAA;AzBoiFhB;;AwB7gFE;EChEE,WAAA;EFKA,uBlBsEW;EoBzEX,mBpByEW;EO5DT,2EaZF;AzBilFJ;AMzkFE;EmBLM,WAAA;EFDJ,uBEN2D;EASvD,mBAT+F;AzB0lFvG;AyB9kFI;EAIQ,uGAAA;AzB6kFZ;AyBvkFI;EAEI,WAAA;EACA,uBpBmDO;EoBlDP,mBpBkDO;ALshFf;AyBrkFI;EAGI,WAAA;EACA,uBAjCwI;EAqCxI,mBArCkL;AzBumF1L;AyBhkFQ;EAGQ,4CAAA;AzBgkFhB;;AwBniFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALqiFf;AyBxjFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;AL0iFf;AyBvjFI;EAEI,2CAAA;AzBwjFR;AyBrjFI;EAEI,cpBMO;EoBLP,6BAAA;AzBsjFR;AyBnjFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALsjFf;AyBjjFQ;EAMQ,2CAAA;AzB8iFhB;;AwB9jFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALgkFf;AyBnlFI;EACI,cAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALqkFf;AyBllFI;EAEI,4CAAA;AzBmlFR;AyBhlFI;EAEI,cpBMO;EoBLP,6BAAA;AzBilFR;AyB9kFI;EAGI,cAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALilFf;AyB5kFQ;EAMQ,4CAAA;AzBykFhB;;AwBzlFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL2lFf;AyB9mFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALgmFf;AyB7mFI;EAEI,2CAAA;AzB8mFR;AyB3mFI;EAEI,cpBMO;EoBLP,6BAAA;AzB4mFR;AyBzmFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;AL4mFf;AyBvmFQ;EAMQ,2CAAA;AzBomFhB;;AwBpnFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALsnFf;AyBzoFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;AL2nFf;AyBxoFI;EAEI,2CAAA;AzByoFR;AyBtoFI;EAEI,cpBMO;EoBLP,6BAAA;AzBuoFR;AyBpoFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALuoFf;AyBloFQ;EAMQ,2CAAA;AzB+nFhB;;AwB/oFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALipFf;AyBpqFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALspFf;AyBnqFI;EAEI,0CAAA;AzBoqFR;AyBjqFI;EAEI,cpBMO;EoBLP,6BAAA;AzBkqFR;AyB/pFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALkqFf;AyB7pFQ;EAMQ,0CAAA;AzB0pFhB;;AwB1qFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL4qFf;AyB/rFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALirFf;AyB9rFI;EAEI,0CAAA;AzB+rFR;AyB5rFI;EAEI,cpBMO;EoBLP,6BAAA;AzB6rFR;AyB1rFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;AL6rFf;AyBxrFQ;EAMQ,0CAAA;AzBqrFhB;;AwBrsFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALusFf;AyB1tFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;AL4sFf;AyBztFI;EAEI,4CAAA;AzB0tFR;AyBvtFI;EAEI,cpBMO;EoBLP,6BAAA;AzBwtFR;AyBrtFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALwtFf;AyBntFQ;EAMQ,4CAAA;AzBgtFhB;;AwBhuFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALkuFf;AyBrvFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALuuFf;AyBpvFI;EAEI,yCAAA;AzBqvFR;AyBlvFI;EAEI,cpBMO;EoBLP,6BAAA;AzBmvFR;AyBhvFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALmvFf;AyB9uFQ;EAMQ,yCAAA;AzB2uFhB;;AwB3vFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL6vFf;AyBhxFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALkwFf;AyB/wFI;EAEI,yCAAA;AzBgxFR;AyB7wFI;EAEI,cpBMO;EoBLP,6BAAA;AzB8wFR;AyB3wFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;AL8wFf;AyBzwFQ;EAMQ,yCAAA;AzBswFhB;;AwBtxFE;ECnBE,WpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,kBpBqBW;ALwxFf;AyB3yFI;EACI,cAP4C;EAQ5C,sBpBiBO;EoBhBP,kBpBgBO;AL6xFf;AyB1yFI;EAEI,4CAAA;AzB2yFR;AyBxyFI;EAEI,WpBMO;EoBLP,6BAAA;AzByyFR;AyBtyFI;EAGI,cAAA;EACA,sBpBFO;EoBGP,kBpBHO;ALyyFf;AyBpyFQ;EAMQ,4CAAA;AzBiyFhB;;AwBjzFE;ECnBE,WpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,kBpBqBW;ALmzFf;AyBt0FI;EACI,cAP4C;EAQ5C,sBpBiBO;EoBhBP,kBpBgBO;ALwzFf;AyBr0FI;EAEI,4CAAA;AzBs0FR;AyBn0FI;EAEI,WpBMO;EoBLP,6BAAA;AzBo0FR;AyBj0FI;EAGI,cAAA;EACA,sBpBFO;EoBGP,kBpBHO;ALo0Ff;AyB/zFQ;EAMQ,4CAAA;AzB4zFhB;;AwB50FE;ECnBE,YpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,mBpBqBW;AL80Ff;AyBj2FI;EACI,WAP4C;EAQ5C,uBpBiBO;EoBhBP,mBpBgBO;ALm1Ff;AyBh2FI;EAEI,sCAAA;AzBi2FR;AyB91FI;EAEI,YpBMO;EoBLP,6BAAA;AzB+1FR;AyB51FI;EAGI,WAAA;EACA,uBpBFO;EoBGP,mBpBHO;AL+1Ff;AyB11FQ;EAMQ,sCAAA;AzBu1FhB;;AwB51FA;EACE,gBrBoR4B;EqBnR5B,crBiBc;EqBhBd,qBrBwK0B;AHurF5B;AMx6FE;EkB4EE,crBsKwB;EqBrKxB,qBrBsKwB;AHyrF5B;AwB51FE;EAEE,qBrBiKwB;AH4rF5B;AwB11FE;EAEE,crBhDO;EqBiDP,oBAAA;AxB21FJ;;AwBh1FA;EChBI,sBAAA;EACA,mBtBmZ6B;EsBlZ7B,gBtB4N2B;EsB1NvB,wBtBkOsB;AHioF9B;;AwBn1FA;ECpBI,uBAAA;EACA,kBtBiZ0B;EsBhZ1B,gBtB6N2B;EsB3NvB,uBtBgOsB;AH0oF9B;;AwBj1FA;EACE,cAAA;EACA,WAAA;AxBo1FF;AwBj1FE;EACE,kBnBwT0B;AL2hF9B;;AwB30FE;;;EACE,WAAA;AxBg1FJ;;A0B39FA;ELgBM,gCKfJ;A1B89FF;AqB38FM;EKpBN;ILqBQ,gBAAA;ErB88FN;AACF;A0Bj+FE;EACE,UAAA;A1Bm+FJ;;A0B99FE;EACE,aAAA;A1Bi+FJ;;A0B79FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A1Bg+FF;AqB99FM;EKNN;ILOQ,gBAAA;ErBi+FN;AACF;A0Bn+FE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A1Bq+FJ;AqBx+FM;EKAJ;ILCM,gBAAA;ErB2+FN;AACF;;A2BhgGA;;;;EAIE,kBAAA;A3BmgGF;;A2BhgGA;EACE,mBAAA;A3BmgGF;A4B/+FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A5BkhGF;A4B79FI;EACE,cAAA;A5B+9FN;;A2BzgGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;EvB2JI,eAAA;EuBzJJ,cxByBS;EwBxBT,gBAAA;EACA,gBAAA;EACA,sBxBeS;EwBdT,4BAAA;EACA,mCAAA;EhBdE,wBAAA;ECFE,iHekBJ;A3B4gGF;;A2BrgGI;EACE,WAAA;EACA,OAAA;A3BwgGN;;A2BrgGI;EACE,QAAA;EACA,UAAA;A3BwgGN;;AgB5/FI;EWnBA;IACE,WAAA;IACA,OAAA;E3BmhGJ;E2BhhGE;IACE,QAAA;IACA,UAAA;E3BkhGJ;AACF;AgBvgGI;EWnBA;IACE,WAAA;IACA,OAAA;E3B6hGJ;E2B1hGE;IACE,QAAA;IACA,UAAA;E3B4hGJ;AACF;AgBjhGI;EWnBA;IACE,WAAA;IACA,OAAA;E3BuiGJ;E2BpiGE;IACE,QAAA;IACA,UAAA;E3BsiGJ;AACF;AgB3hGI;EWnBA;IACE,WAAA;IACA,OAAA;E3BijGJ;E2B9iGE;IACE,QAAA;IACA,UAAA;E3BgjGJ;AACF;A2BziGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;AL42EpC;A4B1kGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A5BsmGF;A4BxjGI;EACE,cAAA;A5B0jGN;;A2B/iGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;ALi4EpC;A4B/lGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A5BonGF;A4B7kGI;EACE,cAAA;A5B+kGN;A2B1jGI;EACE,iBAAA;A3B4jGN;;A2BtjGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;ALy5EpC;A4BvnGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A5BynGN;A4B9mGM;EACE,aAAA;A5BgnGR;A4B7mGM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A5B8oGF;A4B7mGI;EACE,cAAA;A5B+mGN;A2BzkGI;EACE,iBAAA;A3B2kGN;;A2BnkGE;EAIE,WAAA;EACA,YAAA;A3BmkGJ;;A2B9jGA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A7BgrGF;;A2B9jGA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBxBwO4B;EwBvO5B,cxB1ES;EwB2ET,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A3BgkGF;AMrrGE;EqBoIE,ctBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBpByCO;AH2pGX;A2BjjGE;EAEE,WxB9GO;EwB+GP,qBAAA;EJtJA,yBpBuU4B;AHk4FhC;A2B/iGE;EAEE,cxBhHO;EwBiHP,oBAAA;EACA,6BAAA;A3BgjGJ;;A2BxiGA;EACE,cAAA;A3B2iGF;;A2BviGA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;EvBAI,mBAAA;EuBEJ,cxBnIS;EwBoIT,mBAAA;A3B0iGF;;A2BtiGA;EACE,cAAA;EACA,uBAAA;EACA,cxBxIS;AHirGX;;A8BpuGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A9BuuGF;A8BruGE;;EACE,kBAAA;EACA,cAAA;A9BwuGJ;AMvuGE;;EwBII,UAAA;A9BuuGN;A8BruGI;;;;EAGE,UAAA;A9BwuGN;;A8BluGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A9BquGF;A8BnuGE;EACE,WAAA;A9BquGJ;;A8B/tGE;;EAEE,iBAAA;A9BkuGJ;A8B9tGE;;EnBXE,0BAAA;EACA,6BAAA;AX6uGJ;A8B9tGE;;EnBFE,yBAAA;EACA,4BAAA;AXouGJ;;A8BjtGA;EACE,wBAAA;EACA,uBAAA;A9BotGF;A8BltGE;EAGE,cAAA;A9BktGJ;A8B/sGE;EACE,eAAA;A9BitGJ;;A8B7sGA;EACE,uBAAA;EACA,sBAAA;A9BgtGF;;A8B7sGA;EACE,sBAAA;EACA,qBAAA;A9BgtGF;;A8B1sGA;ElBhFM,gBkBiFJ;A9B6sGF;A8B1sGE;ElBpFI,gBkBqFF;A9B4sGJ;;A8BnsGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A9BssGF;A8BpsGE;;EAEE,WAAA;A9BssGJ;A8BnsGE;;EAEE,gBAAA;A9BqsGJ;A8BjsGE;;EnBrFE,6BAAA;EACA,4BAAA;AX0xGJ;A8BjsGE;;EnBxGE,yBAAA;EACA,0BAAA;AX6yGJ;;A8BlrGE;;EAEE,gBAAA;A9BqrGJ;A8BnrGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9BurGN;;A+Bh1GA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/Bm1GF;A+Bj1GE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A/Bm1GJ;A+Bj1GI;;;;;;;;;;;;EAGE,iBAAA;A/B41GN;A+Bv1GE;;;EAGE,UAAA;A/By1GJ;A+Br1GE;EACE,UAAA;A/Bu1GJ;A+Bl1GI;;EpBIA,yBAAA;EACA,4BAAA;AXk1GJ;A+Bl1GE;EACE,aAAA;EACA,mBAAA;A/Bo1GJ;A+Bl1GI;EpBnBA,0BAAA;EACA,6BAAA;AXw2GJ;A+Bp1GI;EpBPA,yBAAA;EACA,4BAAA;AX81GJ;A+Bp1GI;;;;EpBzBA,0BAAA;EACA,6BAAA;AXm3GJ;A+Bl1GI;;;;EpBlCA,0BAAA;EACA,6BAAA;AX03GJ;;A+Bz0GA;;EAEE,aAAA;A/B40GF;A+Bv0GE;;EACE,kBAAA;EACA,UAAA;A/B00GJ;A+Bx0GI;;EACE,UAAA;A/B20GN;A+Bv0GE;;;;;;;;EAIE,iBAAA;A/B60GJ;;A+Bz0GA;EAAuB,kBAAA;A/B60GvB;;A+B50GA;EAAsB,iBAAA;A/Bg1GtB;;A+Bx0GA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;E3B2DI,mBAAA;E2BzDJ,gB5B4O4B;E4B3O5B,gB5BiP4B;E4BhP5B,c5B3ES;E4B4ET,kBAAA;EACA,mBAAA;EACA,sB5BnFS;E4BoFT,yBAAA;EpB/GE,uBAAA;AX27GJ;A+Bx0GE;;EAEE,aAAA;A/B00GJ;;A+Bh0GA;;EAEE,mC1BmWsC;ALg+FxC;;A+Bh0GA;;;;;;EAME,sBAAA;E3BwBI,mBAAA;E2BtBJ,gB5B+J6B;EQ3S3B,wBAAA;AXg9GJ;;A+Bh0GA;;EAEE,kC1BiVsC;ALk/FxC;;A+Bh0GA;;;;;;EAME,uBAAA;E3BOI,kBAAA;E2BLJ,gB5B+I6B;EQ5S3B,sBAAA;AXi+GJ;;A+Bh0GA;;EAEE,sBAAA;A/Bm0GF;;A+BxzGA;;;;;;;;EpB9JI,0BAAA;EACA,6BAAA;AXi+GJ;;A+BzzGA;;;;;;EpB3JI,yBAAA;EACA,4BAAA;AX69GJ;;AgCrgHA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;UAAA,yBAAA;AhCwgHF;;AgCrgHA;EACE,oBAAA;EACA,kB7BikBsC;AHu8FxC;;AgCrgHA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,c7B2jBsC;E6B1jBtC,gBAAA;EACA,UAAA;AhCwgHF;AgCtgHE;EACE,W7BaO;E6BZP,qB7B6S4B;EoBxU5B,yBpBuU4B;ES7T1B,gBoBmBF;AhCwgHJ;AgCrgHE;EAGI,sBAAA;AhCqgHN;AgC//GE;EACE,sC7BqgBoC;AH4/FxC;AgC9/GE;EACE,W7BPO;E6BQP,yB7BwR4B;E6BvR5B,qB7BwR4B;ES9T1B,gBoBuCF;AhCggHJ;AgC1/GI;EACE,c7BXK;AHugHX;AgC1/GM;EACE,yB7BlBG;AH8gHX;;AgCl/GA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AhCo/GF;AgCh/GE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,c7B8foC;E6B7fpC,e7B6foC;E6B5fpC,oBAAA;EACA,WAAA;EACA,sB7B/CO;E6BgDP,yBAAA;EpB7EE,gBoB8EF;AhCk/GJ;AgC9+GE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,c7B+eoC;E6B9epC,e7B8eoC;E6B7epC,WAAA;EACA,iCAAA;AhCg/GJ;;AgCt+GE;ErBlGE,sBAAA;AX4kHJ;AgCr+GI;EACE,yDAAA;AhCu+GN;AgCl+GI;EACE,qB7B6M0B;EoBvU5B,yBpBuU4B;AHwxGhC;AgCj+GI;EACE,yDAAA;AhCm+GN;AgC99GI;ETpIA,yCpBsmB4C;AH+/FhD;AgC99GI;ETvIA,yCpBsmB4C;AHkgGhD;;AgCt9GE;EAEE,kB3B0Z4C;AL8jGhD;AgCp9GI;EACE,yDAAA;AhCs9GN;AgCj9GI;ET9JA,yCpBsmB4C;AH4gGhD;;AgCz8GA;EACE,uBAAA;AhC48GF;AgCz8GI;EACE,gBAAA;EACA,gB3BkY0C;E2BjY1C,mBAAA;EAEA,uB3BgY0C;AL0kGhD;AgCv8GI;EACE,yBAAA;EACA,4BAAA;EACA,0B3B2X0C;E2B1X1C,2B3B0X0C;E2BzX1C,yB7BgXkC;E6B9WlC,uB3BsX0C;EgBxiB1C,yIWmLA;AhCw8GN;AqBvnHM;EWuKF;IXtKI,gBAAA;ErB0nHN;AACF;AgCx8GI;EACE,sB7B5JK;E6B6JL,gCAAA;AhC08GN;AgCr8GI;ETzMA,yCpBsmB4C;AH2iGhD;;AgC37GA;EACE,qBAAA;EACA,WAAA;EACA,mC3BqRsC;E2BpRtC,0CAAA;E5B5CI,mBAAA;E4B+CJ,gB7BoI4B;E6BnI5B,gB7ByI4B;E6BxI5B,c7BlLS;E6BmLT,sBAAA;EACA,gGAAA;EACA,yBAAA;ErBtNE,uBAAA;ECFE,gDoB0NJ;EACA,wBAAA;UAAA,gBAAA;AhC67GF;AgC37GE;EACE,sC7BuUoC;E6BtUpC,UAAA;EpB/NE,iEALa;AZkqHnB;AgCt7GI;EAME,c7B1MK;E6B2ML,sB7BjNK;AHooHX;AgC/6GE;EAEE,YAAA;EACA,sB7B2N0B;E6B1N1B,sBAAA;AhCg7GJ;AgC76GE;EACE,c7BvNO;E6BwNP,yB7B5NO;AH2oHX;AgC36GE;EACE,aAAA;AhC66GJ;AgCz6GE;EACE,kBAAA;EACA,0BAAA;AhC26GJ;;AgCv6GA;EACE,kC3B0NsC;E2BzNtC,oB7B2M4B;E6B1M5B,uB7B0M4B;E6BzM5B,oB7B0M4B;ECpTxB,kBAAA;AJqhHN;;AgCv6GA;EACE,mC3BmNsC;E2BlNtC,qB7BuM4B;E6BtM5B,wB7BsM4B;E6BrM5B,kB7BsM4B;ECxTxB,mBAAA;AJ6hHN;;AgCl6GA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BiMsC;E2BhMtC,gBAAA;AhCq6GF;;AgCl6GA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3ByLsC;E2BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;AhCq6GF;AgCn6GE;EACE,sC7BoPoC;E6BnPpC,gB7BsPoC;AH+qGxC;AgCj6GE;EAEE,yB7BzRO;AH2rHX;AgC95GI;EACE,iB3B2Ta;ALqmGnB;AgC55GE;EACE,0BAAA;AhC85GJ;;AgC15GA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BwJsC;E2BvJtC,yBAAA;EACA,gBAAA;EAEA,gB7BO4B;E6BN5B,gB7BY4B;E6BX5B,c7B/SS;E6BgTT,sB7BtTS;E6BuTT,yBAAA;ErBlVE,uBAAA;ECFE,gBoBsVJ;AhC45GF;AgC15GE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BiIoC;E2BhIpC,yBAAA;EACA,gB7BJ0B;E6BK1B,c7B/TO;E6BgUP,iBAAA;ET7WA,sBpBuCO;E6BwUP,oBAAA;ErBnWA,oCAAA;AXgwHJ;;AgCl5GA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;UAAA,gBAAA;AhCq5GF;AgCn5GE;EACE,UAAA;AhCq5GJ;AgCj5GI;EAA0B,mC3BoOe;ALgrG7C;AgCn5GI;EAA0B,mC3BmOe;ALmrG7C;AgCr5GI;EAA0B,mC3BkOe;ALsrG7C;AgCr5GE;EACE,SAAA;AhCu5GJ;AgCp5GE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBpBuU4B;E6B6E5B,S3BmNyC;EM3lBzC,mBAAA;ECFE,+CoB4YF;EX5YE,oHW6YF;EX7YE,4GW6YF;EACA,wBAAA;UAAA,gBAAA;AhCs5GJ;AqBhyHM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;ErBmyHN;AACF;AgCz5GI;ET1ZA,yBlB4mByC;AL0sG7C;AgCv5GE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yB7B1XO;E6B2XP,yBAAA;ErBzZA,mBAAA;ECFE,sDoB6ZF;AhCy5GJ;AgCt5GE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBpBuU4B;E6BuG5B,S3ByLyC;EM3lBzC,mBAAA;ECFE,+CoBsaF;EXtaE,iHWuaF;EXvaE,4GWuaF;EACA,gBAAA;AhCw5GJ;AqB5zHM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;ErB+zHN;AACF;AgC35GI;ETpbA,yBlB4mByC;ALsuG7C;AgCz5GE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yB7BpZO;E6BqZP,yBAAA;ErBnbA,mBAAA;ECFE,sDoBubF;AhC25GJ;AgCx5GE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,e7ByGoC;E6BxGpC,c7BwGoC;EoBjjBpC,yBpBuU4B;E6BoI5B,S3B4JyC;EM3lBzC,mBAAA;ECFE,+CoBmcF;EXncE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;AhC05GJ;AqB31HM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;ErB81HN;AACF;AgC75GI;ETjdA,yBlB4mByC;ALqwG7C;AgC35GE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;EpBndE,sDoBodF;AhC65GJ;AgC15GE;EACE,yB7BxbO;EQ9BP,mBAAA;AXm3HJ;AgCz5GE;EACE,kBAAA;EACA,yB7B9bO;EQ9BP,mBAAA;AXw3HJ;AgCv5GI;EACE,yB7BlcK;AH21HX;AgCt5GI;EACE,eAAA;AhCw5GN;AgCr5GI;EACE,yB7B1cK;AHi2HX;AgCp5GI;EACE,eAAA;AhCs5GN;AgCn5GI;EACE,yB7BldK;AHu2HX;;AgCh5GA;;;EXzfM,4GW4fJ;AhCm5GF;AqB34HM;EWqfN;;;IXpfQ,gBAAA;ErBg5HN;AACF;;AiCj6HA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjCo6HF;;AiCj6HA;EACE,cAAA;EACA,wBAAA;AjCo6HF;AMn6HE;E2BGE,qBAAA;AjCm6HJ;AiC/5HE;EACE,c9B2BO;E8B1BP,oBAAA;EACA,eAAA;AjCi6HJ;;AiCz5HA;EACE,gCAAA;AjC45HF;AiC15HE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;EtBbA,gCAAA;EACA,iCAAA;AX06HJ;AMt7HE;E2B6BI,kBAAA;EACA,qC5BipB8B;AL2wGpC;AiCz5HI;EACE,c9BCK;E8BAL,6BAAA;EACA,yBAAA;AjC25HN;AiCv5HE;;EAEE,c9BNO;E8BOP,yB9B+KM;E8B9KN,qC5BsoBgC;ALmxGpC;AiCt5HE;EAEE,gBAAA;EtBtCA,yBAAA;EACA,0BAAA;AX87HJ;;AiC74HE;EACE,gBAAA;EACA,SAAA;EtB7DA,uBAAA;AX88HJ;AiC74HE;;EAEE,W9BqnBgC;E8BpnBhC,yB9BqnBgC;AH0xGpC;;AiCr4HE;;EAEE,cAAA;EACA,kBAAA;AjCw4HJ;;AiCn4HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AjCs4HJ;;AiC53HE;EACE,aAAA;AjC+3HJ;AiC73HE;EACE,cAAA;AjC+3HJ;;AkCx+HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AlC2+HF;AkCv+HE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AlC8+HJ;AkC19HA;EACE,qBAAA;EACA,sB7BkqBkC;E6BjqBlC,yB7BiqBkC;E6BhqBlC,kB/B2pBkC;EC9hB9B,kBAAA;E8B3HJ,oBAAA;EACA,mBAAA;AlC49HF;AMtgIE;E4B6CE,qBAAA;AlC49HJ;;AkCn9HA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCs9HF;AkCp9HE;EACE,gBAAA;EACA,eAAA;AlCs9HJ;AkCn9HE;EACE,gBAAA;EACA,WAAA;AlCq9HJ;;AkC58HA;EACE,qBAAA;EACA,oB/BylBkC;E+BxlBlC,uB/BwlBkC;AHu3GpC;;AkCn8HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AlCo8HF;;AkCh8HA;EACE,wBAAA;E9B8DI,kBAAA;E8B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EvBxGE,uBAAA;AX4iIJ;AM9iIE;E4B8GE,qBAAA;AlCm8HJ;;AkC77HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AlCg8HF;;AkC77HA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AlCg8HF;;AgBtgII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElC67HR;AACF;AgB/hII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCk7HN;EkCh7HM;IACE,mBAAA;ElCk7HR;EkCh7HQ;IACE,kBAAA;ElCk7HV;EkC/6HQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EHs5GlC;EkC56HM;;;;;;IACE,iBAAA;ElCm7HR;EkCr6HM;IACE,iBAAA;ElCu6HR;EkCp6HM;IACE,wBAAA;IAGA,gBAAA;ElCo6HR;EkCj6HM;IACE,aAAA;ElCm6HR;AACF;AgBpjII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElC0+HR;AACF;AgB5kII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC+9HN;EkC79HM;IACE,mBAAA;ElC+9HR;EkC79HQ;IACE,kBAAA;ElC+9HV;EkC59HQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EHm8GlC;EkCz9HM;;;;;;IACE,iBAAA;ElCg+HR;EkCl9HM;IACE,iBAAA;ElCo9HR;EkCj9HM;IACE,wBAAA;IAGA,gBAAA;ElCi9HR;EkC98HM;IACE,aAAA;ElCg9HR;AACF;AgBjmII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCuhIR;AACF;AgBznII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC4gIN;EkC1gIM;IACE,mBAAA;ElC4gIR;EkC1gIQ;IACE,kBAAA;ElC4gIV;EkCzgIQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EHg/GlC;EkCtgIM;;;;;;IACE,iBAAA;ElC6gIR;EkC//HM;IACE,iBAAA;ElCigIR;EkC9/HM;IACE,wBAAA;IAGA,gBAAA;ElC8/HR;EkC3/HM;IACE,aAAA;ElC6/HR;AACF;AgB9oII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCokIR;AACF;AgBtqII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCyjIN;EkCvjIM;IACE,mBAAA;ElCyjIR;EkCvjIQ;IACE,kBAAA;ElCyjIV;EkCtjIQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EH6hHlC;EkCnjIM;;;;;;IACE,iBAAA;ElC0jIR;EkC5iIM;IACE,iBAAA;ElC8iIR;EkC3iIM;IACE,wBAAA;IAGA,gBAAA;ElC2iIR;EkCxiIM;IACE,aAAA;ElC0iIR;AACF;AkC3mII;EAoBI,qBAAA;EACA,2BAAA;AlC0lIR;AkC7mIQ;;;;;;EACE,gBAAA;EACA,eAAA;AlConIV;AkCjmIQ;EACE,mBAAA;AlCmmIV;AkCjmIU;EACE,kBAAA;AlCmmIZ;AkChmIU;EACE,mB/B4hBwB;E+B3hBxB,kB/B2hBwB;AHukHpC;AkC7lIQ;;;;;;EACE,iBAAA;AlComIV;AkCtlIQ;EACE,iBAAA;AlCwlIV;AkCrlIQ;EACE,wBAAA;EAGA,gBAAA;AlCqlIV;AkCllIQ;EACE,aAAA;AlColIV;;AkCtkIE;EACE,yB/B+gBgC;AH0jHpC;AMjyIE;E4B2NI,yB/B4gB8B;AH6jHpC;AkCpkII;EACE,yB/BogB8B;AHkkHpC;AMvyIE;E4BoOM,yB/BkgB4B;AHokHpC;AkCnkIM;EACE,yB/BggB4B;AHqkHpC;AkCjkII;;;;EAIE,yB/Buf8B;AH4kHpC;AkC/jIE;EACE,yB/BgfgC;E+B/ehC,yB/BmfgC;AH8kHpC;AkC9jIE;EACE,yDAAA;AlCgkIJ;AkC7jIE;EACE,yB/BuegC;AHwlHpC;AkC9jII;EACE,yB/Bue8B;AHylHpC;AMh0IE;E4BmQM,yB/Boe4B;AH4lHpC;;AkCxjIE;EACE,gC/B4cgC;AH+mHpC;AMv0IE;E4B+QI,gC/Byc8B;AHknHpC;AkCtjII;EACE,gC/Bic8B;AHunHpC;AM70IE;E4BwRM,gC/B+b4B;AHynHpC;AkCrjIM;EACE,gC/B6b4B;AH0nHpC;AkCnjII;;;;EAIE,gC/Bob8B;AHioHpC;AkCjjIE;EACE,gC/B6agC;E+B5ahC,yB/BgbgC;AHmoHpC;AkChjIE;EACE,yDAAA;AlCkjIJ;AkC/iIE;EACE,gC/BoagC;AH6oHpC;AkChjII;EACE,gC/Boa8B;AH8oHpC;AMt2IE;E4BuTM,gC/Bia4B;AHipHpC;;AmCr3IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBhCkCS;EgCjCT,2BAAA;EACA,qCAAA;ExBKE,uBAAA;AXm3IJ;AmCr3IE;EACE,eAAA;EACA,cAAA;AnCu3IJ;AmCp3IE;EACE,mBAAA;EACA,sBAAA;AnCs3IJ;AmCp3II;EACE,mBAAA;ExBCF,4CAAA;EACA,6CAAA;AXs3IJ;AmCp3II;EACE,sBAAA;ExBUF,gDAAA;EACA,+CAAA;AX62IJ;AmCj3IE;;EAEE,aAAA;AnCm3IJ;;AmC/2IA;EAGE,cAAA;EAGA,eAAA;EACA,ehCg2BkC;AH8gHpC;;AmC12IA;EACE,sBhC01BkC;AHmhHpC;;AmC12IA;EACE,qBAAA;EACA,gBAAA;AnC62IF;;AmC12IA;EACE,gBAAA;AnC62IF;;AMl6IE;E6B0DE,qBAAA;AnC42IJ;AmCz2IE;EACE,mBhCy0BgC;AHkiHpC;;AmCn2IA;EACE,uBAAA;EACA,gBAAA;EAEA,sBhCzCS;EgC0CT,4CAAA;AnCq2IF;AmCn2IE;ExBvEE,4DAAA;AX66IJ;;AmCj2IA;EACE,uBAAA;EAEA,sBhCpDS;EgCqDT,yCAAA;AnCm2IF;AmCj2IE;ExBlFE,4DAAA;AXs7IJ;;AmC11IA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AnC61IF;;AmC11IA;EACE,sBAAA;EACA,qBAAA;AnC61IF;;AmCz1IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBhC0xBkC;EQz4BhC,mCAAA;AX48IJ;;AmCz1IA;;;EAGE,cAAA;EACA,WAAA;AnC41IF;;AmCz1IA;;ExBjHI,4CAAA;EACA,6CAAA;AX+8IJ;;AmC11IA;;ExBxGI,gDAAA;EACA,+CAAA;AXu8IJ;;AmCv1IE;EACE,mB9BqrBgC;ALqqHpC;AgBz7II;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EnC01IF;EmCx1IE;IAEE,SAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;ELkrHlC;AACF;;AmC70IE;EACE,mB9BypBgC;ALurHpC;AgB38II;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EnCg1IF;EmC70IE;IAEE,SAAA;IACA,gBAAA;EnC80IJ;EmC50II;IACE,cAAA;IACA,cAAA;EnC80IN;EmCz0IM;IxBzKJ,0BAAA;IACA,6BAAA;EXq/IF;EmC10IQ;;IAGE,0BAAA;EnC20IV;EmCz0IQ;;IAGE,6BAAA;EnC00IV;EmCt0IM;IxB1KJ,yBAAA;IACA,4BAAA;EXm/IF;EmCv0IQ;;IAGE,yBAAA;EnCw0IV;EmCt0IQ;;IAGE,4BAAA;EnCu0IV;AACF;;AmC1zIE;EACE,sBhC8pBgC;AH+pHpC;AgBr/II;EmBsLJ;IAMI,ehCwqBgC;IgCvqBhC,mBhCwqBgC;IgCvqBhC,UAAA;IACA,SAAA;EnC6zIF;EmC3zIE;IACE,qBAAA;IACA,WAAA;EnC6zIJ;AACF;;AmCpzIA;EACE,qBAAA;AnCuzIF;AmCrzIE;EACE,gBAAA;AnCuzIJ;AmCrzII;EACE,gBAAA;ExBvOF,6BAAA;EACA,4BAAA;AX+hJJ;AmCrzII;ExBzPA,yBAAA;EACA,0BAAA;AXijJJ;AmCrzII;ExBtQA,gBAAA;EwBwQE,mBAAA;AnCuzIN;;AoCjlJA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yBjCwCS;EQ7BP,uBAAA;AXykJJ;;AoC9kJE;EACE,oB/ByhCgC;ALwjHpC;AoC/kJI;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,cjCgCK;EiC/BL,YAAA;ApCilJN;AoCvkJE;EACE,0BAAA;ApCykJJ;AoCtkJE;EACE,qBAAA;ApCwkJJ;AoCrkJE;EACE,cjCYO;AH2jJX;;AqC9mJA;EACE,aAAA;E7BGA,eAAA;EACA,gBAAA;EGaE,uBAAA;AXmmJJ;;AqC/mJA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCoxBkC;EgCnxBlC,clCuCS;EkCrCT,sBlC+BS;EkC9BT,yBAAA;ArCinJF;AqC/mJE;EACE,UAAA;EACA,clCgCO;EkC/BP,qBAAA;EACA,yBlC2BO;EkC1BP,qBlC0BO;AHulJX;AqC9mJE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,gBlCyc0B;AHuqI9B;;AqC1mJI;EACE,cAAA;E1BaF,gCAAA;EACA,mCAAA;AXimJJ;AqC1mJI;E1BNA,iCAAA;EACA,oCAAA;AXmnJJ;AqCzmJE;EACE,UAAA;EACA,WlCFO;EkCGP,yBlC6R4B;EkC5R5B,qBlC4R4B;AH+0IhC;AqCxmJE;EACE,clCFO;EkCGP,oBAAA;EAEA,YAAA;EACA,sBlCZO;EkCaP,qBlCVO;AHmnJX;;AsChqJE;EACE,uBAAA;ElCgLE,kBAAA;EkC9KF,gBjCmO0B;ALg8I9B;AsC9pJM;E3BqCF,iCAAA;EACA,oCAAA;AX4nJJ;AsC7pJM;E3BkBF,kCAAA;EACA,qCAAA;AX8oJJ;;AsC9qJE;EACE,uBAAA;ElCgLE,mBAAA;EkC9KF,gBjCoO0B;AL68I9B;AsC5qJM;E3BqCF,+BAAA;EACA,kCAAA;AX0oJJ;AsC3qJM;E3BkBF,gCAAA;EACA,mCAAA;AX4pJJ;;AuC1rJA;EACE,qBAAA;EACA,yBAAA;EnC6JE,cAAA;EmC3JF,gBpC+V4B;EoC9V5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E5BKE,uBAAA;EUFE,qIkBDJ;AvC6rJF;AqBxrJM;EkBfN;IlBgBQ,gBAAA;ErB2rJN;AACF;AMjsJE;EiCGI,qBAAA;AvCisJN;;AuC5rJE;EACE,aAAA;AvC+rJJ;;AuC1rJA;EACE,kBAAA;EACA,SAAA;AvC6rJF;;AuCtrJA;EACE,sBpCo0BkC;EoCn0BlC,qBpCm0BkC;EQ11BhC,oBAAA;AXitJJ;;AuCjrJE;ECjDD,cAAA;EACG,0CAAA;AxCsuJJ;AMxtJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCquJT;;AuC3rJE;ECjDD,cAAA;EACG,0CAAA;AxCgvJJ;AMluJE;EkCVO,cAAA;EACA,qBAAA;EACA,yBAAA;AxC+uJT;;AuCrsJE;ECjDD,cAAA;EACG,0CAAA;AxC0vJJ;AM5uJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCyvJT;;AuC/sJE;ECjDD,cAAA;EACG,0CAAA;AxCowJJ;AMtvJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCmwJT;;AuCztJE;ECjDD,cAAA;EACG,0CAAA;AxC8wJJ;AMhwJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxC6wJT;;AuCnuJE;ECjDD,cAAA;EACG,0CAAA;AxCwxJJ;AM1wJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCuxJT;;AuC7uJE;ECjDD,cAAA;EACG,0CAAA;AxCkyJJ;AMpxJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCiyJT;;AuCvvJE;ECjDD,cAAA;EACG,yCAAA;AxC4yJJ;AM9xJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxC2yJT;;AuCjwJE;ECjDD,cAAA;EACG,wCAAA;AxCszJJ;AMxyJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCqzJT;;AuC3wJE;ECjDD,cAAA;EACG,0CAAA;AxCg0JJ;AMlzJE;EkCVO,cAAA;EACA,qBAAA;EACA,yBAAA;AxC+zJT;;AuCrxJE;ECjDD,cAAA;EACG,0CAAA;AxC00JJ;AM5zJE;EkCVO,cAAA;EACA,qBAAA;EACA,yBAAA;AxCy0JT;;AuC/xJE;ECjDD,YAAA;EACG,uCAAA;AxCo1JJ;AMt0JE;EkCVO,WAAA;EACA,qBAAA;EACA,uBAAA;AxCm1JT;;AyC31JA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBtC2CS;EQ7BP,wBAAA;AXg1JJ;AgBtyJI;EyB5DJ;IAQI,kBAAA;EzC81JF;AACF;;AyC31JA;EACE,gBAAA;EACA,eAAA;E9BIE,gBAAA;AX21JJ;;A0Cz2JA;EACE,kBAAA;EACA,oBAAA;EACA,mBrCy9BkC;EqCx9BlC,6BAAA;E/BUE,uBAAA;AXm2JJ;;A0Cx2JA;EAEE,cAAA;A1C02JF;;A0Ct2JA;EACE,gBvCoV4B;AHqhJ9B;;A0Cj2JA;EACE,qBAAA;A1Co2JF;A0Cj2JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;A1Cm2JJ;;A0Cz1JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C81JvE;A2C14JI;EACI,yBAAA;A3C44JR;A2Cz4JI;EACI,cAAA;A3C24JR;;A0Cr2JE;EC/CE,cAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C02JvE;A2Ct5JI;EACI,yBAAA;A3Cw5JR;A2Cr5JI;EACI,cAAA;A3Cu5JR;;A0Cj3JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Cs3JvE;A2Cl6JI;EACI,yBAAA;A3Co6JR;A2Cj6JI;EACI,cAAA;A3Cm6JR;;A0C73JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Ck4JvE;A2C96JI;EACI,yBAAA;A3Cg7JR;A2C76JI;EACI,cAAA;A3C+6JR;;A0Cz4JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C84JvE;A2C17JI;EACI,yBAAA;A3C47JR;A2Cz7JI;EACI,cAAA;A3C27JR;;A0Cr5JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C05JvE;A2Ct8JI;EACI,yBAAA;A3Cw8JR;A2Cr8JI;EACI,cAAA;A3Cu8JR;;A0Cj6JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Cs6JvE;A2Cl9JI;EACI,yBAAA;A3Co9JR;A2Cj9JI;EACI,cAAA;A3Cm9JR;;A0C76JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Ck7JvE;A2C99JI;EACI,yBAAA;A3Cg+JR;A2C79JI;EACI,cAAA;A3C+9JR;;A0Cz7JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C87JvE;A2C1+JI;EACI,yBAAA;A3C4+JR;A2Cz+JI;EACI,cAAA;A3C2+JR;;A0Cr8JE;EC/CE,cAAA;EpBKA,uBmB2CuB;EC9CvB,mBD8CmE;A1C08JvE;A2Ct/JI;EACI,yBAAA;A3Cw/JR;A2Cr/JI;EACI,cAAA;A3Cu/JR;;A0Cj9JE;EC/CE,cAAA;EpBKA,uBmB2CuB;EC9CvB,mBD8CmE;A1Cs9JvE;A2ClgKI;EACI,yBAAA;A3CogKR;A2CjgKI;EACI,cAAA;A3CmgKR;;A0C79JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Ck+JvE;A2C9gKI;EACI,yBAAA;A3CghKR;A2C7gKI;EACI,YAAA;A3C+gKR;;A4CvhKE;EACE;IAAO,2BAAA;E5C2hKT;E4C1hKE;IAAK,wBAAA;E5C6hKP;AACF;A4C1hKA;EACE,aAAA;EACA,YvCk+BkC;EuCj+BlC,gBAAA;EACA,cAAA;ExCwKI,kBAAA;EwCtKJ,yBzCiCS;EQ7BP,uBAAA;ECFE,oDAAA;AZ4hKN;;A4CzhKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WzCqBS;EyCpBT,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;A5C4hKF;AqBpiKM;EuBDN;IvBEQ,gBAAA;ErBuiKN;AACF;;A4C9hKA;ErBYE,qMAAA;EqBVA,0BAAA;A5CiiKF;;A4C7hKE;EACE,kDAAA;A5CgiKJ;A4C7hKM;EAJJ;IAKM,eAAA;E5CgiKN;AACF;;A6C3kKA;EACE,aAAA;EACA,uBAAA;A7C8kKF;;A6C3kKA;EACE,SAAA;A7C8kKF;;A8ChlKA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EnCQE,uBAAA;AX0kKJ;;A8CxkKA;EACE,WAAA;EACA,c3C8BS;E2C7BT,mBAAA;A9C2kKF;AMllKE;EwCWE,UAAA;EACA,c3CwBO;E2CvBP,qBAAA;EACA,yB3CgBO;AH0jKX;A8CvkKE;EACE,c3CkBO;E2CjBP,yB3CYO;AH6jKX;;A8ChkKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAGA,sB3CLS;E2CMT,yBAAA;A9CikKF;A8C/jKE;EnC1BE,+BAAA;EACA,gCAAA;AX4lKJ;A8C/jKE;EnChBE,mCAAA;EACA,kCAAA;AXklKJ;A8C/jKE;EAEE,c3CZO;E2CaP,oBAAA;EACA,sB3CpBO;AHolKX;A8C5jKE;EACE,UAAA;EACA,W3C1BO;E2C2BP,yB3CqQ4B;E2CpQ5B,qB3CoQ4B;AH0zJhC;A8C3jKE;EACE,mBAAA;A9C6jKJ;A8C3jKI;EACE,gBAAA;EACA,qB3C+OwB;AH80J9B;;A8C/iKI;EACE,mBAAA;A9CkjKN;A8C/iKQ;EnC1BJ,mCAAA;EAZA,0BAAA;AXylKJ;A8C9iKQ;EnC3CJ,iCAAA;EAYA,4BAAA;AXilKJ;A8C7iKQ;EACE,aAAA;A9C+iKV;A8C5iKQ;EACE,qB3C8MoB;E2C7MpB,oBAAA;A9C8iKV;A8C5iKU;EACE,iBAAA;EACA,sB3CyMkB;AHq2J9B;;AgBzmKI;E8BmCA;IACE,mBAAA;E9C0kKJ;E8CvkKM;InC1BJ,mCAAA;IAZA,0BAAA;EXinKF;E8CtkKM;InC3CJ,iCAAA;IAYA,4BAAA;EXymKF;E8CrkKM;IACE,aAAA;E9CukKR;E8CpkKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9CskKR;E8CpkKQ;IACE,iBAAA;IACA,sB3CyMkB;EH63J5B;AACF;AgBloKI;E8BmCA;IACE,mBAAA;E9CkmKJ;E8C/lKM;InC1BJ,mCAAA;IAZA,0BAAA;EXyoKF;E8C9lKM;InC3CJ,iCAAA;IAYA,4BAAA;EXioKF;E8C7lKM;IACE,aAAA;E9C+lKR;E8C5lKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9C8lKR;E8C5lKQ;IACE,iBAAA;IACA,sB3CyMkB;EHq5J5B;AACF;AgB1pKI;E8BmCA;IACE,mBAAA;E9C0nKJ;E8CvnKM;InC1BJ,mCAAA;IAZA,0BAAA;EXiqKF;E8CtnKM;InC3CJ,iCAAA;IAYA,4BAAA;EXypKF;E8CrnKM;IACE,aAAA;E9CunKR;E8CpnKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9CsnKR;E8CpnKQ;IACE,iBAAA;IACA,sB3CyMkB;EH66J5B;AACF;AgBlrKI;E8BmCA;IACE,mBAAA;E9CkpKJ;E8C/oKM;InC1BJ,mCAAA;IAZA,0BAAA;EXyrKF;E8C9oKM;InC3CJ,iCAAA;IAYA,4BAAA;EXirKF;E8C7oKM;IACE,aAAA;E9C+oKR;E8C5oKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9C8oKR;E8C5oKQ;IACE,iBAAA;IACA,sB3CyMkB;EHq8J5B;AACF;A8CjoKA;EnCnHI,gBAAA;AXuvKJ;A8CjoKE;EACE,qBAAA;A9CmoKJ;A8CjoKI;EACE,sBAAA;A9CmoKN;;A+C5wKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C4nK3C;AMpwKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C8wKR;A+C3wKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CqoK1E;;A+C1xKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C0oK3C;AMlxKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C4xKR;A+CzxKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CmpK1E;;A+CxyKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CwpK3C;AMhyKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C0yKR;A+CvyKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CiqK1E;;A+CtzKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CsqK3C;AM9yKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/CwzKR;A+CrzKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9C+qK1E;;A+Cp0KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CorK3C;AM5zKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Cs0KR;A+Cn0KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9C6rK1E;;A+Cl1KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CksK3C;AM10KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Co1KR;A+Cj1KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9C2sK1E;;A+Ch2KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CgtK3C;AMx1KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Ck2KR;A+C/1KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CytK1E;;A+C92KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C8tK3C;AMt2KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Cg3KR;A+C72KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CuuK1E;;A+C53KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C4uK3C;AMp3KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C83KR;A+C33KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CqvK1E;;A+C14KE;EACE,cDoJsE;ECnJtE,uBDmJuC;A9C0vK3C;AMl4KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C44KR;A+Cz4KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CmwK1E;;A+Cx5KE;EACE,cDoJsE;ECnJtE,uBDmJuC;A9CwwK3C;AMh5KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C05KR;A+Cv5KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CixK1E;;A+Ct6KE;EACE,YDoJsE;ECnJtE,yBDmJuC;A9CsxK3C;AM95KE;EyCPM,YD+IkE;EC9IlE,yBAAA;A/Cw6KR;A+Cr6KM;EACE,W5C+BG;E4C9BH,uBDyIkE;ECxIlE,mBDwIkE;A9C+xK1E;;AgDv7KA;EACE,YAAA;E5CmLI,iBAAA;E4CjLJ,gB7CqW4B;E6CpW5B,cAAA;EACA,yB7C+zBkC;E6C9zBlC,iB7Cg0BkC;E6C/zBlC,YAAA;AhD07KF;AMr7KE;E0CDE,yB7CyzBgC;E6CxzBhC,qBAAA;AhDy7KJ;AMr7KE;E0CCI,aAAA;AhDu7KN;;AgD56KA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AhD+6KF;;AgDz6KA;EACE,oBAAA;AhD46KF;;AiD58KA;EAEE,gBAAA;AjD88KF;AiD58KE;EACE,kBAAA;EACA,gBAAA;AjD88KJ;;AiDz8KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C4pBkC;E4C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AjD08KF;;AiDn8KA;EACE,kBAAA;EACA,WAAA;EACA,c5Ci5BkC;E4C/4BlC,oBAAA;AjDq8KF;AiDl8KE;E5B3BI,mC4B4BF;EACA,8B5Cu6BgC;AL6hJpC;AqB79KM;E4BuBJ;I5BtBM,gBAAA;ErBg+KN;AACF;AiDv8KE;EACE,e5Cq6BgC;ALoiJpC;AiDr8KE;EACE,sB5Ck6BgC;ALqiJpC;;AiDn8KA;EACE,aAAA;EACA,6BAAA;AjDs8KF;AiDp8KE;EACE,8BAAA;EACA,gBAAA;AjDs8KJ;AiDn8KE;;EAEE,cAAA;AjDq8KJ;AiDl8KE;EACE,gBAAA;AjDo8KJ;;AiDh8KA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AjDm8KF;AiDh8KE;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EAAA,mBAAA;EACA,WAAA;AjDk8KJ;AiD97KE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AjDg8KJ;AiD97KI;EACE,gBAAA;AjDg8KN;AiD77KI;EACE,aAAA;AjD+7KN;;AiDz7KA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB9CrES;E8CsET,4BAAA;EACA,kCAAA;EtClGE,wBAAA;ECFE,6EqCsGJ;EAEA,UAAA;AjDy7KF;;AiDr7KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CgjBkC;E4C/iBlC,YAAA;EACA,aAAA;EACA,sB9C5ES;AHogLX;AiDr7KE;EAAS,UAAA;AjDw7KX;AiDv7KE;EAAS,a9CmzBmB;AHuoJ9B;;AiDr7KA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gB9C+yB4B;E8C9yB5B,8BAAA;EtCtHE,iCAAA;EACA,kCAAA;AX+iLJ;AiDv7KE;EACE,gB9C0yB0B;E8CxyB1B,8BAAA;AjDw7KJ;;AiDn7KA;EACE,gBAAA;EACA,gB9CkxBkC;AHoqJpC;;AiDj7KA;EACE,kBAAA;EAGA,cAAA;EACA,e9CkwBkC;AHgrJpC;;AiD96KA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EtCzIE,qCAAA;EACA,oCAAA;AX2jLJ;AiD76KE;EACE,eAAA;AjD+6KJ;;AiD16KA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjD66KF;;AgBpjLI;EiC6IF;IACE,gB9CmuBgC;I8CluBhC,oBAAA;EjD26KF;EiDx6KA;IACE,+BAAA;EjD06KF;EiDx6KE;IACE,gCAAA;EjD06KJ;EiDt6KA;IACE,+BAAA;EjDw6KF;EiDt6KE;IACE,4BAAA;IACA,2BAAA;IAAA,mBAAA;EjDw6KJ;EiDp6KA;IrC/MI,6EqCgNF;EjDs6KF;EiDn6KA;IAAY,gB9C2sBsB;EH2tJlC;AACF;AgB9kLI;EiC2KF;;IAEE,gB9CmsBgC;EHmuJlC;AACF;AgBplLI;EiCkLF;IAAY,iB5CiuBsB;ELqsJlC;AACF;AkDppLA;EACE,kBAAA;EACA,a7CgrBkC;E6C/qBlC,cAAA;EACA,S7C61BkC;E8Cj2BlC,kChD4VuB;EgD1VvB,kBAAA;EACA,gBhDmW4B;EgDlW5B,gBhDuW4B;EgDtW5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;E8CzKJ,qBAAA;EACA,UAAA;AlDgqLF;AkD9pLE;EAAS,Y7Ci1ByB;ALg1JpC;AkD/pLE;EACE,kBAAA;EACA,cAAA;EACA,a7Ci1BgC;E6Ch1BhC,c7Ci1BgC;ALg1JpC;AkD/pLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlDiqLN;;AkD5pLA;EACE,iBAAA;AlD+pLF;AkD7pLE;EACE,SAAA;AlD+pLJ;AkD7pLI;EACE,MAAA;EACA,6BAAA;EACA,sB/CeK;AHgpLX;;AkD1pLA;EACE,iBAAA;AlD6pLF;AkD3pLE;EACE,OAAA;EACA,a7CmzBgC;E6ClzBhC,c7CizBgC;AL42JpC;AkD3pLI;EACE,QAAA;EACA,oCAAA;EACA,wB/CDK;AH8pLX;;AkDxpLA;EACE,iBAAA;AlD2pLF;AkDzpLE;EACE,MAAA;AlD2pLJ;AkDzpLI;EACE,SAAA;EACA,6BAAA;EACA,yB/CfK;AH0qLX;;AkDtpLA;EACE,iBAAA;AlDypLF;AkDvpLE;EACE,QAAA;EACA,a7CqxBgC;E6CpxBhC,c7CmxBgC;ALs4JpC;AkDvpLI;EACE,OAAA;EACA,oCAAA;EACA,uB/C/BK;AHwrLX;;AkDpoLA;EACE,gB7C+uBkC;E6C9uBlC,uBAAA;EACA,W/CjES;E+CkET,kBAAA;EACA,sB/CzDS;EQrCP,uBAAA;AXsuLJ;;AoDxvLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C8qBkC;E+C7qBlC,cAAA;EACA,gBjDu0BkC;EgD50BlC,kChD4VuB;EgD1VvB,kBAAA;EACA,gBhDmW4B;EgDlW5B,gBhDuW4B;EgDtW5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;EgDxKJ,qBAAA;EACA,sBjDgCS;EiD/BT,4BAAA;EACA,qCAAA;EzCGE,wBAAA;ECFE,kDwCCJ;ApDqwLF;AoDnwLE;EACE,kBAAA;EACA,cAAA;EACA,ajDs0BgC;EiDr0BhC,ejDs0BgC;EiDr0BhC,mBAAA;ApDqwLJ;AoDnwLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDowLN;;AoD/vLA;EACE,sBjDuzBkC;AH28JpC;AoDhwLE;EACE,4BAAA;ApDkwLJ;AoDhwLI;EACE,SAAA;EACA,+BAAA;EACA,6BjDkzB8B;AHg9JpC;AoD/vLI;EACE,WjD4xB8B;EiD3xB9B,+BAAA;EACA,sBjDPK;AHwwLX;;AoD5vLA;EACE,oBjDmyBkC;AH49JpC;AoD7vLE;EACE,0BAAA;EACA,cjD+xBgC;EiD9xBhC,cjD6xBgC;EiD5xBhC,mBAAA;ApD+vLJ;AoD7vLI;EACE,OAAA;EACA,uCAAA;EACA,+BjD2xB8B;AHo+JpC;AoD5vLI;EACE,SjDqwB8B;EiDpwB9B,uCAAA;EACA,wBjD9BK;AH4xLX;;AoDzvLA;EACE,mBjD4wBkC;AHg/JpC;AoD1vLE;EACE,yBAAA;ApD4vLJ;AoD1vLI;EACE,MAAA;EACA,uCAAA;EACA,gCjDuwB8B;AHq/JpC;AoDzvLI;EACE,QjDivB8B;EiDhvB9B,uCAAA;EACA,yBjDlDK;AH6yLX;AoDtvLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,ajDmvBgC;EiDlvBhC,qBAAA;EACA,WAAA;EACA,6BAAA;ApDwvLJ;;AoDpvLA;EACE,qBjD4uBkC;AH2gKpC;AoDrvLE;EACE,2BAAA;EACA,cjDwuBgC;EiDvuBhC,cjDsuBgC;EiDruBhC,mBAAA;ApDuvLJ;AoDrvLI;EACE,QAAA;EACA,uCAAA;EACA,8BjDouB8B;AHmhKpC;AoDpvLI;EACE,UjD8sB8B;EiD7sB9B,uCAAA;EACA,uBjDrFK;AH20LX;;AoDhuLA;EACE,uBAAA;EACA,gBAAA;EhD0BI,eAAA;EgDxBJ,cjDvGS;EiDwGT,sBjDhHS;EiDiHT,gCAAA;EzCnIE,6CAAA;EACA,8CAAA;AXu2LJ;AoDluLE;EACE,aAAA;ApDouLJ;;AoDhuLA;EACE,uBAAA;EACA,cjDpHS;AHu1LX;;AqD93LA;EACE,kBAAA;ArDi4LF;;AqD93LA;EACE,mBAAA;ArDi4LF;;AqD93LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArDi4LF;AsDx5LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD05LJ;;AqDl4LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EhClBI,sCgCmBJ;ArDq4LF;AqBp5LM;EgCQN;IhCPQ,gBAAA;ErBu5LN;AACF;;AqDv4LA;;;EAGE,cAAA;ArD04LF;;AqDv4LA;;EAEE,2BAAA;ArD04LF;;AqDv4LA;;EAEE,4BAAA;ArD04LF;;AqDj4LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArDo4LJ;AqDj4LE;;;EAGE,UAAA;EACA,UAAA;ArDm4LJ;AqDh4LE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;ArDk4LJ;AqB37LM;EgCqDJ;;IhCpDM,gBAAA;ErB+7LN;AACF;;AqD/3LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDs9BmC;EgDr9BnC,UAAA;EACA,WlDrDS;EkDsDT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhDi9BmC;EgBviC/B,8BgCuFJ;ArDi4LF;AqBp9LM;EgCkEN;;IhCjEQ,gBAAA;ErBw9LN;AACF;AM99LE;;;E+C2FE,WlD9DO;EkD+DP,qBAAA;EACA,UAAA;EACA,YhD08BiC;AL87JrC;;AqDr4LA;EACE,OAAA;ArDw4LF;;AqDn4LA;EACE,QAAA;ArDs4LF;;AqD/3LA;;EAEE,qBAAA;EACA,WhDm8BmC;EgDl8BnC,YhDk8BmC;EgDj8BnC,mCAAA;ArDk4LF;;AqDh4LA;EACE,yDAAA;ArDm4LF;;AqDj4LA;EACE,yDAAA;ArDo4LF;;AqD33LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDy5BmC;EgDx5BnC,gBhDw5BmC;EgDv5BnC,gBAAA;ArD63LF;AqD33LE;EACE,uBAAA;EACA,cAAA;EACA,WhDu5BiC;EgDt5BjC,WhDu5BiC;EgDt5BjC,iBhDw5BiC;EgDv5BjC,gBhDu5BiC;EgDt5BjC,mBAAA;EACA,eAAA;EACA,sBlD7HO;EkD8HP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EhC/JE,6BgCgKF;ArD43LJ;AqBxhMM;EgC6IJ;IhC5IM,gBAAA;ErB2hMN;AACF;AqD93LE;EACE,UAAA;ArDg4LJ;;AqDv3LA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WlDxJS;EkDyJT,kBAAA;ArD03LF;;AuD9jMA;EAAqB,mCAAA;AvDkkMrB;;AuDjkMA;EAAqB,8BAAA;AvDqkMrB;;AuDpkMA;EAAqB,iCAAA;AvDwkMrB;;AuDvkMA;EAAqB,iCAAA;AvD2kMrB;;AuD1kMA;EAAqB,sCAAA;AvD8kMrB;;AuD7kMA;EAAqB,mCAAA;AvDilMrB;;AwDtlMI;EACI,oCAAA;AxDylMR;;AM5kME;;;EkDRU,oCAAA;AxD0lMZ;;AwDhmMI;EACI,oCAAA;AxDmmMR;;AMtlME;;;EkDRU,oCAAA;AxDomMZ;;AwD1mMI;EACI,oCAAA;AxD6mMR;;AMhmME;;;EkDRU,oCAAA;AxD8mMZ;;AwDpnMI;EACI,oCAAA;AxDunMR;;AM1mME;;;EkDRU,oCAAA;AxDwnMZ;;AwD9nMI;EACI,oCAAA;AxDioMR;;AMpnME;;;EkDRU,oCAAA;AxDkoMZ;;AwDxoMI;EACI,oCAAA;AxD2oMR;;AM9nME;;;EkDRU,oCAAA;AxD4oMZ;;AwDlpMI;EACI,oCAAA;AxDqpMR;;AMxoME;;;EkDRU,oCAAA;AxDspMZ;;AwD5pMI;EACI,oCAAA;AxD+pMR;;AMlpME;;;EkDRU,oCAAA;AxDgqMZ;;AwDtqMI;EACI,oCAAA;AxDyqMR;;AM5pME;;;EkDRU,oCAAA;AxD0qMZ;;AwDhrMI;EACI,iCAAA;AxDmrMR;;AMtqME;;;EkDRU,oCAAA;AxDorMZ;;AwD1rMI;EACI,iCAAA;AxD6rMR;;AMhrME;;;EkDRU,oCAAA;AxD8rMZ;;AwDpsMI;EACI,kCAAA;AxDusMR;;AM1rME;;;EkDRU,kCAAA;AxDwsMZ;;AyDpsMA;EACE,iCAAA;AzDusMF;;AyDpsMA;EACE,wCAAA;AzDusMF;;A0DltMA;EAAkB,oCAAA;A1DstMlB;;A0DrtMA;EAAkB,wCAAA;A1DytMlB;;A0DxtMA;EAAkB,0CAAA;A1D4tMlB;;A0D3tMA;EAAkB,2CAAA;A1D+tMlB;;A0D9tMA;EAAkB,yCAAA;A1DkuMlB;;A0DhuMA;EAAmB,oBAAA;A1DouMnB;;A0DnuMA;EAAmB,wBAAA;A1DuuMnB;;A0DtuMA;EAAmB,0BAAA;A1D0uMnB;;A0DzuMA;EAAmB,2BAAA;A1D6uMnB;;A0D5uMA;EAAmB,yBAAA;A1DgvMnB;;A0D7uME;EACE,gCAAA;A1DgvMJ;;A0DjvME;EACE,gCAAA;A1DovMJ;;A0DrvME;EACE,gCAAA;A1DwvMJ;;A0DzvME;EACE,gCAAA;A1D4vMJ;;A0D7vME;EACE,gCAAA;A1DgwMJ;;A0DjwME;EACE,gCAAA;A1DowMJ;;A0DrwME;EACE,gCAAA;A1DwwMJ;;A0DzwME;EACE,gCAAA;A1D4wMJ;;A0D7wME;EACE,gCAAA;A1DgxMJ;;A0DjxME;EACE,6BAAA;A1DoxMJ;;A0DrxME;EACE,6BAAA;A1DwxMJ;;A0DzxME;EACE,8BAAA;A1D4xMJ;;A0DxxMA;EACE,6BAAA;A1D2xMF;;A0DpxMA;EACE,iCAAA;A1DuxMF;;A0DpxMA;EACE,kCAAA;A1DuxMF;;A0DpxMA;EACE,2CAAA;EACA,4CAAA;A1DuxMF;;A0DpxMA;EACE,4CAAA;EACA,+CAAA;A1DuxMF;;A0DpxMA;EACE,+CAAA;EACA,8CAAA;A1DuxMF;;A0DpxMA;EACE,2CAAA;EACA,8CAAA;A1DuxMF;;A0DpxMA;EACE,mCAAA;A1DuxMF;;A0DpxMA;EACE,6BAAA;A1DuxMF;;A0DpxMA;EACE,+BAAA;A1DuxMF;;A0DpxMA;EACE,2BAAA;A1DuxMF;;AsD/1ME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDk2MJ;;A2D31MM;EAAwB,wBAAA;A3D+1M9B;;A2D/1MM;EAAwB,0BAAA;A3Dm2M9B;;A2Dn2MM;EAAwB,gCAAA;A3Du2M9B;;A2Dv2MM;EAAwB,yBAAA;A3D22M9B;;A2D32MM;EAAwB,yBAAA;A3D+2M9B;;A2D/2MM;EAAwB,6BAAA;A3Dm3M9B;;A2Dn3MM;EAAwB,8BAAA;A3Du3M9B;;A2Dv3MM;EAAwB,wBAAA;A3D23M9B;;A2D33MM;EAAwB,+BAAA;A3D+3M9B;;AgB90MI;E2CjDE;IAAwB,wBAAA;E3Do4M5B;E2Dp4MI;IAAwB,0BAAA;E3Du4M5B;E2Dv4MI;IAAwB,gCAAA;E3D04M5B;E2D14MI;IAAwB,yBAAA;E3D64M5B;E2D74MI;IAAwB,yBAAA;E3Dg5M5B;E2Dh5MI;IAAwB,6BAAA;E3Dm5M5B;E2Dn5MI;IAAwB,8BAAA;E3Ds5M5B;E2Dt5MI;IAAwB,wBAAA;E3Dy5M5B;E2Dz5MI;IAAwB,+BAAA;E3D45M5B;AACF;AgB52MI;E2CjDE;IAAwB,wBAAA;E3Di6M5B;E2Dj6MI;IAAwB,0BAAA;E3Do6M5B;E2Dp6MI;IAAwB,gCAAA;E3Du6M5B;E2Dv6MI;IAAwB,yBAAA;E3D06M5B;E2D16MI;IAAwB,yBAAA;E3D66M5B;E2D76MI;IAAwB,6BAAA;E3Dg7M5B;E2Dh7MI;IAAwB,8BAAA;E3Dm7M5B;E2Dn7MI;IAAwB,wBAAA;E3Ds7M5B;E2Dt7MI;IAAwB,+BAAA;E3Dy7M5B;AACF;AgBz4MI;E2CjDE;IAAwB,wBAAA;E3D87M5B;E2D97MI;IAAwB,0BAAA;E3Di8M5B;E2Dj8MI;IAAwB,gCAAA;E3Do8M5B;E2Dp8MI;IAAwB,yBAAA;E3Du8M5B;E2Dv8MI;IAAwB,yBAAA;E3D08M5B;E2D18MI;IAAwB,6BAAA;E3D68M5B;E2D78MI;IAAwB,8BAAA;E3Dg9M5B;E2Dh9MI;IAAwB,wBAAA;E3Dm9M5B;E2Dn9MI;IAAwB,+BAAA;E3Ds9M5B;AACF;AgBt6MI;E2CjDE;IAAwB,wBAAA;E3D29M5B;E2D39MI;IAAwB,0BAAA;E3D89M5B;E2D99MI;IAAwB,gCAAA;E3Di+M5B;E2Dj+MI;IAAwB,yBAAA;E3Do+M5B;E2Dp+MI;IAAwB,yBAAA;E3Du+M5B;E2Dv+MI;IAAwB,6BAAA;E3D0+M5B;E2D1+MI;IAAwB,8BAAA;E3D6+M5B;E2D7+MI;IAAwB,wBAAA;E3Dg/M5B;E2Dh/MI;IAAwB,+BAAA;E3Dm/M5B;AACF;A2D1+MA;EAEI;IAAqB,wBAAA;E3D4+MvB;E2D5+ME;IAAqB,0BAAA;E3D++MvB;E2D/+ME;IAAqB,gCAAA;E3Dk/MvB;E2Dl/ME;IAAqB,yBAAA;E3Dq/MvB;E2Dr/ME;IAAqB,yBAAA;E3Dw/MvB;E2Dx/ME;IAAqB,6BAAA;E3D2/MvB;E2D3/ME;IAAqB,8BAAA;E3D8/MvB;E2D9/ME;IAAqB,wBAAA;E3DigNvB;E2DjgNE;IAAqB,+BAAA;E3DogNvB;AACF;A4D1hNA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A5D4hNF;A4D1hNE;EACE,cAAA;EACA,WAAA;A5D4hNJ;A4DzhNE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A5D2hNJ;;A4DlhNI;EACE,yBAAA;A5DqhNN;;A4DthNI;EACE,mBAAA;A5DyhNN;;A4D1hNI;EACE,gBAAA;A5D6hNN;;A4D9hNI;EACE,iBAAA;A5DiiNN;;A6D1jNI;EAAgC,8BAAA;A7D8jNpC;;A6D7jNI;EAAgC,iCAAA;A7DikNpC;;A6DhkNI;EAAgC,sCAAA;A7DokNpC;;A6DnkNI;EAAgC,yCAAA;A7DukNpC;;A6DrkNI;EAA8B,0BAAA;A7DykNlC;;A6DxkNI;EAA8B,4BAAA;A7D4kNlC;;A6D3kNI;EAA8B,kCAAA;A7D+kNlC;;A6D9kNI;EAA8B,yBAAA;A7DklNlC;;A6DjlNI;EAA8B,uBAAA;A7DqlNlC;;A6DplNI;EAA8B,uBAAA;A7DwlNlC;;A6DvlNI;EAA8B,yBAAA;A7D2lNlC;;A6D1lNI;EAA8B,yBAAA;A7D8lNlC;;A6D5lNI;EAAoC,sCAAA;A7DgmNxC;;A6D/lNI;EAAoC,oCAAA;A7DmmNxC;;A6DlmNI;EAAoC,kCAAA;A7DsmNxC;;A6DrmNI;EAAoC,yCAAA;A7DymNxC;;A6DxmNI;EAAoC,wCAAA;A7D4mNxC;;A6D1mNI;EAAiC,kCAAA;A7D8mNrC;;A6D7mNI;EAAiC,gCAAA;A7DinNrC;;A6DhnNI;EAAiC,8BAAA;A7DonNrC;;A6DnnNI;EAAiC,gCAAA;A7DunNrC;;A6DtnNI;EAAiC,+BAAA;A7D0nNrC;;A6DxnNI;EAAkC,oCAAA;A7D4nNtC;;A6D3nNI;EAAkC,kCAAA;A7D+nNtC;;A6D9nNI;EAAkC,gCAAA;A7DkoNtC;;A6DjoNI;EAAkC,uCAAA;A7DqoNtC;;A6DpoNI;EAAkC,sCAAA;A7DwoNtC;;A6DvoNI;EAAkC,iCAAA;A7D2oNtC;;A6DzoNI;EAAgC,2BAAA;A7D6oNpC;;A6D5oNI;EAAgC,iCAAA;A7DgpNpC;;A6D/oNI;EAAgC,+BAAA;A7DmpNpC;;A6DlpNI;EAAgC,6BAAA;A7DspNpC;;A6DrpNI;EAAgC,+BAAA;A7DypNpC;;A6DxpNI;EAAgC,8BAAA;A7D4pNpC;;AgBhpNI;E6ClDA;IAAgC,8BAAA;E7DusNlC;E6DtsNE;IAAgC,iCAAA;E7DysNlC;E6DxsNE;IAAgC,sCAAA;E7D2sNlC;E6D1sNE;IAAgC,yCAAA;E7D6sNlC;E6D3sNE;IAA8B,0BAAA;E7D8sNhC;E6D7sNE;IAA8B,4BAAA;E7DgtNhC;E6D/sNE;IAA8B,kCAAA;E7DktNhC;E6DjtNE;IAA8B,yBAAA;E7DotNhC;E6DntNE;IAA8B,uBAAA;E7DstNhC;E6DrtNE;IAA8B,uBAAA;E7DwtNhC;E6DvtNE;IAA8B,yBAAA;E7D0tNhC;E6DztNE;IAA8B,yBAAA;E7D4tNhC;E6D1tNE;IAAoC,sCAAA;E7D6tNtC;E6D5tNE;IAAoC,oCAAA;E7D+tNtC;E6D9tNE;IAAoC,kCAAA;E7DiuNtC;E6DhuNE;IAAoC,yCAAA;E7DmuNtC;E6DluNE;IAAoC,wCAAA;E7DquNtC;E6DnuNE;IAAiC,kCAAA;E7DsuNnC;E6DruNE;IAAiC,gCAAA;E7DwuNnC;E6DvuNE;IAAiC,8BAAA;E7D0uNnC;E6DzuNE;IAAiC,gCAAA;E7D4uNnC;E6D3uNE;IAAiC,+BAAA;E7D8uNnC;E6D5uNE;IAAkC,oCAAA;E7D+uNpC;E6D9uNE;IAAkC,kCAAA;E7DivNpC;E6DhvNE;IAAkC,gCAAA;E7DmvNpC;E6DlvNE;IAAkC,uCAAA;E7DqvNpC;E6DpvNE;IAAkC,sCAAA;E7DuvNpC;E6DtvNE;IAAkC,iCAAA;E7DyvNpC;E6DvvNE;IAAgC,2BAAA;E7D0vNlC;E6DzvNE;IAAgC,iCAAA;E7D4vNlC;E6D3vNE;IAAgC,+BAAA;E7D8vNlC;E6D7vNE;IAAgC,6BAAA;E7DgwNlC;E6D/vNE;IAAgC,+BAAA;E7DkwNlC;E6DjwNE;IAAgC,8BAAA;E7DowNlC;AACF;AgBzvNI;E6ClDA;IAAgC,8BAAA;E7D+yNlC;E6D9yNE;IAAgC,iCAAA;E7DizNlC;E6DhzNE;IAAgC,sCAAA;E7DmzNlC;E6DlzNE;IAAgC,yCAAA;E7DqzNlC;E6DnzNE;IAA8B,0BAAA;E7DszNhC;E6DrzNE;IAA8B,4BAAA;E7DwzNhC;E6DvzNE;IAA8B,kCAAA;E7D0zNhC;E6DzzNE;IAA8B,yBAAA;E7D4zNhC;E6D3zNE;IAA8B,uBAAA;E7D8zNhC;E6D7zNE;IAA8B,uBAAA;E7Dg0NhC;E6D/zNE;IAA8B,yBAAA;E7Dk0NhC;E6Dj0NE;IAA8B,yBAAA;E7Do0NhC;E6Dl0NE;IAAoC,sCAAA;E7Dq0NtC;E6Dp0NE;IAAoC,oCAAA;E7Du0NtC;E6Dt0NE;IAAoC,kCAAA;E7Dy0NtC;E6Dx0NE;IAAoC,yCAAA;E7D20NtC;E6D10NE;IAAoC,wCAAA;E7D60NtC;E6D30NE;IAAiC,kCAAA;E7D80NnC;E6D70NE;IAAiC,gCAAA;E7Dg1NnC;E6D/0NE;IAAiC,8BAAA;E7Dk1NnC;E6Dj1NE;IAAiC,gCAAA;E7Do1NnC;E6Dn1NE;IAAiC,+BAAA;E7Ds1NnC;E6Dp1NE;IAAkC,oCAAA;E7Du1NpC;E6Dt1NE;IAAkC,kCAAA;E7Dy1NpC;E6Dx1NE;IAAkC,gCAAA;E7D21NpC;E6D11NE;IAAkC,uCAAA;E7D61NpC;E6D51NE;IAAkC,sCAAA;E7D+1NpC;E6D91NE;IAAkC,iCAAA;E7Di2NpC;E6D/1NE;IAAgC,2BAAA;E7Dk2NlC;E6Dj2NE;IAAgC,iCAAA;E7Do2NlC;E6Dn2NE;IAAgC,+BAAA;E7Ds2NlC;E6Dr2NE;IAAgC,6BAAA;E7Dw2NlC;E6Dv2NE;IAAgC,+BAAA;E7D02NlC;E6Dz2NE;IAAgC,8BAAA;E7D42NlC;AACF;AgBj2NI;E6ClDA;IAAgC,8BAAA;E7Du5NlC;E6Dt5NE;IAAgC,iCAAA;E7Dy5NlC;E6Dx5NE;IAAgC,sCAAA;E7D25NlC;E6D15NE;IAAgC,yCAAA;E7D65NlC;E6D35NE;IAA8B,0BAAA;E7D85NhC;E6D75NE;IAA8B,4BAAA;E7Dg6NhC;E6D/5NE;IAA8B,kCAAA;E7Dk6NhC;E6Dj6NE;IAA8B,yBAAA;E7Do6NhC;E6Dn6NE;IAA8B,uBAAA;E7Ds6NhC;E6Dr6NE;IAA8B,uBAAA;E7Dw6NhC;E6Dv6NE;IAA8B,yBAAA;E7D06NhC;E6Dz6NE;IAA8B,yBAAA;E7D46NhC;E6D16NE;IAAoC,sCAAA;E7D66NtC;E6D56NE;IAAoC,oCAAA;E7D+6NtC;E6D96NE;IAAoC,kCAAA;E7Di7NtC;E6Dh7NE;IAAoC,yCAAA;E7Dm7NtC;E6Dl7NE;IAAoC,wCAAA;E7Dq7NtC;E6Dn7NE;IAAiC,kCAAA;E7Ds7NnC;E6Dr7NE;IAAiC,gCAAA;E7Dw7NnC;E6Dv7NE;IAAiC,8BAAA;E7D07NnC;E6Dz7NE;IAAiC,gCAAA;E7D47NnC;E6D37NE;IAAiC,+BAAA;E7D87NnC;E6D57NE;IAAkC,oCAAA;E7D+7NpC;E6D97NE;IAAkC,kCAAA;E7Di8NpC;E6Dh8NE;IAAkC,gCAAA;E7Dm8NpC;E6Dl8NE;IAAkC,uCAAA;E7Dq8NpC;E6Dp8NE;IAAkC,sCAAA;E7Du8NpC;E6Dt8NE;IAAkC,iCAAA;E7Dy8NpC;E6Dv8NE;IAAgC,2BAAA;E7D08NlC;E6Dz8NE;IAAgC,iCAAA;E7D48NlC;E6D38NE;IAAgC,+BAAA;E7D88NlC;E6D78NE;IAAgC,6BAAA;E7Dg9NlC;E6D/8NE;IAAgC,+BAAA;E7Dk9NlC;E6Dj9NE;IAAgC,8BAAA;E7Do9NlC;AACF;AgBz8NI;E6ClDA;IAAgC,8BAAA;E7D+/NlC;E6D9/NE;IAAgC,iCAAA;E7DigOlC;E6DhgOE;IAAgC,sCAAA;E7DmgOlC;E6DlgOE;IAAgC,yCAAA;E7DqgOlC;E6DngOE;IAA8B,0BAAA;E7DsgOhC;E6DrgOE;IAA8B,4BAAA;E7DwgOhC;E6DvgOE;IAA8B,kCAAA;E7D0gOhC;E6DzgOE;IAA8B,yBAAA;E7D4gOhC;E6D3gOE;IAA8B,uBAAA;E7D8gOhC;E6D7gOE;IAA8B,uBAAA;E7DghOhC;E6D/gOE;IAA8B,yBAAA;E7DkhOhC;E6DjhOE;IAA8B,yBAAA;E7DohOhC;E6DlhOE;IAAoC,sCAAA;E7DqhOtC;E6DphOE;IAAoC,oCAAA;E7DuhOtC;E6DthOE;IAAoC,kCAAA;E7DyhOtC;E6DxhOE;IAAoC,yCAAA;E7D2hOtC;E6D1hOE;IAAoC,wCAAA;E7D6hOtC;E6D3hOE;IAAiC,kCAAA;E7D8hOnC;E6D7hOE;IAAiC,gCAAA;E7DgiOnC;E6D/hOE;IAAiC,8BAAA;E7DkiOnC;E6DjiOE;IAAiC,gCAAA;E7DoiOnC;E6DniOE;IAAiC,+BAAA;E7DsiOnC;E6DpiOE;IAAkC,oCAAA;E7DuiOpC;E6DtiOE;IAAkC,kCAAA;E7DyiOpC;E6DxiOE;IAAkC,gCAAA;E7D2iOpC;E6D1iOE;IAAkC,uCAAA;E7D6iOpC;E6D5iOE;IAAkC,sCAAA;E7D+iOpC;E6D9iOE;IAAkC,iCAAA;E7DijOpC;E6D/iOE;IAAgC,2BAAA;E7DkjOlC;E6DjjOE;IAAgC,iCAAA;E7DojOlC;E6DnjOE;IAAgC,+BAAA;E7DsjOlC;E6DrjOE;IAAgC,6BAAA;E7DwjOlC;E6DvjOE;IAAgC,+BAAA;E7D0jOlC;E6DzjOE;IAAgC,8BAAA;E7D4jOlC;AACF;A8DvmOI;EAAwB,sBAAA;A9D0mO5B;;A8DzmOI;EAAwB,uBAAA;A9D6mO5B;;A8D5mOI;EAAwB,sBAAA;A9DgnO5B;;AgB5jOI;E8CtDA;IAAwB,sBAAA;E9DunO1B;E8DtnOE;IAAwB,uBAAA;E9DynO1B;E8DxnOE;IAAwB,sBAAA;E9D2nO1B;AACF;AgBxkOI;E8CtDA;IAAwB,sBAAA;E9DkoO1B;E8DjoOE;IAAwB,uBAAA;E9DooO1B;E8DnoOE;IAAwB,sBAAA;E9DsoO1B;AACF;AgBnlOI;E8CtDA;IAAwB,sBAAA;E9D6oO1B;E8D5oOE;IAAwB,uBAAA;E9D+oO1B;E8D9oOE;IAAwB,sBAAA;E9DipO1B;AACF;AgB9lOI;E8CtDA;IAAwB,sBAAA;E9DwpO1B;E8DvpOE;IAAwB,uBAAA;E9D0pO1B;E8DzpOE;IAAwB,sBAAA;E9D4pO1B;AACF;A+DlqOE;EAAyB,mCAAA;UAAA,2BAAA;A/DqqO3B;;A+DrqOE;EAAyB,oCAAA;UAAA,4BAAA;A/DyqO3B;;A+DzqOE;EAAyB,oCAAA;UAAA,4BAAA;A/D6qO3B;;AgE7qOE;EAAsB,yBAAA;AhEirOxB;;AgEjrOE;EAAsB,2BAAA;AhEqrOxB;;AiEprOE;EAAyB,2BAAA;AjEwrO3B;;AiExrOE;EAAyB,6BAAA;AjE4rO3B;;AiE5rOE;EAAyB,6BAAA;AjEgsO3B;;AiEhsOE;EAAyB,0BAAA;AjEosO3B;;AiEpsOE;EAAyB,mCAAA;EAAA,2BAAA;AjEwsO3B;;AiEnsOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a5DiqBkC;ALqiNpC;;AiEnsOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5DypBkC;AL6iNpC;;AiElsOE;EADF;IAEI,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a5DipBgC;ELqjNlC;AACF;;AkEhuOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnEkuOF;;AmExtOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AnE0tOJ;;AoEvvOA;EAAa,4DAAA;ApE2vOb;;AoE1vOA;EAAU,2DAAA;ApE8vOV;;AoE7vOA;EAAa,0DAAA;ApEiwOb;;AoEhwOA;EAAe,2BAAA;ApEowOf;;AqEnwOI;EAAuB,qBAAA;ArEuwO3B;;AqEvwOI;EAAuB,qBAAA;ArE2wO3B;;AqE3wOI;EAAuB,qBAAA;ArE+wO3B;;AqE/wOI;EAAuB,sBAAA;ArEmxO3B;;AqEnxOI;EAAuB,sBAAA;ArEuxO3B;;AqEvxOI;EAAuB,sBAAA;ArE2xO3B;;AqE3xOI;EAAuB,sBAAA;ArE+xO3B;;AqE/xOI;EAAuB,sBAAA;ArEmyO3B;;AqEnyOI;EAAuB,uBAAA;ArEuyO3B;;AqEvyOI;EAAuB,uBAAA;ArE2yO3B;;AqEvyOA;EAAU,0BAAA;ArE2yOV;;AqE1yOA;EAAU,2BAAA;ArE8yOV;;AqE1yOA;EAAc,2BAAA;ArE8yOd;;AqE7yOA;EAAc,4BAAA;ArEizOd;;AqE/yOA;EAAU,uBAAA;ArEmzOV;;AqElzOA;EAAU,wBAAA;ArEszOV;;AsE/zOQ;EAAgC,oBAAA;AtEm0OxC;;AsEl0OQ;;EAEE,wBAAA;AtEq0OV;;AsEn0OQ;;EAEE,0BAAA;AtEs0OV;;AsEp0OQ;;EAEE,2BAAA;AtEu0OV;;AsEr0OQ;;EAEE,yBAAA;AtEw0OV;;AsEv1OQ;EAAgC,0BAAA;AtE21OxC;;AsE11OQ;;EAEE,8BAAA;AtE61OV;;AsE31OQ;;EAEE,gCAAA;AtE81OV;;AsE51OQ;;EAEE,iCAAA;AtE+1OV;;AsE71OQ;;EAEE,+BAAA;AtEg2OV;;AsE/2OQ;EAAgC,yBAAA;AtEm3OxC;;AsEl3OQ;;EAEE,6BAAA;AtEq3OV;;AsEn3OQ;;EAEE,+BAAA;AtEs3OV;;AsEp3OQ;;EAEE,gCAAA;AtEu3OV;;AsEr3OQ;;EAEE,8BAAA;AtEw3OV;;AsEv4OQ;EAAgC,uBAAA;AtE24OxC;;AsE14OQ;;EAEE,2BAAA;AtE64OV;;AsE34OQ;;EAEE,6BAAA;AtE84OV;;AsE54OQ;;EAEE,8BAAA;AtE+4OV;;AsE74OQ;;EAEE,4BAAA;AtEg5OV;;AsE/5OQ;EAAgC,yBAAA;AtEm6OxC;;AsEl6OQ;;EAEE,6BAAA;AtEq6OV;;AsEn6OQ;;EAEE,+BAAA;AtEs6OV;;AsEp6OQ;;EAEE,gCAAA;AtEu6OV;;AsEr6OQ;;EAEE,8BAAA;AtEw6OV;;AsEv7OQ;EAAgC,uBAAA;AtE27OxC;;AsE17OQ;;EAEE,2BAAA;AtE67OV;;AsE37OQ;;EAEE,6BAAA;AtE87OV;;AsE57OQ;;EAEE,8BAAA;AtE+7OV;;AsE77OQ;;EAEE,4BAAA;AtEg8OV;;AsE/8OQ;EAAgC,yBAAA;AtEm9OxC;;AsEl9OQ;;EAEE,6BAAA;AtEq9OV;;AsEn9OQ;;EAEE,+BAAA;AtEs9OV;;AsEp9OQ;;EAEE,gCAAA;AtEu9OV;;AsEr9OQ;;EAEE,8BAAA;AtEw9OV;;AsEv+OQ;EAAgC,wBAAA;AtE2+OxC;;AsE1+OQ;;EAEE,4BAAA;AtE6+OV;;AsE3+OQ;;EAEE,8BAAA;AtE8+OV;;AsE5+OQ;;EAEE,+BAAA;AtE++OV;;AsE7+OQ;;EAEE,6BAAA;AtEg/OV;;AsE//OQ;EAAgC,wBAAA;AtEmgPxC;;AsElgPQ;;EAEE,4BAAA;AtEqgPV;;AsEngPQ;;EAEE,8BAAA;AtEsgPV;;AsEpgPQ;;EAEE,+BAAA;AtEugPV;;AsErgPQ;;EAEE,6BAAA;AtEwgPV;;AsEvhPQ;EAAgC,0BAAA;AtE2hPxC;;AsE1hPQ;;EAEE,8BAAA;AtE6hPV;;AsE3hPQ;;EAEE,gCAAA;AtE8hPV;;AsE5hPQ;;EAEE,iCAAA;AtE+hPV;;AsE7hPQ;;EAEE,+BAAA;AtEgiPV;;AsE/iPQ;EAAgC,wBAAA;AtEmjPxC;;AsEljPQ;;EAEE,4BAAA;AtEqjPV;;AsEnjPQ;;EAEE,8BAAA;AtEsjPV;;AsEpjPQ;;EAEE,+BAAA;AtEujPV;;AsErjPQ;;EAEE,6BAAA;AtEwjPV;;AsEvkPQ;EAAgC,0BAAA;AtE2kPxC;;AsE1kPQ;;EAEE,8BAAA;AtE6kPV;;AsE3kPQ;;EAEE,gCAAA;AtE8kPV;;AsE5kPQ;;EAEE,iCAAA;AtE+kPV;;AsE7kPQ;;EAEE,+BAAA;AtEglPV;;AsE/lPQ;EAAgC,wBAAA;AtEmmPxC;;AsElmPQ;;EAEE,4BAAA;AtEqmPV;;AsEnmPQ;;EAEE,8BAAA;AtEsmPV;;AsEpmPQ;;EAEE,+BAAA;AtEumPV;;AsErmPQ;;EAEE,6BAAA;AtEwmPV;;AsEvnPQ;EAAgC,0BAAA;AtE2nPxC;;AsE1nPQ;;EAEE,8BAAA;AtE6nPV;;AsE3nPQ;;EAEE,gCAAA;AtE8nPV;;AsE5nPQ;;EAEE,iCAAA;AtE+nPV;;AsE7nPQ;;EAEE,+BAAA;AtEgoPV;;AsE/oPQ;EAAgC,2BAAA;AtEmpPxC;;AsElpPQ;;EAEE,+BAAA;AtEqpPV;;AsEnpPQ;;EAEE,iCAAA;AtEspPV;;AsEppPQ;;EAEE,kCAAA;AtEupPV;;AsErpPQ;;EAEE,gCAAA;AtEwpPV;;AsEvqPQ;EAAgC,yBAAA;AtE2qPxC;;AsE1qPQ;;EAEE,6BAAA;AtE6qPV;;AsE3qPQ;;EAEE,+BAAA;AtE8qPV;;AsE5qPQ;;EAEE,gCAAA;AtE+qPV;;AsE7qPQ;;EAEE,8BAAA;AtEgrPV;;AsE/rPQ;EAAgC,uBAAA;AtEmsPxC;;AsElsPQ;;EAEE,2BAAA;AtEqsPV;;AsEnsPQ;;EAEE,6BAAA;AtEssPV;;AsEpsPQ;;EAEE,8BAAA;AtEusPV;;AsErsPQ;;EAEE,4BAAA;AtEwsPV;;AsEvtPQ;EAAgC,uBAAA;AtE2tPxC;;AsE1tPQ;;EAEE,2BAAA;AtE6tPV;;AsE3tPQ;;EAEE,6BAAA;AtE8tPV;;AsE5tPQ;;EAEE,8BAAA;AtE+tPV;;AsE7tPQ;;EAEE,4BAAA;AtEguPV;;AsE/uPQ;EAAgC,wBAAA;AtEmvPxC;;AsElvPQ;;EAEE,4BAAA;AtEqvPV;;AsEnvPQ;;EAEE,8BAAA;AtEsvPV;;AsEpvPQ;;EAEE,+BAAA;AtEuvPV;;AsErvPQ;;EAEE,6BAAA;AtEwvPV;;AsEvwPQ;EAAgC,qBAAA;AtE2wPxC;;AsE1wPQ;;EAEE,yBAAA;AtE6wPV;;AsE3wPQ;;EAEE,2BAAA;AtE8wPV;;AsE5wPQ;;EAEE,4BAAA;AtE+wPV;;AsE7wPQ;;EAEE,0BAAA;AtEgxPV;;AsE/xPQ;EAAgC,2BAAA;AtEmyPxC;;AsElyPQ;;EAEE,+BAAA;AtEqyPV;;AsEnyPQ;;EAEE,iCAAA;AtEsyPV;;AsEpyPQ;;EAEE,kCAAA;AtEuyPV;;AsEryPQ;;EAEE,gCAAA;AtEwyPV;;AsEvzPQ;EAAgC,0BAAA;AtE2zPxC;;AsE1zPQ;;EAEE,8BAAA;AtE6zPV;;AsE3zPQ;;EAEE,gCAAA;AtE8zPV;;AsE5zPQ;;EAEE,iCAAA;AtE+zPV;;AsE7zPQ;;EAEE,+BAAA;AtEg0PV;;AsE/0PQ;EAAgC,wBAAA;AtEm1PxC;;AsEl1PQ;;EAEE,4BAAA;AtEq1PV;;AsEn1PQ;;EAEE,8BAAA;AtEs1PV;;AsEp1PQ;;EAEE,+BAAA;AtEu1PV;;AsEr1PQ;;EAEE,6BAAA;AtEw1PV;;AsEv2PQ;EAAgC,0BAAA;AtE22PxC;;AsE12PQ;;EAEE,8BAAA;AtE62PV;;AsE32PQ;;EAEE,gCAAA;AtE82PV;;AsE52PQ;;EAEE,iCAAA;AtE+2PV;;AsE72PQ;;EAEE,+BAAA;AtEg3PV;;AsE/3PQ;EAAgC,wBAAA;AtEm4PxC;;AsEl4PQ;;EAEE,4BAAA;AtEq4PV;;AsEn4PQ;;EAEE,8BAAA;AtEs4PV;;AsEp4PQ;;EAEE,+BAAA;AtEu4PV;;AsEr4PQ;;EAEE,6BAAA;AtEw4PV;;AsEv5PQ;EAAgC,0BAAA;AtE25PxC;;AsE15PQ;;EAEE,8BAAA;AtE65PV;;AsE35PQ;;EAEE,gCAAA;AtE85PV;;AsE55PQ;;EAEE,iCAAA;AtE+5PV;;AsE75PQ;;EAEE,+BAAA;AtEg6PV;;AsE/6PQ;EAAgC,yBAAA;AtEm7PxC;;AsEl7PQ;;EAEE,6BAAA;AtEq7PV;;AsEn7PQ;;EAEE,+BAAA;AtEs7PV;;AsEp7PQ;;EAEE,gCAAA;AtEu7PV;;AsEr7PQ;;EAEE,8BAAA;AtEw7PV;;AsEv8PQ;EAAgC,yBAAA;AtE28PxC;;AsE18PQ;;EAEE,6BAAA;AtE68PV;;AsE38PQ;;EAEE,+BAAA;AtE88PV;;AsE58PQ;;EAEE,gCAAA;AtE+8PV;;AsE78PQ;;EAEE,8BAAA;AtEg9PV;;AsE/9PQ;EAAgC,2BAAA;AtEm+PxC;;AsEl+PQ;;EAEE,+BAAA;AtEq+PV;;AsEn+PQ;;EAEE,iCAAA;AtEs+PV;;AsEp+PQ;;EAEE,kCAAA;AtEu+PV;;AsEr+PQ;;EAEE,gCAAA;AtEw+PV;;AsEv/PQ;EAAgC,yBAAA;AtE2/PxC;;AsE1/PQ;;EAEE,6BAAA;AtE6/PV;;AsE3/PQ;;EAEE,+BAAA;AtE8/PV;;AsE5/PQ;;EAEE,gCAAA;AtE+/PV;;AsE7/PQ;;EAEE,8BAAA;AtEggQV;;AsE/gQQ;EAAgC,2BAAA;AtEmhQxC;;AsElhQQ;;EAEE,+BAAA;AtEqhQV;;AsEnhQQ;;EAEE,iCAAA;AtEshQV;;AsEphQQ;;EAEE,kCAAA;AtEuhQV;;AsErhQQ;;EAEE,gCAAA;AtEwhQV;;AsEviQQ;EAAgC,yBAAA;AtE2iQxC;;AsE1iQQ;;EAEE,6BAAA;AtE6iQV;;AsE3iQQ;;EAEE,+BAAA;AtE8iQV;;AsE5iQQ;;EAEE,gCAAA;AtE+iQV;;AsE7iQQ;;EAEE,8BAAA;AtEgjQV;;AsE/jQQ;EAAgC,2BAAA;AtEmkQxC;;AsElkQQ;;EAEE,+BAAA;AtEqkQV;;AsEnkQQ;;EAEE,iCAAA;AtEskQV;;AsEpkQQ;;EAEE,kCAAA;AtEukQV;;AsErkQQ;;EAEE,gCAAA;AtEwkQV;;AsEvlQQ;EAAgC,4BAAA;AtE2lQxC;;AsE1lQQ;;EAEE,gCAAA;AtE6lQV;;AsE3lQQ;;EAEE,kCAAA;AtE8lQV;;AsE5lQQ;;EAEE,mCAAA;AtE+lQV;;AsE7lQQ;;EAEE,iCAAA;AtEgmQV;;AsE/mQQ;EAAgC,0BAAA;AtEmnQxC;;AsElnQQ;;EAEE,8BAAA;AtEqnQV;;AsEnnQQ;;EAEE,gCAAA;AtEsnQV;;AsEpnQQ;;EAEE,iCAAA;AtEunQV;;AsErnQQ;;EAEE,+BAAA;AtEwnQV;;AsEvoQQ;EAAgC,wBAAA;AtE2oQxC;;AsE1oQQ;;EAEE,4BAAA;AtE6oQV;;AsE3oQQ;;EAEE,8BAAA;AtE8oQV;;AsE5oQQ;;EAEE,+BAAA;AtE+oQV;;AsE7oQQ;;EAEE,6BAAA;AtEgpQV;;AsE/pQQ;EAAgC,wBAAA;AtEmqQxC;;AsElqQQ;;EAEE,4BAAA;AtEqqQV;;AsEnqQQ;;EAEE,8BAAA;AtEsqQV;;AsEpqQQ;;EAEE,+BAAA;AtEuqQV;;AsErqQQ;;EAEE,6BAAA;AtEwqQV;;AsEvrQQ;EAAgC,yBAAA;AtE2rQxC;;AsE1rQQ;;EAEE,6BAAA;AtE6rQV;;AsE3rQQ;;EAEE,+BAAA;AtE8rQV;;AsE5rQQ;;EAEE,gCAAA;AtE+rQV;;AsE7rQQ;;EAEE,8BAAA;AtEgsQV;;AsExrQQ;EAAwB,2BAAA;AtE4rQhC;;AsE3rQQ;;EAEE,+BAAA;AtE8rQV;;AsE5rQQ;;EAEE,iCAAA;AtE+rQV;;AsE7rQQ;;EAEE,kCAAA;AtEgsQV;;AsE9rQQ;;EAEE,gCAAA;AtEisQV;;AsEhtQQ;EAAwB,0BAAA;AtEotQhC;;AsEntQQ;;EAEE,8BAAA;AtEstQV;;AsEptQQ;;EAEE,gCAAA;AtEutQV;;AsErtQQ;;EAEE,iCAAA;AtEwtQV;;AsEttQQ;;EAEE,+BAAA;AtEytQV;;AsExuQQ;EAAwB,wBAAA;AtE4uQhC;;AsE3uQQ;;EAEE,4BAAA;AtE8uQV;;AsE5uQQ;;EAEE,8BAAA;AtE+uQV;;AsE7uQQ;;EAEE,+BAAA;AtEgvQV;;AsE9uQQ;;EAEE,6BAAA;AtEivQV;;AsEhwQQ;EAAwB,0BAAA;AtEowQhC;;AsEnwQQ;;EAEE,8BAAA;AtEswQV;;AsEpwQQ;;EAEE,gCAAA;AtEuwQV;;AsErwQQ;;EAEE,iCAAA;AtEwwQV;;AsEtwQQ;;EAEE,+BAAA;AtEywQV;;AsExxQQ;EAAwB,wBAAA;AtE4xQhC;;AsE3xQQ;;EAEE,4BAAA;AtE8xQV;;AsE5xQQ;;EAEE,8BAAA;AtE+xQV;;AsE7xQQ;;EAEE,+BAAA;AtEgyQV;;AsE9xQQ;;EAEE,6BAAA;AtEiyQV;;AsEhzQQ;EAAwB,wBAAA;AtEozQhC;;AsEnzQQ;;EAEE,4BAAA;AtEszQV;;AsEpzQQ;;EAEE,8BAAA;AtEuzQV;;AsErzQQ;;EAEE,+BAAA;AtEwzQV;;AsEtzQQ;;EAEE,6BAAA;AtEyzQV;;AsEx0QQ;EAAwB,uBAAA;AtE40QhC;;AsE30QQ;;EAEE,2BAAA;AtE80QV;;AsE50QQ;;EAEE,6BAAA;AtE+0QV;;AsE70QQ;;EAEE,8BAAA;AtEg1QV;;AsE90QQ;;EAEE,4BAAA;AtEi1QV;;AsEh2QQ;EAAwB,uBAAA;AtEo2QhC;;AsEn2QQ;;EAEE,2BAAA;AtEs2QV;;AsEp2QQ;;EAEE,6BAAA;AtEu2QV;;AsEr2QQ;;EAEE,8BAAA;AtEw2QV;;AsEt2QQ;;EAEE,4BAAA;AtEy2QV;;AsEx3QQ;EAAwB,yBAAA;AtE43QhC;;AsE33QQ;;EAEE,6BAAA;AtE83QV;;AsE53QQ;;EAEE,+BAAA;AtE+3QV;;AsE73QQ;;EAEE,gCAAA;AtEg4QV;;AsE93QQ;;EAEE,8BAAA;AtEi4QV;;AsEh5QQ;EAAwB,uBAAA;AtEo5QhC;;AsEn5QQ;;EAEE,2BAAA;AtEs5QV;;AsEp5QQ;;EAEE,6BAAA;AtEu5QV;;AsEr5QQ;;EAEE,8BAAA;AtEw5QV;;AsEt5QQ;;EAEE,4BAAA;AtEy5QV;;AsEx6QQ;EAAwB,yBAAA;AtE46QhC;;AsE36QQ;;EAEE,6BAAA;AtE86QV;;AsE56QQ;;EAEE,+BAAA;AtE+6QV;;AsE76QQ;;EAEE,gCAAA;AtEg7QV;;AsE96QQ;;EAEE,8BAAA;AtEi7QV;;AsEh8QQ;EAAwB,uBAAA;AtEo8QhC;;AsEn8QQ;;EAEE,2BAAA;AtEs8QV;;AsEp8QQ;;EAEE,6BAAA;AtEu8QV;;AsEr8QQ;;EAEE,8BAAA;AtEw8QV;;AsEt8QQ;;EAEE,4BAAA;AtEy8QV;;AsEx9QQ;EAAwB,yBAAA;AtE49QhC;;AsE39QQ;;EAEE,6BAAA;AtE89QV;;AsE59QQ;;EAEE,+BAAA;AtE+9QV;;AsE79QQ;;EAEE,gCAAA;AtEg+QV;;AsE99QQ;;EAEE,8BAAA;AtEi+QV;;AsEh/QQ;EAAwB,0BAAA;AtEo/QhC;;AsEn/QQ;;EAEE,8BAAA;AtEs/QV;;AsEp/QQ;;EAEE,gCAAA;AtEu/QV;;AsEr/QQ;;EAEE,iCAAA;AtEw/QV;;AsEt/QQ;;EAEE,+BAAA;AtEy/QV;;AsExgRQ;EAAwB,0BAAA;AtE4gRhC;;AsE3gRQ;;EAEE,8BAAA;AtE8gRV;;AsE5gRQ;;EAEE,gCAAA;AtE+gRV;;AsE7gRQ;;EAEE,iCAAA;AtEghRV;;AsE9gRQ;;EAEE,+BAAA;AtEihRV;;AsEhiRQ;EAAwB,wBAAA;AtEoiRhC;;AsEniRQ;;EAEE,4BAAA;AtEsiRV;;AsEpiRQ;;EAEE,8BAAA;AtEuiRV;;AsEriRQ;;EAEE,+BAAA;AtEwiRV;;AsEtiRQ;;EAEE,6BAAA;AtEyiRV;;AsExjRQ;EAAwB,wBAAA;AtE4jRhC;;AsE3jRQ;;EAEE,4BAAA;AtE8jRV;;AsE5jRQ;;EAEE,8BAAA;AtE+jRV;;AsE7jRQ;;EAEE,+BAAA;AtEgkRV;;AsE9jRQ;;EAEE,6BAAA;AtEikRV;;AsEhlRQ;EAAwB,yBAAA;AtEolRhC;;AsEnlRQ;;EAEE,6BAAA;AtEslRV;;AsEplRQ;;EAEE,+BAAA;AtEulRV;;AsErlRQ;;EAEE,gCAAA;AtEwlRV;;AsEtlRQ;;EAEE,8BAAA;AtEylRV;;AsEnlRI;EAAmB,uBAAA;AtEulRvB;;AsEtlRI;;EAEE,2BAAA;AtEylRN;;AsEvlRI;;EAEE,6BAAA;AtE0lRN;;AsExlRI;;EAEE,8BAAA;AtE2lRN;;AsEzlRI;;EAEE,4BAAA;AtE4lRN;;AgBrmRI;EsDlDI;IAAgC,oBAAA;EtE4pRtC;EsE3pRM;;IAEE,wBAAA;EtE6pRR;EsE3pRM;;IAEE,0BAAA;EtE6pRR;EsE3pRM;;IAEE,2BAAA;EtE6pRR;EsE3pRM;;IAEE,yBAAA;EtE6pRR;EsE5qRM;IAAgC,0BAAA;EtE+qRtC;EsE9qRM;;IAEE,8BAAA;EtEgrRR;EsE9qRM;;IAEE,gCAAA;EtEgrRR;EsE9qRM;;IAEE,iCAAA;EtEgrRR;EsE9qRM;;IAEE,+BAAA;EtEgrRR;EsE/rRM;IAAgC,yBAAA;EtEksRtC;EsEjsRM;;IAEE,6BAAA;EtEmsRR;EsEjsRM;;IAEE,+BAAA;EtEmsRR;EsEjsRM;;IAEE,gCAAA;EtEmsRR;EsEjsRM;;IAEE,8BAAA;EtEmsRR;EsEltRM;IAAgC,uBAAA;EtEqtRtC;EsEptRM;;IAEE,2BAAA;EtEstRR;EsEptRM;;IAEE,6BAAA;EtEstRR;EsEptRM;;IAEE,8BAAA;EtEstRR;EsEptRM;;IAEE,4BAAA;EtEstRR;EsEruRM;IAAgC,yBAAA;EtEwuRtC;EsEvuRM;;IAEE,6BAAA;EtEyuRR;EsEvuRM;;IAEE,+BAAA;EtEyuRR;EsEvuRM;;IAEE,gCAAA;EtEyuRR;EsEvuRM;;IAEE,8BAAA;EtEyuRR;EsExvRM;IAAgC,uBAAA;EtE2vRtC;EsE1vRM;;IAEE,2BAAA;EtE4vRR;EsE1vRM;;IAEE,6BAAA;EtE4vRR;EsE1vRM;;IAEE,8BAAA;EtE4vRR;EsE1vRM;;IAEE,4BAAA;EtE4vRR;EsE3wRM;IAAgC,yBAAA;EtE8wRtC;EsE7wRM;;IAEE,6BAAA;EtE+wRR;EsE7wRM;;IAEE,+BAAA;EtE+wRR;EsE7wRM;;IAEE,gCAAA;EtE+wRR;EsE7wRM;;IAEE,8BAAA;EtE+wRR;EsE9xRM;IAAgC,wBAAA;EtEiyRtC;EsEhyRM;;IAEE,4BAAA;EtEkyRR;EsEhyRM;;IAEE,8BAAA;EtEkyRR;EsEhyRM;;IAEE,+BAAA;EtEkyRR;EsEhyRM;;IAEE,6BAAA;EtEkyRR;EsEjzRM;IAAgC,wBAAA;EtEozRtC;EsEnzRM;;IAEE,4BAAA;EtEqzRR;EsEnzRM;;IAEE,8BAAA;EtEqzRR;EsEnzRM;;IAEE,+BAAA;EtEqzRR;EsEnzRM;;IAEE,6BAAA;EtEqzRR;EsEp0RM;IAAgC,0BAAA;EtEu0RtC;EsEt0RM;;IAEE,8BAAA;EtEw0RR;EsEt0RM;;IAEE,gCAAA;EtEw0RR;EsEt0RM;;IAEE,iCAAA;EtEw0RR;EsEt0RM;;IAEE,+BAAA;EtEw0RR;EsEv1RM;IAAgC,wBAAA;EtE01RtC;EsEz1RM;;IAEE,4BAAA;EtE21RR;EsEz1RM;;IAEE,8BAAA;EtE21RR;EsEz1RM;;IAEE,+BAAA;EtE21RR;EsEz1RM;;IAEE,6BAAA;EtE21RR;EsE12RM;IAAgC,0BAAA;EtE62RtC;EsE52RM;;IAEE,8BAAA;EtE82RR;EsE52RM;;IAEE,gCAAA;EtE82RR;EsE52RM;;IAEE,iCAAA;EtE82RR;EsE52RM;;IAEE,+BAAA;EtE82RR;EsE73RM;IAAgC,wBAAA;EtEg4RtC;EsE/3RM;;IAEE,4BAAA;EtEi4RR;EsE/3RM;;IAEE,8BAAA;EtEi4RR;EsE/3RM;;IAEE,+BAAA;EtEi4RR;EsE/3RM;;IAEE,6BAAA;EtEi4RR;EsEh5RM;IAAgC,0BAAA;EtEm5RtC;EsEl5RM;;IAEE,8BAAA;EtEo5RR;EsEl5RM;;IAEE,gCAAA;EtEo5RR;EsEl5RM;;IAEE,iCAAA;EtEo5RR;EsEl5RM;;IAEE,+BAAA;EtEo5RR;EsEn6RM;IAAgC,2BAAA;EtEs6RtC;EsEr6RM;;IAEE,+BAAA;EtEu6RR;EsEr6RM;;IAEE,iCAAA;EtEu6RR;EsEr6RM;;IAEE,kCAAA;EtEu6RR;EsEr6RM;;IAEE,gCAAA;EtEu6RR;EsEt7RM;IAAgC,yBAAA;EtEy7RtC;EsEx7RM;;IAEE,6BAAA;EtE07RR;EsEx7RM;;IAEE,+BAAA;EtE07RR;EsEx7RM;;IAEE,gCAAA;EtE07RR;EsEx7RM;;IAEE,8BAAA;EtE07RR;EsEz8RM;IAAgC,uBAAA;EtE48RtC;EsE38RM;;IAEE,2BAAA;EtE68RR;EsE38RM;;IAEE,6BAAA;EtE68RR;EsE38RM;;IAEE,8BAAA;EtE68RR;EsE38RM;;IAEE,4BAAA;EtE68RR;EsE59RM;IAAgC,uBAAA;EtE+9RtC;EsE99RM;;IAEE,2BAAA;EtEg+RR;EsE99RM;;IAEE,6BAAA;EtEg+RR;EsE99RM;;IAEE,8BAAA;EtEg+RR;EsE99RM;;IAEE,4BAAA;EtEg+RR;EsE/+RM;IAAgC,wBAAA;EtEk/RtC;EsEj/RM;;IAEE,4BAAA;EtEm/RR;EsEj/RM;;IAEE,8BAAA;EtEm/RR;EsEj/RM;;IAEE,+BAAA;EtEm/RR;EsEj/RM;;IAEE,6BAAA;EtEm/RR;EsElgSM;IAAgC,qBAAA;EtEqgStC;EsEpgSM;;IAEE,yBAAA;EtEsgSR;EsEpgSM;;IAEE,2BAAA;EtEsgSR;EsEpgSM;;IAEE,4BAAA;EtEsgSR;EsEpgSM;;IAEE,0BAAA;EtEsgSR;EsErhSM;IAAgC,2BAAA;EtEwhStC;EsEvhSM;;IAEE,+BAAA;EtEyhSR;EsEvhSM;;IAEE,iCAAA;EtEyhSR;EsEvhSM;;IAEE,kCAAA;EtEyhSR;EsEvhSM;;IAEE,gCAAA;EtEyhSR;EsExiSM;IAAgC,0BAAA;EtE2iStC;EsE1iSM;;IAEE,8BAAA;EtE4iSR;EsE1iSM;;IAEE,gCAAA;EtE4iSR;EsE1iSM;;IAEE,iCAAA;EtE4iSR;EsE1iSM;;IAEE,+BAAA;EtE4iSR;EsE3jSM;IAAgC,wBAAA;EtE8jStC;EsE7jSM;;IAEE,4BAAA;EtE+jSR;EsE7jSM;;IAEE,8BAAA;EtE+jSR;EsE7jSM;;IAEE,+BAAA;EtE+jSR;EsE7jSM;;IAEE,6BAAA;EtE+jSR;EsE9kSM;IAAgC,0BAAA;EtEilStC;EsEhlSM;;IAEE,8BAAA;EtEklSR;EsEhlSM;;IAEE,gCAAA;EtEklSR;EsEhlSM;;IAEE,iCAAA;EtEklSR;EsEhlSM;;IAEE,+BAAA;EtEklSR;EsEjmSM;IAAgC,wBAAA;EtEomStC;EsEnmSM;;IAEE,4BAAA;EtEqmSR;EsEnmSM;;IAEE,8BAAA;EtEqmSR;EsEnmSM;;IAEE,+BAAA;EtEqmSR;EsEnmSM;;IAEE,6BAAA;EtEqmSR;EsEpnSM;IAAgC,0BAAA;EtEunStC;EsEtnSM;;IAEE,8BAAA;EtEwnSR;EsEtnSM;;IAEE,gCAAA;EtEwnSR;EsEtnSM;;IAEE,iCAAA;EtEwnSR;EsEtnSM;;IAEE,+BAAA;EtEwnSR;EsEvoSM;IAAgC,yBAAA;EtE0oStC;EsEzoSM;;IAEE,6BAAA;EtE2oSR;EsEzoSM;;IAEE,+BAAA;EtE2oSR;EsEzoSM;;IAEE,gCAAA;EtE2oSR;EsEzoSM;;IAEE,8BAAA;EtE2oSR;EsE1pSM;IAAgC,yBAAA;EtE6pStC;EsE5pSM;;IAEE,6BAAA;EtE8pSR;EsE5pSM;;IAEE,+BAAA;EtE8pSR;EsE5pSM;;IAEE,gCAAA;EtE8pSR;EsE5pSM;;IAEE,8BAAA;EtE8pSR;EsE7qSM;IAAgC,2BAAA;EtEgrStC;EsE/qSM;;IAEE,+BAAA;EtEirSR;EsE/qSM;;IAEE,iCAAA;EtEirSR;EsE/qSM;;IAEE,kCAAA;EtEirSR;EsE/qSM;;IAEE,gCAAA;EtEirSR;EsEhsSM;IAAgC,yBAAA;EtEmsStC;EsElsSM;;IAEE,6BAAA;EtEosSR;EsElsSM;;IAEE,+BAAA;EtEosSR;EsElsSM;;IAEE,gCAAA;EtEosSR;EsElsSM;;IAEE,8BAAA;EtEosSR;EsEntSM;IAAgC,2BAAA;EtEstStC;EsErtSM;;IAEE,+BAAA;EtEutSR;EsErtSM;;IAEE,iCAAA;EtEutSR;EsErtSM;;IAEE,kCAAA;EtEutSR;EsErtSM;;IAEE,gCAAA;EtEutSR;EsEtuSM;IAAgC,yBAAA;EtEyuStC;EsExuSM;;IAEE,6BAAA;EtE0uSR;EsExuSM;;IAEE,+BAAA;EtE0uSR;EsExuSM;;IAEE,gCAAA;EtE0uSR;EsExuSM;;IAEE,8BAAA;EtE0uSR;EsEzvSM;IAAgC,2BAAA;EtE4vStC;EsE3vSM;;IAEE,+BAAA;EtE6vSR;EsE3vSM;;IAEE,iCAAA;EtE6vSR;EsE3vSM;;IAEE,kCAAA;EtE6vSR;EsE3vSM;;IAEE,gCAAA;EtE6vSR;EsE5wSM;IAAgC,4BAAA;EtE+wStC;EsE9wSM;;IAEE,gCAAA;EtEgxSR;EsE9wSM;;IAEE,kCAAA;EtEgxSR;EsE9wSM;;IAEE,mCAAA;EtEgxSR;EsE9wSM;;IAEE,iCAAA;EtEgxSR;EsE/xSM;IAAgC,0BAAA;EtEkyStC;EsEjySM;;IAEE,8BAAA;EtEmySR;EsEjySM;;IAEE,gCAAA;EtEmySR;EsEjySM;;IAEE,iCAAA;EtEmySR;EsEjySM;;IAEE,+BAAA;EtEmySR;EsElzSM;IAAgC,wBAAA;EtEqzStC;EsEpzSM;;IAEE,4BAAA;EtEszSR;EsEpzSM;;IAEE,8BAAA;EtEszSR;EsEpzSM;;IAEE,+BAAA;EtEszSR;EsEpzSM;;IAEE,6BAAA;EtEszSR;EsEr0SM;IAAgC,wBAAA;EtEw0StC;EsEv0SM;;IAEE,4BAAA;EtEy0SR;EsEv0SM;;IAEE,8BAAA;EtEy0SR;EsEv0SM;;IAEE,+BAAA;EtEy0SR;EsEv0SM;;IAEE,6BAAA;EtEy0SR;EsEx1SM;IAAgC,yBAAA;EtE21StC;EsE11SM;;IAEE,6BAAA;EtE41SR;EsE11SM;;IAEE,+BAAA;EtE41SR;EsE11SM;;IAEE,gCAAA;EtE41SR;EsE11SM;;IAEE,8BAAA;EtE41SR;EsEp1SM;IAAwB,2BAAA;EtEu1S9B;EsEt1SM;;IAEE,+BAAA;EtEw1SR;EsEt1SM;;IAEE,iCAAA;EtEw1SR;EsEt1SM;;IAEE,kCAAA;EtEw1SR;EsEt1SM;;IAEE,gCAAA;EtEw1SR;EsEv2SM;IAAwB,0BAAA;EtE02S9B;EsEz2SM;;IAEE,8BAAA;EtE22SR;EsEz2SM;;IAEE,gCAAA;EtE22SR;EsEz2SM;;IAEE,iCAAA;EtE22SR;EsEz2SM;;IAEE,+BAAA;EtE22SR;EsE13SM;IAAwB,wBAAA;EtE63S9B;EsE53SM;;IAEE,4BAAA;EtE83SR;EsE53SM;;IAEE,8BAAA;EtE83SR;EsE53SM;;IAEE,+BAAA;EtE83SR;EsE53SM;;IAEE,6BAAA;EtE83SR;EsE74SM;IAAwB,0BAAA;EtEg5S9B;EsE/4SM;;IAEE,8BAAA;EtEi5SR;EsE/4SM;;IAEE,gCAAA;EtEi5SR;EsE/4SM;;IAEE,iCAAA;EtEi5SR;EsE/4SM;;IAEE,+BAAA;EtEi5SR;EsEh6SM;IAAwB,wBAAA;EtEm6S9B;EsEl6SM;;IAEE,4BAAA;EtEo6SR;EsEl6SM;;IAEE,8BAAA;EtEo6SR;EsEl6SM;;IAEE,+BAAA;EtEo6SR;EsEl6SM;;IAEE,6BAAA;EtEo6SR;EsEn7SM;IAAwB,wBAAA;EtEs7S9B;EsEr7SM;;IAEE,4BAAA;EtEu7SR;EsEr7SM;;IAEE,8BAAA;EtEu7SR;EsEr7SM;;IAEE,+BAAA;EtEu7SR;EsEr7SM;;IAEE,6BAAA;EtEu7SR;EsEt8SM;IAAwB,uBAAA;EtEy8S9B;EsEx8SM;;IAEE,2BAAA;EtE08SR;EsEx8SM;;IAEE,6BAAA;EtE08SR;EsEx8SM;;IAEE,8BAAA;EtE08SR;EsEx8SM;;IAEE,4BAAA;EtE08SR;EsEz9SM;IAAwB,uBAAA;EtE49S9B;EsE39SM;;IAEE,2BAAA;EtE69SR;EsE39SM;;IAEE,6BAAA;EtE69SR;EsE39SM;;IAEE,8BAAA;EtE69SR;EsE39SM;;IAEE,4BAAA;EtE69SR;EsE5+SM;IAAwB,yBAAA;EtE++S9B;EsE9+SM;;IAEE,6BAAA;EtEg/SR;EsE9+SM;;IAEE,+BAAA;EtEg/SR;EsE9+SM;;IAEE,gCAAA;EtEg/SR;EsE9+SM;;IAEE,8BAAA;EtEg/SR;EsE//SM;IAAwB,uBAAA;EtEkgT9B;EsEjgTM;;IAEE,2BAAA;EtEmgTR;EsEjgTM;;IAEE,6BAAA;EtEmgTR;EsEjgTM;;IAEE,8BAAA;EtEmgTR;EsEjgTM;;IAEE,4BAAA;EtEmgTR;EsElhTM;IAAwB,yBAAA;EtEqhT9B;EsEphTM;;IAEE,6BAAA;EtEshTR;EsEphTM;;IAEE,+BAAA;EtEshTR;EsEphTM;;IAEE,gCAAA;EtEshTR;EsEphTM;;IAEE,8BAAA;EtEshTR;EsEriTM;IAAwB,uBAAA;EtEwiT9B;EsEviTM;;IAEE,2BAAA;EtEyiTR;EsEviTM;;IAEE,6BAAA;EtEyiTR;EsEviTM;;IAEE,8BAAA;EtEyiTR;EsEviTM;;IAEE,4BAAA;EtEyiTR;EsExjTM;IAAwB,yBAAA;EtE2jT9B;EsE1jTM;;IAEE,6BAAA;EtE4jTR;EsE1jTM;;IAEE,+BAAA;EtE4jTR;EsE1jTM;;IAEE,gCAAA;EtE4jTR;EsE1jTM;;IAEE,8BAAA;EtE4jTR;EsE3kTM;IAAwB,0BAAA;EtE8kT9B;EsE7kTM;;IAEE,8BAAA;EtE+kTR;EsE7kTM;;IAEE,gCAAA;EtE+kTR;EsE7kTM;;IAEE,iCAAA;EtE+kTR;EsE7kTM;;IAEE,+BAAA;EtE+kTR;EsE9lTM;IAAwB,0BAAA;EtEimT9B;EsEhmTM;;IAEE,8BAAA;EtEkmTR;EsEhmTM;;IAEE,gCAAA;EtEkmTR;EsEhmTM;;IAEE,iCAAA;EtEkmTR;EsEhmTM;;IAEE,+BAAA;EtEkmTR;EsEjnTM;IAAwB,wBAAA;EtEonT9B;EsEnnTM;;IAEE,4BAAA;EtEqnTR;EsEnnTM;;IAEE,8BAAA;EtEqnTR;EsEnnTM;;IAEE,+BAAA;EtEqnTR;EsEnnTM;;IAEE,6BAAA;EtEqnTR;EsEpoTM;IAAwB,wBAAA;EtEuoT9B;EsEtoTM;;IAEE,4BAAA;EtEwoTR;EsEtoTM;;IAEE,8BAAA;EtEwoTR;EsEtoTM;;IAEE,+BAAA;EtEwoTR;EsEtoTM;;IAEE,6BAAA;EtEwoTR;EsEvpTM;IAAwB,yBAAA;EtE0pT9B;EsEzpTM;;IAEE,6BAAA;EtE2pTR;EsEzpTM;;IAEE,+BAAA;EtE2pTR;EsEzpTM;;IAEE,gCAAA;EtE2pTR;EsEzpTM;;IAEE,8BAAA;EtE2pTR;EsErpTE;IAAmB,uBAAA;EtEwpTrB;EsEvpTE;;IAEE,2BAAA;EtEypTJ;EsEvpTE;;IAEE,6BAAA;EtEypTJ;EsEvpTE;;IAEE,8BAAA;EtEypTJ;EsEvpTE;;IAEE,4BAAA;EtEypTJ;AACF;AgBnqTI;EsDlDI;IAAgC,oBAAA;EtEytTtC;EsExtTM;;IAEE,wBAAA;EtE0tTR;EsExtTM;;IAEE,0BAAA;EtE0tTR;EsExtTM;;IAEE,2BAAA;EtE0tTR;EsExtTM;;IAEE,yBAAA;EtE0tTR;EsEzuTM;IAAgC,0BAAA;EtE4uTtC;EsE3uTM;;IAEE,8BAAA;EtE6uTR;EsE3uTM;;IAEE,gCAAA;EtE6uTR;EsE3uTM;;IAEE,iCAAA;EtE6uTR;EsE3uTM;;IAEE,+BAAA;EtE6uTR;EsE5vTM;IAAgC,yBAAA;EtE+vTtC;EsE9vTM;;IAEE,6BAAA;EtEgwTR;EsE9vTM;;IAEE,+BAAA;EtEgwTR;EsE9vTM;;IAEE,gCAAA;EtEgwTR;EsE9vTM;;IAEE,8BAAA;EtEgwTR;EsE/wTM;IAAgC,uBAAA;EtEkxTtC;EsEjxTM;;IAEE,2BAAA;EtEmxTR;EsEjxTM;;IAEE,6BAAA;EtEmxTR;EsEjxTM;;IAEE,8BAAA;EtEmxTR;EsEjxTM;;IAEE,4BAAA;EtEmxTR;EsElyTM;IAAgC,yBAAA;EtEqyTtC;EsEpyTM;;IAEE,6BAAA;EtEsyTR;EsEpyTM;;IAEE,+BAAA;EtEsyTR;EsEpyTM;;IAEE,gCAAA;EtEsyTR;EsEpyTM;;IAEE,8BAAA;EtEsyTR;EsErzTM;IAAgC,uBAAA;EtEwzTtC;EsEvzTM;;IAEE,2BAAA;EtEyzTR;EsEvzTM;;IAEE,6BAAA;EtEyzTR;EsEvzTM;;IAEE,8BAAA;EtEyzTR;EsEvzTM;;IAEE,4BAAA;EtEyzTR;EsEx0TM;IAAgC,yBAAA;EtE20TtC;EsE10TM;;IAEE,6BAAA;EtE40TR;EsE10TM;;IAEE,+BAAA;EtE40TR;EsE10TM;;IAEE,gCAAA;EtE40TR;EsE10TM;;IAEE,8BAAA;EtE40TR;EsE31TM;IAAgC,wBAAA;EtE81TtC;EsE71TM;;IAEE,4BAAA;EtE+1TR;EsE71TM;;IAEE,8BAAA;EtE+1TR;EsE71TM;;IAEE,+BAAA;EtE+1TR;EsE71TM;;IAEE,6BAAA;EtE+1TR;EsE92TM;IAAgC,wBAAA;EtEi3TtC;EsEh3TM;;IAEE,4BAAA;EtEk3TR;EsEh3TM;;IAEE,8BAAA;EtEk3TR;EsEh3TM;;IAEE,+BAAA;EtEk3TR;EsEh3TM;;IAEE,6BAAA;EtEk3TR;EsEj4TM;IAAgC,0BAAA;EtEo4TtC;EsEn4TM;;IAEE,8BAAA;EtEq4TR;EsEn4TM;;IAEE,gCAAA;EtEq4TR;EsEn4TM;;IAEE,iCAAA;EtEq4TR;EsEn4TM;;IAEE,+BAAA;EtEq4TR;EsEp5TM;IAAgC,wBAAA;EtEu5TtC;EsEt5TM;;IAEE,4BAAA;EtEw5TR;EsEt5TM;;IAEE,8BAAA;EtEw5TR;EsEt5TM;;IAEE,+BAAA;EtEw5TR;EsEt5TM;;IAEE,6BAAA;EtEw5TR;EsEv6TM;IAAgC,0BAAA;EtE06TtC;EsEz6TM;;IAEE,8BAAA;EtE26TR;EsEz6TM;;IAEE,gCAAA;EtE26TR;EsEz6TM;;IAEE,iCAAA;EtE26TR;EsEz6TM;;IAEE,+BAAA;EtE26TR;EsE17TM;IAAgC,wBAAA;EtE67TtC;EsE57TM;;IAEE,4BAAA;EtE87TR;EsE57TM;;IAEE,8BAAA;EtE87TR;EsE57TM;;IAEE,+BAAA;EtE87TR;EsE57TM;;IAEE,6BAAA;EtE87TR;EsE78TM;IAAgC,0BAAA;EtEg9TtC;EsE/8TM;;IAEE,8BAAA;EtEi9TR;EsE/8TM;;IAEE,gCAAA;EtEi9TR;EsE/8TM;;IAEE,iCAAA;EtEi9TR;EsE/8TM;;IAEE,+BAAA;EtEi9TR;EsEh+TM;IAAgC,2BAAA;EtEm+TtC;EsEl+TM;;IAEE,+BAAA;EtEo+TR;EsEl+TM;;IAEE,iCAAA;EtEo+TR;EsEl+TM;;IAEE,kCAAA;EtEo+TR;EsEl+TM;;IAEE,gCAAA;EtEo+TR;EsEn/TM;IAAgC,yBAAA;EtEs/TtC;EsEr/TM;;IAEE,6BAAA;EtEu/TR;EsEr/TM;;IAEE,+BAAA;EtEu/TR;EsEr/TM;;IAEE,gCAAA;EtEu/TR;EsEr/TM;;IAEE,8BAAA;EtEu/TR;EsEtgUM;IAAgC,uBAAA;EtEygUtC;EsExgUM;;IAEE,2BAAA;EtE0gUR;EsExgUM;;IAEE,6BAAA;EtE0gUR;EsExgUM;;IAEE,8BAAA;EtE0gUR;EsExgUM;;IAEE,4BAAA;EtE0gUR;EsEzhUM;IAAgC,uBAAA;EtE4hUtC;EsE3hUM;;IAEE,2BAAA;EtE6hUR;EsE3hUM;;IAEE,6BAAA;EtE6hUR;EsE3hUM;;IAEE,8BAAA;EtE6hUR;EsE3hUM;;IAEE,4BAAA;EtE6hUR;EsE5iUM;IAAgC,wBAAA;EtE+iUtC;EsE9iUM;;IAEE,4BAAA;EtEgjUR;EsE9iUM;;IAEE,8BAAA;EtEgjUR;EsE9iUM;;IAEE,+BAAA;EtEgjUR;EsE9iUM;;IAEE,6BAAA;EtEgjUR;EsE/jUM;IAAgC,qBAAA;EtEkkUtC;EsEjkUM;;IAEE,yBAAA;EtEmkUR;EsEjkUM;;IAEE,2BAAA;EtEmkUR;EsEjkUM;;IAEE,4BAAA;EtEmkUR;EsEjkUM;;IAEE,0BAAA;EtEmkUR;EsEllUM;IAAgC,2BAAA;EtEqlUtC;EsEplUM;;IAEE,+BAAA;EtEslUR;EsEplUM;;IAEE,iCAAA;EtEslUR;EsEplUM;;IAEE,kCAAA;EtEslUR;EsEplUM;;IAEE,gCAAA;EtEslUR;EsErmUM;IAAgC,0BAAA;EtEwmUtC;EsEvmUM;;IAEE,8BAAA;EtEymUR;EsEvmUM;;IAEE,gCAAA;EtEymUR;EsEvmUM;;IAEE,iCAAA;EtEymUR;EsEvmUM;;IAEE,+BAAA;EtEymUR;EsExnUM;IAAgC,wBAAA;EtE2nUtC;EsE1nUM;;IAEE,4BAAA;EtE4nUR;EsE1nUM;;IAEE,8BAAA;EtE4nUR;EsE1nUM;;IAEE,+BAAA;EtE4nUR;EsE1nUM;;IAEE,6BAAA;EtE4nUR;EsE3oUM;IAAgC,0BAAA;EtE8oUtC;EsE7oUM;;IAEE,8BAAA;EtE+oUR;EsE7oUM;;IAEE,gCAAA;EtE+oUR;EsE7oUM;;IAEE,iCAAA;EtE+oUR;EsE7oUM;;IAEE,+BAAA;EtE+oUR;EsE9pUM;IAAgC,wBAAA;EtEiqUtC;EsEhqUM;;IAEE,4BAAA;EtEkqUR;EsEhqUM;;IAEE,8BAAA;EtEkqUR;EsEhqUM;;IAEE,+BAAA;EtEkqUR;EsEhqUM;;IAEE,6BAAA;EtEkqUR;EsEjrUM;IAAgC,0BAAA;EtEorUtC;EsEnrUM;;IAEE,8BAAA;EtEqrUR;EsEnrUM;;IAEE,gCAAA;EtEqrUR;EsEnrUM;;IAEE,iCAAA;EtEqrUR;EsEnrUM;;IAEE,+BAAA;EtEqrUR;EsEpsUM;IAAgC,yBAAA;EtEusUtC;EsEtsUM;;IAEE,6BAAA;EtEwsUR;EsEtsUM;;IAEE,+BAAA;EtEwsUR;EsEtsUM;;IAEE,gCAAA;EtEwsUR;EsEtsUM;;IAEE,8BAAA;EtEwsUR;EsEvtUM;IAAgC,yBAAA;EtE0tUtC;EsEztUM;;IAEE,6BAAA;EtE2tUR;EsEztUM;;IAEE,+BAAA;EtE2tUR;EsEztUM;;IAEE,gCAAA;EtE2tUR;EsEztUM;;IAEE,8BAAA;EtE2tUR;EsE1uUM;IAAgC,2BAAA;EtE6uUtC;EsE5uUM;;IAEE,+BAAA;EtE8uUR;EsE5uUM;;IAEE,iCAAA;EtE8uUR;EsE5uUM;;IAEE,kCAAA;EtE8uUR;EsE5uUM;;IAEE,gCAAA;EtE8uUR;EsE7vUM;IAAgC,yBAAA;EtEgwUtC;EsE/vUM;;IAEE,6BAAA;EtEiwUR;EsE/vUM;;IAEE,+BAAA;EtEiwUR;EsE/vUM;;IAEE,gCAAA;EtEiwUR;EsE/vUM;;IAEE,8BAAA;EtEiwUR;EsEhxUM;IAAgC,2BAAA;EtEmxUtC;EsElxUM;;IAEE,+BAAA;EtEoxUR;EsElxUM;;IAEE,iCAAA;EtEoxUR;EsElxUM;;IAEE,kCAAA;EtEoxUR;EsElxUM;;IAEE,gCAAA;EtEoxUR;EsEnyUM;IAAgC,yBAAA;EtEsyUtC;EsEryUM;;IAEE,6BAAA;EtEuyUR;EsEryUM;;IAEE,+BAAA;EtEuyUR;EsEryUM;;IAEE,gCAAA;EtEuyUR;EsEryUM;;IAEE,8BAAA;EtEuyUR;EsEtzUM;IAAgC,2BAAA;EtEyzUtC;EsExzUM;;IAEE,+BAAA;EtE0zUR;EsExzUM;;IAEE,iCAAA;EtE0zUR;EsExzUM;;IAEE,kCAAA;EtE0zUR;EsExzUM;;IAEE,gCAAA;EtE0zUR;EsEz0UM;IAAgC,4BAAA;EtE40UtC;EsE30UM;;IAEE,gCAAA;EtE60UR;EsE30UM;;IAEE,kCAAA;EtE60UR;EsE30UM;;IAEE,mCAAA;EtE60UR;EsE30UM;;IAEE,iCAAA;EtE60UR;EsE51UM;IAAgC,0BAAA;EtE+1UtC;EsE91UM;;IAEE,8BAAA;EtEg2UR;EsE91UM;;IAEE,gCAAA;EtEg2UR;EsE91UM;;IAEE,iCAAA;EtEg2UR;EsE91UM;;IAEE,+BAAA;EtEg2UR;EsE/2UM;IAAgC,wBAAA;EtEk3UtC;EsEj3UM;;IAEE,4BAAA;EtEm3UR;EsEj3UM;;IAEE,8BAAA;EtEm3UR;EsEj3UM;;IAEE,+BAAA;EtEm3UR;EsEj3UM;;IAEE,6BAAA;EtEm3UR;EsEl4UM;IAAgC,wBAAA;EtEq4UtC;EsEp4UM;;IAEE,4BAAA;EtEs4UR;EsEp4UM;;IAEE,8BAAA;EtEs4UR;EsEp4UM;;IAEE,+BAAA;EtEs4UR;EsEp4UM;;IAEE,6BAAA;EtEs4UR;EsEr5UM;IAAgC,yBAAA;EtEw5UtC;EsEv5UM;;IAEE,6BAAA;EtEy5UR;EsEv5UM;;IAEE,+BAAA;EtEy5UR;EsEv5UM;;IAEE,gCAAA;EtEy5UR;EsEv5UM;;IAEE,8BAAA;EtEy5UR;EsEj5UM;IAAwB,2BAAA;EtEo5U9B;EsEn5UM;;IAEE,+BAAA;EtEq5UR;EsEn5UM;;IAEE,iCAAA;EtEq5UR;EsEn5UM;;IAEE,kCAAA;EtEq5UR;EsEn5UM;;IAEE,gCAAA;EtEq5UR;EsEp6UM;IAAwB,0BAAA;EtEu6U9B;EsEt6UM;;IAEE,8BAAA;EtEw6UR;EsEt6UM;;IAEE,gCAAA;EtEw6UR;EsEt6UM;;IAEE,iCAAA;EtEw6UR;EsEt6UM;;IAEE,+BAAA;EtEw6UR;EsEv7UM;IAAwB,wBAAA;EtE07U9B;EsEz7UM;;IAEE,4BAAA;EtE27UR;EsEz7UM;;IAEE,8BAAA;EtE27UR;EsEz7UM;;IAEE,+BAAA;EtE27UR;EsEz7UM;;IAEE,6BAAA;EtE27UR;EsE18UM;IAAwB,0BAAA;EtE68U9B;EsE58UM;;IAEE,8BAAA;EtE88UR;EsE58UM;;IAEE,gCAAA;EtE88UR;EsE58UM;;IAEE,iCAAA;EtE88UR;EsE58UM;;IAEE,+BAAA;EtE88UR;EsE79UM;IAAwB,wBAAA;EtEg+U9B;EsE/9UM;;IAEE,4BAAA;EtEi+UR;EsE/9UM;;IAEE,8BAAA;EtEi+UR;EsE/9UM;;IAEE,+BAAA;EtEi+UR;EsE/9UM;;IAEE,6BAAA;EtEi+UR;EsEh/UM;IAAwB,wBAAA;EtEm/U9B;EsEl/UM;;IAEE,4BAAA;EtEo/UR;EsEl/UM;;IAEE,8BAAA;EtEo/UR;EsEl/UM;;IAEE,+BAAA;EtEo/UR;EsEl/UM;;IAEE,6BAAA;EtEo/UR;EsEngVM;IAAwB,uBAAA;EtEsgV9B;EsErgVM;;IAEE,2BAAA;EtEugVR;EsErgVM;;IAEE,6BAAA;EtEugVR;EsErgVM;;IAEE,8BAAA;EtEugVR;EsErgVM;;IAEE,4BAAA;EtEugVR;EsEthVM;IAAwB,uBAAA;EtEyhV9B;EsExhVM;;IAEE,2BAAA;EtE0hVR;EsExhVM;;IAEE,6BAAA;EtE0hVR;EsExhVM;;IAEE,8BAAA;EtE0hVR;EsExhVM;;IAEE,4BAAA;EtE0hVR;EsEziVM;IAAwB,yBAAA;EtE4iV9B;EsE3iVM;;IAEE,6BAAA;EtE6iVR;EsE3iVM;;IAEE,+BAAA;EtE6iVR;EsE3iVM;;IAEE,gCAAA;EtE6iVR;EsE3iVM;;IAEE,8BAAA;EtE6iVR;EsE5jVM;IAAwB,uBAAA;EtE+jV9B;EsE9jVM;;IAEE,2BAAA;EtEgkVR;EsE9jVM;;IAEE,6BAAA;EtEgkVR;EsE9jVM;;IAEE,8BAAA;EtEgkVR;EsE9jVM;;IAEE,4BAAA;EtEgkVR;EsE/kVM;IAAwB,yBAAA;EtEklV9B;EsEjlVM;;IAEE,6BAAA;EtEmlVR;EsEjlVM;;IAEE,+BAAA;EtEmlVR;EsEjlVM;;IAEE,gCAAA;EtEmlVR;EsEjlVM;;IAEE,8BAAA;EtEmlVR;EsElmVM;IAAwB,uBAAA;EtEqmV9B;EsEpmVM;;IAEE,2BAAA;EtEsmVR;EsEpmVM;;IAEE,6BAAA;EtEsmVR;EsEpmVM;;IAEE,8BAAA;EtEsmVR;EsEpmVM;;IAEE,4BAAA;EtEsmVR;EsErnVM;IAAwB,yBAAA;EtEwnV9B;EsEvnVM;;IAEE,6BAAA;EtEynVR;EsEvnVM;;IAEE,+BAAA;EtEynVR;EsEvnVM;;IAEE,gCAAA;EtEynVR;EsEvnVM;;IAEE,8BAAA;EtEynVR;EsExoVM;IAAwB,0BAAA;EtE2oV9B;EsE1oVM;;IAEE,8BAAA;EtE4oVR;EsE1oVM;;IAEE,gCAAA;EtE4oVR;EsE1oVM;;IAEE,iCAAA;EtE4oVR;EsE1oVM;;IAEE,+BAAA;EtE4oVR;EsE3pVM;IAAwB,0BAAA;EtE8pV9B;EsE7pVM;;IAEE,8BAAA;EtE+pVR;EsE7pVM;;IAEE,gCAAA;EtE+pVR;EsE7pVM;;IAEE,iCAAA;EtE+pVR;EsE7pVM;;IAEE,+BAAA;EtE+pVR;EsE9qVM;IAAwB,wBAAA;EtEirV9B;EsEhrVM;;IAEE,4BAAA;EtEkrVR;EsEhrVM;;IAEE,8BAAA;EtEkrVR;EsEhrVM;;IAEE,+BAAA;EtEkrVR;EsEhrVM;;IAEE,6BAAA;EtEkrVR;EsEjsVM;IAAwB,wBAAA;EtEosV9B;EsEnsVM;;IAEE,4BAAA;EtEqsVR;EsEnsVM;;IAEE,8BAAA;EtEqsVR;EsEnsVM;;IAEE,+BAAA;EtEqsVR;EsEnsVM;;IAEE,6BAAA;EtEqsVR;EsEptVM;IAAwB,yBAAA;EtEutV9B;EsEttVM;;IAEE,6BAAA;EtEwtVR;EsEttVM;;IAEE,+BAAA;EtEwtVR;EsEttVM;;IAEE,gCAAA;EtEwtVR;EsEttVM;;IAEE,8BAAA;EtEwtVR;EsEltVE;IAAmB,uBAAA;EtEqtVrB;EsEptVE;;IAEE,2BAAA;EtEstVJ;EsEptVE;;IAEE,6BAAA;EtEstVJ;EsEptVE;;IAEE,8BAAA;EtEstVJ;EsEptVE;;IAEE,4BAAA;EtEstVJ;AACF;AgBhuVI;EsDlDI;IAAgC,oBAAA;EtEsxVtC;EsErxVM;;IAEE,wBAAA;EtEuxVR;EsErxVM;;IAEE,0BAAA;EtEuxVR;EsErxVM;;IAEE,2BAAA;EtEuxVR;EsErxVM;;IAEE,yBAAA;EtEuxVR;EsEtyVM;IAAgC,0BAAA;EtEyyVtC;EsExyVM;;IAEE,8BAAA;EtE0yVR;EsExyVM;;IAEE,gCAAA;EtE0yVR;EsExyVM;;IAEE,iCAAA;EtE0yVR;EsExyVM;;IAEE,+BAAA;EtE0yVR;EsEzzVM;IAAgC,yBAAA;EtE4zVtC;EsE3zVM;;IAEE,6BAAA;EtE6zVR;EsE3zVM;;IAEE,+BAAA;EtE6zVR;EsE3zVM;;IAEE,gCAAA;EtE6zVR;EsE3zVM;;IAEE,8BAAA;EtE6zVR;EsE50VM;IAAgC,uBAAA;EtE+0VtC;EsE90VM;;IAEE,2BAAA;EtEg1VR;EsE90VM;;IAEE,6BAAA;EtEg1VR;EsE90VM;;IAEE,8BAAA;EtEg1VR;EsE90VM;;IAEE,4BAAA;EtEg1VR;EsE/1VM;IAAgC,yBAAA;EtEk2VtC;EsEj2VM;;IAEE,6BAAA;EtEm2VR;EsEj2VM;;IAEE,+BAAA;EtEm2VR;EsEj2VM;;IAEE,gCAAA;EtEm2VR;EsEj2VM;;IAEE,8BAAA;EtEm2VR;EsEl3VM;IAAgC,uBAAA;EtEq3VtC;EsEp3VM;;IAEE,2BAAA;EtEs3VR;EsEp3VM;;IAEE,6BAAA;EtEs3VR;EsEp3VM;;IAEE,8BAAA;EtEs3VR;EsEp3VM;;IAEE,4BAAA;EtEs3VR;EsEr4VM;IAAgC,yBAAA;EtEw4VtC;EsEv4VM;;IAEE,6BAAA;EtEy4VR;EsEv4VM;;IAEE,+BAAA;EtEy4VR;EsEv4VM;;IAEE,gCAAA;EtEy4VR;EsEv4VM;;IAEE,8BAAA;EtEy4VR;EsEx5VM;IAAgC,wBAAA;EtE25VtC;EsE15VM;;IAEE,4BAAA;EtE45VR;EsE15VM;;IAEE,8BAAA;EtE45VR;EsE15VM;;IAEE,+BAAA;EtE45VR;EsE15VM;;IAEE,6BAAA;EtE45VR;EsE36VM;IAAgC,wBAAA;EtE86VtC;EsE76VM;;IAEE,4BAAA;EtE+6VR;EsE76VM;;IAEE,8BAAA;EtE+6VR;EsE76VM;;IAEE,+BAAA;EtE+6VR;EsE76VM;;IAEE,6BAAA;EtE+6VR;EsE97VM;IAAgC,0BAAA;EtEi8VtC;EsEh8VM;;IAEE,8BAAA;EtEk8VR;EsEh8VM;;IAEE,gCAAA;EtEk8VR;EsEh8VM;;IAEE,iCAAA;EtEk8VR;EsEh8VM;;IAEE,+BAAA;EtEk8VR;EsEj9VM;IAAgC,wBAAA;EtEo9VtC;EsEn9VM;;IAEE,4BAAA;EtEq9VR;EsEn9VM;;IAEE,8BAAA;EtEq9VR;EsEn9VM;;IAEE,+BAAA;EtEq9VR;EsEn9VM;;IAEE,6BAAA;EtEq9VR;EsEp+VM;IAAgC,0BAAA;EtEu+VtC;EsEt+VM;;IAEE,8BAAA;EtEw+VR;EsEt+VM;;IAEE,gCAAA;EtEw+VR;EsEt+VM;;IAEE,iCAAA;EtEw+VR;EsEt+VM;;IAEE,+BAAA;EtEw+VR;EsEv/VM;IAAgC,wBAAA;EtE0/VtC;EsEz/VM;;IAEE,4BAAA;EtE2/VR;EsEz/VM;;IAEE,8BAAA;EtE2/VR;EsEz/VM;;IAEE,+BAAA;EtE2/VR;EsEz/VM;;IAEE,6BAAA;EtE2/VR;EsE1gWM;IAAgC,0BAAA;EtE6gWtC;EsE5gWM;;IAEE,8BAAA;EtE8gWR;EsE5gWM;;IAEE,gCAAA;EtE8gWR;EsE5gWM;;IAEE,iCAAA;EtE8gWR;EsE5gWM;;IAEE,+BAAA;EtE8gWR;EsE7hWM;IAAgC,2BAAA;EtEgiWtC;EsE/hWM;;IAEE,+BAAA;EtEiiWR;EsE/hWM;;IAEE,iCAAA;EtEiiWR;EsE/hWM;;IAEE,kCAAA;EtEiiWR;EsE/hWM;;IAEE,gCAAA;EtEiiWR;EsEhjWM;IAAgC,yBAAA;EtEmjWtC;EsEljWM;;IAEE,6BAAA;EtEojWR;EsEljWM;;IAEE,+BAAA;EtEojWR;EsEljWM;;IAEE,gCAAA;EtEojWR;EsEljWM;;IAEE,8BAAA;EtEojWR;EsEnkWM;IAAgC,uBAAA;EtEskWtC;EsErkWM;;IAEE,2BAAA;EtEukWR;EsErkWM;;IAEE,6BAAA;EtEukWR;EsErkWM;;IAEE,8BAAA;EtEukWR;EsErkWM;;IAEE,4BAAA;EtEukWR;EsEtlWM;IAAgC,uBAAA;EtEylWtC;EsExlWM;;IAEE,2BAAA;EtE0lWR;EsExlWM;;IAEE,6BAAA;EtE0lWR;EsExlWM;;IAEE,8BAAA;EtE0lWR;EsExlWM;;IAEE,4BAAA;EtE0lWR;EsEzmWM;IAAgC,wBAAA;EtE4mWtC;EsE3mWM;;IAEE,4BAAA;EtE6mWR;EsE3mWM;;IAEE,8BAAA;EtE6mWR;EsE3mWM;;IAEE,+BAAA;EtE6mWR;EsE3mWM;;IAEE,6BAAA;EtE6mWR;EsE5nWM;IAAgC,qBAAA;EtE+nWtC;EsE9nWM;;IAEE,yBAAA;EtEgoWR;EsE9nWM;;IAEE,2BAAA;EtEgoWR;EsE9nWM;;IAEE,4BAAA;EtEgoWR;EsE9nWM;;IAEE,0BAAA;EtEgoWR;EsE/oWM;IAAgC,2BAAA;EtEkpWtC;EsEjpWM;;IAEE,+BAAA;EtEmpWR;EsEjpWM;;IAEE,iCAAA;EtEmpWR;EsEjpWM;;IAEE,kCAAA;EtEmpWR;EsEjpWM;;IAEE,gCAAA;EtEmpWR;EsElqWM;IAAgC,0BAAA;EtEqqWtC;EsEpqWM;;IAEE,8BAAA;EtEsqWR;EsEpqWM;;IAEE,gCAAA;EtEsqWR;EsEpqWM;;IAEE,iCAAA;EtEsqWR;EsEpqWM;;IAEE,+BAAA;EtEsqWR;EsErrWM;IAAgC,wBAAA;EtEwrWtC;EsEvrWM;;IAEE,4BAAA;EtEyrWR;EsEvrWM;;IAEE,8BAAA;EtEyrWR;EsEvrWM;;IAEE,+BAAA;EtEyrWR;EsEvrWM;;IAEE,6BAAA;EtEyrWR;EsExsWM;IAAgC,0BAAA;EtE2sWtC;EsE1sWM;;IAEE,8BAAA;EtE4sWR;EsE1sWM;;IAEE,gCAAA;EtE4sWR;EsE1sWM;;IAEE,iCAAA;EtE4sWR;EsE1sWM;;IAEE,+BAAA;EtE4sWR;EsE3tWM;IAAgC,wBAAA;EtE8tWtC;EsE7tWM;;IAEE,4BAAA;EtE+tWR;EsE7tWM;;IAEE,8BAAA;EtE+tWR;EsE7tWM;;IAEE,+BAAA;EtE+tWR;EsE7tWM;;IAEE,6BAAA;EtE+tWR;EsE9uWM;IAAgC,0BAAA;EtEivWtC;EsEhvWM;;IAEE,8BAAA;EtEkvWR;EsEhvWM;;IAEE,gCAAA;EtEkvWR;EsEhvWM;;IAEE,iCAAA;EtEkvWR;EsEhvWM;;IAEE,+BAAA;EtEkvWR;EsEjwWM;IAAgC,yBAAA;EtEowWtC;EsEnwWM;;IAEE,6BAAA;EtEqwWR;EsEnwWM;;IAEE,+BAAA;EtEqwWR;EsEnwWM;;IAEE,gCAAA;EtEqwWR;EsEnwWM;;IAEE,8BAAA;EtEqwWR;EsEpxWM;IAAgC,yBAAA;EtEuxWtC;EsEtxWM;;IAEE,6BAAA;EtEwxWR;EsEtxWM;;IAEE,+BAAA;EtEwxWR;EsEtxWM;;IAEE,gCAAA;EtEwxWR;EsEtxWM;;IAEE,8BAAA;EtEwxWR;EsEvyWM;IAAgC,2BAAA;EtE0yWtC;EsEzyWM;;IAEE,+BAAA;EtE2yWR;EsEzyWM;;IAEE,iCAAA;EtE2yWR;EsEzyWM;;IAEE,kCAAA;EtE2yWR;EsEzyWM;;IAEE,gCAAA;EtE2yWR;EsE1zWM;IAAgC,yBAAA;EtE6zWtC;EsE5zWM;;IAEE,6BAAA;EtE8zWR;EsE5zWM;;IAEE,+BAAA;EtE8zWR;EsE5zWM;;IAEE,gCAAA;EtE8zWR;EsE5zWM;;IAEE,8BAAA;EtE8zWR;EsE70WM;IAAgC,2BAAA;EtEg1WtC;EsE/0WM;;IAEE,+BAAA;EtEi1WR;EsE/0WM;;IAEE,iCAAA;EtEi1WR;EsE/0WM;;IAEE,kCAAA;EtEi1WR;EsE/0WM;;IAEE,gCAAA;EtEi1WR;EsEh2WM;IAAgC,yBAAA;EtEm2WtC;EsEl2WM;;IAEE,6BAAA;EtEo2WR;EsEl2WM;;IAEE,+BAAA;EtEo2WR;EsEl2WM;;IAEE,gCAAA;EtEo2WR;EsEl2WM;;IAEE,8BAAA;EtEo2WR;EsEn3WM;IAAgC,2BAAA;EtEs3WtC;EsEr3WM;;IAEE,+BAAA;EtEu3WR;EsEr3WM;;IAEE,iCAAA;EtEu3WR;EsEr3WM;;IAEE,kCAAA;EtEu3WR;EsEr3WM;;IAEE,gCAAA;EtEu3WR;EsEt4WM;IAAgC,4BAAA;EtEy4WtC;EsEx4WM;;IAEE,gCAAA;EtE04WR;EsEx4WM;;IAEE,kCAAA;EtE04WR;EsEx4WM;;IAEE,mCAAA;EtE04WR;EsEx4WM;;IAEE,iCAAA;EtE04WR;EsEz5WM;IAAgC,0BAAA;EtE45WtC;EsE35WM;;IAEE,8BAAA;EtE65WR;EsE35WM;;IAEE,gCAAA;EtE65WR;EsE35WM;;IAEE,iCAAA;EtE65WR;EsE35WM;;IAEE,+BAAA;EtE65WR;EsE56WM;IAAgC,wBAAA;EtE+6WtC;EsE96WM;;IAEE,4BAAA;EtEg7WR;EsE96WM;;IAEE,8BAAA;EtEg7WR;EsE96WM;;IAEE,+BAAA;EtEg7WR;EsE96WM;;IAEE,6BAAA;EtEg7WR;EsE/7WM;IAAgC,wBAAA;EtEk8WtC;EsEj8WM;;IAEE,4BAAA;EtEm8WR;EsEj8WM;;IAEE,8BAAA;EtEm8WR;EsEj8WM;;IAEE,+BAAA;EtEm8WR;EsEj8WM;;IAEE,6BAAA;EtEm8WR;EsEl9WM;IAAgC,yBAAA;EtEq9WtC;EsEp9WM;;IAEE,6BAAA;EtEs9WR;EsEp9WM;;IAEE,+BAAA;EtEs9WR;EsEp9WM;;IAEE,gCAAA;EtEs9WR;EsEp9WM;;IAEE,8BAAA;EtEs9WR;EsE98WM;IAAwB,2BAAA;EtEi9W9B;EsEh9WM;;IAEE,+BAAA;EtEk9WR;EsEh9WM;;IAEE,iCAAA;EtEk9WR;EsEh9WM;;IAEE,kCAAA;EtEk9WR;EsEh9WM;;IAEE,gCAAA;EtEk9WR;EsEj+WM;IAAwB,0BAAA;EtEo+W9B;EsEn+WM;;IAEE,8BAAA;EtEq+WR;EsEn+WM;;IAEE,gCAAA;EtEq+WR;EsEn+WM;;IAEE,iCAAA;EtEq+WR;EsEn+WM;;IAEE,+BAAA;EtEq+WR;EsEp/WM;IAAwB,wBAAA;EtEu/W9B;EsEt/WM;;IAEE,4BAAA;EtEw/WR;EsEt/WM;;IAEE,8BAAA;EtEw/WR;EsEt/WM;;IAEE,+BAAA;EtEw/WR;EsEt/WM;;IAEE,6BAAA;EtEw/WR;EsEvgXM;IAAwB,0BAAA;EtE0gX9B;EsEzgXM;;IAEE,8BAAA;EtE2gXR;EsEzgXM;;IAEE,gCAAA;EtE2gXR;EsEzgXM;;IAEE,iCAAA;EtE2gXR;EsEzgXM;;IAEE,+BAAA;EtE2gXR;EsE1hXM;IAAwB,wBAAA;EtE6hX9B;EsE5hXM;;IAEE,4BAAA;EtE8hXR;EsE5hXM;;IAEE,8BAAA;EtE8hXR;EsE5hXM;;IAEE,+BAAA;EtE8hXR;EsE5hXM;;IAEE,6BAAA;EtE8hXR;EsE7iXM;IAAwB,wBAAA;EtEgjX9B;EsE/iXM;;IAEE,4BAAA;EtEijXR;EsE/iXM;;IAEE,8BAAA;EtEijXR;EsE/iXM;;IAEE,+BAAA;EtEijXR;EsE/iXM;;IAEE,6BAAA;EtEijXR;EsEhkXM;IAAwB,uBAAA;EtEmkX9B;EsElkXM;;IAEE,2BAAA;EtEokXR;EsElkXM;;IAEE,6BAAA;EtEokXR;EsElkXM;;IAEE,8BAAA;EtEokXR;EsElkXM;;IAEE,4BAAA;EtEokXR;EsEnlXM;IAAwB,uBAAA;EtEslX9B;EsErlXM;;IAEE,2BAAA;EtEulXR;EsErlXM;;IAEE,6BAAA;EtEulXR;EsErlXM;;IAEE,8BAAA;EtEulXR;EsErlXM;;IAEE,4BAAA;EtEulXR;EsEtmXM;IAAwB,yBAAA;EtEymX9B;EsExmXM;;IAEE,6BAAA;EtE0mXR;EsExmXM;;IAEE,+BAAA;EtE0mXR;EsExmXM;;IAEE,gCAAA;EtE0mXR;EsExmXM;;IAEE,8BAAA;EtE0mXR;EsEznXM;IAAwB,uBAAA;EtE4nX9B;EsE3nXM;;IAEE,2BAAA;EtE6nXR;EsE3nXM;;IAEE,6BAAA;EtE6nXR;EsE3nXM;;IAEE,8BAAA;EtE6nXR;EsE3nXM;;IAEE,4BAAA;EtE6nXR;EsE5oXM;IAAwB,yBAAA;EtE+oX9B;EsE9oXM;;IAEE,6BAAA;EtEgpXR;EsE9oXM;;IAEE,+BAAA;EtEgpXR;EsE9oXM;;IAEE,gCAAA;EtEgpXR;EsE9oXM;;IAEE,8BAAA;EtEgpXR;EsE/pXM;IAAwB,uBAAA;EtEkqX9B;EsEjqXM;;IAEE,2BAAA;EtEmqXR;EsEjqXM;;IAEE,6BAAA;EtEmqXR;EsEjqXM;;IAEE,8BAAA;EtEmqXR;EsEjqXM;;IAEE,4BAAA;EtEmqXR;EsElrXM;IAAwB,yBAAA;EtEqrX9B;EsEprXM;;IAEE,6BAAA;EtEsrXR;EsEprXM;;IAEE,+BAAA;EtEsrXR;EsEprXM;;IAEE,gCAAA;EtEsrXR;EsEprXM;;IAEE,8BAAA;EtEsrXR;EsErsXM;IAAwB,0BAAA;EtEwsX9B;EsEvsXM;;IAEE,8BAAA;EtEysXR;EsEvsXM;;IAEE,gCAAA;EtEysXR;EsEvsXM;;IAEE,iCAAA;EtEysXR;EsEvsXM;;IAEE,+BAAA;EtEysXR;EsExtXM;IAAwB,0BAAA;EtE2tX9B;EsE1tXM;;IAEE,8BAAA;EtE4tXR;EsE1tXM;;IAEE,gCAAA;EtE4tXR;EsE1tXM;;IAEE,iCAAA;EtE4tXR;EsE1tXM;;IAEE,+BAAA;EtE4tXR;EsE3uXM;IAAwB,wBAAA;EtE8uX9B;EsE7uXM;;IAEE,4BAAA;EtE+uXR;EsE7uXM;;IAEE,8BAAA;EtE+uXR;EsE7uXM;;IAEE,+BAAA;EtE+uXR;EsE7uXM;;IAEE,6BAAA;EtE+uXR;EsE9vXM;IAAwB,wBAAA;EtEiwX9B;EsEhwXM;;IAEE,4BAAA;EtEkwXR;EsEhwXM;;IAEE,8BAAA;EtEkwXR;EsEhwXM;;IAEE,+BAAA;EtEkwXR;EsEhwXM;;IAEE,6BAAA;EtEkwXR;EsEjxXM;IAAwB,yBAAA;EtEoxX9B;EsEnxXM;;IAEE,6BAAA;EtEqxXR;EsEnxXM;;IAEE,+BAAA;EtEqxXR;EsEnxXM;;IAEE,gCAAA;EtEqxXR;EsEnxXM;;IAEE,8BAAA;EtEqxXR;EsE/wXE;IAAmB,uBAAA;EtEkxXrB;EsEjxXE;;IAEE,2BAAA;EtEmxXJ;EsEjxXE;;IAEE,6BAAA;EtEmxXJ;EsEjxXE;;IAEE,8BAAA;EtEmxXJ;EsEjxXE;;IAEE,4BAAA;EtEmxXJ;AACF;AgB7xXI;EsDlDI;IAAgC,oBAAA;EtEm1XtC;EsEl1XM;;IAEE,wBAAA;EtEo1XR;EsEl1XM;;IAEE,0BAAA;EtEo1XR;EsEl1XM;;IAEE,2BAAA;EtEo1XR;EsEl1XM;;IAEE,yBAAA;EtEo1XR;EsEn2XM;IAAgC,0BAAA;EtEs2XtC;EsEr2XM;;IAEE,8BAAA;EtEu2XR;EsEr2XM;;IAEE,gCAAA;EtEu2XR;EsEr2XM;;IAEE,iCAAA;EtEu2XR;EsEr2XM;;IAEE,+BAAA;EtEu2XR;EsEt3XM;IAAgC,yBAAA;EtEy3XtC;EsEx3XM;;IAEE,6BAAA;EtE03XR;EsEx3XM;;IAEE,+BAAA;EtE03XR;EsEx3XM;;IAEE,gCAAA;EtE03XR;EsEx3XM;;IAEE,8BAAA;EtE03XR;EsEz4XM;IAAgC,uBAAA;EtE44XtC;EsE34XM;;IAEE,2BAAA;EtE64XR;EsE34XM;;IAEE,6BAAA;EtE64XR;EsE34XM;;IAEE,8BAAA;EtE64XR;EsE34XM;;IAEE,4BAAA;EtE64XR;EsE55XM;IAAgC,yBAAA;EtE+5XtC;EsE95XM;;IAEE,6BAAA;EtEg6XR;EsE95XM;;IAEE,+BAAA;EtEg6XR;EsE95XM;;IAEE,gCAAA;EtEg6XR;EsE95XM;;IAEE,8BAAA;EtEg6XR;EsE/6XM;IAAgC,uBAAA;EtEk7XtC;EsEj7XM;;IAEE,2BAAA;EtEm7XR;EsEj7XM;;IAEE,6BAAA;EtEm7XR;EsEj7XM;;IAEE,8BAAA;EtEm7XR;EsEj7XM;;IAEE,4BAAA;EtEm7XR;EsEl8XM;IAAgC,yBAAA;EtEq8XtC;EsEp8XM;;IAEE,6BAAA;EtEs8XR;EsEp8XM;;IAEE,+BAAA;EtEs8XR;EsEp8XM;;IAEE,gCAAA;EtEs8XR;EsEp8XM;;IAEE,8BAAA;EtEs8XR;EsEr9XM;IAAgC,wBAAA;EtEw9XtC;EsEv9XM;;IAEE,4BAAA;EtEy9XR;EsEv9XM;;IAEE,8BAAA;EtEy9XR;EsEv9XM;;IAEE,+BAAA;EtEy9XR;EsEv9XM;;IAEE,6BAAA;EtEy9XR;EsEx+XM;IAAgC,wBAAA;EtE2+XtC;EsE1+XM;;IAEE,4BAAA;EtE4+XR;EsE1+XM;;IAEE,8BAAA;EtE4+XR;EsE1+XM;;IAEE,+BAAA;EtE4+XR;EsE1+XM;;IAEE,6BAAA;EtE4+XR;EsE3/XM;IAAgC,0BAAA;EtE8/XtC;EsE7/XM;;IAEE,8BAAA;EtE+/XR;EsE7/XM;;IAEE,gCAAA;EtE+/XR;EsE7/XM;;IAEE,iCAAA;EtE+/XR;EsE7/XM;;IAEE,+BAAA;EtE+/XR;EsE9gYM;IAAgC,wBAAA;EtEihYtC;EsEhhYM;;IAEE,4BAAA;EtEkhYR;EsEhhYM;;IAEE,8BAAA;EtEkhYR;EsEhhYM;;IAEE,+BAAA;EtEkhYR;EsEhhYM;;IAEE,6BAAA;EtEkhYR;EsEjiYM;IAAgC,0BAAA;EtEoiYtC;EsEniYM;;IAEE,8BAAA;EtEqiYR;EsEniYM;;IAEE,gCAAA;EtEqiYR;EsEniYM;;IAEE,iCAAA;EtEqiYR;EsEniYM;;IAEE,+BAAA;EtEqiYR;EsEpjYM;IAAgC,wBAAA;EtEujYtC;EsEtjYM;;IAEE,4BAAA;EtEwjYR;EsEtjYM;;IAEE,8BAAA;EtEwjYR;EsEtjYM;;IAEE,+BAAA;EtEwjYR;EsEtjYM;;IAEE,6BAAA;EtEwjYR;EsEvkYM;IAAgC,0BAAA;EtE0kYtC;EsEzkYM;;IAEE,8BAAA;EtE2kYR;EsEzkYM;;IAEE,gCAAA;EtE2kYR;EsEzkYM;;IAEE,iCAAA;EtE2kYR;EsEzkYM;;IAEE,+BAAA;EtE2kYR;EsE1lYM;IAAgC,2BAAA;EtE6lYtC;EsE5lYM;;IAEE,+BAAA;EtE8lYR;EsE5lYM;;IAEE,iCAAA;EtE8lYR;EsE5lYM;;IAEE,kCAAA;EtE8lYR;EsE5lYM;;IAEE,gCAAA;EtE8lYR;EsE7mYM;IAAgC,yBAAA;EtEgnYtC;EsE/mYM;;IAEE,6BAAA;EtEinYR;EsE/mYM;;IAEE,+BAAA;EtEinYR;EsE/mYM;;IAEE,gCAAA;EtEinYR;EsE/mYM;;IAEE,8BAAA;EtEinYR;EsEhoYM;IAAgC,uBAAA;EtEmoYtC;EsEloYM;;IAEE,2BAAA;EtEooYR;EsEloYM;;IAEE,6BAAA;EtEooYR;EsEloYM;;IAEE,8BAAA;EtEooYR;EsEloYM;;IAEE,4BAAA;EtEooYR;EsEnpYM;IAAgC,uBAAA;EtEspYtC;EsErpYM;;IAEE,2BAAA;EtEupYR;EsErpYM;;IAEE,6BAAA;EtEupYR;EsErpYM;;IAEE,8BAAA;EtEupYR;EsErpYM;;IAEE,4BAAA;EtEupYR;EsEtqYM;IAAgC,wBAAA;EtEyqYtC;EsExqYM;;IAEE,4BAAA;EtE0qYR;EsExqYM;;IAEE,8BAAA;EtE0qYR;EsExqYM;;IAEE,+BAAA;EtE0qYR;EsExqYM;;IAEE,6BAAA;EtE0qYR;EsEzrYM;IAAgC,qBAAA;EtE4rYtC;EsE3rYM;;IAEE,yBAAA;EtE6rYR;EsE3rYM;;IAEE,2BAAA;EtE6rYR;EsE3rYM;;IAEE,4BAAA;EtE6rYR;EsE3rYM;;IAEE,0BAAA;EtE6rYR;EsE5sYM;IAAgC,2BAAA;EtE+sYtC;EsE9sYM;;IAEE,+BAAA;EtEgtYR;EsE9sYM;;IAEE,iCAAA;EtEgtYR;EsE9sYM;;IAEE,kCAAA;EtEgtYR;EsE9sYM;;IAEE,gCAAA;EtEgtYR;EsE/tYM;IAAgC,0BAAA;EtEkuYtC;EsEjuYM;;IAEE,8BAAA;EtEmuYR;EsEjuYM;;IAEE,gCAAA;EtEmuYR;EsEjuYM;;IAEE,iCAAA;EtEmuYR;EsEjuYM;;IAEE,+BAAA;EtEmuYR;EsElvYM;IAAgC,wBAAA;EtEqvYtC;EsEpvYM;;IAEE,4BAAA;EtEsvYR;EsEpvYM;;IAEE,8BAAA;EtEsvYR;EsEpvYM;;IAEE,+BAAA;EtEsvYR;EsEpvYM;;IAEE,6BAAA;EtEsvYR;EsErwYM;IAAgC,0BAAA;EtEwwYtC;EsEvwYM;;IAEE,8BAAA;EtEywYR;EsEvwYM;;IAEE,gCAAA;EtEywYR;EsEvwYM;;IAEE,iCAAA;EtEywYR;EsEvwYM;;IAEE,+BAAA;EtEywYR;EsExxYM;IAAgC,wBAAA;EtE2xYtC;EsE1xYM;;IAEE,4BAAA;EtE4xYR;EsE1xYM;;IAEE,8BAAA;EtE4xYR;EsE1xYM;;IAEE,+BAAA;EtE4xYR;EsE1xYM;;IAEE,6BAAA;EtE4xYR;EsE3yYM;IAAgC,0BAAA;EtE8yYtC;EsE7yYM;;IAEE,8BAAA;EtE+yYR;EsE7yYM;;IAEE,gCAAA;EtE+yYR;EsE7yYM;;IAEE,iCAAA;EtE+yYR;EsE7yYM;;IAEE,+BAAA;EtE+yYR;EsE9zYM;IAAgC,yBAAA;EtEi0YtC;EsEh0YM;;IAEE,6BAAA;EtEk0YR;EsEh0YM;;IAEE,+BAAA;EtEk0YR;EsEh0YM;;IAEE,gCAAA;EtEk0YR;EsEh0YM;;IAEE,8BAAA;EtEk0YR;EsEj1YM;IAAgC,yBAAA;EtEo1YtC;EsEn1YM;;IAEE,6BAAA;EtEq1YR;EsEn1YM;;IAEE,+BAAA;EtEq1YR;EsEn1YM;;IAEE,gCAAA;EtEq1YR;EsEn1YM;;IAEE,8BAAA;EtEq1YR;EsEp2YM;IAAgC,2BAAA;EtEu2YtC;EsEt2YM;;IAEE,+BAAA;EtEw2YR;EsEt2YM;;IAEE,iCAAA;EtEw2YR;EsEt2YM;;IAEE,kCAAA;EtEw2YR;EsEt2YM;;IAEE,gCAAA;EtEw2YR;EsEv3YM;IAAgC,yBAAA;EtE03YtC;EsEz3YM;;IAEE,6BAAA;EtE23YR;EsEz3YM;;IAEE,+BAAA;EtE23YR;EsEz3YM;;IAEE,gCAAA;EtE23YR;EsEz3YM;;IAEE,8BAAA;EtE23YR;EsE14YM;IAAgC,2BAAA;EtE64YtC;EsE54YM;;IAEE,+BAAA;EtE84YR;EsE54YM;;IAEE,iCAAA;EtE84YR;EsE54YM;;IAEE,kCAAA;EtE84YR;EsE54YM;;IAEE,gCAAA;EtE84YR;EsE75YM;IAAgC,yBAAA;EtEg6YtC;EsE/5YM;;IAEE,6BAAA;EtEi6YR;EsE/5YM;;IAEE,+BAAA;EtEi6YR;EsE/5YM;;IAEE,gCAAA;EtEi6YR;EsE/5YM;;IAEE,8BAAA;EtEi6YR;EsEh7YM;IAAgC,2BAAA;EtEm7YtC;EsEl7YM;;IAEE,+BAAA;EtEo7YR;EsEl7YM;;IAEE,iCAAA;EtEo7YR;EsEl7YM;;IAEE,kCAAA;EtEo7YR;EsEl7YM;;IAEE,gCAAA;EtEo7YR;EsEn8YM;IAAgC,4BAAA;EtEs8YtC;EsEr8YM;;IAEE,gCAAA;EtEu8YR;EsEr8YM;;IAEE,kCAAA;EtEu8YR;EsEr8YM;;IAEE,mCAAA;EtEu8YR;EsEr8YM;;IAEE,iCAAA;EtEu8YR;EsEt9YM;IAAgC,0BAAA;EtEy9YtC;EsEx9YM;;IAEE,8BAAA;EtE09YR;EsEx9YM;;IAEE,gCAAA;EtE09YR;EsEx9YM;;IAEE,iCAAA;EtE09YR;EsEx9YM;;IAEE,+BAAA;EtE09YR;EsEz+YM;IAAgC,wBAAA;EtE4+YtC;EsE3+YM;;IAEE,4BAAA;EtE6+YR;EsE3+YM;;IAEE,8BAAA;EtE6+YR;EsE3+YM;;IAEE,+BAAA;EtE6+YR;EsE3+YM;;IAEE,6BAAA;EtE6+YR;EsE5/YM;IAAgC,wBAAA;EtE+/YtC;EsE9/YM;;IAEE,4BAAA;EtEggZR;EsE9/YM;;IAEE,8BAAA;EtEggZR;EsE9/YM;;IAEE,+BAAA;EtEggZR;EsE9/YM;;IAEE,6BAAA;EtEggZR;EsE/gZM;IAAgC,yBAAA;EtEkhZtC;EsEjhZM;;IAEE,6BAAA;EtEmhZR;EsEjhZM;;IAEE,+BAAA;EtEmhZR;EsEjhZM;;IAEE,gCAAA;EtEmhZR;EsEjhZM;;IAEE,8BAAA;EtEmhZR;EsE3gZM;IAAwB,2BAAA;EtE8gZ9B;EsE7gZM;;IAEE,+BAAA;EtE+gZR;EsE7gZM;;IAEE,iCAAA;EtE+gZR;EsE7gZM;;IAEE,kCAAA;EtE+gZR;EsE7gZM;;IAEE,gCAAA;EtE+gZR;EsE9hZM;IAAwB,0BAAA;EtEiiZ9B;EsEhiZM;;IAEE,8BAAA;EtEkiZR;EsEhiZM;;IAEE,gCAAA;EtEkiZR;EsEhiZM;;IAEE,iCAAA;EtEkiZR;EsEhiZM;;IAEE,+BAAA;EtEkiZR;EsEjjZM;IAAwB,wBAAA;EtEojZ9B;EsEnjZM;;IAEE,4BAAA;EtEqjZR;EsEnjZM;;IAEE,8BAAA;EtEqjZR;EsEnjZM;;IAEE,+BAAA;EtEqjZR;EsEnjZM;;IAEE,6BAAA;EtEqjZR;EsEpkZM;IAAwB,0BAAA;EtEukZ9B;EsEtkZM;;IAEE,8BAAA;EtEwkZR;EsEtkZM;;IAEE,gCAAA;EtEwkZR;EsEtkZM;;IAEE,iCAAA;EtEwkZR;EsEtkZM;;IAEE,+BAAA;EtEwkZR;EsEvlZM;IAAwB,wBAAA;EtE0lZ9B;EsEzlZM;;IAEE,4BAAA;EtE2lZR;EsEzlZM;;IAEE,8BAAA;EtE2lZR;EsEzlZM;;IAEE,+BAAA;EtE2lZR;EsEzlZM;;IAEE,6BAAA;EtE2lZR;EsE1mZM;IAAwB,wBAAA;EtE6mZ9B;EsE5mZM;;IAEE,4BAAA;EtE8mZR;EsE5mZM;;IAEE,8BAAA;EtE8mZR;EsE5mZM;;IAEE,+BAAA;EtE8mZR;EsE5mZM;;IAEE,6BAAA;EtE8mZR;EsE7nZM;IAAwB,uBAAA;EtEgoZ9B;EsE/nZM;;IAEE,2BAAA;EtEioZR;EsE/nZM;;IAEE,6BAAA;EtEioZR;EsE/nZM;;IAEE,8BAAA;EtEioZR;EsE/nZM;;IAEE,4BAAA;EtEioZR;EsEhpZM;IAAwB,uBAAA;EtEmpZ9B;EsElpZM;;IAEE,2BAAA;EtEopZR;EsElpZM;;IAEE,6BAAA;EtEopZR;EsElpZM;;IAEE,8BAAA;EtEopZR;EsElpZM;;IAEE,4BAAA;EtEopZR;EsEnqZM;IAAwB,yBAAA;EtEsqZ9B;EsErqZM;;IAEE,6BAAA;EtEuqZR;EsErqZM;;IAEE,+BAAA;EtEuqZR;EsErqZM;;IAEE,gCAAA;EtEuqZR;EsErqZM;;IAEE,8BAAA;EtEuqZR;EsEtrZM;IAAwB,uBAAA;EtEyrZ9B;EsExrZM;;IAEE,2BAAA;EtE0rZR;EsExrZM;;IAEE,6BAAA;EtE0rZR;EsExrZM;;IAEE,8BAAA;EtE0rZR;EsExrZM;;IAEE,4BAAA;EtE0rZR;EsEzsZM;IAAwB,yBAAA;EtE4sZ9B;EsE3sZM;;IAEE,6BAAA;EtE6sZR;EsE3sZM;;IAEE,+BAAA;EtE6sZR;EsE3sZM;;IAEE,gCAAA;EtE6sZR;EsE3sZM;;IAEE,8BAAA;EtE6sZR;EsE5tZM;IAAwB,uBAAA;EtE+tZ9B;EsE9tZM;;IAEE,2BAAA;EtEguZR;EsE9tZM;;IAEE,6BAAA;EtEguZR;EsE9tZM;;IAEE,8BAAA;EtEguZR;EsE9tZM;;IAEE,4BAAA;EtEguZR;EsE/uZM;IAAwB,yBAAA;EtEkvZ9B;EsEjvZM;;IAEE,6BAAA;EtEmvZR;EsEjvZM;;IAEE,+BAAA;EtEmvZR;EsEjvZM;;IAEE,gCAAA;EtEmvZR;EsEjvZM;;IAEE,8BAAA;EtEmvZR;EsElwZM;IAAwB,0BAAA;EtEqwZ9B;EsEpwZM;;IAEE,8BAAA;EtEswZR;EsEpwZM;;IAEE,gCAAA;EtEswZR;EsEpwZM;;IAEE,iCAAA;EtEswZR;EsEpwZM;;IAEE,+BAAA;EtEswZR;EsErxZM;IAAwB,0BAAA;EtEwxZ9B;EsEvxZM;;IAEE,8BAAA;EtEyxZR;EsEvxZM;;IAEE,gCAAA;EtEyxZR;EsEvxZM;;IAEE,iCAAA;EtEyxZR;EsEvxZM;;IAEE,+BAAA;EtEyxZR;EsExyZM;IAAwB,wBAAA;EtE2yZ9B;EsE1yZM;;IAEE,4BAAA;EtE4yZR;EsE1yZM;;IAEE,8BAAA;EtE4yZR;EsE1yZM;;IAEE,+BAAA;EtE4yZR;EsE1yZM;;IAEE,6BAAA;EtE4yZR;EsE3zZM;IAAwB,wBAAA;EtE8zZ9B;EsE7zZM;;IAEE,4BAAA;EtE+zZR;EsE7zZM;;IAEE,8BAAA;EtE+zZR;EsE7zZM;;IAEE,+BAAA;EtE+zZR;EsE7zZM;;IAEE,6BAAA;EtE+zZR;EsE90ZM;IAAwB,yBAAA;EtEi1Z9B;EsEh1ZM;;IAEE,6BAAA;EtEk1ZR;EsEh1ZM;;IAEE,+BAAA;EtEk1ZR;EsEh1ZM;;IAEE,gCAAA;EtEk1ZR;EsEh1ZM;;IAEE,8BAAA;EtEk1ZR;EsE50ZE;IAAmB,uBAAA;EtE+0ZrB;EsE90ZE;;IAEE,2BAAA;EtEg1ZJ;EsE90ZE;;IAEE,6BAAA;EtEg1ZJ;EsE90ZE;;IAEE,8BAAA;EtEg1ZJ;EsE90ZE;;IAEE,4BAAA;EtEg1ZJ;AACF;AuEj5ZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AvEi5ZJ;;AwE35ZA;EAAkB,4GAAA;AxE+5ZlB;;AwE35ZA;EAAiB,8BAAA;AxE+5ZjB;;AwE95ZA;EAAiB,8BAAA;AxEk6ZjB;;AwEj6ZA;EAAiB,8BAAA;AxEq6ZjB;;AwEp6ZA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzEi7ZF;;AwEl6ZI;EAAwB,2BAAA;AxEs6Z5B;;AwEr6ZI;EAAwB,4BAAA;AxEy6Z5B;;AwEx6ZI;EAAwB,6BAAA;AxE46Z5B;;AgBv4ZI;EwDvCA;IAAwB,2BAAA;ExEm7Z1B;EwEl7ZE;IAAwB,4BAAA;ExEq7Z1B;EwEp7ZE;IAAwB,6BAAA;ExEu7Z1B;AACF;AgBn5ZI;EwDvCA;IAAwB,2BAAA;ExE87Z1B;EwE77ZE;IAAwB,4BAAA;ExEg8Z1B;EwE/7ZE;IAAwB,6BAAA;ExEk8Z1B;AACF;AgB95ZI;EwDvCA;IAAwB,2BAAA;ExEy8Z1B;EwEx8ZE;IAAwB,4BAAA;ExE28Z1B;EwE18ZE;IAAwB,6BAAA;ExE68Z1B;AACF;AgBz6ZI;EwDvCA;IAAwB,2BAAA;ExEo9Z1B;EwEn9ZE;IAAwB,4BAAA;ExEs9Z1B;EwEr9ZE;IAAwB,6BAAA;ExEw9Z1B;AACF;AwEn9ZA;EAAmB,oCAAA;AxEs9ZnB;;AwEr9ZA;EAAmB,oCAAA;AxEy9ZnB;;AwEx9ZA;EAAmB,qCAAA;AxE49ZnB;;AwEx9ZA;EAAuB,2BAAA;AxE49ZvB;;AwE39ZA;EAAuB,+BAAA;AxE+9ZvB;;AwE99ZA;EAAuB,2BAAA;AxEk+ZvB;;AwEj+ZA;EAAuB,2BAAA;AxEq+ZvB;;AwEp+ZA;EAAuB,8BAAA;AxEw+ZvB;;AwEv+ZA;EAAuB,6BAAA;AxE2+ZvB;;AwEv+ZA;EAAc,sBAAA;AxE2+Zd;;A0ElhaE;EACE,yBAAA;A1EqhaJ;;AM3gaE;EoELM,yBAAA;A1EohaR;;A0E1haE;EACE,yBAAA;A1E6haJ;;AMnhaE;EoELM,yBAAA;A1E4haR;;A0EliaE;EACE,yBAAA;A1EqiaJ;;AM3haE;EoELM,yBAAA;A1EoiaR;;A0E1iaE;EACE,yBAAA;A1E6iaJ;;AMniaE;EoELM,yBAAA;A1E4iaR;;A0EljaE;EACE,yBAAA;A1EqjaJ;;AM3iaE;EoELM,yBAAA;A1EojaR;;A0E1jaE;EACE,yBAAA;A1E6jaJ;;AMnjaE;EoELM,yBAAA;A1E4jaR;;A0ElkaE;EACE,yBAAA;A1EqkaJ;;AM3jaE;EoELM,yBAAA;A1EokaR;;A0E1kaE;EACE,yBAAA;A1E6kaJ;;AMnkaE;EoELM,uBAAA;A1E4kaR;;A0EllaE;EACE,yBAAA;A1EqlaJ;;AM3kaE;EoELM,yBAAA;A1EolaR;;A0E1laE;EACE,sBAAA;A1E6laJ;;AMnlaE;EoELM,yBAAA;A1E4laR;;A0ElmaE;EACE,sBAAA;A1EqmaJ;;AM3laE;EoELM,yBAAA;A1EomaR;;A0E1maE;EACE,uBAAA;A1E6maJ;;AMnmaE;EoELM,uBAAA;A1E4maR;;AwErkaA;EAAa,yBAAA;AxEykab;;AwExkaA;EAAc,yBAAA;AxE4kad;;AwE1kaA;EAAiB,oCAAA;AxE8kajB;;AwE7kaA;EAAiB,0CAAA;AxEilajB;;AwE7kaA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A3EwoaF;;AwEjlaA;EAAwB,gCAAA;AxEqlaxB;;AwEnlaA;EACE,iCAAA;EACA,gCAAA;AxEslaF;;AwEjlaA;EAAc,yBAAA;AxEqlad;;A4EtpaA;EACE,8BAAA;A5EypaF;;A4EtpaA;EACE,6BAAA;A5EypaF;;A6EzpaE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E7EypaJ;E6ErpaI;IACE,0BAAA;E7EupaN;E6E9oaE;IACE,6BAAA;E7EgpaJ;E6EloaE;IACE,gCAAA;E7EooaJ;E6EloaE;;IAEE,yBAAA;IACA,wBAAA;E7EooaJ;E6EjoaE;;IAEE,wBAAA;E7EmoaJ;E6EhoaE;;;IAGE,UAAA;IACA,SAAA;E7EkoaJ;E6E/naE;;IAEE,uBAAA;E7EioaJ;E6EznaE;IACE,QxE2iC8B;ELglYlC;E6EznaE;IACE,2BAAA;E7E2naJ;E6EznaE;IACE,2BAAA;E7E2naJ;E6EvnaE;IACE,aAAA;E7EynaJ;E6EvnaE;IACE,sBAAA;E7EynaJ;E6EtnaE;IACE,oCAAA;E7EwnaJ;E6EtnaI;;IAEE,iCAAA;E7EwnaN;E6EnnaI;;IAEE,oCAAA;E7EqnaN;E6EjnaE;IACE,cAAA;E7EmnaJ;E6EjnaI;;;;IAIE,qB1EzEG;EH4raT;E6E/maE;IACE,cAAA;IACA,qB1E/EK;EHgsaT;AACF;A8EhvaA;EACI,SAAA;A9EkvaJ;;A8E/uaA;;;EAGI,cAAA;A9EkvaJ;;A8E/uaA;EACI,gBAAA;A9EkvaJ;;AwD3vaI;EACI,oCAAA;AxD8vaR;;AMjvaE;;;EkDRU,oCAAA;AxD+vaZ;;AwDrwaI;EACI,oCAAA;AxDwwaR;;AM3vaE;;;EkDRU,oCAAA;AxDywaZ;;AwD/waI;EACI,oCAAA;AxDkxaR;;AMrwaE;;;EkDRU,oCAAA;AxDmxaZ;;AwDzxaI;EACI,oCAAA;AxD4xaR;;AM/waE;;;EkDRU,oCAAA;AxD6xaZ;;AwDnyaI;EACI,oCAAA;AxDsyaR;;AMzxaE;;;EkDRU,oCAAA;AxDuyaZ;;AwD7yaI;EACI,oCAAA;AxDgzaR;;AMnyaE;;;EkDRU,oCAAA;AxDizaZ;;AwDvzaI;EACI,oCAAA;AxD0zaR;;AM7yaE;;;EkDRU,oCAAA;AxD2zaZ;;AwDj0aI;EACI,oCAAA;AxDo0aR;;AMvzaE;;;EkDRU,oCAAA;AxDq0aZ;;AwD30aI;EACI,oCAAA;AxD80aR;;AMj0aE;;;EkDRU,oCAAA;AxD+0aZ;;AwDr1aI;EACI,oCAAA;AxDw1aR;;AM30aE;;;EkDRU,oCAAA;AxDy1aZ;;AwD/1aI;EACI,iCAAA;AxDk2aR;;AMr1aE;;;EkDRU,oCAAA;AxDm2aZ;;AwDz2aI;EACI,oCAAA;AxD42aR;;AM/1aE;;;EkDRU,oCAAA;AxD62aZ;;AwDn3aI;EACI,oCAAA;AxDs3aR;;AMz2aE;;;EkDRU,oCAAA;AxDu3aZ;;AwD73aI;EACI,oCAAA;AxDg4aR;;AMn3aE;;;EkDRU,oCAAA;AxDi4aZ;;AwDv4aI;EACI,oCAAA;AxD04aR;;AM73aE;;;EkDRU,oCAAA;AxD24aZ;;AwDr4aI;EACI,sEAAA;AxDw4aR;;AwDz4aI;EACI,sEAAA;AxD44aR;;AwD74aI;EACI,sEAAA;AxDg5aR;;AwDj5aI;EACI,sEAAA;AxDo5aR;;AwDr5aI;EACI,sEAAA;AxDw5aR;;AwDz5aI;EACI,sEAAA;AxD45aR;;AwD75aI;EACI,sEAAA;AxDg6aR;;AwDj6aI;EACI,sEAAA;AxDo6aR;;AwDr6aI;EACI,sEAAA;AxDw6aR;;AwDz6aI;EACI,iEAAA;AxD46aR;;AwD76aI;EACI,iEAAA;AxDg7aR;;AwDj7aI;EACI,kEAAA;AxDo7aR;;AwDr7aI;EACI,sEAAA;AxDw7aR;;AwDz7aI;EACI,sEAAA;AxD47aR;;AwD77aI;EACI,sEAAA;AxDg8aR;;AwDj8aI;EACI,sEAAA;AxDo8aR;;AwDr8aI;EACI,sEAAA;AxDw8aR;;AwDz8aI;EACI,sEAAA;AxD48aR;;AwD78aI;EACI,sEAAA;AxDg9aR;;AwDj9aI;EACI,sEAAA;AxDo9aR;;AwDr9aI;EACI,sEAAA;AxDw9aR;;AwDz9aI;EACI,sEAAA;AxD49aR;;AwD79aI;EACI,iEAAA;AxDg+aR;;AwDj+aI;EACI,sEAAA;AxDo+aR;;AwDr+aI;EACI,sEAAA;AxDw+aR;;AwDz+aI;EACI,sEAAA;AxD4+aR;;AwD7+aI;EACI,sEAAA;AxDg/aR;;AwD3+aI;EACI,mDAAA;AxD8+aR;;AMn/aE;;;EkDUU,mDAAA;AxD++aZ;;AwDr/aI;EACI,qDAAA;AxDw/aR;;AM7/aE;;;EkDUU,qDAAA;AxDy/aZ;;AwD//aI;EACI,oDAAA;AxDkgbR;;AMvgbE;;;EkDUU,oDAAA;AxDmgbZ;;AwDzgbI;EACI,oDAAA;AxD4gbR;;AMjhbE;;;EkDUU,oDAAA;AxD6gbZ;;AwDnhbI;EACI,mDAAA;AxDshbR;;AM3hbE;;;EkDUU,kDAAA;AxDuhbZ;;AwD7hbI;EACI,mDAAA;AxDgibR;;AMribE;;;EkDUU,mDAAA;AxDiibZ;;AwDvibI;EACI,qDAAA;AxD0ibR;;AM/ibE;;;EkDUU,qDAAA;AxD2ibZ;;AwDjjbI;EACI,kDAAA;AxDojbR;;AMzjbE;;;EkDUU,+CAAA;AxDqjbZ;;AwD3jbI;EACI,kDAAA;AxD8jbR;;AMnkbE;;;EkDUU,iDAAA;AxD+jbZ;;AwDrkbI;EACI,qDAAA;AxDwkbR;;AM7kbE;;;EkDUU,qDAAA;AxDykbZ;;AwD/kbI;EACI,qDAAA;AxDklbR;;AMvlbE;;;EkDUU,qDAAA;AxDmlbZ;;AwDzlbI;EACI,+CAAA;AxD4lbR;;AMjmbE;;;EkDUU,+CAAA;AxD6lbZ;;AwDrnbI;EACI,oCAAA;AxDwnbR;;AM3mbE;;;EkDRU,oCAAA;AxDynbZ;;AwD/nbI;EACI,oCAAA;AxDkobR;;AMrnbE;;;EkDRU,oCAAA;AxDmobZ;;AwDzobI;EACI,oCAAA;AxD4obR;;AM/nbE;;;EkDRU,oCAAA;AxD6obZ;;AwDnpbI;EACI,oCAAA;AxDspbR;;AMzobE;;;EkDRU,oCAAA;AxDupbZ;;AwD7pbI;EACI,kCAAA;AxDgqbR;;AMnpbE;;;EkDRU,kCAAA;AxDiqbZ;;AwD3pbI;EACI,sEAAA;AxD8pbR;;AwD/pbI;EACI,sEAAA;AxDkqbR;;AwDnqbI;EACI,sEAAA;AxDsqbR;;AwDvqbI;EACI,sEAAA;AxD0qbR;;AwD3qbI;EACI,sEAAA;AxD8qbR;;AwD/qbI;EACI,sEAAA;AxDkrbR;;AwDnrbI;EACI,sEAAA;AxDsrbR;;AwDvrbI;EACI,sEAAA;AxD0rbR;;AwD3rbI;EACI,sEAAA;AxD8rbR;;AwD/rbI;EACI,iEAAA;AxDksbR;;AwDnsbI;EACI,iEAAA;AxDssbR;;AwDvsbI;EACI,kEAAA;AxD0sbR;;A+ElrbI;EACI,a1EoCO;ALipbf;;A+ElrbI;EACI,e1EgCO;ALqpbf;;A+E1rbI;EACI,a1EoCO;ALypbf;;A+E1rbI;EACI,e1EgCO;AL6pbf;;A+ElsbI;EACI,a1EoCO;ALiqbf;;A+ElsbI;EACI,e1EgCO;ALqqbf;;A+E1sbI;EACI,a1EoCO;ALyqbf;;A+E1sbI;EACI,e1EgCO;AL6qbf;;A+EltbI;EACI,a1EoCO;ALirbf;;A+EltbI;EACI,e1EgCO;ALqrbf;;A+E1tbI;EACI,a1EoCO;ALyrbf;;A+E1tbI;EACI,e1EgCO;AL6rbf;;A+ElubI;EACI,a1EoCO;ALisbf;;A+ElubI;EACI,e1EgCO;ALqsbf;;A+E1ubI;EACI,a1EoCO;ALysbf;;A+E1ubI;EACI,e1EgCO;AL6sbf;;A+ElvbI;EACI,a1EoCO;ALitbf;;A+ElvbI;EACI,e1EgCO;ALqtbf;;A+E1vbI;EACI,U1EoCO;ALytbf;;A+E1vbI;EACI,Y1EgCO;AL6tbf;;A+ElwbI;EACI,U1EoCO;ALiubf;;A+ElwbI;EACI,Y1EgCO;ALqubf;;A+E1wbI;EACI,W1EoCO;ALyubf;;A+E1wbI;EACI,a1EgCO;AL6ubf;;A+EzwbA;EACC,iBAAA;A/E4wbD;;AgFvzbA;EACC,oCAAA;EACA,sBAAA;AhF0zbD;AgFxzbC;EACO,4BAAA;AhF0zbR;;AgFnzbA;EACC,uCAAA;AhFszbD;;AgFnzbA;EACC,uCAAA;AhFszbD;;AgFhzbA;EACI;IACI,0BAAA;EhFmzbN;EgFjzbE;IACI,2BAAA;EhFmzbN;EgFjzbE;IACI,0BAAA;EhFmzbN;AACF;AgFhzbA;EACI;IACI,0BAAA;EhFkzbN;EgFhzbE;IACI,2BAAA;EhFkzbN;EgFhzbE;IACI,0BAAA;EhFkzbN;AACF;AgF/ybA;EACI;IACI,0BAAA;EhFizbN;EgF/ybE;IACI,0BAAA;EhFizbN;EgF/ybE;IACI,0BAAA;EhFizbN;AACF;AiFt2bI;EAEI,WAAA;EACA,cAAA;AjFu2bR;AiFr2bI;EACI,WAAA;AjFu2bR;;AkFl3bA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AlFq3bJ;;AmFv3bA;EACI,uBAAA;AnF03bJ;;AmFx3bA;EACI,uBAAA;AnF23bJ;;AmFz3bA;EACI,uBAAA;AnF43bJ;;AmF13bA;EACI,uBAAA;AnF63bJ;;AmF33bA;EACI,uBAAA;AnF83bJ;;AmF53bA;EACI,uBAAA;AnF+3bJ;;AmF73bA;EACI,uBAAA;AnFg4bJ;;AmF93bA;EACI,uBAAA;AnFi4bJ;;AmF/3bA;EACI,uBAAA;AnFk4bJ;;AmFh4bA;EACI,qBAAA;AnFm4bJ;;AoFh6bA;EACI,4BAAA;ApFm6bJ;;AoFh6bA;EACI,2BAAA;ApFm6bJ;;AqFr6bC;EACC,MhFiIQ;ALuybV;;AqFt6bC;EACC,QhF8HQ;AL2ybV;;AqFv6bC;EACC,ShF2HQ;AL+ybV;;AqFx6bC;EACC,OhFwHQ;ALmzbV;;AqFr7bC;EACC,YhFiIQ;ALuzbV;;AqFt7bC;EACC,chF8HQ;AL2zbV;;AqFv7bC;EACC,ehF2HQ;AL+zbV;;AqFx7bC;EACC,ahFwHQ;ALm0bV;;AqFr8bC;EACC,WhFiIQ;ALu0bV;;AqFt8bC;EACC,ahF8HQ;AL20bV;;AqFv8bC;EACC,chF2HQ;AL+0bV;;AqFx8bC;EACC,YhFwHQ;ALm1bV;;AqFr9bC;EACC,ShFiIQ;ALu1bV;;AqFt9bC;EACC,WhF8HQ;AL21bV;;AqFv9bC;EACC,YhF2HQ;AL+1bV;;AqFx9bC;EACC,UhFwHQ;ALm2bV;;AqFr+bC;EACC,WhFiIQ;ALu2bV;;AqFt+bC;EACC,ahF8HQ;AL22bV;;AqFv+bC;EACC,chF2HQ;AL+2bV;;AqFx+bC;EACC,YhFwHQ;ALm3bV;;AqFr/bC;EACC,ShFiIQ;ALu3bV;;AqFt/bC;EACC,WhF8HQ;AL23bV;;AqFv/bC;EACC,YhF2HQ;AL+3bV;;AqFx/bC;EACC,UhFwHQ;ALm4bV;;AqFrgcC;EACC,WhFiIQ;ALu4bV;;AqFtgcC;EACC,ahF8HQ;AL24bV;;AqFvgcC;EACC,chF2HQ;AL+4bV;;AqFxgcC;EACC,YhFwHQ;ALm5bV;;AqFrhcC;EACC,UhFiIQ;ALu5bV;;AqFthcC;EACC,YhF8HQ;AL25bV;;AqFvhcC;EACC,ahF2HQ;AL+5bV;;AqFxhcC;EACC,WhFwHQ;ALm6bV;;AqFricC;EACC,UhFiIQ;ALu6bV;;AqFticC;EACC,YhF8HQ;AL26bV;;AqFvicC;EACC,ahF2HQ;AL+6bV;;AqFxicC;EACC,WhFwHQ;ALm7bV;;AqFrjcC;EACC,YhFiIQ;ALu7bV;;AqFtjcC;EACC,chF8HQ;AL27bV;;AqFvjcC;EACC,ehF2HQ;AL+7bV;;AqFxjcC;EACC,ahFwHQ;ALm8bV;;AqFrkcC;EACC,UhFiIQ;ALu8bV;;AqFtkcC;EACC,YhF8HQ;AL28bV;;AqFvkcC;EACC,ahF2HQ;AL+8bV;;AqFxkcC;EACC,WhFwHQ;ALm9bV;;AqFrlcC;EACC,YhFiIQ;ALu9bV;;AqFtlcC;EACC,chF8HQ;AL29bV;;AqFvlcC;EACC,ehF2HQ;AL+9bV;;AqFxlcC;EACC,ahFwHQ;ALm+bV;;AqFrmcC;EACC,UhFiIQ;ALu+bV;;AqFtmcC;EACC,YhF8HQ;AL2+bV;;AqFvmcC;EACC,ahF2HQ;AL++bV;;AqFxmcC;EACC,WhFwHQ;ALm/bV;;AqFrncC;EACC,YhFiIQ;ALu/bV;;AqFtncC;EACC,chF8HQ;AL2/bV;;AqFvncC;EACC,ehF2HQ;AL+/bV;;AqFxncC;EACC,ahFwHQ;ALmgcV;;AqFrocC;EACC,ahFiIQ;ALugcV;;AqFtocC;EACC,ehF8HQ;AL2gcV;;AqFvocC;EACC,gBhF2HQ;AL+gcV;;AqFxocC;EACC,chFwHQ;ALmhcV;;AqFrpcC;EACC,WhFiIQ;ALuhcV;;AqFtpcC;EACC,ahF8HQ;AL2hcV;;AqFvpcC;EACC,chF2HQ;AL+hcV;;AqFxpcC;EACC,YhFwHQ;ALmicV;;AqFrqcC;EACC,ShFiIQ;ALuicV;;AqFtqcC;EACC,WhF8HQ;AL2icV;;AqFvqcC;EACC,YhF2HQ;AL+icV;;AqFxqcC;EACC,UhFwHQ;ALmjcV;;AqFrrcC;EACC,ShFiIQ;ALujcV;;AqFtrcC;EACC,WhF8HQ;AL2jcV;;AqFvrcC;EACC,YhF2HQ;AL+jcV;;AqFxrcC;EACC,UhFwHQ;ALmkcV;;AqFrscC;EACC,UhFiIQ;ALukcV;;AqFtscC;EACC,YhF8HQ;AL2kcV;;AqFvscC;EACC,ahF2HQ;AL+kcV;;AqFxscC;EACC,WhFwHQ;ALmlcV;;AqFvscA;EACC,SAAA;EACA,2BAAA;ArF0scD;;AsF7tcA;EACC,wBAAA;AtFgucD;;AuFjucA;EACI,gBAAA;AvFoucJ;;AgB7qcI;EuEnDA;IACI,aAAA;EvFoucN;AACF;AgBnrcI;EuE9CA;IACI,aAAA;EvFoucN;AACF;AgBxrcI;EuEzCA;IACI,aAAA;EvFoucN;AACF;AuFjucA;EACI,gBAAA;AvFmucJ;;AuF7tcA;EAWI;IACI,6BAAA;EvFstcN;EuFptcE;IACI,+BAAA;EvFstcN;EuFptcE;IACI,gCAAA;EvFstcN;EuFptcE;IACI,8BAAA;EvFstcN;EuFptcE;IACI,6BAAA;EvFstcN;EuFptcE;IACI,gCAAA;EvFstcN;EuFptcE;IACI,6BAAA;EvFstcN;EuFptcE;IACI,gCAAA;EvFstcN;EuFptcE;IACI,6BAAA;EvFstcN;EuFptcE;IACI,gCAAA;EvFstcN;EuFhtcE;IACI,6BAAA;EvFktcN;EuFhtcE;IACI,gCAAA;EvFktcN;EuFhtcE;IACI,6BAAA;EvFktcN;EuFhtcE;IACI,gCAAA;EvFktcN;EuFhtcE;IACI,6BAAA;EvFktcN;EuFhtcE;IACI,gCAAA;EvFktcN;EuFhtcE;IACI,6BAAA;EvFktcN;EuFhtcE;IACI,gCAAA;EvFktcN;EuFhtcE;IACI,6BAAA;EvFktcN;EuFhtcE;IACI,gCAAA;EvFktcN;AACF;AwFtzcA;EAEQ,0BrF+UsB;AHw+b9B;;AwFjzcA;EACC,4DAAA;AxFozcD;;AwFjzcA;EACC,2DAAA;AxFozcD;;AwFjzcA;EACC,0DAAA;AxFozcD;;AwFjzcA;EACC,2BAAA;AxFozcD;;AyF50cA;EAAmB,2BAAA;AzFg1cnB;;AyF/0cA;EAAmB,2BAAA;AzFm1cnB;;AyFl1cA;EAAmB,2BAAA;AzFs1cnB;;AyFr1cA;EAAmB,2BAAA;AzFy1cnB;;AyFx1cA;EAAmB,2BAAA;AzF41cnB;;AyF31cA;EAAmB,2BAAA;AzF+1cnB;;AyF91cA;EAAmB,2BAAA;AzFk2cnB;;AyF71cA;EAAkB,0BAAA;AzFi2clB;;AyFh2cA;EAAgB,6BAAA;AzFo2chB;;AyF/1cA;EAAW,6BAAA;AzFm2cX;;AyFl2cA;EAAW,8BAAA;AzFs2cX;;AyFr2cA;EAAW,6BAAA;AzFy2cX;;AyFx2cA;EAAW,4BAAA;AzF42cX;;AyFv2cA;EAAU,cAAA;AzF22cV;;AyF12cA;EAAU,gBAAA;AzF82cV;;AyF72cA;EAAU,gBAAA;AzFi3cV;;AyFh3cA;EAAU,gBAAA;AzFo3cV;;AyFn3cA;EAAU,gBAAA;AzFu3cV;;AyFt3cA;EAAU,gBAAA;AzF03cV;;AyFz3cA;EAAU,gBAAA;AzF63cV;;AyF53cA;EAAU,gBAAA;AzFg4cV;;AyF/3cA;EAAU,gBAAA;AzFm4cV;;AyF93cA;EAAQ,yBAAA;AzFk4cR;;AyFj4cA;EAAS,0BAAA;AzFq4cT;;AyFp4cA;EAAQ,wBAAA;AzFw4cR;;A0E76cE;EACE,yBAAA;A1Eg7cJ;;AMt6cE;EoELM,yBAAA;A1E+6cR;;A0Er7cE;EACE,yBAAA;A1Ew7cJ;;AM96cE;EoELM,yBAAA;A1Eu7cR;;A0E77cE;EACE,yBAAA;A1Eg8cJ;;AMt7cE;EoELM,yBAAA;A1E+7cR;;A0Er8cE;EACE,yBAAA;A1Ew8cJ;;AM97cE;EoELM,yBAAA;A1Eu8cR;;A0E78cE;EACE,yBAAA;A1Eg9cJ;;AMt8cE;EoELM,yBAAA;A1E+8cR;;A0Er9cE;EACE,yBAAA;A1Ew9cJ;;AM98cE;EoELM,yBAAA;A1Eu9cR;;A0E79cE;EACE,yBAAA;A1Eg+cJ;;AMt9cE;EoELM,yBAAA;A1E+9cR;;A0Er+cE;EACE,yBAAA;A1Ew+cJ;;AM99cE;EoELM,yBAAA;A1Eu+cR;;A0E7+cE;EACE,yBAAA;A1Eg/cJ;;AMt+cE;EoELM,yBAAA;A1E++cR;;A0Er/cE;EACE,yBAAA;A1Ew/cJ;;AM9+cE;EoELM,yBAAA;A1Eu/cR;;A0E7/cE;EACE,sBAAA;A1EggdJ;;AMt/cE;EoELM,yBAAA;A1E+/cR;;A0ErgdE;EACE,yBAAA;A1EwgdJ;;AM9/cE;EoELM,yBAAA;A1EugdR;;A0E7gdE;EACE,yBAAA;A1EghdJ;;AMtgdE;EoELM,yBAAA;A1E+gdR;;A0ErhdE;EACE,yBAAA;A1EwhdJ;;AM9gdE;EoELM,yBAAA;A1EuhdR;;A0E7hdE;EACE,yBAAA;A1EgidJ;;AMthdE;EoELM,yBAAA;A1E+hdR;;AgB9+cI;E0EtDH;IACC,kFAAA;E1FwidA;E0FtidD;IACC,kFAAA;E1FwidA;AACF;A2F/idA;EACI,mBxF8V0B;AHmtc9B;;A2F5idA;EACI,gBxF6V0B;EwF5V1B,oBxFuW0B;EwFtW1B,mBAAA;A3F+idJ;;A2F1idA;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;A3F6idJ;A2F3idI;EACI,kBAAA;EACA,QAAA;A3F6idR;;A2FvidA;EACI,qBAAA;EACA,sBAAA;A3F0idJ;;A2FnidI;EACI,WxFGG;EwFFH,kDAAA;A3FsidR;;A4F5kdI;EACI,QAAA;EACA,azFsxBU;EyFrxBV,UAAA;EACA,2BAAA;EACA,+BAAA;EACA,UAAA;A5F+kdR;A4F7kdQ;EAEI,+BAAA;EACA,qBAAA;A5F8kdZ;AgBrhdI;E4EpEA;IAeQ,SAAA;IACA,aAAA;E5F8kdV;AACF;A4F5kdQ;EACI,iBAAA;EACA,6BAAA;EACA,+BAAA;A5F8kdZ;A4FzkdY;EACI,6BAAA;EACA,+BAAA;A5F2kdhB;;A6FvmdA;EACC,W1FsCU;E0FrCV,yB1F0CU;E0FzCV,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;A7F0mdD;A6FxmdI;EACC,WAAA;EACA,kBAAA;A7F0mdL;A6FvmdI;EACC,qBAAA;EACA,oBAAA;A7FymdL;;A6FlmdA;EACC,WAAA;EACA,YAAA;EACA,mB1FiU6B;AHoyc9B;;A6FlmdA;EACC,WAAA;EACA,YAAA;EACA,mB1F2T6B;AH0yc9B;;A8FtodC;EACC,kBAAA;EACA,UAAA;EACA,sBAAA;A9FyodF;A8FvodE;EACC,UAAA;A9FyodH;A8FrodC;EACC,kBAAA;A9FuodF;;A+FlpdA;EACI,yB5Fk2BgC;AHmzbpC;A+FnpdI;EACI,W5FkCG;AHmndX;;A+F9odA;EACI,mBAAA;A/FipdJ;;A+F9odA;EACI,uBAAA;A/FipdJ;;A+F3odA;EACI,sBAAA;A/F8odJ;A+F5odI;EACI,QAAA;EACA,kBAAA;A/F8odR;A+F5odQ;EACI,0BAAA;A/F8odZ;;A+FpodQ;EACI,mBAAA;A/FuodZ;A+FrodQ;EACI,oBAAA;A/FuodZ;;AgGnrdA;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AhGsrdJ;;AiG9rdA;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gB9F4V0B;E8F3V1B,mB9FuV0B;E8FtV1B,oBAAA;AjGisdJ;AiG/rdI;EACI,c9FqCG;AH4pdX;AiG9rdI;EACI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AjGgsdR;AiG5rdQ;EACI,aAAA;EACA,cAAA;AjG8rdZ;AiGzrdQ;EACI,eAAA;EACA,gBAAA;AjG2rdZ;;AkG3tdA;EACG,kBAAA;EACA,oB/F+f2B;E+F9f3B,0B/F6U2B;E+F5U3B,uB/FggB2B;E+F/f3B,mB/Fue2B;E+Fte3B,sBAAA;AlG8tdH;AkG5tdG;EtFEG,2EsFDA;EACA,2BAAA;AlG8tdN;AkG3tdG;EACG,oBAAA;AlG6tdN;AkGvtdG;;EAEG,mBAAA;AlGytdN;AkGttdG;;EAEG,oBAAA;AlGwtdN;;AkG/sdG;;EACG,eAAA;EACA,wBAAA;AlGmtdN;;AkG5sdA;EACG,kB/F6b2B;AHkxc9B;;AkG5sdA;EACG,mB/F2b8B;AHoxcjC;;AkGxsdA;EACG,iBAAA;AlG2sdH;;AkGxsdA;EACG,cAAA;AlG2sdH;;AkGvsdG;EACG,kBAAA;EACA,QAAA;AlG0sdN;;AkGtsdA;EACG,gB/Fsb2B;E+Frb3B,gBAAA;AlGysdH;AkGvsdG;EACG,gBAAA;EACA,eAAA;AlGysdN;;AkGrsdA;EACG,cAAA;AlGwsdH;;AmG3xdQ;EACI,WAAA;AnG8xdZ;AmG1xdG;EACI,mBAAA;AnG4xdP;AmGzxdG;EACI,oBAAA;AnG2xdP;;AmGpxdA;EACI,eAAA;EACA,gBAAA;EACA,UAAA;AnGuxdJ;;AmGpxdA;EACI,gBAAA;AnGuxdJ;;AmGpxdA;EACI,WAAA;EACA,YAAA;AnGuxdJ;;AmG9wdA;EACI,SAAA;EACA,eAAA;EACA,ehGiT0B;EgGhT1B,gBhGuT0B;EgGtT1B,iBAAA;EACA,chGGO;EgGFP,yBhGLO;EgGMP,uBhG+Q0B;EgG9Q1B,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AnGixdJ;AmG/wdI;EACI,sBhGpBG;EgGqBH,uEAAA;AnGixdR;AmG9wdI;EACI,mBAAA;EACA,aAAA;AnGgxdR;AmG7wdI;EACI,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AnG+wdR;AmG5wdI;EACI,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AnG8wdR;;AoG/1dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB02dJ;AMl2dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBm3dvG;AyBv2dI;EAIQ,2GAAA;AzBs2dZ;AyBh2dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHkvdf;AyB91dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBg4d1L;AyBz1dQ;EAGQ,gDAAA;AzBy1dhB;;AoG33dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBs4dJ;AM93dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB+4dvG;AyBn4dI;EAIQ,4GAAA;AzBk4dZ;AyB53dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AH8wdf;AyB13dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB45d1L;AyBr3dQ;EAGQ,iDAAA;AzBq3dhB;;AoGv5dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBk6dJ;AM15dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB26dvG;AyB/5dI;EAIQ,2GAAA;AzB85dZ;AyBx5dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AH0ydf;AyBt5dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBw7d1L;AyBj5dQ;EAGQ,gDAAA;AzBi5dhB;;AoGn7dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB87dJ;AMt7dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBu8dvG;AyB37dI;EAIQ,2GAAA;AzB07dZ;AyBp7dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHs0df;AyBl7dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBo9d1L;AyB76dQ;EAGQ,gDAAA;AzB66dhB;;AoG/8dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB09dJ;AMl9dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBm+dvG;AyBv9dI;EAIQ,0GAAA;AzBs9dZ;AyBh9dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHk2df;AyB98dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBg/d1L;AyBz8dQ;EAGQ,+CAAA;AzBy8dhB;;AoG3+dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBs/dJ;AM9+dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB+/dvG;AyBn/dI;EAIQ,2GAAA;AzBk/dZ;AyB5+dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AH83df;AyB1+dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB4ge1L;AyBr+dQ;EAGQ,gDAAA;AzBq+dhB;;AoGvgeI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBkheJ;AM1geE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB2hevG;AyB/geI;EAIQ,4GAAA;AzB8geZ;AyBxgeI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AH05df;AyBtgeI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBwie1L;AyBjgeQ;EAGQ,iDAAA;AzBigehB;;AoGnieI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB8ieJ;AMtieE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBujevG;AyB3ieI;EAIQ,4GAAA;AzB0ieZ;AyBpieI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHs7df;AyBlieI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBoke1L;AyB7heQ;EAGQ,iDAAA;AzB6hehB;;AoG/jeI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB0keJ;AMlkeE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBmlevG;AyBvkeI;EAIQ,0GAAA;AzBskeZ;AyBhkeI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHk9df;AyB9jeI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBgme1L;AyBzjeQ;EAGQ,+CAAA;AzByjehB;;AqG9leA;EACI,yCAAA;ArGimeJ;;AsGnmeA;EACI,kBAAA;AtGsmeJ;AsGpmeI;EACI,gBAAA;EACA,uBnG0TsB;EmGxTtB,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,0BnGwUsB;AH6xd9B;AsGnmeQ;EACI,gCAAA;AtGqmeZ;;AsGhmeA;EACI,eAAA;AtGmmeJ;AsGjmeI;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;AtGmmeR;AsGjmeQ;EACI,eAAA;AtGmmeZ;AsGhmeQ;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;AtGkmeZ;AsGhmeQ;EACI,mBAAA;EACA,cnGSD;AHyleX;;AsG7leA;EACI,iBAAA;AtGgmeJ;;AuG1oeI;EACI,4BAAA;ElFUF,0BkFTE;AvG6oeR;AqBhoeM;EkFfF;IlFgBI,gBAAA;ErBmoeN;AACF;;AwGppeI;EACI,oBAAA;AxGupeR;AwGppeI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,+BAAA;AxGspeR;;AyG/peA;EACI,kBAAA;EACA,atGqoBW;AH6hdf;;AyG5peA;EACI,atG+nBc;AHgidlB;;AyGzpeA;EACI,aAAA;EACA,uBAAA;EACA,kBtGwnBsB;EsGvnBtB,mBtG4U0B;EsG3U1B,kBAAA;EACA,ctG0BO;AHkoeX;;AyGzpeA;EACI,oBAAA;EACA,mBAAA;AzG4peJ;AyG1peI;EACI,iBAAA;AzG4peR;;AyGxpeA;EACI,qBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AzG2peJ;;AyGrpeA;EACI,UAAA;AzGwpeJ;AyGtpeI;EACI,SAAA;EACA,SAAA;EACA,+CAAA;AzGwpeR;;AyGjpeA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AzGopeF;;A0GnteA;EAEQ,0BvGgVsB;AHq4d9B;A0GlteI;EACI,6BvGwzB4B;EuGvzB5B,yBvGyzB4B;EuGxzB5B,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAEI,0BvGmUkB;AHg5d9B;A0G/seI;EAEI,6BvG0yB4B;EuGzyB5B,yBvG2yB4B;EuG1yB5B,aAAA;A1GgteR;A0G9seQ;EACI,6BvGqyBwB;AH26cpC;;A2G9ueA;EACI,kBAAA;A3GiveJ;A2G9ueI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;A3GgveR;AgBhseI;E2F5CA;IAEQ,6BAAA;IACA,8BAAA;E3G8ueV;AACF;;A2G7tegB;EACI,kBxG8tBI;AHkgdxB;A2G9tegB;EACI,mBxG2tBI;AHqgdxB;AgB7seI;E2FvBY;IACI,kBxG8tBI;EHygdtB;E2Gruec;IACI,mBxG2tBI;EH4gdtB;AACF;AgBrteI;E2FvBY;IACI,kBxG8tBI;EHihdtB;E2G7uec;IACI,mBxG2tBI;EHohdtB;AACF;AgB7teI;E2FvBY;IACI,kBxG8tBI;EHyhdtB;E2Grvec;IACI,mBxG2tBI;EH4hdtB;AACF;AgBrueI;E2FvBY;IACI,kBxG8tBI;EHiidtB;E2G7vec;IACI,mBxG2tBI;EHoidtB;AACF;;A4GpyeI;EACI,eAAA;EACA,mBzG4VsB;AH28d9B;A4GjyegB;EACI,qBzGgUY;AHm+dhC;A4GjyegB;EACI,yDvG2hB4B;ALwwdhD;A4G5xegB;EACI,qBzGsBT;AHwweX;A4GzxegB;EACI,qCzG6kB4B;AH8sdhD;;A6GnzeI;EACI,yBAAA;EAEI,2D1GqjB4B;AHgwdxC;A6GjzeI;EACI,kBAAA;EACA,QAAA;A7GmzeR;;A6G/yeA;EACI,gBAAA;A7GkzeJ;;A6GzyeQ;EACI,SAAA;EACA,yE1G4gB4B;AHgydxC;A6GryegB;EACI,2E1GqgBoB;AHkydxC;A6GlyeQ;EAEI,yE1G6f4B;AHsydxC;;A8G70eI;EACI,eAAA;EACA,mB3G4VsB;AHo/d9B;A8G10egB;EACI,qB3GgUY;AH4gehC;A8G10egB;EACI,yDzG2hB4B;ALizdhD;A8Gr0egB;EACI,qB3GsBT;AHizeX;A8Gl0egB;EACI,qC3G6kB4B;AHuvdhD;;A+G91eI;EACI,eAAA;EACA,mB5G4VsB;AHqge9B;A+G31egB;EACI,qB5GgUY;AH6hehC;A+G31egB;EACI,yD1GoiB4B;ALyzdhD;A+Gt1egB;EACI,qB5GsBT;AHk0eX;A+Gn1egB;EACI,qC5G6kB4B;AHwwdhD;;AgHh3eA;EACI,kBAAA;EACA,qBAAA;EACA,W7G+mB4B;E6G9mB5B,cAAA;AhHm3eJ;AgHj3eI;EACI,aAAA;AhHm3eR;AgHh3ea;EACG,yBAAA;AhHk3ehB;AgHh3egB;EACI,mB7GsmBY;E6GrmBZ,+BAAA;AhHk3epB;AgH52eY;EACI,yBAAA;AhH82ehB;AgH12egB;EACI,yBAAA;AhH42epB;AgH12eoB;EACI,yBAAA;AhH42exB;;AgHp2eA;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;AhHu2eJ;AgHp2eI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yB7GfG;E6GgBH,2D7GggBgC;AHs2dxC;;AiH/5eA;;;;EAII,qBAAA;AjHk6eJ;;AiH/5eA;EACI,gBAAA;AjHk6eJ;AiHh6eI;EACI,oBAAA;EACA,mB9GiVsB;AHile9B;AiHj6eQ;;EAEI,kBAAA;EACA,eAAA;EACA,oBAAA;AjHm6eZ;;AiH95eA;EACI,kBAAA;EACA,mBAAA;EACA,c9GeO;E8GdP,mBAAA;EACA,yBAAA;EACA,gBAAA;AjHi6eJ;;AiHv5eY;EACI,cAAA;AjH05ehB;AiHt5eQ;EACI,c9GCD;AHu5eX;AiHp5eY;;EAEI,yBAAA;AjHs5ehB;;AiH74eA;EACI,gBAAA;EACA,iB9GkQ0B;AH8oe9B;;AiH74eA;EACI,gBAAA;EACA,wB9G6P0B;AHmpe9B;;AiH74eA;EACI,gBAAA;EACA,wB9GwP0B;AHwpe9B;;AkHt9eA;EACI,mB/G+9BQ;E+G99BR,iBAAA;AlHy9eJ;AkHt9eQ;EACI,c/GsCD;E+GrCC,iBAAA;EACA,mB/GoVkB;E+GnVlB,yBAAA;EACA,gB/GuVkB;E+GtVlB,mBAAA;AlHw9eZ;AkHp9eI;;EAEI,yBAAA;AlHs9eR;AkHp9eQ;;EACI,yBAAA;AlHu9eZ;AkHn9eI;EACI,qBAAA;EACA,mBAAA;EACA,c/GiBG;E+GhBH,kB/Gm8BgB;AHkhdxB;AkHn9eQ;EACI,c/GcD;AHu8eX;AkHj9eI;EACI,mB/GwTsB;AH2pe9B;;AkH38eI;EACI,W/GPG;AHq9eX;;AkHt8eI;EACI,mB/GsSsB;AHmqe9B;AkHr8eQ;EACI,gBAAA;AlHu8eZ;;AkH/7eA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;AlHk8eJ;AkHh8eI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AlHk8eR;AkH/7eI;EACI,oBAAA;EACA,kBAAA;AlHi8eR;;AmHzhfA;EACI,chH4CO;EgH3CP,mBhH0V0B;EgHzV1B,gBhH8V0B;AH8re9B;;AmHthfA;EACI,mBhHie0B;AHwje9B;AmHthfQ;EACI,chH6BD;AH2/eX;;AmHhhfA;EACI,uBAAA;AnHmhfJ;;AmHhhfA;EACI,uBAAA;AnHmhfJ;;AmHhhfA;EACI,2BAAA;AnHmhfJ;;AmHhhfA;EACI,6BAAA;AnHmhfJ;;AmH3gfA;EACI,yBhHsfoC;EgHrfpC,qBhHqfoC;EgHpfpC,gBAAA;AnH8gfJ;AmH5gfI;EACI,yBhHkfgC;AH4hexC;;AmHvgfA;EACI,yEhH4eoC;EgH3epC,SAAA;EACA,iCAAA;AnH0gfJ;AmHxgfI;EACI,2EhHwegC;AHkiexC;;AmHpgfA;EACI,ehHoR0B;AHmve9B;;AoH7kfA;;EAEI,kBAAA;ApHglfJ;AoH9kfI;;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;ApHilfR;;AoH5kfI;EACI,gBAAA;EACA,0BAAA;EACA,yBjH6lByB;AHk/djC;AoH5kfI;EACI,sBjHUG;AHokfX;AoH5kfQ;EACI,sCjH+gB4B;AH+jexC;AoHxkfQ;EACI,cjHglBqB;AH0/djC;;AoHpkfI;EACI,gBAAA;EACA,0BAAA;EACA,yBjHwkByB;AH+/djC;AoHpkfI;EACI,sBjHbG;AHmlfX;AoHpkfQ;EACI,sCjHwf4B;AH8kexC;AoHjkfQ;EACI,cjH4jBqB;AHugejC;;AqHlofA;EACC,gBlH6iBuC;EkH5iBvC,uBlH6T6B;EkH5T7B,0BlH+U6B;AHsze9B;AqHnofC;EACC,gBAAA;ArHqofF;AqHnofE;EACI,cAAA;EACA,eAAA;ArHqofN;AqHnofE;EACC,eAAA;EACA,gBAAA;ArHqofH;AqHnofE;EACC,gBAAA;ArHqofH;;AqHhofA;EACI,2DlHoiBoC;AH+lexC;;AqH5nfA;EACI,yElHygBoC;EkHxgBpC,SAAA;EACA,iCAAA;ArH+nfJ;AqH7nfI;;EAEI,SAAA;EACA,gBAAA;ArH+nfR;;AqH1nfC;EACO,sFAAA;ArH6nfR;;AqHrnfC;EACC,gBlH+fsC;AHynexC;AqHrnfC;EACI,clHVM;EkHWN,sBlHjBM;EkHkBN,sClHsfmC;AHioexC;AqHpnfC;EACC,sClHkfsC;AHooexC;;AsHrrfA;EACI,kBAAA;AtHwrfJ;;AuHzrfA;EACC,WpHibW;EoHhbX,YpHgbW;AH4weZ;AuH1rfC;EACC,kBAAA;AvH4rfF;AuHzrfI;EACC,kBAAA;EACA,4BAAA;AvH2rfL;;AuHprfA;EACC,WpHiac;EoHhad,YpHgac;AHuxef;AuHrrfC;EACC,kBAAA;AvHurfF;AuHprfI;EACC,4BAAA;AvHsrfL;;AuH/qfA;EACC,WpHkZc;EoHjZd,YpHiZc;AHiyef;AuHhrfC;EACC,kBAAA;AvHkrfF;AuH/qfI;EACC,4BAAA;AvHirfL;;AuH1qfA;EACC,WpHmYc;EoHlYd,YpHkYc;AH2yef;AuH3qfC;EACC,kBAAA;AvH6qfF;AuH1qfI;EACC,4BAAA;AvH4qfL;;AwHrufA;EACC,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxHwufD;AwHrufC;EACC,kBAAA;AxHuufF;AwHnufE;EACC,mBAAA;AxHqufH;AwHhufE;EACC,mBAAA;AxHkufH;AwH9tfC;EACC,WAAA;EACA,YAAA;AxHgufF;;AwH1tfC;ECrCG,cAAA;EACA,0CAAA;AzHmwfJ;;AwH/tfC;ECrCG,cAAA;EACA,0CAAA;AzHwwfJ;;AwHpufC;ECrCG,cAAA;EACA,yCAAA;AzH6wfJ;;AwHzufC;ECrCG,cAAA;EACA,yCAAA;AzHkxfJ;;AwH9ufC;ECrCG,cAAA;EACA,0CAAA;AzHuxfJ;;AwHnvfC;ECrCG,cAAA;EACA,0CAAA;AzH4xfJ;;AwHxvfC;ECrCG,cAAA;EACA,0CAAA;AzHiyfJ;;AwH7vfC;ECrCG,cAAA;EACA,uCAAA;AzHsyfJ;;AwHlwfC;ECrCG,cAAA;EACA,wCAAA;AzH2yfJ;;AwHvwfC;ECrCG,cAAA;EACA,0CAAA;AzHgzfJ;;AwH5wfC;ECrCG,cAAA;EACA,0CAAA;AzHqzfJ;;AwHjxfC;ECrCG,YAAA;EACA,uCAAA;AzH0zfJ;;AqHxzfA;EACC,gBlH6iBuC;EkH5iBvC,uBlH6T6B;EkH5T7B,0BlH+U6B;AH4+e9B;AqHzzfC;EACC,gBAAA;ArH2zfF;AqHzzfE;EACI,cAAA;EACA,eAAA;ArH2zfN;AqHzzfE;EACC,eAAA;EACA,gBAAA;ArH2zfH;AqHzzfE;EACC,gBAAA;ArH2zfH;;AqHtzfA;EACI,2DlHoiBoC;AHqxexC;;AqHlzfA;EACI,yElHygBoC;EkHxgBpC,SAAA;EACA,iCAAA;ArHqzfJ;AqHnzfI;;EAEI,SAAA;EACA,gBAAA;ArHqzfR;;AqHhzfC;EACO,sFAAA;ArHmzfR;;AqH3yfC;EACC,gBlH+fsC;AH+yexC;AqH3yfC;EACI,clHVM;EkHWN,sBlHjBM;EkHkBN,sClHsfmC;AHuzexC;AqH1yfC;EACC,sClHkfsC;AH0zexC;;A0Hv2fI;EACI,qBAAA;E/GSJ,uBAAA;AXk2fJ;;A0Hn2fA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;A1Hs2fJ;;A0Hn2fA;EACI,SAAA;EACA,YAAA;A1Hs2fJ;A0Hp2fI;EACG,cvHoBI;EuHnBJ,gBAAA;EACA,kBAAA;A1Hs2fP;;A0Hl2fA;EACI,evH2T0B;EuH1T1B,cvHeO;AHs1fX;A0Hn2fI;EACG,YAAA;EACA,cvHQI;EuHPJ,gBAAA;A1Hq2fP;;A2H54fA;EACI,kBAAA;EACA,WAAA;EACA,axHgpBS;EwH/oBT,uBxH2T0B;AHolf9B;;A4Hn5fA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EvGOE,0BuGNF;A5Hs5fJ;AqB54fM;EuGhBN;IvGiBQ,gBAAA;ErB+4fN;AACF;;A6H75fI;EACI,aAAA;EACA,gBAAA;A7Hg6fR;A6H95fI;EACI,gBAAA;A7Hg6fR;;A8H56fC;EACC,WAAA;A9H+6fF;A8H76fC;;EAEC,wCAAA;A9H+6fF;A8H76fC;EACC,yBzHmEa;EyHlEb,WAAA;A9H+6fF;A8H76fE;EACC,WAAA;A9H+6fH;A8H16fK;EACC,W3H0BK;AHk5fX;;A8H97fC;EACC,cAAA;A9Hi8fF;A8H/7fC;;EAEC,qCAAA;A9Hi8fF;A8H/7fC;EACC,yBzHmEa;EyHlEb,cAAA;A9Hi8fF;A8H/7fE;EACC,cAAA;A9Hi8fH;A8H57fK;EACC,W3H0BK;AHo6fX;;A8Hh9fC;EACC,WAAA;A9Hm9fF;A8Hj9fC;;EAEC,wCAAA;A9Hm9fF;A8Hj9fC;EACC,yBzHmEa;EyHlEb,WAAA;A9Hm9fF;A8Hj9fE;EACC,WAAA;A9Hm9fH;A8H98fK;EACC,W3H0BK;AHs7fX;;A8Hl+fC;EACC,WAAA;A9Hq+fF;A8Hn+fC;;EAEC,wCAAA;A9Hq+fF;A8Hn+fC;EACC,yBzHmEa;EyHlEb,WAAA;A9Hq+fF;A8Hn+fE;EACC,WAAA;A9Hq+fH;A8Hh+fK;EACC,W3H0BK;AHw8fX;;A8Hp/fC;EACC,WAAA;A9Hu/fF;A8Hr/fC;;EAEC,wCAAA;A9Hu/fF;A8Hr/fC;EACC,yBzHmEa;EyHlEb,WAAA;A9Hu/fF;A8Hr/fE;EACC,WAAA;A9Hu/fH;A8Hl/fK;EACC,W3H0BK;AH09fX;;A8HtggBC;EACC,WAAA;A9HyggBF;A8HvggBC;;EAEC,wCAAA;A9HyggBF;A8HvggBC;EACC,yBzHmEa;EyHlEb,WAAA;A9HyggBF;A8HvggBE;EACC,WAAA;A9HyggBH;A8HpggBK;EACC,W3H0BK;AH4+fX;;A8HxhgBC;EACC,WAAA;A9H2hgBF;A8HzhgBC;;EAEC,wCAAA;A9H2hgBF;A8HzhgBC;EACC,yBzHmEa;EyHlEb,WAAA;A9H2hgBF;A8HzhgBE;EACC,WAAA;A9H2hgBH;A8HthgBK;EACC,W3H0BK;AH8/fX;;A8H1igBC;EACC,WAAA;A9H6igBF;A8H3igBC;;EAEC,wCAAA;A9H6igBF;A8H3igBC;EACC,yBzHmEa;EyHlEb,WAAA;A9H6igBF;A8H3igBE;EACC,WAAA;A9H6igBH;A8HxigBK;EACC,W3H0BK;AHghgBX;;A8H5jgBC;EACC,WAAA;A9H+jgBF;A8H7jgBC;;EAEC,wCAAA;A9H+jgBF;A8H7jgBC;EACC,yBzHmEa;EyHlEb,WAAA;A9H+jgBF;A8H7jgBE;EACC,WAAA;A9H+jgBH;A8H1jgBK;EACC,W3H0BK;AHkigBX;;A8H9kgBC;EACC,cAAA;A9HilgBF;A8H/kgBC;;EAEC,qCAAA;A9HilgBF;A8H/kgBC;EACC,sBzHmEa;EyHlEb,cAAA;A9HilgBF;A8H/kgBE;EACC,cAAA;A9HilgBH;A8H5kgBK;EACC,W3H0BK;AHojgBX;;A8HhmgBC;EACC,cAAA;A9HmmgBF;A8HjmgBC;;EAEC,qCAAA;A9HmmgBF;A8HjmgBC;EACC,sBzHmEa;EyHlEb,cAAA;A9HmmgBF;A8HjmgBE;EACC,cAAA;A9HmmgBH;A8H9lgBK;EACC,W3H0BK;AHskgBX;;A8HlngBC;EACC,WAAA;A9HqngBF;A8HnngBC;;EAEC,wCAAA;A9HqngBF;A8HnngBC;EACC,uBzHmEa;EyHlEb,WAAA;A9HqngBF;A8HnngBE;EACC,WAAA;A9HqngBH;A8HhngBK;EACC,W3H0BK;AHwlgBX;;A+H7ngBA;EACI,eAAA;EpHkBA,gCAAA;EACA,iCAAA;AX+mgBJ;A+H/ngBI;EpHeA,yBAAA;EACA,0BAAA;EAaA,oCAAA;EACA,mCAAA;AXumgBJ;;A+H5ngBA;EACI,c5H8BO;AHimgBX;A+H7ngBI;EACI,c5HkqB4B;AH69epC;A+H5ngBI;EACI,kBAAA;EACA,QAAA;A/H8ngBR;;A+H1ngBA;EACE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mB5HOK;EHsngBT;AACF;AgI7pgBI;EACI,mB7HwrB4B;AHu+epC;AgI5pgBI;EACC,qBAAA;EACG,c7H0rB4B;E6HzrB5B,gBAAA;EACA,mB7HmVsB;E6HlVtB,2E7H0fsB;E6HzftB,sB7H2BG;E6H1BH,0B7HmUsB;AH21f9B;AgI5pgBQ;EACC,c7HmrB2B;AH2+epC;AgI1pgBI;;EAEI,W7H8qB4B;E6H7qB5B,yB7H8qB4B;AH8+epC;AgBhngBI;EgHxCI;IACI,mB7HqPH;EHs6fP;AACF;;AgBrngBI;EgHhCI;IACI,gBAAA;EhIypgBV;AACF;AgIjpgBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AhImpgBR;AgI/ogBQ;EACI,eAAA;AhIipgBZ;;AiItsgBQ;EACI,iB9H6sBwB;E8H5sBxB,gB9H6sBwB;E8H5sBxB,sB9H6sBwB;E8H5sBxB,iB9H6sBwB;EkB1sB9B,4B4GFM;AjIysgBZ;AqBnsgBM;E4GXE;I5GYA,gBAAA;ErBssgBN;AACF;AiI5sgBY;EACI,oBAAA;AjI8sgBhB;AiItsgBI;EACI,mB9HyUsB;E8HxUtB,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AjIwsgBR;AiItsgBQ;EACI,YAAA;AjIwsgBZ;AiInsgBQ;EACI,W9HMD;AH+rgBX;AiIhsgBQ;EACI,c9HQD;AH0rgBX;AiI5rgBQ;EACE,qBAAA;AjI8rgBV;AgBtrgBI;EiHDQ;IACI,oBAAA;EjI0rgBd;EiIxrgBc;IACI,0B9HuRU;EHm6f5B;EiItrgBkB;IACI,yBAAA;EjIwrgBtB;EiIprgBU;IACI,iB9H4oBoB;I8H3oBpB,oB9H2oBoB;I8H1oBpB,uB9HwPc;EH87f5B;EiIprgBc;IACI,sBAAA;EjIsrgBlB;EiIlrgBU;IACI,+BAAA;IACA,gCAAA;IACA,eAAA;IACA,uB9H6Oc;EHu8f5B;EiIlrgBc;IACI,eAAA;EjIorgBlB;AACF;AiI5qgBI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AjI8qgBR;AiI5qgBQ;EACI,yBAAA;AjI8qgBZ;AiI3qgBQ;EACI,yBAAA;AjI6qgBZ;AiI1qgBQ;EACI,0D5HgnBwB;AL4jfpC;AgBpugBI;EiH+DY;IACI,gC9H0mBgB;EH8jflC;EMpxgBA;I2H+GsB,gC9HwmBY;EHgkflC;EiIrqgBkB;IACI,gC9HsmBY;EHikflC;EiInqgBc;;;;IAII,gC9H6lBgB;EHwkflC;EiIjqgBU;IACI,gC9HslBoB;EH6kflC;EMnygBA;I2HmIkB,gC9HmlBgB;EHglflC;AACF;;AkI/ygBA;EACI,2D/H0vByB;AHwjf7B;AkIhzgBI;EACI,uBAAA;EACA,mBAAA;AlIkzgBR;AkI5ygBI;EACI,6B/H6tB4B;E+H5tB5B,qB/HyBG;AHqxgBX;AkIxygBI;EACI,eAAA;AlI0ygBR;AkIvygBI;;EAEI,eAAA;EACA,gBAAA;AlIyygBR;AgB/wgBI;EkHnBI;IACI,kBAAA;IACA,mBAAA;IACA,kB/HsqBwB;I+HrqBxB,mB/HqqBwB;EHgoflC;EkInygBU;IACI,WAAA;IACA,cAAA;IACA,kBAAA;ElIqygBd;AACF;AkI7xgBI;EACI,kBAAA;EACA,mBAAA;AlI+xgBR;AkI1xgBQ;EACI,kB/H+oBwB;E+H9oBxB,mB/H8oBwB;E+H7oBxB,iB/HkpBwB;AH0ofpC;AkI1xgBY;EACI,kBAAA;AlI4xgBhB;AkI1xgBgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,Y/H0mBgB;E+HzmBhB,e/HymBgB;E+HxmBhB,8BAAA;AlI4xgBpB;AkIrxgBY;EACI,kB/HirBQ;E+HhrBR,oBAAA;EACA,mBAAA;AlIuxgBhB;AkIjxgBY;EACI,YAAA;AlImxgBhB;AkIjxgBgB;EACI,oBAAA;AlImxgBpB;AkI3wgBI;EACI,aAAA;EACA,mBAAA;AlI6wgBR;AkIzwgBQ;EACI,qBAAA;EACA,kBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,c/HzED;E+H0EC,0B/HyNkB;AHkjgB9B;AkIvwgBY;EACI,wBAAA;AlIywgBhB;AkInwgBI;EACI,qBAAA;AlIqwgBR;AkIjwgBI;EACI,qBAAA;AlImwgBR;AkI9vgBI;EACI,oB/HoiB4B;E+HniB5B,uB/HmiB4B;E+HliB5B,kB/H8MsB;E+H7MtB,yBAAA;EACA,sBAAA;AlIgwgBR;AkIvvgBY;EAEQ,cAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,gB/H4lBI;E+H3lBJ,oB/H4lBQ;E+H3lBR,qB/H2lBQ;E+HzlBR,gBAAA;AlIuvgBpB;AkIpvgBoB;EACI,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AlIsvgBxB;AkIrvgBwB;EANJ;IAOQ,gBAAA;IACA,YAAA;ElIwvgB1B;AACF;AkInvgBoB;EACI,OAAA;EACA,uBAAA;AlIqvgBxB;AkIhvgBoB;EACI,QAAA;EACA,uBAAA;AlIkvgBxB;AkI7ugBoB;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oB/HmjBI;E+HljBJ,qB/HkjBI;AH6rf5B;AkI7ugBwB;EACI,eAAA;AlI+ugB5B;AkIzugBoB;EACI,sBAAA;EACA,oBAAA;EACA,qBAAA;AlI2ugBxB;AkIxugBoB;EACI,uBAAA;AlI0ugBxB;AkIvugB4B;EACI,Y/HidI;E+HhdJ,e/HgdI;E+H/cJ,OAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AlIyugBhC;AkIlugBoB;EACI,qBAAA;AlIougBxB;AkI/tgBoB;EACI,oBAAA;AlIiugBxB;AkI7tgBoB;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AlI+tgBxB;AkI5tgBoB;EACI,kBAAA;AlI8tgBxB;AkI1tgBoB;EACI,oBAAA;EACA,qBAAA;EACA,iB/HUf;E+HTe,oBAAA;EACA,oB/HsfI;E+HrfJ,qB/HqfI;E+HpfJ,6BAAA;AlI4tgBxB;AkIztgBwB;EACI,SAAA;EACA,2BAAA;AlI2tgB5B;AgBr7gBI;EkHqGQ;IAEQ,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/H4lBI;I+H3lBJ,oB/H4lBQ;I+H3lBR,qB/H2lBQ;I+HzlBR,gBAAA;ElIi1gBlB;EkI90gBkB;IACI,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElIg1gBtB;AACF;AkIh1gBwB;EANJ;IAOQ,gBAAA;IACA,YAAA;ElIm1gB1B;AACF;AgB/8gBI;EkHiIgB;IACI,OAAA;IACA,uBAAA;ElIi1gBtB;EkI50gBkB;IACI,QAAA;IACA,uBAAA;ElI80gBtB;EkIz0gBkB;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/HmjBI;I+HljBJ,qB/HkjBI;EHyxf1B;EkIz0gBsB;IACI,eAAA;ElI20gB1B;EkIr0gBkB;IACI,sBAAA;IACA,oBAAA;IACA,qBAAA;ElIu0gBtB;EkIp0gBkB;IACI,uBAAA;ElIs0gBtB;EkIn0gB0B;IACI,Y/HidI;I+HhdJ,e/HgdI;I+H/cJ,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElIq0gB9B;EkI9zgBkB;IACI,qBAAA;ElIg0gBtB;EkI3zgBkB;IACI,oBAAA;ElI6zgBtB;EkIzzgBkB;IACI,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElI2zgBtB;EkIxzgBkB;IACI,kBAAA;ElI0zgBtB;EkItzgBkB;IACI,oBAAA;IACA,qBAAA;IACA,iB/HUf;I+HTe,oBAAA;IACA,oB/HsfI;I+HrfJ,qB/HqfI;I+HpfJ,6BAAA;ElIwzgBtB;EkIrzgBsB;IACI,SAAA;IACA,2BAAA;ElIuzgB1B;AACF;AgBlhhBI;EkHqGQ;IAEQ,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/H4lBI;I+H3lBJ,oB/H4lBQ;I+H3lBR,qB/H2lBQ;I+HzlBR,gBAAA;ElI86gBlB;EkI36gBkB;IACI,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElI66gBtB;AACF;AkI76gBwB;EANJ;IAOQ,gBAAA;IACA,YAAA;ElIg7gB1B;AACF;AgB5ihBI;EkHiIgB;IACI,OAAA;IACA,uBAAA;ElI86gBtB;EkIz6gBkB;IACI,QAAA;IACA,uBAAA;ElI26gBtB;EkIt6gBkB;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/HmjBI;I+HljBJ,qB/HkjBI;EHs3f1B;EkIt6gBsB;IACI,eAAA;ElIw6gB1B;EkIl6gBkB;IACI,sBAAA;IACA,oBAAA;IACA,qBAAA;ElIo6gBtB;EkIj6gBkB;IACI,uBAAA;ElIm6gBtB;EkIh6gB0B;IACI,Y/HidI;I+HhdJ,e/HgdI;I+H/cJ,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElIk6gB9B;EkI35gBkB;IACI,qBAAA;ElI65gBtB;EkIx5gBkB;IACI,oBAAA;ElI05gBtB;EkIt5gBkB;IACI,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElIw5gBtB;EkIr5gBkB;IACI,kBAAA;ElIu5gBtB;EkIn5gBkB;IACI,oBAAA;IACA,qBAAA;IACA,iB/HUf;I+HTe,oBAAA;IACA,oB/HsfI;I+HrfJ,qB/HqfI;I+HpfJ,6BAAA;ElIq5gBtB;EkIl5gBsB;IACI,SAAA;IACA,2BAAA;ElIo5gB1B;AACF;AgB/mhBI;EkHqGQ;IAEQ,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/H4lBI;I+H3lBJ,oB/H4lBQ;I+H3lBR,qB/H2lBQ;I+HzlBR,gBAAA;ElI2ghBlB;EkIxghBkB;IACI,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElI0ghBtB;AACF;AkI1ghBwB;EANJ;IAOQ,gBAAA;IACA,YAAA;ElI6ghB1B;AACF;AgBzohBI;EkHiIgB;IACI,OAAA;IACA,uBAAA;ElI2ghBtB;EkItghBkB;IACI,QAAA;IACA,uBAAA;ElIwghBtB;EkInghBkB;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/HmjBI;I+HljBJ,qB/HkjBI;EHm9f1B;EkInghBsB;IACI,eAAA;ElIqghB1B;EkI//gBkB;IACI,sBAAA;IACA,oBAAA;IACA,qBAAA;ElIighBtB;EkI9/gBkB;IACI,uBAAA;ElIgghBtB;EkI7/gB0B;IACI,Y/HidI;I+HhdJ,e/HgdI;I+H/cJ,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElI+/gB9B;EkIx/gBkB;IACI,qBAAA;ElI0/gBtB;EkIr/gBkB;IACI,oBAAA;ElIu/gBtB;EkIn/gBkB;IACI,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElIq/gBtB;EkIl/gBkB;IACI,kBAAA;ElIo/gBtB;EkIh/gBkB;IACI,oBAAA;IACA,qBAAA;IACA,iB/HUf;I+HTe,oBAAA;IACA,oB/HsfI;I+HrfJ,qB/HqfI;I+HpfJ,6BAAA;ElIk/gBtB;EkI/+gBsB;IACI,SAAA;IACA,2BAAA;ElIi/gB1B;AACF;AgB5shBI;EkHqGQ;IAEQ,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/H4lBI;I+H3lBJ,oB/H4lBQ;I+H3lBR,qB/H2lBQ;I+HzlBR,gBAAA;ElIwmhBlB;EkIrmhBkB;IACI,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElIumhBtB;AACF;AkIvmhBwB;EANJ;IAOQ,gBAAA;IACA,YAAA;ElI0mhB1B;AACF;AgBtuhBI;EkHiIgB;IACI,OAAA;IACA,uBAAA;ElIwmhBtB;EkInmhBkB;IACI,QAAA;IACA,uBAAA;ElIqmhBtB;EkIhmhBkB;IACI,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/HmjBI;I+HljBJ,qB/HkjBI;EHgjgB1B;EkIhmhBsB;IACI,eAAA;ElIkmhB1B;EkI5lhBkB;IACI,sBAAA;IACA,oBAAA;IACA,qBAAA;ElI8lhBtB;EkI3lhBkB;IACI,uBAAA;ElI6lhBtB;EkI1lhB0B;IACI,Y/HidI;I+HhdJ,e/HgdI;I+H/cJ,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElI4lhB9B;EkIrlhBkB;IACI,qBAAA;ElIulhBtB;EkIllhBkB;IACI,oBAAA;ElIolhBtB;EkIhlhBkB;IACI,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElIklhBtB;EkI/khBkB;IACI,kBAAA;ElIilhBtB;EkI7khBkB;IACI,oBAAA;IACA,qBAAA;IACA,iB/HUf;I+HTe,oBAAA;IACA,oB/HsfI;I+HrfJ,qB/HqfI;I+HpfJ,6BAAA;ElI+khBtB;EkI5khBsB;IACI,SAAA;IACA,2BAAA;ElI8khB1B;AACF;;AmIh2hBI;EACI,mBhI0tB4B;EgIztB5B,iBAAA;EACA,6BAAA;AnIm2hBR;AmIj2hBQ;EACI,6BAAA;EACA,kBAAA;AnIm2hBZ;AmI/1hBI;EACI,YhI4sB4B;EgI3sB5B,6BAAA;AnIi2hBR;;AmI51hBI;EACI,sChIotB4B;AH2ogBpC;AmI51hBI;EACI,+BhIitB4B;AH6ogBpC;AmI31hBI;EACI,+BhI+sB4B;AH8ogBpC;AmI31hBQ;EACI,+BhI0sBwB;AHmpgBpC;AmIx1hBQ;EACI,sChIqsB4B;AHqpgBxC;;AmIp1hBI;EACI,gChI2sB4B;AH4ogBpC;AmIp1hBI;EACI,yBhIwsB6B;AH8ogBrC;AmIn1hBI;EACI,yBhIssB6B;AH+ogBrC;AmIn1hBQ;EACI,yBhIisByB;AHopgBrC;AmIh1hBQ;EACI,gChI4rB6B;AHspgBzC;;AgBv1hBI;EoHxDI;IACI,UAAA;IACA,oBAAA;IACA,SAAA;EpIm5hBV;EoI/4hBU;IACI,gBjIiCL;IiIhCK,gBAAA;IACA,WAAA;IACA,cAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,kBAAA;IACA,YAAA;IACA,0CAAA;IACA,WAAA;IACA,kBAAA;EpIi5hBd;EoI54hBU;IACI,WAAA;IACA,UAAA;EpI84hBd;EoIx4hBc;IACI,UAAA;IACA,oBAAA;IACA,mDAAA;EpI04hBlB;EoIv4hBc;IACI,cAAA;IACA,oDAAA;EpIy4hBlB;EoIn4hBU;IACI,UAAA;IACA,cAAA;IACA,oBAAA;IACA,+DAAA;IACA,4DAAA;EpIq4hBd;EoIl4hBU;IACI,cAAA;IACA,UAAA;IACA,oBAAA;IACA,mBAAA;IACA,0BAAA;IACA,eAAA;EpIo4hBd;EoIh4hBM;IACI,kBAAA;IACA,aAAA;EpIk4hBV;EoI53hBM;IACI;MACI,UAAA;MACA,+DAAA;MACA,4DAAA;IpI83hBZ;IoI33hBQ;MACI,0BAAA;MACA,UAAA;IpI63hBZ;EACF;EoI13hBM;IACI;MACI,UAAA;IpI43hBZ;IoIz3hBQ;MACI,UAAA;MACA,6BAAA;IpI23hBZ;EACF;AACF;AqIv9hBA;EACI,aAAA;ArIy9hBJ;;AgBv5hBI;EqH7DI;IACI,mBAAA;IACA,yBAAA;ErIw9hBV;EqIr9hBM;IACI,gBAAA;IACA,eAAA;ErIu9hBV;EqIp9hBc;IACI,WAAA;ErIs9hBlB;EqIh9hBE;IACI,0BAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;ErIk9hBN;EqIh9hBM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,qBAAA;IACA,UAAA;ErIk9hBV;EqIh9hBU;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;ErIk9hBd;EqI/8hBU;IACI,yBAAA;ErIi9hBd;EqI98hBU;IACI,0BAAA;ErIg9hBd;EqI58hBM;IACI,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,2CAAA;ErI88hBV;EqI18hBU;IACI,YAAA;ErI48hBd;EqIx8hBM;IACI,iBAAA;ErI08hBV;EqIt8hBE;;IAEI,eAAA;IACA,uBlI0OsB;IkIzOtB,gBAAA;IACA,iHAAA;IACA,kDAAA;ErIw8hBN;EqIr8hBE;IACI,kDAAA;ErIu8hBN;AACF;AqIp8hBA;EACI;IACI,UAAA;IACA,sBAAA;IACA,wBAAA;ErIs8hBN;EqIn8hBE;IACI,UAAA;IACA,mBAAA;ErIq8hBN;AACF;AqIl8hBA;EACI;IACI,UAAA;IACA,mBAAA;IACA,wBAAA;ErIo8hBN;EqIj8hBE;IACI,UAAA;IACA,sBAAA;ErIm8hBN;AACF;AsIxjiBI;EACI,2EnIqgBsB;AHqjhB9B;AsIvjiBI;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACN,YAAA;EACA,mBnI+U4B;AH0uhB9B;;AsIhjiBQ;;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AtImjiBZ;;AsI5iiBQ;;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AtI+iiBZ;;AuItliBA;EACI,SAAA;AvIyliBJ;;AuItliBA;EACC,gBpI8V6B;AH2vhB9B;;AuIlliBI;ECfH,yBnI0Ec;AL2hiBf;AwInmiBC;EACC,yBnIuEa;EmItEb,WAAA;AxIqmiBF;AwIlmiBC;EACC,WAAA;AxIomiBF;AwIlmiBC;EACC,sCAAA;AxIomiBF;AwIjmiBE;EACC,yBnI2DY;ALwiiBf;AwI/liBE;EACC,2BnIsDY;AL2iiBf;AwI7liBE;EACC,4BnIiDY;AL8iiBf;AwI3liBE;EACC,0BnI4CY;ALijiBf;;AuI5miBI;ECfH,yBnI0Ec;ALqjiBf;AwI7niBC;EACC,yBnIuEa;EmItEb,cAAA;AxI+niBF;AwI5niBC;EACC,cAAA;AxI8niBF;AwI5niBC;EACC,mCAAA;AxI8niBF;AwI3niBE;EACC,yBnI2DY;ALkkiBf;AwIzniBE;EACC,2BnIsDY;ALqkiBf;AwIvniBE;EACC,4BnIiDY;ALwkiBf;AwIrniBE;EACC,0BnI4CY;AL2kiBf;;AuItoiBI;ECfH,yBnI0Ec;AL+kiBf;AwIvpiBC;EACC,yBnIuEa;EmItEb,WAAA;AxIypiBF;AwItpiBC;EACC,WAAA;AxIwpiBF;AwItpiBC;EACC,sCAAA;AxIwpiBF;AwIrpiBE;EACC,yBnI2DY;AL4liBf;AwInpiBE;EACC,2BnIsDY;AL+liBf;AwIjpiBE;EACC,4BnIiDY;ALkmiBf;AwI/oiBE;EACC,0BnI4CY;ALqmiBf;;AuIhqiBI;ECfH,yBnI0Ec;ALymiBf;AwIjriBC;EACC,yBnIuEa;EmItEb,WAAA;AxImriBF;AwIhriBC;EACC,WAAA;AxIkriBF;AwIhriBC;EACC,sCAAA;AxIkriBF;AwI/qiBE;EACC,yBnI2DY;ALsniBf;AwI7qiBE;EACC,2BnIsDY;ALyniBf;AwI3qiBE;EACC,4BnIiDY;AL4niBf;AwIzqiBE;EACC,0BnI4CY;AL+niBf;;AuI1riBI;ECfH,yBnI0Ec;ALmoiBf;AwI3siBC;EACC,yBnIuEa;EmItEb,WAAA;AxI6siBF;AwI1siBC;EACC,WAAA;AxI4siBF;AwI1siBC;EACC,sCAAA;AxI4siBF;AwIzsiBE;EACC,yBnI2DY;ALgpiBf;AwIvsiBE;EACC,2BnIsDY;ALmpiBf;AwIrsiBE;EACC,4BnIiDY;ALspiBf;AwInsiBE;EACC,0BnI4CY;ALypiBf;;AuIptiBI;ECfH,yBnI0Ec;AL6piBf;AwIruiBC;EACC,yBnIuEa;EmItEb,WAAA;AxIuuiBF;AwIpuiBC;EACC,WAAA;AxIsuiBF;AwIpuiBC;EACC,sCAAA;AxIsuiBF;AwInuiBE;EACC,yBnI2DY;AL0qiBf;AwIjuiBE;EACC,2BnIsDY;AL6qiBf;AwI/tiBE;EACC,4BnIiDY;ALgriBf;AwI7tiBE;EACC,0BnI4CY;ALmriBf;;AuI9uiBI;ECfH,yBnI0Ec;ALuriBf;AwI/viBC;EACC,yBnIuEa;EmItEb,WAAA;AxIiwiBF;AwI9viBC;EACC,WAAA;AxIgwiBF;AwI9viBC;EACC,sCAAA;AxIgwiBF;AwI7viBE;EACC,yBnI2DY;ALosiBf;AwI3viBE;EACC,2BnIsDY;ALusiBf;AwIzviBE;EACC,4BnIiDY;AL0siBf;AwIvviBE;EACC,0BnI4CY;AL6siBf;;AuIxwiBI;ECfH,yBnI0Ec;ALitiBf;AwIzxiBC;EACC,yBnIuEa;EmItEb,WAAA;AxI2xiBF;AwIxxiBC;EACC,WAAA;AxI0xiBF;AwIxxiBC;EACC,sCAAA;AxI0xiBF;AwIvxiBE;EACC,yBnI2DY;AL8tiBf;AwIrxiBE;EACC,2BnIsDY;ALiuiBf;AwInxiBE;EACC,4BnIiDY;ALouiBf;AwIjxiBE;EACC,0BnI4CY;ALuuiBf;;AuIlyiBI;ECfH,yBnI0Ec;AL2uiBf;AwInziBC;EACC,yBnIuEa;EmItEb,WAAA;AxIqziBF;AwIlziBC;EACC,WAAA;AxIoziBF;AwIlziBC;EACC,sCAAA;AxIoziBF;AwIjziBE;EACC,yBnI2DY;ALwviBf;AwI/yiBE;EACC,2BnIsDY;AL2viBf;AwI7yiBE;EACC,4BnIiDY;AL8viBf;AwI3yiBE;EACC,0BnI4CY;ALiwiBf;;AuI5ziBI;ECfH,sBnI0Ec;ALqwiBf;AwI70iBC;EACC,sBnIuEa;EmItEb,cAAA;AxI+0iBF;AwI50iBC;EACC,cAAA;AxI80iBF;AwI50iBC;EACC,mCAAA;AxI80iBF;AwI30iBE;EACC,sBnI2DY;ALkxiBf;AwIz0iBE;EACC,wBnIsDY;ALqxiBf;AwIv0iBE;EACC,yBnIiDY;ALwxiBf;AwIr0iBE;EACC,uBnI4CY;AL2xiBf;;AuIt1iBI;ECfH,sBnI0Ec;AL+xiBf;AwIv2iBC;EACC,sBnIuEa;EmItEb,cAAA;AxIy2iBF;AwIt2iBC;EACC,cAAA;AxIw2iBF;AwIt2iBC;EACC,mCAAA;AxIw2iBF;AwIr2iBE;EACC,sBnI2DY;AL4yiBf;AwIn2iBE;EACC,wBnIsDY;AL+yiBf;AwIj2iBE;EACC,yBnIiDY;ALkziBf;AwI/1iBE;EACC,uBnI4CY;ALqziBf;;AuIh3iBI;ECfH,uBnI0Ec;ALyziBf;AwIj4iBC;EACC,uBnIuEa;EmItEb,WAAA;AxIm4iBF;AwIh4iBC;EACC,WAAA;AxIk4iBF;AwIh4iBC;EACC,sCAAA;AxIk4iBF;AwI/3iBE;EACC,uBnI2DY;ALs0iBf;AwI73iBE;EACC,yBnIsDY;ALy0iBf;AwI33iBE;EACC,0BnIiDY;AL40iBf;AwIz3iBE;EACC,wBnI4CY;AL+0iBf;;AyIp5iBA;EACI,kBAAA;EACA,mBAAA;AzIu5iBJ;;AyIj5iBA;EACI,WAAA;EACA,mBtIsQK;EsIrQL,gBAAA;EACA,sBtImT0B;EsIlT1B,yBtI2BO;EsI1BP,8CAAA;AzIo5iBJ;AyIl5iBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AzIo5iBR;;AyI74iBA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AzIg5iBJ;;AyI74iBA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;AzIg5iBJ;;AyI74iBA;EACI,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AzIg5iBJ;;AyI54iBI;EACI,qBAAA;EACA,ctIyCQ;EsIxCR,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;AzI+4iBR;;AyI34iBA;EACI,iBAAA;AzI84iBJ;AyI74iBI;EACI,qBAAA;EACA,ctIvBG;EsIwBH,mBAAA;EACA,gBAAA;AzI+4iBR;;A0Ir9iBA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,oBAAA;A1Iw9iBJ;A0It9iBI;EACI,kBAAA;EACA,oBAAA;A1Iw9iBR;;A0Ip9iBA;EACI,MAAA;EACA,YAAA;A1Iu9iBJ;A0Ir9iBI;EACI,MAAA;A1Iu9iBR;;A0In9iBA;EACI,SAAA;EACA,SAAA;A1Is9iBJ;A0Ip9iBI;EACI,SAAA;A1Is9iBR;;A0Il9iBA;EACI,yBAAA;A1Iq9iBJ;;A0Ih9iBA;EACI,YAAA;A1Im9iBJ;AgBv8iBI;E0HbJ;IAIQ,YAAA;E1Io9iBN;AACF;;A2IhgjBI;EACI,oBxIkcsB;EwIjctB,uBxIicsB;EwIhctB,kBxIkcsB;EwIjctB,yBxImcsB;EwIlctB,mBxImcsB;EwIlctB,gCAAA;A3ImgjBR;A2IhgjBI;EACI,gBxIsVsB;AH4qiB9B;A2I9/iBQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;A3IggjBZ;A2I5/iBI;;EAEI,oBxImbsB;EwIlbtB,mBAAA;A3I8/iBR;A2Iv/iBQ;;EAEI,sBAAA;A3Iy/iBZ;A2Ij/iBQ;EACI,yBxIwakB;EwIvalB,cxIwakB;AH2kiB9B;A2I3+iBQ;EACI,yBxIdD;EwIeC,cxIVD;AHu/iBX;;A2Ip+iBI;EtHtDE,0BsHuDE;A3Iu+iBR;AqB1hjBM;EsHkDF;ItHjDI,gBAAA;ErB6hjBN;AACF;;A2Ip+iBI;;EAEI,cAAA;EACA,eAAA;A3Iu+iBR;A2Ij+iBgB;;EAEI,aAAA;A3Im+iBpB;A2I99iBgB;;EAEI,gBAAA;A3Ig+iBpB;;A2Ir9iBI;EACI,gBAAA;A3Iw9iBR;A2It9iBQ;;EAEI,oBxIkyBwB;EwIjyBxB,qBxIiyBwB;AHurhBpC;;A4InkjBA;EACC,ezIgZ6B;EyI/Y7B,gBzIgZ6B;EyI/Y7B,gBzIgZ6B;AHsriB9B;;A4InkjBA;EACC,kBzI8Y6B;EyI7Y3B,gBzI8Y2B;EyI7Y7B,gBzI0Y6B;EyIzY7B,kBAAA;A5IskjBD;A4IpkjBC;EACC,gBAAA;A5IskjBF;;A4IlkjBA;EACC,mBzI0U6B;AH2viB9B;;A6IvljBA;EACC,uB1IsX6B;E0IrX7B,kB1IsX6B;E0IrX7B,yB1IsX6B;E0IrX7B,gB1I6V6B;AH6viB9B;;A6IpljBA;EACC,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;A7IuljBD;;A6IpljBA;EACC,uB1IyWmC;E0IxWnC,mB1IyWmC;E0IxWnC,gB1I4U6B;E0I3U7B,yB1IyWmC;AH8uiBpC;;A6IpljBA;EACC,uB1IuWqC;E0ItWrC,mB1IuWqC;E0ItWrC,gB1IqU6B;E0IpU7B,yB1IuWqC;AHgviBtC;A6IrljBC;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;A7IuljBF;A6InljBE;EACC,iBAAA;EACA,kBAAA;A7IqljBH;;A8I5njBC;;;;EACC,cAAA;EACA,gB3I2V4B;AHuyiB9B;;A+IxojBC;;EAEC,gBAAA;A/I2ojBF;A+IxojBC;EACC,qBAAA;A/I0ojBF;A+IvojBC;EACC,cAAA;A/IyojBF;A+ItojBC;EACC,aAAA;A/IwojBF;;AgJtpjBA;EACI,uB7I6T0B;E6IvT1B,cAAA;AhJopjBJ;AgJxpjBI;EACI,YAAA;AhJ0pjBR;AgJrpjBI;EACI,cAAA;AhJupjBR;AgJtpjBQ;EACI,UAAA;AhJwpjBZ;AgJtpjBQ;EACI,YAAA;AhJwpjBZ;AgJppjBI;EACI,MAAA;EACA,OAAA;EACA,kB7Iy6BsB;ESp7BxB,iHoIYE;AhJspjBR;AgJppjBQ;EACI,SAAA;AhJspjBZ;AgJppjBQ;EACI,SAAA;AhJspjBZ;AgJppjBQ;EACI,UAAA;AhJspjBZ;AgJppjBQ;EACI,UAAA;AhJspjBZ;AgJppjBQ;EACI,SAAA;AhJspjBZ;AgJppjBQ;EACI,SAAA;AhJspjBZ;AgJnpjBQ;EACI,YAAA;EACA,gBAAA;EACA,2BAAA;AhJqpjBZ;AgJlpjBQ;EACI,YAAA;EACA,gBAAA;EACA,0BAAA;AhJopjBZ;AgJhpjBI;EACI,SAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AhJkpjBR;AgJ/ojBY;EACI,kB7Im4BgB;AH8whBhC;AgJ9ojBY;EACI,uB7I0Pc;E6IzPd,gBAAA;AhJgpjBhB;AgJ7ojBY;;EAEI,0B7IuQc;E6ItQd,W7Iy3BQ;E6Ix3BR,Y7Iy3BS;E6Ix3BT,YAAA;EACA,kBAAA;EACA,mB7I+Qc;AHg4iB9B;AgJvojBQ;;EAEI,6BAAA;AhJyojBZ;AgJpojBQ;EAEI,c7InDD;AHwrjBX;AgJlojBQ;EAEI,iB7I61BuB;E6I51BvB,eAAA;AhJmojBZ;AgJhojBQ;EAEI,gBAAA;EACA,c7IjED;E6IkEC,eAAA;AhJiojBZ;AgJ9njBQ;EACI,gBAAA;AhJgojBZ;AgJ9njBY;EACI,mB7Iy1Be;AHuyhB/B;AgJ7njBY;EAEI,mB7Io1Be;E6In1Bf,c7I9EL;AH4sjBX;AgJ1njBQ;EACI,iBAAA;AhJ4njBZ;AgJ3njBY;EACI,iBAAA;AhJ6njBhB;AgJ1njBY;EAEI,iBAAA;EACA,c7IzFL;AHotjBX;AgJtnjBQ;EACI,mB7Im0BkB;E6Il0BlB,W7ItGD;E6IuGC,gBAAA;AhJwnjBZ;AgJtnjBY;EACI,mBAAA;AhJwnjBhB;AgJrnjBY;EAGI,mBAAA;EACA,cAAA;AhJqnjBhB;AgJhnjBY;EACI,mBAAA;AhJknjBhB;AgJ/mjBY;EAEI,mB7I1HL;E6I2HK,c7I1HL;AH0ujBX;AgJ3mjBY;EAEI,mB7I3GN;E6I4GM,W7IrIL;AHivjBX;AgJxmjBQ;EACI,0BAAA;EACA,6BAAA;AhJ0mjBZ;AgJvmjBQ;EACI,yBAAA;EACA,4BAAA;AhJymjBZ;AgJtmjBQ;EACI,kB7IuwBoB;AHi2hBhC;AgJrmjBQ;EAKI,mB7IywBmB;E6IxwBnB,W7I7JD;AHgwjBX;AgJhmjBQ;EAII,mB7IiwBmB;E6IhwBnB,W7IrKD;E6IsKC,gB7IgwBwB;AH+1hBpC;AgJ5ljBQ;EACI,cAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AhJ8ljBZ;AgJ5ljBY;EAEI,mB7InLL;AHgxjBX;AgJ1ljBY;EAEI,gBAAA;EACA,c7IxLL;E6IyLK,eAAA;AhJ2ljBhB;AgJxljBY;EAII,yCAAA;AhJuljBhB;AgJpljBY;EAEI,c7IlML;AHuxjBX;AgJhljBI;EACI,YAAA;AhJkljBR;AgJ/kjBI;;;;EAII,eAAA;AhJiljBR;AgJhljBQ;;;;EACI,mB7IrND;AH0yjBX;AgJ/kjBQ;;EACI,kBAAA;AhJkljBZ;AgJ7kjBI;EACI,eAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AhJ+kjBR;;AiJn2jBA,qCAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AjJs2jBF;;AiJp2jBA;EACE,kBAAA;EACA,cAAA;AjJu2jBF;;AiJr2jBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AjJw2jBF;;AiJt2jBA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AjJy2jBF;;AiJv2jBA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AjJ02jBF;;AiJx2jBA;EACE,YAAA;EACA,WAAA;AjJ22jBF;;AiJz2jBA;EACE,WAAA;EACA,UAAA;AjJ42jBF;;AiJ12jBA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AjJ62jBF;;AiJ32jBA;;EAAA;AAGA;EACE,QAAA;AjJ82jBF;;AiJ52jBA;EACE,SAAA;AjJ+2jBF;;AiJ72jBA;EACE,mCAAA;EACA,2BAAA;EACA,kBAAA;AjJg3jBF;;AiJ92jBA;EACE,YAAA;EACA,WAAA;AjJi3jBF;;AiJ/2jBA;;EAGE,0BAAA;AjJk3jBF;;AiJh3jBA;EACE,0BAAA;AjJm3jBF;;AiJj3jBA;EAAA;AAEA;EACE,YAAA;AjJo3jBF;;AiJl3jBA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AjJq3jBF;;AiJn3jBA;EACE,WAAA;AjJs3jBF;;AiJp3jBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AjJu3jBF;;AiJr3jBA;EACE,YAAA;EACA,UAAA;AjJw3jBF;;AiJt3jBA;;EAAA;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wDAAA;AjJy3jBF;;AiJv3jBA;EACE,kBAAA;AjJ03jBF;;AiJx3jBA;EACE,mBAAA;AjJ23jBF;;AiJz3jBA;EAAA;AAEA;EACE,iBAAA;AjJ43jBF;;AiJ13jBA;EACE,iBAAA;AjJ63jBF;;AiJ33jBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;AjJ83jBF;;AiJ53jBA;EACE,yEAAA;AjJ+3jBF;;AiJ73jBA;EAAA;AAEA;;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AjJg4jBF;;AiJ93jBA;EACE,UAAA;AjJi4jBF;;AiJ/3jBA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AjJk4jBF;;AiJh4jBA;EACE,SAAA;AjJm4jBF;;AiJj4jBA;EAAA;AAEA;EACE,mBAAA;AjJo4jBF;;AiJl4jBA;;;EAGE,mBAAA;AjJq4jBF;;AiJn4jBA;;EAAA;AAGA;;EAGE,sBAAA;AjJs4jBF;;AiJp4jBA;EACE,kBAAA;EACA,WAAA;AjJu4jBF;;AiJr4jBA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AjJw4jBF;;AiJt4jBA;EACE,WAAA;EACA,eAAA;AjJy4jBF;;AiJv4jBA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AjJ04jBF;;AiJx4jBA;EACE,gBAAA;AjJ24jBF;;AiJz4jBA;EACE,gBAAA;AjJ44jBF;;AiJ14jBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AjJ64jBF;;AiJ34jBA;EAEE,+BAAA;AjJ84jBF;;AiJ54jBA;EAEE,8BAAA;AjJ+4jBF;;AiJ74jBA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AjJg5jBF;;AiJ94jBA;EACE,YAAA;AjJi5jBF;;AiJ/4jBA;EACE,YAAA;AjJk5jBF;;AiJh5jBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AjJm5jBF;;AiJj5jBA;EAEE,6BAAA;EACA,kBAAA;AjJo5jBF;;AiJl5jBA;EAEE,4BAAA;AjJq5jBF;;AiJn5jBA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AjJs5jBF;;AiJp5jBA;EACE,WAAA;AjJu5jBF;;AiJr5jBA;EACE,WAAA;AjJw5jBF;;AiJt5jBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AjJy5jBF;;AiJv5jBA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AjJ05jBF;;AiJx5jBA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AjJ25jBF;;AiJp5jBA;EACI,mB9I2W8B;E8I1W9B,kB9I4W8B;E8I3W9B,SAAA;EACA,kD9I4W8B;E8I3W9B,cAAA;EACA,eAAA;AjJu5jBJ;;AiJp5jBA;EACI,W9ImW8B;AHojjBlC;;AiJp5jBA;EACI,YAAA;AjJu5jBJ;;AiJp5jBA;EACI,U9I2V8B;AH4jjBlC;;AiJp5jBA;EACI,mBAAA;EACA,gBAAA;AjJu5jBJ;;AiJn5jBE;EACE,aAAA;AjJs5jBJ;AiJn5jBE;EACE,aAAA;AjJq5jBJ;;AiJj5jBA;;EAEI,SAAA;EACA,W9I8U8B;E8I7U9B,Y9I6U8B;E8I5U9B,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yB9I0U8B;E8IzU9B,S9I0U8B;E8IzU9B,6CAAA;AjJo5jBJ;;AiJj5jBA;;EAEI,mCAAA;AjJo5jBJ;;AiJj5jBA;EACI,mB9IxRM;AH4qkBV;;AiJh5jBA,mBAAA;AAEA;;EAEI,mB9IoT8B;AH8ljBlC;;AiJ/4jBA;;EAEI,mBAAA;AjJk5jBJ;;AiJ/4jBA,8BAAA;AAEA;EACI,kB9ItB0B;E8IuB1B,gBAAA;EACA,uCAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;AjJi5jBJ;;AiJ94jBA;EACI,gBAAA;EACA,kBAAA;AjJi5jBJ;;AiJ94jBA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AjJi5jBJ;;AiJ94jBA;EACI,YAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AjJi5jBJ;;AiJ94jBA;EACI,UAAA;EACA,WAAA;AjJi5jBJ;;AiJ94jBA;EACI,WAAA;EACA,UAAA;AjJi5jBJ;;AkJpzkBA;EACI,YAAA;AlJuzkBJ;AkJrzkBI;EACI,UAAA;AlJuzkBR;AkJpzkBI;EACI,yBAAA;EACA,iBAAA;AlJszkBR;AkJpzkBQ;;EAEI,kCAAA;AlJszkBZ;AkJnzkBQ;EACI,6BAAA;AlJqzkBZ;AkJjzkBI;EACI,UAAA;EACA,QAAA;AlJmzkBR;AkJhzkBI;EACI,WAAA;EACA,SAAA;AlJkzkBR;;AmJ/0kBA;EACI,yBCHgB;EDIhB,oDAAA;EACA,mBAAA;EACA,sBAAA;AnJk1kBJ;AgBhxkBI;EmItEJ;IAOQ,qBAAA;IACA,oBAAA;EnJm1kBN;EmJj1kBM;IACI,eAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;IACA,mBAAA;EnJm1kBV;EmJj1kBU;IACI,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iCAAA;EnJm1kBd;AACF;AgBhzkBI;EmI9BI;IA3BR;MA4BY,wBAAA;MAAA,gBAAA;MACA,MAAA;MACA,aAAA;InJk1kBR;EACF;AACF;AmJ/0kBQ;EACI,qBAAA;EACA,oBAAA;EACA,0CAAA;AnJi1kBZ;AmJ/0kBY;EAEI,sBAAA;EACA,wCAAA;AnJg1kBhB;AmJ70kBY;EACI,gBAAA;AnJ+0kBhB;AmJ10kBI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AnJ40kBR;AmJz0kBI;EACI,mBAAA;AnJ20kBR;AmJx0kBI;EACI,gBAAA;EACA,chJdG;EgJeH,6BAAA;EACA,0DAAA;EACA,4BAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;AnJ00kBR;;AmJr0kBA;EACI,eAAA;EACA,QAAA;EACA,aAAA;AnJw0kBJ;AmJr0kBQ;EACI,yCAAA;AnJu0kBZ;AmJn0kBI;EACI,UhJ9CG;EgJ+CH,cC3FY;ApJg6kBpB;;AmJj0kBA;EACI;IAEI,oBAAA;EnJm0kBN;EmJj0kBE;IAEI,yBAAA;EnJk0kBN;EmJh0kBE;IAEI,wBAAA;EnJi0kBN;AACF;AqJz6kBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;ArJ26kBF;AqJz6kBE;EACE,aAAA;ArJ26kBJ;;AqJv6kBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,yBD1BkB;ApJo8kBpB;AqJx6kBE;EACE,WAAA;EACA,yBAAA;ArJ06kBJ;;AqJt6kBA;EACE;IACE,cAAA;ErJy6kBF;AACF;AsJr8kBM;;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,+EAAA;EACA,mBnJmVsB;EmJlVtB,sBAAA;EACA,cAAA;AtJw8kBR;AsJh8kBM;;EACE,gBAAA;AtJm8kBR;AsJ97kBE;;;EAGE,gBAAA;EACA,sCAAA;AtJg8kBJ;;AsJ57kBA;EACE,iBAAA;EACA,sCAAA;AtJ+7kBF;AsJ77kBE;EACE,gBAAA;AtJ+7kBJ;;AsJ37kBA;EACE,0CAAA;EACA,0CAAA;AtJ87kBF;;AsJ17kBA;EACE,YAAA;EvInDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Afi/kBF;;AsJ97kBA;EvI/CE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;Afi/kBF;;AsJj8kBA;EvIlCE,kBAAA;EAIA,WAAA;EACA,mBAAA;EACA,kBAAA;Afo+kBF;AgB58kBI;EsIIJ;IvIxBE,aAAA;IAIA,cAAA;Efi+kBA;AACF;AgBl9kBI;EsIIJ;IvIxBE,sBAAA;IAIA,uBAAA;Efu+kBA;AACF;;AsJx8kBA;EvI9CE,kBAAA;EAIA,WAAA;EACA,mBAAA;EACA,kBAAA;Afu/kBF;AgB/9kBI;EsIgBJ;IvIpCE,aAAA;IAIA,cAAA;Efo/kBA;AACF;AgBr+kBI;EsIgBJ;IvIpCE,sBAAA;IAIA,uBAAA;Ef0/kBA;AACF;;AsJ18kBA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AtJ68kBF;;AsJ18kBA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;AtJ68kBF;;AsJ18kBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;AtJ68kBF;;AsJ18kBA;EACE,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AtJ68kBF;;AsJ18kBA;EACE,eAAA;AtJ68kBF;;AsJr8kBA;EACE,kBAAA;EACA,0BAAA;AtJw8kBF;AsD5klBE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD8klBJ;AgBthlBI;EsIuEJ;IAMI,eAAA;IACA,cAAA;EtJ68kBF;AACF;AsJ38kBE;;EAEE,aAAA;AtJ68kBJ;AsJ18kBE;EACE,gBAAA;AtJ48kBJ;AsJz8kBE;EACE,kBAAA;EACA,aAAA;AtJ28kBJ;AgBvilBI;EsI0FF;IAKI,eAAA;EtJ48kBJ;AACF;AsJz8kBE;EACE,iBAAA;AtJ28kBJ;AsJv8kBI;EACE,kBAAA;AtJy8kBN;AsJr8kBE;;;;;;;EAOE,kBAAA;EACA,qBAAA;AtJu8kBJ;AsJp8kBE;EACE,kBAAA;EACA,qBAAA;AtJs8kBJ;AsJr8kBI;EACE,SAAA;AtJu8kBN;AsJn8kBE;EACE,SAAA;AtJq8kBJ;AsJn8kBI;EACE,mBAAA;AtJq8kBN;AsJj8kBE;EACE,oBAAA;AtJm8kBJ;AsJh8kBE;EACE,gBAAA;EACA,cAAA;AtJk8kBJ;AsJ/7kBE;EACE,gBAAA;AtJi8kBJ;AsJ97kBE;EACE,WAAA;AtJg8kBJ;;AsJz7kBI;EACE,WAAA;EACA,sBAAA;AtJ47kBN;AsJ17kBI;EACE,eAAA;EACA,kBAAA;AtJ47kBN;AsJ17kBI;EACE,aAAA;AtJ47kBN;AsJx7kBE;;;;;;EAME,aAAA;EACA,gBAAA;AtJ07kBJ;;AsJr7kBA;EACE,aAAA;AtJw7kBF;;AsJn7kBE;EACE,mBAAA;AtJs7kBJ;;AsJh7kBE;EACE,mBAAA;EACA,sBAAA;AtJm7kBJ;AsJj7kBE;EACE,kBAAA;AtJm7kBJ;;AsJ96kBA;;EAEE,kBAAA;AtJi7kBF;;AsJ/6kBA;EACE,qBAAA;AtJk7kBF;;AsJh7kBA;EACE,gBAAA;AtJm7kBF;;AsJ/6kBA;EACE,gBAAA;AtJk7kBF;;AsJ76kBE;;EAEE,gBAAA;EACA,wBAAA;AtJg7kBJ;AsJ96kBE;EACE,gBAAA;EACA,wBAAA;AtJg7kBJ;AgBtplBI;EsI0OA;;IAEE,4BAAA;EtJ+6kBJ;EsJ76kBE;IACE,4BAAA;EtJ+6kBJ;AACF;;AsJ16kBA;EACE,kBAAA;EACA,qBAAA;AtJ66kBF;;AsJz6kBA;EACE,aAAA;AtJ46kBF;AsJ16kBE;;EAEE,aAAA;AtJ46kBJ;;AsJx6kBA;EACE,aAAA;AtJ26kBF;;AsJx6kBA;EACE,yBAAA;AtJ26kBF;AsJz6kBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AtJ26kBJ;AsJx6kBE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;AtJ06kBJ;;AsJr6kBA;EACE,mBAAA;AtJw6kBF;;AsJp6kBA;EACE,sBAAA;EACA,yBAAA;AtJu6kBF;AsJr6kBE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AtJu6kBJ;;AsJl6kBA;EACE,mBAAA;AtJq6kBF;;AsJl6kBA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AtJq6kBF;;AsJj6kBA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AtJo6kBF;;AsJj6kBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AtJo6kBF;;AsJh6kBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AtJm6kBJ;;AsJ95kBE;EACE,yBAAA;AtJi6kBJ;;AsJz5kBA;EACE,UAAA;EACA,gBAAA;EAGA,4CAAA;AtJ05kBF;AgB5vlBI;EsI6VJ;IAQI,UAAA;EtJ25kBF;AACF;;AsJx5kBA;EACE,yBAAA;EACA,wBAAA;AtJ25kBF;AgBtwlBI;EsIyWJ;IAKI,eAAA;IACA,cAAA;EtJ45kBF;AACF;;AsJr5kBA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AtJw5kBF;AsJr5kBI;EACI,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AtJu5kBR;AsJn5kBE;EACE,uBAAA;AtJq5kBJ;AsJn5kBI;EACE,mBAAA;AtJq5kBN;AsJn5kBM;EAEE,cFxcY;ApJ41lBpB;;AsJ74kBA;EACE,gBAAA;AtJg5kBF;;AsJ94kBA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AtJi5kBF;AsJ/4kBE;EACE,oCAAA;EACA,+EAAA;AtJi5kBJ;AsJ94kBE;EACE,mBAAA;EACA,aAAA;AtJg5kBJ;AsJ74kBE;EACE,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AtJ+4kBJ;AsJ54kBE;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AtJ84kBJ;;AuJ/4lBA;;EAEI,wOAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,WAAA;EACA,qBAAA;EAGA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AvJk5lBJ;;AuJv4lBA;;;;EAII,iBAAA;EACA,mBAAA;AvJk5lBJ;;AuJ94lBA,gBAAA;AAEA;EACI,gBAAA;EACA,SAAA;EACA,cAAA;AvJg5lBJ;;AuJ54lBA,gBAAA;AAEA;EACI,cAAA;EACA,oBAAA;AvJ84lBJ;;AuJ34lBA;;;;EAII,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,YAAA;AvJ84lBJ;;AuJ34lBA;;;EAGI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;;;;EAII,cAAA;AvJ84lBJ;;AuJ34lBA;;;;;EAKI,cAAA;AvJ84lBJ;;AuJ34lBA;;;EAGI,cAAA;AvJ84lBJ;;AuJ34lBA;;EAEI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,6BAAA;AvJ84lBJ;;AuJ34lBA;EACI,iCAAA;EACA,qBAAA;AvJ84lBJ;;AuJ34lBA;EACI,kBAAA;AvJ84lBJ;;AuJ34lBA;;EAEI,iBAAA;AvJ84lBJ;;AuJ34lBA;EACI,cAAA;AvJ84lBJ;;AuJ34lBA;EACI,YAAA;AvJ84lBJ;;AuJ34lBA;EACI,4BAAA;EACA,qBAAA;AvJ84lBJ;;AuJ14lBA;;EAAA;AAIA;EACI,2BAAA;AvJ44lBJ;;AuJz4lBA;EACI,cAAA;AvJ44lBJ;;AuJx4lBA;;EAAA;AAIA;EACI,oCAAA;EAEA,2FAAA;AvJ04lBJ;;AwJxjmBA;EACI,gBAAA;AxJ2jmBJ;AwJzjmBI;EACI,eAAA;EACA,gBrJmWsB;AHwtlB9B;;AwJvjmBA;EACI,QAAA;AxJ0jmBJ;AwJxjmBI;;;EAGI,oBAAA;AxJ0jmBR;AwJxjmBQ;;;;;;EAEI,oBAAA;AxJ8jmBZ;AwJ3jmBQ;;;EACI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AxJ+jmBZ;AwJ3jmBI;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AxJ6jmBR;AgBthmBI;EwI1CA;IAMQ,cAAA;IACA,gBAAA;IACA,4CAAA;ExJ8jmBV;EwJ7jmBU;IACI,SAAA;ExJ+jmBd;AACF;AwJzjmBgB;;;;;;EAEI,arJ4YU;EqJ3YV,mBAAA;EACA,yBAAA;AxJ+jmBpB;AwJ7jmBoB;;;;;;EACI,gBAAA;AxJokmBxB;AwJ/jmBQ;EACI,mBAAA;AxJikmBZ;;AwJxjmBI;EACI,gBAAA;EACA,iBAAA;EACA,gBrJ+RsB;AH4xlB9B;AwJxjmBI;EACI,kBAAA;EACA,kBAAA;EACA,gBrJyRsB;AHiylB9B;AwJvjmBI;;EAEI,sBAAA;AxJyjmBR;AgBjlmBI;EwI4BI;;;IAGI,cAAA;ExJwjmBV;AACF;;AwJpjmBA;EACI,qBAAA;EACA,8BAAA;EACA,qBAAA;AxJujmBJ;;AwJpjmBA;EACI,gBAAA;EACA,qBAAA;EACA,gBAAA;AxJujmBJ;AgBpmmBI;EwI0CJ;IAMQ,iBAAA;IACA,gBrJ2PsB;EH6zlB5B;AACF;;AwJrjmBA;EACI,sBAAA;EACA,gBAAA;AxJwjmBJ;AgB/mmBI;EwIqDJ;IAKQ,cAAA;IACA,mBAAA;IACA,mBAAA;ExJyjmBN;AACF;;AwJtjmBA;EACI,cJ5HgB;ApJqrmBpB;;AwJtjmBA;EACI,cJ/HgB;ApJwrmBpB;;AwJpjmBI;EACI,iBAAA;AxJujmBR;;AwJljmBA;EACI,cAAA;EACA,sBAAA;EACA,yBAAA;AxJqjmBJ;;AwJljmBA;EACI,YAAA;EACA,cAAA;EACA,WAAA;AxJqjmBJ;;AwJljmBA;EACI,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,6BAAA;AxJqjmBJ;;AwJljmBA;EACI,qBAAA;AxJqjmBJ;;AwJljmBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AxJqjmBJ;;AwJljmBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EAGA,2BAAA;AxJqjmBJ;;AwJljmBA;EACI,qBAAA;EACA,cAAA;AxJqjmBJ;;AwJljmBA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AxJqjmBJ;;AwJljmBA;EACI,WAAA;AxJqjmBJ;;AwJljmBA;EACI,eAAA;AxJqjmBJ;;AwJljmBA;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AxJqjmBJ;;AwJljmBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EAGA,2BAAA;AxJqjmBJ;;AwJljmBA;EACI,WAAA;EACA,eAAA;EACA,eAAA;AxJqjmBJ;;AwJljmBA;EACI,eAAA;AxJqjmBJ;;AwJljmBA;EACI,eAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;AxJqjmBJ;;AwJljmBA;EACI,eAAA;AxJqjmBJ;;AwJljmBA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AxJqjmBJ;;AwJljmBA;;;;;;EAMI,oCJ3PgB;EI4PhB,2CAAA;EACA,aAAA;AxJqjmBJ;;AwJljmBA;;EAEI,mBAAA;AxJqjmBJ;;AwJljmBA;;EAEI,iBAAA;AxJqjmBJ;;AwJljmBA;;EAEI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;AxJqjmBJ;;AwJljmBA;;EAEI,qBAAA;AxJqjmBJ;;AwJljmBA;;EAEI,WAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AxJqjmBJ;;AyJ31mBA;EAOI,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AzJw1mBJ;AyJj2mBI;EADJ;IAEQ,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,0BAAA;IACA,gBAAA;EzJo2mBN;AACF;;AyJ71mBA;EACI,eAAA;EACA,2BAAA;AzJg2mBJ;AyJ91mBI;EACI,kBAAA;AzJg2mBR;AyJ91mBQ;EACI,aAAA;AzJg2mBZ;;AyJ31mBA;EACI,cAAA;EACA,eAAA;AzJ81mBJ;AyJ51mBI;EACI,cAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;AzJ81mBR;AyJ51mBQ;EACI,ctJ6BF;EsJ5BE,qBAAA;AzJ81mBZ;;AyJt1mBA;EACI,QAAA;EACA,gCAAA;EACA,yBL3CY;ApJo4mBhB;AgBl1mBI;EyIVJ;IAYQ,+BAAA;EzJo1mBN;EyJ11mBM;IANR;MAOY,wBAAA;MAAA,gBAAA;MACA,SAAA;MACA,aAAA;MACA,0BAAA;IzJ61mBR;EACF;AACF;AgB/1mBI;EyIVJ;IAgBQ,eAAA;EzJ61mBN;AACF;;AyJ11mBA;EACI,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AzJ61mBJ;AgB32mBI;EyIiBI;IAPR;MAQY,8BAAA;MACA,gBAAA;IzJ81mBR;EACF;AACF;AgBn3mBI;EyIUJ;IAaQ,yBAAA;EzJg2mBN;AACF;;AyJ71mBA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;AzJg2mBJ;AyJ91mBI;EACI,qBL7FY;EK8FZ,+CAAA;AzJg2mBR;;AyJ51mBA;EACI,cAAA;EACA,ctJhDO;AH+4mBX;;AyJ51mBA;EACI,aAAA;AzJ+1mBJ;;AyJ51mBA;EACI,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AzJ+1mBJ;AyJ71mBI;EACI,0BAAA;EACA,qBAAA;AzJ+1mBR;;AyJ11mBI;EACI,mBAAA;AzJ61mBR;AyJ31mBQ;EACI,gBAAA;AzJ61mBZ;AyJ11mBQ;EACI,0BAAA;AzJ41mBZ;AyJ11mBY;EACI,6BAAA;AzJ41mBhB;AyJx1mBQ;EACI,cAAA;AzJ01mBZ;;AyJp1mBA;EACI,cAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AzJu1mBJ;;AyJp1mBA;EACI,0BAAA;EACA,qBAAA;EACA,6BAAA;AzJu1mBJ;;AyJp1mBA;EACI,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AzJu1mBJ;AyJr1mBI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;AzJu1mBR;;AyJn1mBA;EACI,cAAA;AzJs1mBJ;;AyJl1mBA;EACI,YAAA;AzJq1mBJ;AyJn1mBI;EACI,UAAA;AzJq1mBR;AyJl1mBI;EACI,yBAAA;EACA,iBAAA;AzJo1mBR;AyJl1mBQ;;EAEI,kCAAA;AzJo1mBZ;AyJj1mBQ;EACI,6BAAA;AzJm1mBZ;AyJ/0mBI;EACI,UAAA;EACA,QAAA;AzJi1mBR;AyJ90mBI;EACI,WAAA;EACA,SAAA;AzJg1mBR;;A0J/hnBA;EACI,cAAA;EACA,kBAAA;EACA,yBAAA;A1JkinBJ;A0JhinBI;EACI,gBAAA;EACA,cvJ0CG;AHw/mBX;A0JhinBQ;EAEI,cvJuFI;AH08mBhB;A0J7hnBI;EACI,gBAAA;A1J+hnBR;AgBt/mBI;E0IzDJ;IAoBQ,gBAAA;E1J+hnBN;AACF;;A0J5hnBA;EACI,eAAA;EACA,mBAAA;A1J+hnBJ;A0J7hnBI;EACI,qBAAA;A1J+hnBR;A0J7hnBQ;EACI,iBAAA;A1J+hnBZ;;A2J9jnBA;EACE;IAAK,yBAAA;E3JkknBL;AACF;A2JhknBA;EACE,qBAAA;EACA,WtJskCwB;EsJrkCxB,YtJqkCwB;EsJpkCxB,wBtJskCwB;EsJrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A3JiknBF;;A2J9jnBA;EACE,WtJgkCwB;EsJ/jCxB,YtJ+jCwB;EsJ9jCxB,mBtJgkCwB;ALiglB1B;;A2J1jnBA;EACE;IACE,mBAAA;E3J6jnBF;E2J3jnBA;IACE,UAAA;IACA,eAAA;E3J6jnBF;AACF;A2J1jnBA;EACE,qBAAA;EACA,WtJsiCwB;EsJriCxB,YtJqiCwB;EsJpiCxB,wBtJsiCwB;EsJriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A3J2jnBF;;A2JxjnBA;EACE,WtJgiCwB;EsJ/hCxB,YtJ+hCwB;AL4hlB1B;;A2JvjnBE;EACE;;IAEE,wBAAA;E3J0jnBJ;AACF;A4JxnnBA;;CAAA;AAGA;EACE,kBAAA;A5J0nnBF;A4JxnnBE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A5J0nnBJ;A4JvnnBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;A5JynnBN;;A4JrnnBA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EACA,oCAAA;EACA,4BAAA;EACA,gBAAA;A5JwnnBF;A4JtnnBE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A5JwnnBJ;A4JtnnBE;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A5JwnnBJ;;A4JpnnBA;EACE,cAAA;EACA,SAAA;A5JunnBF;;A4JrnnBA;EACE,gBAAA;EACA,gBAAA;A5JwnnBF;;A4JrnnBA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;A5JwnnBF;A4JvnnBE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;A5JynnBJ;;A4JrnnBA;EACE,WAAA;EACA,SAAA;EACA,6BAAA;A5JwnnBF;;A4JtnnBA;;EAEE,kBAAA;EACA,YAAA;A5JynnBF;;A4JvnnBA;EACE,eAAA;A5J0nnBF;;A4JxnnBA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A5J2nnBF;A4J1nnBE;EASE,oCAAA;EACA,sBAAA;A5JonnBJ;A4JlnnBE;EACE,0BAAA;EACA,6BAAA;A5JonnBJ;A4JlnnBE;EACE,gBAAA;A5JonnBJ;A4JlnnBE;EACE,yBAAA;EACA,4BAAA;A5JonnBJ;;A4J/mnBI;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;A5JknnBN;A4JhnnBI;EACE,czJxGK;EyJyGL,mBAAA;A5JknnBN;A4JjnnBM;EAEE,czJ9GG;EyJ+GH,gBAAA;A5JknnBR;;A4J5mnBA;;;;;;EAME,mBAAA;EACA,eAAA;A5J+mnBF;;A4J7mnBA;EACE,kBAAA;A5JgnnBF;;A4J9mnBA;EACE,yBAAA;A5JinnBF;;A4J/mnBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JknnBF;;A4J/mnBA;EACE,cAAA;A5JknnBF;;A4JhnnBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JmnnBF;;A4JjnnBA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EAAa,gBAAA;EACb,uBAAA;A5JqnnBF;;A4JnnnBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;A5JsnnBF;;A4JpnnBA;;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;A5JunnBF;;A4JnnnBE;;;;;EAKE,czJzLO;AH+ynBX;;A4JlnnBA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A5JqnnBF;;A4JlnnBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JqnnBF;;A4JnnnBA;EACE,eAAA;A5JsnnBF;;A4JpnnBA;EACE,mBAAA;A5JunnBF;;A4JpnnBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A5JunnBF;;A4JrnnBA;EACE,sBAAA;A5JwnnBF;;A4JrnnBA;EACE,WAAA;EACA,YAAA;A5JwnnBF;;A4JrnnBA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;A5JwnnBF;;A4JtnnBA;;EAEE,gBAAA;A5JynnBF;;A4JtnnBA;EACE,qBAAA;A5JynnBF;;A4JrnnBE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;A5JwnnBJ;A4JtnnBE;EACE,QAAA;EACA,6BAAA;A5JwnnBJ;;A4JpnnBA;EACE,aAAA;A5JunnBF;;A4JpnnBA;EACE,WAAA;A5JunnBF;A4JtnnBE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;A5JwnnBJ;;A4JnnnBI;EACE,czJrPI;EyJsPJ,kBAAA;EACA,yBAAA;A5JsnnBN;;A4JjnnBA;EACE,YAAA;EACA,kBAAA;A5JonnBF;;A4JlnnBA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,czJjSS;EyJsST,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A5JonnBF;;A4JlnnBA;EACE,gBAAA;EACA,cAAA;A5JqnnBF;;A4JnnnBA;EACE,kBAAA;EACA,iBAAA;A5JsnnBF;;A4JnnnBA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;A5JsnnBF;;A4JnnnBA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;A5JsnnBF;;A4JpnnBA;;EAEE,oBAAA;A5JunnBF;A4JtnnBE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A5J0nnBJ;A4JxnnBI;;;;;;;;;;;;;EAIE,oCAAA;EACA,WzJ3VK;AH89nBX;;A4J/nnBA;EACE,yBAAA;EACA,4BAAA;A5JkonBF;;A4JhonBA;EACE,yBAAA;EACA,4BAAA;A5JmonBF;;A4JjonBA;EACE,0BAAA;EACA,6BAAA;A5JoonBF;;A4JjonBA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;A5JoonBF;;A6J/hoBE;EACE,iBAAA;A7JkioBJ;;A6J/hoBA;EACE,gBAAA;A7JkioBF;;A8JxioBA;EACE,aAAA;A9J2ioBF;;A+J5ioBA;EACE;IACE,UAAA;IACA,2CAAA;E/J+ioBF;E+J7ioBA;IACE,UAAA;E/J+ioBF;AACF;AgKtjoBA;EACE,oBAAA;AhKwjoBF;;AgKtjoBA;EACE,iBAAA;AhKyjoBF;;AiK5joBE;EAEE,iBAAA;AjK8joBJ;AiK5joBE;EACE,kBAAA;AjK8joBJ","sourcesContent":["/*!\n\n=========================================================\n* Argon Dashboard React - v1.2.4\n=========================================================\n\n* Product Page: https://www.creative-tim.com/product/argon-dashboard-react\n* Copyright 2024 Creative Tim (https://www.creative-tim.com)\n* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)\n\n* Coded by Creative Tim\n\n=========================================================\n\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n*/\n\n// Core\n\n@import \"argon-dashboard/custom/functions\";\n@import \"argon-dashboard/custom/variables\";\n@import \"argon-dashboard/custom/mixins\";\n\n// bootstrap (4.6.0) components\n\n@import \"~bootstrap/scss/root\";\n@import \"~bootstrap/scss/reboot\";\n@import \"~bootstrap/scss/type\";\n@import \"~bootstrap/scss/images\";\n@import \"~bootstrap/scss/code\";\n@import \"~bootstrap/scss/grid\";\n@import \"~bootstrap/scss/tables\";\n@import \"~bootstrap/scss/forms\";\n@import \"~bootstrap/scss/buttons\";\n@import \"~bootstrap/scss/transitions\";\n@import \"~bootstrap/scss/dropdown\";\n@import \"~bootstrap/scss/button-group\";\n@import \"~bootstrap/scss/input-group\";\n@import \"~bootstrap/scss/custom-forms\";\n@import \"~bootstrap/scss/nav\";\n@import \"~bootstrap/scss/navbar\";\n@import \"~bootstrap/scss/card\";\n@import \"~bootstrap/scss/breadcrumb\";\n@import \"~bootstrap/scss/pagination\";\n@import \"~bootstrap/scss/badge\";\n@import \"~bootstrap/scss/jumbotron\";\n@import \"~bootstrap/scss/alert\";\n@import \"~bootstrap/scss/progress\";\n@import \"~bootstrap/scss/media\";\n@import \"~bootstrap/scss/list-group\";\n@import \"~bootstrap/scss/close\";\n@import \"~bootstrap/scss/modal\";\n@import \"~bootstrap/scss/tooltip\";\n@import \"~bootstrap/scss/popover\";\n@import \"~bootstrap/scss/carousel\";\n@import \"~bootstrap/scss/utilities\";\n@import \"~bootstrap/scss/print\";\n\n// Argon utilities and components\n\n@import \"argon-dashboard/custom/reboot\";\n@import \"argon-dashboard/custom/utilities\";\n@import \"argon-dashboard/custom/components\";\n\n// Vendor (Plugins)\n\n@import \"argon-dashboard/custom/vendors\";\n\n// Docs components\n\n@import \"argon-dashboard/docs/variables\";\n@import \"argon-dashboard/docs/nav\";\n@import \"argon-dashboard/docs/clipboard-js\";\n@import \"argon-dashboard/docs/component-examples\";\n@import \"argon-dashboard/docs/prism\";\n@import \"argon-dashboard/docs/content\";\n@import \"argon-dashboard/docs/sidebar\";\n@import \"argon-dashboard/docs/footer\";\n\n// React Differences\n@import \"react/react-differences\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n//\n// Variables\n//\n\n// Global settings\n\n$enable-caret:              true !default;\n$enable-rounded:            true !default;\n$enable-shadows:            true !default;\n$enable-gradients:          false !default;\n$enable-transitions:        true !default;\n$enable-grid-classes:       true !default;\n$enable-print-styles:       true !default;\n\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f6f9fc !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #8898aa !default;   // Line footer color\n$gray-700: #525f7f !default;   // Line p color\n$gray-800: #32325d !default;   // Line heading color\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge((\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n), $grays);\n\n$blue:    #5e72e4 !default;\n$indigo:  #5603ad !default;\n$purple:  #8965e0 !default;\n$pink:    #f3a4b5 !default;\n$red:     #f5365c !default;\n$orange:  #fb6340 !default;\n$yellow:  #ffd600 !default;\n$green:   #2dce89 !default;\n$teal:    #11cdef !default;\n$cyan:    #2bffc6 !default;\n\n$colors: () !default;\n$colors: map-merge((\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"light\":      $gray-400,\n  \"lighter\":    $gray-200,\n  \"gray-dark\":  $gray-800\n), $colors);\n\n$default:       #172b4d !default;\n$primary:       #5e72e4 !default;\n$secondary:     #f7fafc !default;\n$success:       $green !default;\n$info:          $teal !default;\n$warning:       $orange !default;\n$danger:        $red !default;\n$light:         $gray-500 !default;\n$dark:          $gray-900 !default;\n$darker:        darken($gray-900, 15%) !default;\n\n$facebook:      #3b5999 !default;\n$twitter:       #1da1f2 !default;\n$google-plus:   #dd4b39 !default;\n$instagram:     #e4405f !default;\n$pinterest:     #bd081c !default;\n$youtube:       #cd201f !default;\n$slack:         #3aaf85 !default;\n$dribbble:      #ea4c89 !default;\n$github:        #222222 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge((\n  \"default\":      $default,\n  \"primary\":      $primary,\n  \"secondary\":    $secondary,\n  \"success\":      $success,\n  \"info\":         $info,\n  \"warning\":      $warning,\n  \"danger\":       $danger,\n  \"white\":        $white,\n  \"neutral\":      $white,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $theme-colors);\n\n$brand-colors: () !default;\n$brand-colors: map-merge((\n  \"facebook\":     $facebook,\n  \"twitter\":      $twitter,\n  \"google-plus\":  $google-plus,\n  \"instagram\":    $instagram,\n  \"pinterest\":    $pinterest,\n  \"youtube\":      $youtube,\n  \"slack\":        $slack,\n  \"dribbble\":     $dribbble,\n  \"github\":       $github\n), $brand-colors);\n\n$shape-colors: () !default;\n$shape-colors: map-merge((\n  \"default\":      #32325d,\n  \"primary\":      #5533ff,\n  \"secondary\":    #24b47e,\n  \"neutral\":      #e9ecef,\n  \"blue-gray\":    #b2cbe1,\n\n), $shape-colors);\n\n$shapes-primary-colors: () !default;\n$shapes-primary-colors: map-merge((\n  \"step-1-gradient-bg\":         #281483,\n  \"step-2-gradient-bg\":         #8f6ed5,\n  \"step-3-gradient-bg\":         #d782d9,\n  \"span-1-bg\":                  #53f,\n  \"span-2-bg\":                  #4553ff,\n  \"span-3-bg\":                  #4f40ff,\n  \"span-4-bg\":                  #25ddf5,\n  \"span-5-bg\":                  #1fa2ff\n), $shapes-primary-colors);\n\n$shapes-default-colors: () !default;\n$shapes-default-colors: map-merge((\n  \"step-1-gradient-bg\":         #7795f8,\n  \"step-2-gradient-bg\":         #6772e5,\n  \"step-3-gradient-bg\":         #555abf,\n  \"span-1-bg\":                  #7795f8,\n  \"span-2-bg\":                  #7b9aff,\n  \"span-3-bg\":                  #6f8ff8,\n  \"span-4-bg\":                  #76eea7,\n  \"span-5-bg\":                  #6adaff\n), $shapes-default-colors);\n\n$shapes-light-colors: () !default;\n$shapes-light-colors: map-merge((\n  \"step-1-gradient-bg\":         #b2cbe1,\n  \"step-2-gradient-bg\":         #f6f9fc,\n  \"step-3-gradient-bg\":         #f6f9fc,\n  \"span-1-bg\":                  #b4cce1,\n  \"span-2-bg\":                  #c5dbef,\n  \"span-3-bg\":                  #b9d5ed,\n  \"span-4-bg\":                  #74e4a2,\n  \"span-5-bg\":                  #008169\n), $shapes-light-colors);\n\n$shapes-dark-colors: () !default;\n$shapes-dark-colors: map-merge((\n  \"step-1-gradient-bg\":         #32325d,\n  \"step-2-gradient-bg\":         #32325d,\n  \"step-3-gradient-bg\":         #32325d,\n  \"span-1-bg\":                  #2e2e57,\n  \"span-2-bg\":                  #2b2b58,\n  \"span-3-bg\":                  #25254d,\n  \"span-4-bg\":                  #d782d9,\n  \"span-5-bg\":                  #008169\n), $shapes-dark-colors);\n\n\n// Translucent color variations\n$translucent-color-opacity: .6 !default;\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  200 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Action colors\n\n$star-rating-color: $gray-400 !default;\n$star-rating-color-active: $yellow !default;\n\n$favorite-color: $yellow !default;\n$like-color: $blue !default;\n$love-color: $red !default;\n\n\n// Body\n\n\n$body-bg: #f8f9fe !default;\n$body-color: $gray-700 !default;\n\n\n\n// Sections\n\n$section-colors: () !default;\n$section-colors: map-merge((\n  \"primary\":      $body-bg,\n  \"secondary\":    $secondary,\n  \"light\":        $gray-400,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $section-colors);\n\n// Links\n\n$link-color:                $primary !default;\n$link-decoration:           none !default;\n$link-hover-color:          darken($link-color, 15%) !default;\n$link-hover-decoration:     none !default;\n\n// Grid breakpoints\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n);\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n\n\n// Spacing\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge((\n  -9: -($spacer * 10),\n  -8: -($spacer * 8),\n  -7: -($spacer * 6),\n  -6: -($spacer * 4.5),\n  -5: -($spacer * 3),\n  -4: -($spacer * 1.5),\n  -3: -$spacer,\n  -2: -($spacer * .5),\n  -1: -($spacer * .25),\n  0: 0,\n  1: ($spacer * .25),\n  2: ($spacer * .5),\n  3: $spacer,\n  4: ($spacer * 1.5),\n  5: ($spacer * 3),\n  6: ($spacer * 4.5),\n  7: ($spacer * 6),\n  8: ($spacer * 8),\n  9: ($spacer * 10)\n), $spacers);\n\n\n// This variable affects the `.h-*` and `.w-*` classes.\n\n$sizes: () !default;\n$sizes: map-merge((\n  25: 25%,\n  50: 50%,\n  75: 75%,\n  100: 100%\n), $sizes);\n\n// Components\n\n$shape-height-xl:              1.5 !default;\n$shape-height-lg:              1.5 !default;\n$shape-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-200 !default;\n\n$border-radius:               .375rem !default;\n$border-radius-xl:            .5rem !default;\n$border-radius-lg:            .4375rem !default;\n$border-radius-sm:            .25rem !default;\n\n$box-shadow-sm:               0 0 .5rem rgba($gray-600, .075) !default;\n$box-shadow:                  0 0 2rem 0 rgba($gray-600, .15) !default;\n$box-shadow-lg:               0 0 3rem rgba($gray-600, .175) !default;\n\n$component-active-color:        $white !default;\n$component-active-bg:           theme-color(\"primary\") !default;\n$component-active-border-color: theme-color(\"primary\") !default;\n\n$component-hover-color:        $gray-300 !default;\n$component-hover-bg:           $gray-300 !default;\n$component-hover-border-color: $gray-300 !default;\n\n$caret-width:                 .3em !default;\n\n$transition-base:             all .15s ease !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n\n// Fonts\n\n$font-family-sans-serif: Open Sans, sans-serif !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-xl:                ($font-size-base * 1.5);\n$font-size-lg:                ($font-size-base * 1.25);\n$font-size-sm:                ($font-size-base * .875);\n$font-size-xs:                ($font-size-base * .75);\n\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            600 !default;\n$font-weight-extra-bold:      700 !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n$shape-height-base:           1.5 !default;\n\n\n$h1-font-size:                $font-size-base * 1.625 !default;\n$h2-font-size:                $font-size-base * 1.25 !default;\n$h3-font-size:                $font-size-base * 1.0625 !default;\n$h4-font-size:                $font-size-base * .9375 !default;\n$h5-font-size:                $font-size-base * .8125 !default;\n$h6-font-size:                $font-size-base * .625 !default;\n\n\n$headings-margin-bottom:      calc($spacer / 2);\n$headings-font-family:        inherit !default;\n$headings-font-weight:        $font-weight-bold !default;\n$headings-line-height:        1.5 !default;\n$headings-color:              $gray-800 !default;\n\n$heading-letter-spacing:      .025em !default;\n$heading-font-size:           .95rem !default;\n$heading-text-transform:      uppercase !default;\n$heading-font-weight:         $headings-font-weight !default;\n\n$heading-title-letter-spacing:      .025em !default;\n$heading-title-font-size:           1.375rem !default;\n$heading-title-font-weight:         $font-weight-bold !default;\n$heading-title-text-transform:      uppercase !default;\n\n$heading-section-letter-spacing:      .025em !default;\n$heading-section-font-size:           1.375rem !default;\n$heading-section-font-weight:         $font-weight-bold !default;\n$heading-section-text-transform:      uppercase !default;\n\n$display1-size:               3.3rem !default;\n$display2-size:               2.75rem !default;\n$display3-size:               2.1875rem !default;\n$display4-size:               1.6275rem !default;\n\n$display1-weight:             $font-weight-bold !default;\n$display2-weight:             $font-weight-bold !default;\n$display3-weight:             $font-weight-bold !default;\n$display4-weight:             $font-weight-bold !default;\n$display-line-height:         $headings-line-height !default;\n\n$paragraph-font-size:         1rem !default;\n$paragraph-font-weight:       300 !default;\n$paragraph-line-height:       1.7 !default;\n\n$lead-font-size:              ($paragraph-font-size * 1.25) !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-font-size:        ($font-size-base * 1.25) !default;\n\n$hr-border-color:             rgba($black, .1);\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer * 2 !default;\n\n\n// Icons\n\n$icon-size: 3rem !default;\n$icon-size-xl: 5rem !default;\n$icon-size-lg: 4rem !default;\n$icon-size-sm: 2rem !default;\n\n\n// Tables\n\n$table-cell-padding:          1rem !default;\n$table-cell-padding-sm:       .5rem !default;\n\n$table-bg:                    transparent !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-bg:              $gray-100 !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $gray-200 !default;\n\n$table-head-bg:               $gray-100 !default;\n$table-head-color:            $gray-600 !default;\n$table-head-spacer-y:         .75rem !default;\n\n$table-head-font-size:        .65rem !default;\n$table-head-font-weight:      $font-weight-bold !default;\n$table-head-text-transform:   uppercase !default;\n$table-head-letter-spacing:   1px !default;\n\n$table-body-font-size:        .8125rem !default;\n\n$table-dark-bg:               theme-color(\"default\") !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten(theme-color(\"default\"), 7%) !default;\n$table-dark-color:            $body-bg !default;\n\n$table-dark-head-bg:          lighten(theme-color(\"default\"), 4%) !default;\n$table-dark-head-color:       lighten(theme-color(\"default\"), 35%) !default;\n\n// Buttons + Forms\n\n$input-btn-padding-y:         .625rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-line-height:       $shape-height-base !default;\n\n$input-btn-focus-width:       0 !default;\n$input-btn-focus-color:       rgba($component-active-bg, 1) !default;\n$input-btn-focus-box-shadow:  none !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-line-height-sm:    $shape-height-sm !default;\n\n$input-btn-padding-y-lg:      .875rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-line-height-lg:    $shape-height-lg !default;\n\n$input-btn-border-width:      1px !default;\n\n$input-btn-font-size-sm:      .75rem !default;\n$input-btn-font-size:         .875rem !default;\n$input-btn-font-size-lg:         .875rem !default;\n\n// Buttons\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x + 0.5 !default;\n$btn-line-height:             $input-btn-line-height !default;\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             600 !default;\n\n$btn-text-transform:          none !default;\n\n\n$btn-letter-spacing:          .025em !default;\n$btn-box-shadow:              0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08) !default;\n$btn-hover-box-shadow:        0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08) !default;\n$btn-focus-box-shadow:        $btn-hover-box-shadow !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-active-box-shadow:       none !default;\n\n$btn-hover-translate-y:       -1px !default;\n\n// Forms\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-xl:                $border-radius-xl !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-muted-bg:                        #F7FAFE !default;\n$input-focus-muted-bg:                  lighten($input-muted-bg, 1%) !default;\n\n$input-alternative-box-shadow:          0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02) !default;\n$input-focus-alternative-box-shadow:    0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !default;\n\n$input-color:                           $gray-600 !default;\n$input-border-color:                    #cad1d7 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      none !default; // 0 1px 3px 0 $gray-400 !default;\n\n$input-focus-bg:                        $white !default;\n$input-focus-border-color:              rgba(50,151,211,.25) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     0 !default;\n$input-focus-box-shadow:                none !default; //0 1px 3px 0 $gray-500 !default;\n\n$input-placeholder-color:               $gray-500 !default;\n$input-focus-placeholder-color:         $gray-500 !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-transition:                      all .2s cubic-bezier(0.68, -0.55, 0.265, 1.55) !default;\n\n\n// Input groups\n\n$input-group-addon-color:               $input-placeholder-color !default;\n$input-group-addon-bg:                  $input-bg !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$input-group-addon-focus-color:               $input-focus-color !default;\n$input-group-addon-focus-bg:                  $input-focus-bg !default;\n$input-group-addon-focus-border-color:        $input-focus-border-color !default;\n\n\n// Form group\n\n$form-group-margin-bottom:              1.5rem !default;\n\n\n// Custom forms\n\n$custom-control-gutter:                 1.75rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-indicator-size:         1.25rem !default;\n\n$custom-control-indicator-bg:                   $input-bg !default;\n$custom-control-indicator-border-width:         1px !default;\n$custom-control-indicator-border-color:         $input-border-color !default;\n$custom-control-indicator-box-shadow:           none !default;\n\n$custom-control-indicator-focus-box-shadow:     $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-hover-color:         $component-hover-color !default;\n$custom-control-indicator-hover-bg:            $component-hover-bg !default;\n$custom-control-indicator-hover-border-color:  $component-hover-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            $component-active-bg !default;\n$custom-control-indicator-active-border-color:  $component-active-border-color !default;\n$custom-control-indicator-active-box-shadow:    $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\n$custom-control-indicator-checked-box-shadow:   $custom-control-indicator-box-shadow !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius-sm !default;\n//$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n// Custom toggle\n\n$custom-toggle-width:           50px !default;\n$custom-toggle-slider-bg:       $gray-200 !default;\n$custom-toggle-checked-bg:      theme-color(\"primary\") !default;\n\n// Form validation\n\n$form-feedback-valid-bg:         lighten($success, 15%) !default;\n$form-feedback-valid-color:      theme-color(\"success\") !default;\n$form-feedback-invalid-bg:       lighten($warning, 15%) !default;\n$form-feedback-invalid-color:    theme-color(\"warning\") !default;\n\n\n// Allows for customizing button radius independently from global border radius\n\n$btn-border-radius:           $input-border-radius !default;\n$btn-border-radius-xl:        $input-border-radius-xl !default;\n$btn-border-radius-lg:        $input-border-radius-lg !default;\n$btn-border-radius-sm:        $input-border-radius !default;\n\n\n\n$chart-height: 350px !default;\n$chart-height-sm: 230px !default;\n\n$chart-legend-margin-top: 2.5rem !default;\n$chart-legend-font-size: $font-size-sm !default;\n$chart-legend-color: $text-muted !default;\n$chart-legend-height: $chart-legend-margin-top + $chart-legend-font-size * $line-height-base !default;\n\n\n\n\n// Map\n$map-height: 500px !default;\n\n\n// No UI Slider\n\n$noui-target-bg:                  #eceeef !default;\n$noui-target-thickness:           5px !default;\n$noui-target-border-radius:       5px !default;\n$noui-target-border-color:        0 !default;\n$noui-target-box-shadow:          inset 0 1px 2px rgba(90,97,105,.1) !default;\n\n$noui-slider-connect-bg:          $primary !default;\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\n\n$noui-handle-width:               15px !default;\n$noui-handle-bg:                  theme-color(\"primary\") !default;\n$noui-handle-border:              0 !default;\n$noui-handle-border-radius:       100% !default;\n\n$noui-origin-border-radius:       2px !default;\n\n\n// Dropdown\n\n$dropdown-bg:                    $white !default;\n$dropdown-border-width:          0 !default;\n$dropdown-border-color:          rgba($black, .15) !default;\n$dropdown-border-radius:         $border-radius-lg !default;\n$dropdown-box-shadow:            0 50px 100px rgba(50, 50, 93, .1), 0 15px 35px rgba(50, 50, 93, .15), 0 5px 15px rgba(0, 0, 0, .1) !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .25rem !default;\n$nav-link-padding-x:                .75rem !default;\n$nav-link-color:                    $gray-700 !default;\n$nav-link-hover-color:              theme-color(\"primary\") !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-pills-padding-y:               .75rem !default;\n$nav-pills-padding-x:               1rem !default;\n\n$nav-pills-space-x:                 1rem !default;\n\n$nav-pills-bg:                      $white !default;\n$nav-pills-border-width:            1px !default;\n$nav-pills-border-color:            theme-color(\"primary\") !default;\n$nav-pills-border-radius:           $border-radius !default;\n\n$nav-pills-link-color:              theme-color(\"primary\") !default;\n$nav-pills-link-hover-color:        darken(theme-color(\"primary\"), 5%) !default;\n$nav-pills-link-active-color:       color-yiq(theme-color(\"primary\")) !default;\n$nav-pills-link-active-bg:          theme-color(\"primary\") !default;\n$nav-pills-box-shadow:              $btn-box-shadow !default;\n\n// Navbar\n\n$navbar-transition:                 all .15s linear !default;\n$navbar-padding-y:                  1rem !default;\n$navbar-padding-x:                  1rem !default;\n\n$navbar-nav-link-padding-x:         1rem !default;\n$navbar-nav-link-padding-y:         1rem !default;\n\n$navbar-nav-link-font-size:         .9rem !default;\n$navbar-nav-link-font-weight:       400 !default;\n$navbar-nav-link-text-transform:    normal !default;\n$navbar-nav-link-letter-spacing:    0 !default;\n$navbar-nav-link-border-radius:     $border-radius !default;\n\n$navbar-search-width:               270px !default;\n$navbar-search-bg:                  transparent !default;\n\n$navbar-search-border-radius:       2rem !default;\n$navbar-search-border-width:        2px !default;\n\n$navbar-dark-bg:                    transparent !default;\n$navbar-dark-hover-bg:              rgba(255, 255, 255, .1) !default;\n$navbar-dark-active-bg:             rgba(255, 255, 255, .1) !default;\n$navbar-dark-color:                 rgba($white, .95) !default;\n$navbar-dark-hover-color:           rgba($white, .65) !default;\n$navbar-dark-active-color:          rgba($white, .65) !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-border-color:  transparent !default;\n\n$navbar-search-dark-border-color:   rgba(255, 255, 255, .6) !default;\n$navbar-search-dark-color:          rgba(255, 255, 255, .6) !default;\n$navbar-search-dark-focus-border-color: rgba(255, 255, 255, .9) !default;\n$navbar-search-dark-focus-color:    rgba(255, 255, 255, .9) !default;\n\n$navbar-light-bg:                   transparent !default;\n$navbar-light-hover-bg:             rgba(0, 0, 0, .1) !default;\n$navbar-light-active-bg:            rgba(0, 0, 0, .1) !default;\n$navbar-light-border-color:         $gray-100 !default;\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-border-color: transparent !default;\n\n$navbar-search-light-border-color:  rgba(0, 0, 0, .6) !default;\n$navbar-search-light-color:          rgba(0, 0, 0, .6) !default;\n$navbar-search-light-focus-border-color: rgba(0, 0, 0, .9) !default;\n$navbar-search-light-focus-color:    rgba(0, 0, 0, .9) !default;\n\n\n\n// Vertical navbar\n$navbar-vertical-box-shadow: 0 0 2rem 0 rgba(136, 152, 170, .15) !important;\n$navbar-vertical-width: 250px !default;\n$navbar-vertical-padding-x: 1.5rem !default;\n$navbar-vertical-nav-link-padding-x:  1.5rem !default;\n$navbar-vertical-nav-link-padding-y:  .65rem !default;\n\n$navbar-icon-min-width: 2.25rem !default;\n\n$navbar-breadcrumb-padding-y: $nav-link-padding-y !default;\n$navbar-breadcrumb-padding-x: 0 !default;\n\n$navbar-light-bg: $white !default;\n$navbar-light-border-color: $border-color !default;\n\n\n\n\n// Main content\n\n$main-content-padding-y: 40px !default;\n$main-content-padding-x: 24px !default; // in px to combine with $grid-gutter-width\n\n\n// Alerts\n\n$alert-padding-y: 1rem !default;\n$alert-padding-x: 1.5rem !default;\n$alert-border-radius: $border-radius !default;\n\n$alert-bg-level: -2 !default;\n$alert-border-level: -2 !default;\n$alert-color-level: 0 !default;\n\n\n// List group\n\n$list-group-bg:                     $white !default;\n$list-group-border-color:           $border-color !default; //rgba($black, .125);\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         1rem !default;\n$list-group-item-padding-x:         1rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $list-group-action-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-bg:                          transparent !default;\n$close-hover-bg:                    transparent !default;\n$close-color:                       rgba(0, 0, 0, .6) !default !default;\n$close-hover-color:                 rgba(0, 0, 0, .9) !default;\n$close-text-shadow:                 none !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              1px !default;\n$popover-border-color:              rgba($black, .05) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-box-shadow:                0px .5rem 2rem 0px rgba($black, .2) !default;\n\n$popover-header-bg:                 $popover-bg !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .95rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1.5rem !default;\n$popover-arrow-height:              .75rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         transparent !default;\n\n\n// Badges\n\n$badge-font-size:                   66% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .35rem !default;\n$badge-padding-x:                   .375rem !default;\n$badge-border-radius:               $border-radius !default;\n$badge-text-transfom:               uppercase;\n\n$badge-pill-padding-x:              .875em !default;\n$badge-pill-border-radius:          10rem !default;\n\n$badge-circle-size:                 2rem !default;\n\n// Pagination\n\n// $pagination-padding-y:              .5rem !default;\n// $pagination-padding-x:              .75rem !default;\n// $pagination-padding-y-sm:           .25rem !default;\n// $pagination-padding-x-sm:           .5rem !default;\n// $pagination-padding-y-lg:           .75rem !default;\n// $pagination-padding-x-lg:           1.5rem !default;\n// $pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $gray-600 !default;\n$pagination-bg:                     $white  !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n//$pagination-focus-box-shadow:       $btn-hover-box-shadow !default;\n\n$pagination-hover-color:            $gray-600 !default;\n$pagination-hover-bg:               $gray-300 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n$pagination-active-box-shadow:      $btn-hover-box-shadow !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Cards\n\n$card-spacer-y:                     1.25rem !default;\n$card-spacer-x:                     1.5rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .05) !default;\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width}) !default;\n$card-cap-bg:                       $white !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n//$card-group-margin:                 ($grid-gutter-width / 2);\n//$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n\n// Modals\n\n$modal-inner-padding:               1.5rem !default;\n\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          380px !default;\n\n$modal-title-line-height:           1.1;\n\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        0 !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-box-shadow-xs:       0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17);\n$modal-content-box-shadow-sm-up:    0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17);\n\n$modal-backdrop-bg:           $black !default;\n$modal-backdrop-opacity:      .16 !default;\n$modal-header-border-color:   $gray-200 !default;\n$modal-footer-border-color:   $modal-header-border-color !default;\n$modal-header-border-width:   $modal-content-border-width !default;\n$modal-footer-border-width:   $modal-header-border-width !default;\n$modal-header-padding:        1.25rem !default;\n\n// Datepicker\n\n$datepicker-border-radius: $card-border-radius !default;\n$datepicker-dropdown-padding: 20px 22px !default;\n\n$datepicker-cell-transition: $transition-base !default;\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\n$datepicker-cell-border-radius: 50% !default;\n$datepicker-cell-width: 36px !default;\n$datepicker-cell-height: 36px !default;\n\n$datepicker-disabled-cell-color: $gray-300 !default;\n$datepicker-disabled-old-new-color: $gray-500 !default;\n\n$datepicker-header-cell-border-radius: $border-radius !default;\n\n$datepicker-active-color: $white !default;\n$datepicker-active-background: theme-color(\"primary\") !default;\n$datepicker-active-box-shadow:      none !default;\n\n$datepicker-range-background: theme-color(\"primary\") !default;\n$datepicker-range-cell-focused-background: darken($datepicker-range-background, 5%);\n$datepicker-range-color: $white !default;\n$datepicker-range-highlighted-bg: $gray-200 !default;\n\n$datepicker-dropdown-border: lighten($gray-400, 40%);\n$datepicker-dropdown-bg: $white !default;\n$datepicker-highlighted-bg: $datepicker-active-background !default;\n\n\n// Footer\n\n\n$footer-padding-y:              2.5rem;\n$footer-padding-x:              0;\n\n\n$footer-link-font-size: .85rem !default;\n$footer-bg: theme-color(\"secondary\") !default;\n$footer-color: $gray-600 !default;\n$footer-link-color: $gray-600 !default;\n$footer-link-hover-color: $gray-700 !default;\n$footer-heading-color: $gray-600 !default;\n$footer-heading-font-size: $font-size-sm !default;\n\n// Import Bootstrap variable defaults\n\n@import \"~bootstrap/scss/variables\";\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @if (length($shadow) == 1) {\n      // We can pass `@include box-shadow(none);`\n      $result: $shadow;\n    } @else {\n      // Filter to avoid invalid properties for example `box-shadow: none, 1px 1px black;`\n      @for $i from 1 through length($shadow) {\n        @if nth($shadow, $i) != \"none\" {\n          $result: append($result, nth($shadow, $i), \"comma\");\n        }\n      }\n    }\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@mixin form-control-focus($ignore-warning) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n}\n\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    font-size: $form-feedback-font-size;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: .5rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    line-height: 1;\n    color: #fff;\n    background-color: rgba($color, .8);\n    border-radius: .2rem;\n  }\n\n  .form-control,\n  .custom-select {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      border-color: $color;\n\n      &:focus {\n        border-color: $color;\n        //box-shadow: 0 1px $input-focus-width 0 rgba($color, .75);\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .form-check-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          background-color: lighten($color, 25%);\n          border-color: lighten($color, 25%);\n        }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          @include gradient-bg(lighten($color, 10%));\n          border-color: lighten($color, 25%);\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-file-label {\n        border-color: $color;\n\n        &::before { border-color: inherit; }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","@mixin button-variant($background, $border, $hover-background: darken($background, 0%), $hover-border: darken($border, 0%), $active-background: darken($background, 10%), $active-border: darken($border, 0%)) {\n    color: color-yiq($background);\n    @include gradient-bg($background);\n    border-color: $border;\n    @include box-shadow($btn-box-shadow);\n\n    @include hover {\n        color: color-yiq($hover-background);\n        @include gradient-bg($hover-background);\n        border-color: $hover-border;\n    }\n\n    &:focus,\n    &.focus {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        @if $enable-shadows {\n            box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n        @else {\n            box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n    } // Disabled comes first so active can properly restyle\n    &.disabled,\n    &:disabled {\n        color: color-yiq($background);\n        background-color: $background;\n        border-color: $border;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        @if $enable-gradients {\n            background-image: none; // Remove the gradient for the pressed/active state\n        }\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n        }\n    }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n    color: $color;\n    background-color: transparent;\n    background-image: none;\n    border-color: $color;\n\n    &:hover {\n        color: $color-hover;\n        background-color: $active-background;\n        border-color: $active-border;\n    }\n\n    &:focus,\n    &.focus {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n    }\n\n    &.disabled,\n    &:disabled {\n        color: $color;\n        background-color: transparent;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows and $btn-active-box-shadow !=none {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n        }\n    }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n    padding: $padding-y $padding-x;\n    font-size: $font-size;\n    line-height: $line-height; // Manually declare to provide an override to the browser default\n    @if $enable-rounded {\n        border-radius: $border-radius;\n    }\n    @else {\n        border-radius: 0;\n    }\n}",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n\tcolor: saturate(darken($bg, 10%), 10);\n    background-color: transparentize(lighten($bg, 25%), .5);\n\n  \t&[href] {\n\t    @include hover-focus {\n\t        color: color-yiq($bg);\n\t        text-decoration: none;\n\t        background-color: darken($bg, 10%);\n\t    }\n\t}\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n    color: color-yiq($background);\n    @include gradient-bg($background);\n    border-color: $border;\n\n    hr {\n        border-top-color: darken($border, 5%);\n    }\n\n    .alert-link {\n        color: darken($color, 10%);\n    }\n}","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// Contextual backgrounds\n@mixin bg-variant($parent, $color, $ignore-warning: true) {\n    #{$parent} {\n        background-color: $color !important;\n    }\n    a#{$parent},\n    button#{$parent} {\n        @include hover-focus {\n            background-color: darken($color, 10%) !important;\n        }\n    }\n}\n\n@mixin bg-gradient-variant($parent, $color) {\n    #{$parent} {\n        background: linear-gradient(87deg, $color 0, adjust-hue($color, 25%) 100%) !important;\n    }\n}\n\n@mixin bg-translucent-variant($parent, $color) {\n    #{$parent} {\n        background-color: darken(rgba($color, $translucent-color-opacity), 7%) !important;\n    }\n    a#{$parent},\n    button#{$parent} {\n        @include hover-focus {\n            background-color: darken(rgba($color, $translucent-color-opacity), 12%) !important;\n        }\n    }\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","iframe {\n    border: 0;\n}\n\nfigcaption,\nfigure,\nmain {\n    display: block;\n}\n\nmain {\n    overflow: hidden;\n}\n","//\n// Backgrounds\n//\n\n\n@each $color, $value in $colors {\n\t@include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@each $color, $value in $theme-colors {\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n@each $color, $value in $colors {\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n\n// Background colors with transparency\n\n@each $color, $value in $theme-colors {\n    @include bg-translucent-variant(\".bg-translucent-#{$color}\", $value);\n}\n\n\n// Sections backgrounds\n\n@each $color, $value in $section-colors {\n    @include bg-variant(\".section-#{$color}\", $value);\n}\n\n@each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n\n// Shape (svg) fill colors\n\n@each $color, $value in $theme-colors {\n    .fill-#{$color}  {\n        fill: $value;\n    }\n\n    .stroke-#{$color}  {\n        stroke: $value;\n    }\n}\n\n.fill-opacity-8 {\n\tfill-opacity: .8;\n}\n","//\n// Floating\n// floating animation utility class\n//\n\n\n.floating {\n\tanimation: floating 3s ease infinite;\n\twill-change: transform;\n\n\t&:hover {\n        animation-play-state: paused;\n    }\n}\n\n\n// Size variations\n\n.floating-lg {\n\tanimation: floating-lg 3s ease infinite;\n}\n\n.floating-sm {\n\tanimation: floating-sm 3s ease infinite;\n}\n\n\n// Keyframes\n\n@keyframes floating-lg {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(15px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@keyframes floating {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(10px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@keyframes floating-sm {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(5px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n","//\n// Helper\n// helper classes for different cases\n//\n\n\n// Clearfix for sections that use float property\n\n.floatfix {\n    &:before,\n    &:after {\n        content: '';\n        display: table;\n    }\n    &:after {\n        clear: both;\n    }\n}\n","//\n// Image\n//\n\n.img-center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n","//\n// Opacity\n// modify the transparency of an element with this quick modifier classes\n//\n\n.opacity-1 {\n    opacity: .1 !important;\n}\n.opacity-2 {\n    opacity: .2 !important;\n}\n.opacity-3 {\n    opacity: .3 !important;\n}\n.opacity-4 {\n    opacity: .4 !important;\n}\n.opacity-5 {\n    opacity: .5 !important;\n}\n.opacity-6 {\n    opacity: .6 !important;\n}\n.opacity-7 {\n    opacity: .7 !important;\n}\n.opacity-8 {\n    opacity: .8 !important;\n}\n.opacity-8 {\n    opacity: .9 !important;\n}\n.opacity-10 {\n    opacity: 1 !important;\n}\n","//\n// Overflow\n//\n\n.overflow-visible {\n    overflow: visible !important;\n}\n\n.overflow-hidden {\n    overflow: hidden !important;\n}\n","//\n// Position\n// modifier classes to be applied on an abosolute positioned element\n// use it next to .position-absolute class\n//\n\n@each $size, $value in $spacers {\n\t.top-#{$size} {\n\t\ttop: $value;\n\t}\n\t.right-#{$size} {\n\t\tright: $value;\n\t}\n\t.bottom-#{$size} {\n\t\tbottom: $value;\n\t}\n\t.left-#{$size} {\n\t\tleft: $value;\n\t}\n}\n\n.center {\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n","//\n// Height\n//\n\n.h-100vh {\n\theight: 100vh !important;\n}\n","//\n// Spacing\n//\n\n.row.row-grid > [class*=\"col-\"] + [class*=\"col-\"] {\n    margin-top: 3rem;\n}\n\n@include media-breakpoint-up(lg) {\n    .row.row-grid > [class*=\"col-lg-\"] + [class*=\"col-lg-\"] {\n        margin-top: 0;\n    }\n}\n@include media-breakpoint-up(md) {\n    .row.row-grid > [class*=\"col-md-\"] + [class*=\"col-md-\"] {\n        margin-top: 0;\n    }\n}\n@include media-breakpoint-up(sm) {\n    .row.row-grid > [class*=\"col-sm-\"] + [class*=\"col-sm-\"] {\n        margin-top: 0;\n    }\n}\n\n.row-grid + .row-grid {\n    margin-top: 3rem;\n}\n\n\n// Negative margins and paddings\n\n@media(min-width: 992px) {\n    [class*=\"mt--\"],\n    [class*=\"mr--\"],\n    [class*=\"mb--\"],\n    [class*=\"ml--\"] {\n        \n    }\n\n\n    // Large negative margins in pixels\n\n    .mt--100 {\n        margin-top: -100px !important;\n    }\n    .mr--100 {\n        margin-right: -100px !important;\n    }\n    .mb--100 {\n        margin-bottom: -100px !important;\n    }\n    .ml--100 {\n        margin-left: -100px !important;\n    }\n    .mt--150 {\n        margin-top: -150px !important;\n    }\n    .mb--150 {\n        margin-bottom: -150px !important;\n    }\n    .mt--200 {\n        margin-top: -200px !important;\n    }\n    .mb--200 {\n        margin-bottom: -200px !important;\n    }\n    .mt--300 {\n        margin-top: -300px !important;\n    }\n    .mb--300 {\n        margin-bottom: -300px !important;\n    }\n\n\n    // Large margins in pixels\n\n    .pt-100 {\n        padding-top: 100px !important;\n    }\n    .pb-100 {\n        padding-bottom: 100px !important;\n    }\n    .pt-150 {\n        padding-top: 150px !important;\n    }\n    .pb-150 {\n        padding-bottom: 150px !important;\n    }\n    .pt-200 {\n        padding-top: 200px !important;\n    }\n    .pb-200 {\n        padding-bottom: 200px !important;\n    }\n    .pt-250 {\n        padding-top: 250px !important;\n    }\n    .pb-250 {\n        padding-bottom: 250px !important;\n    }\n    .pt-300 {\n        padding-top: 300px!important;\n    }\n    .pb-300 {\n        padding-bottom: 300px!important;\n    }\n}\n","//\n// Shadows\n//\n\n// General styles\n[class*=\"shadow\"] {\n\t@if $enable-transitions {\n        transition: $transition-base;\n    }\n}\n\n\n// Size variations\n.shadow-sm--hover:hover {\n\tbox-shadow: $box-shadow-sm !important;\n}\n\n.shadow--hover:hover {\n\tbox-shadow: $box-shadow !important;\n}\n\n.shadow-lg--hover:hover {\n\tbox-shadow: $box-shadow-lg !important;\n}\n\n.shadow-none--hover:hover {\n\tbox-shadow: none !important;\n}\n","// Weight and italics\n\n.font-weight-300 { font-weight: 300 !important; }\n.font-weight-400 { font-weight: 400 !important; }\n.font-weight-500 { font-weight: 500 !important; }\n.font-weight-600 { font-weight: 600 !important; }\n.font-weight-700 { font-weight: 700 !important; }\n.font-weight-800 { font-weight: 800 !important; }\n.font-weight-900 { font-weight: 900 !important; }\n\n\n// Text decorations\n\n.text-underline { text-decoration: underline; }\n.text-through { text-decoration: line-through; }\n\n\n// Text size\n\n.text-xs { font-size: $font-size-xs !important; }\n.text-sm { font-size: $font-size-sm !important; }\n.text-lg { font-size: $font-size-lg !important; }\n.text-xl { font-size: $font-size-xl !important; }\n\n\n// Line heights\n\n.lh-100 { line-height: 1; }\n.lh-110 { line-height: 1.1; }\n.lh-120 { line-height: 1.2; }\n.lh-130 { line-height: 1.3; }\n.lh-140 { line-height: 1.4; }\n.lh-150 { line-height: 1.5; }\n.lh-160 { line-height: 1.6; }\n.lh-170 { line-height: 1.7; }\n.lh-180 { line-height: 1.8; }\n\n\n// Letter spacings\n\n.ls-1 { letter-spacing: .0625rem; }\n.ls-15 { letter-spacing: .09375rem; }\n.ls-2 { letter-spacing: 0.125rem; }\n\n// Color variations\n\n@each $color, $value in $colors {\n\t@include text-emphasis-variant(\".text-#{$color}\", $value, $ignore-warning: true);\n}\n","//\n// Tranform\n//\n\n\n@include media-breakpoint-up(lg) {\n\t.transform-perspective-right {\n\t\ttransform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\n\t}\n\t.transform-perspective-left{\n\t\ttransform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg)\n\t}\n}\n","//\n// Alert\n//\n\n.alert {\n    font-size: $font-size-sm;\n}\n\n// Alert heading\n\n.alert-heading {\n    font-weight: $font-weight-bold;\n    font-size: $h4-font-size;\n    margin-top: .15rem;\n}\n\n\n// Alert icon\n.alert-icon {\n    font-size: 1.25rem;\n    margin-right: 1.25rem;\n    display: inline-block;\n    vertical-align: middle;\n\n    i.ni {\n        position: relative;\n        top: 1px;\n    }\n}\n\n\n// Alert text next to an alert icon\n.alert-text {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n\n// Alert links\n\n[class*=\"alert-\"] {\n    .alert-link {\n        color: $white;\n        border-bottom: 1px dotted rgba($white, .5);\n    }\n}\n","//\n// Dismissible alert\n//\n\n.alert-dismissible {\n    .close {\n        top: 50%;\n        right: $alert-padding-x;\n        padding: 0;\n        transform: translateY(-50%);\n        color: rgba($white, .6);\n        opacity: 1;\n\n        &:hover,\n        &:focus {\n            color: rgba($white, .9);\n            opacity: 1 !important;\n        }\n\n        @include media-breakpoint-down(xs) {\n            top: 1rem;\n            right: .5rem;\n        }\n\n        &>span:not(.sr-only) {\n            font-size: 1.5rem;\n            background-color: transparent;\n            color: rgba($white, .6);\n        }\n\n        &:hover,\n        &:focus {\n            &>span:not(.sr-only) {\n                background-color: transparent;\n                color: rgba($white, .9);\n            }\n        }\n    }\n}\n","//\n// Avatar\n//\n\n// General styles\n\n.avatar {\n\tcolor: $white;\n\tbackground-color: $gray-500;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 1rem;\n\tborder-radius: 50%;\n\theight: 48px;\n\twidth: 48px;\n\n    img {\n    \twidth: 100%;\n    \tborder-radius: 50%;\n    }\n\n    + .avatar-content {\n    \tdisplay: inline-block;\n    \tmargin-left: .75rem;\n    }\n}\n\n\n// Avatar size variations\n\n.avatar-lg {\n\twidth: 58px;\n\theight: 58px;\n\tfont-size: $font-size-sm;\n}\n\n.avatar-sm {\n\twidth: 36px;\n\theight: 36px;\n\tfont-size: $font-size-sm;\n}\n","//\n// Avatar group\n//\n\n// General styles\n\n.avatar-group {\n\t.avatar {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tborder: 2px solid $card-bg;\n\n\t\t&:hover {\n\t\t\tz-index: 3;\n\t\t}\n\t}\n\n\t.avatar + .avatar {\n\t\tmargin-left: -1rem;\n\n\t}\n}\n","//\n// Badge\n//\n\n\n// General styles\n\n.badge {\n    text-transform: $badge-text-transfom;\n\n    a {\n        color: $white;\n    }\n}\n\n\n// Size variations\n\n.badge-md {\n    padding: .65em 1em;\n}\n\n.badge-lg {\n    padding: .85em 1.375em;\n}\n\n\n// Multiple inline badges\n\n.badge-inline {\n    margin-right: .625rem;\n\n    + span {\n        top: 2px;\n        position: relative;\n\n        > a {\n            text-decoration: underline;\n        }\n    }\n}\n\n\n// Badge spacing inside a btn with some text\n\n.btn {\n    .badge {\n        &:not(:first-child) {\n            margin-left: .5rem;\n        }\n        &:not(:last-child) {\n            margin-right: .5rem;\n        }\n    }\n}\n","//\n// Circle badge\n//\n\n\n// General styles\n\n.badge-circle {\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    width: 2rem;\n    height: 2rem;\n    font-size: .875rem;\n}\n","//\n// Dot badge\n//\n\n\n// General styles\n\n.badge-dot {\n    padding-left: 0;\n    padding-right: 0;\n    background: transparent;\n    font-weight: $font-weight-normal;\n    font-size: $font-size-sm;\n    text-transform: none;\n\n    strong {\n        color: $gray-800;\n    }\n\n    i {\n        display: inline-block;\n        vertical-align: middle;\n        width: .375rem;\n        height: .375rem;\n        border-radius: 50%;\n        margin-right: .375rem;\n    }\n\n    &.badge-md {\n        i {\n            width: .5rem;\n            height: .5rem;\n        }\n    }\n\n    &.badge-lg {\n        i {\n            width: .625rem;\n            height: .625rem;\n        }\n    }\n}\n","//\n// Icon buttons\n//\n\n// General styles\n\n.btn {\n   position: relative;\n   text-transform: $btn-text-transform;\n   transition: $transition-base;\n   letter-spacing: $btn-letter-spacing;\n   font-size: $input-btn-font-size;\n   will-change: transform;\n\n   &:hover {\n      @include box-shadow($btn-hover-box-shadow);\n      transform: translateY($btn-hover-translate-y);\n   }\n\n   &:not(:last-child) {\n      margin-right: .5rem;\n   }\n\n\n   // Icons\n\n   i:not(:first-child),\n   svg:not(:first-child) {\n      margin-left: .5rem;\n   }\n\n   i:not(:last-child),\n   svg:not(:last-child) {\n      margin-right: .5rem;\n   }\n}\n\n\n// Remove translateY and margin animation when btn is included in a btn-group or input-group\n\n.btn-group,\n.input-group {\n   .btn {\n      margin-right: 0;\n      transform: translateY(0);\n   }\n}\n\n\n// Size variations\n\n.btn-sm {\n   font-size: $input-btn-font-size-sm;\n}\n\n.btn-lg {\n   font-size: $input-btn-font-size-lg;\n}\n\n\n// Some quick fixes (to revise)\n\n// Fixes\n[class*=\"btn-outline-\"] {\n   border-width: 1px;\n}\n\n.btn-outline-secondary {\n   color: darken(theme-color(\"secondary\"), 50%);\n}\n\n.btn-inner--icon {\n   i:not(.fa) {\n      position: relative;\n      top: 2px;\n   }\n}\n\n.btn-link {\n   font-weight: $btn-font-weight;\n   box-shadow: none;\n\n   &:hover {\n      box-shadow: none;\n      transform: none;\n   }\n}\n\n.btn-neutral {\n   color: theme-color(\"primary\");\n}\n","//\n// Icon buttons\n//\n\n.btn-icon {\n    .btn-inner--icon {\n        img {\n            width: 20px;\n        }\n   }\n\n   .btn-inner--text:not(:first-child) {\n       margin-left: 0.75em;\n   }\n\n   .btn-inner--text:not(:last-child) {\n       margin-right: 0.75em;\n   }\n}\n\n\n// Button only with icon and NO text\n\n.btn-icon-only {\n    width: 2.375rem;\n    height: 2.375rem;\n    padding: 0;\n}\n\na.btn-icon-only {\n    line-height: 2.5;\n}\n\n.btn-icon-only.btn-sm {\n    width: 2rem;\n    height: 2rem;\n}\n\n\n//\n// Clipboard button\n// dedicated element for copying icons\n//\n\n.btn-icon-clipboard {\n    margin: 0;\n    padding: 1.5rem;\n    font-size: $font-size-base;\n    font-weight: $font-weight-normal;\n    line-height: 1.25;\n    color: $gray-800;\n    background-color: $gray-100;\n    border-radius: $border-radius;\n    border: 0;\n    text-align: left;\n    font-family: inherit;\n    display: inline-block;\n    vertical-align: middle;\n    text-decoration: none;\n    -moz-appearance: none;\n    cursor: pointer;\n    width: 100%;\n    margin: .5rem 0;\n\n    &:hover {\n        background-color: $white;\n        box-shadow: rgba(0, 0, 0, .1) 0 0 0 1px, rgba(0, 0, 0, .1) 0 4px 16px;\n    }\n\n    > div {\n        align-items: center;\n        display: flex;\n    }\n\n    i {\n        box-sizing: content-box;\n        color: theme-color(\"primary\");\n        vertical-align: middle;\n        font-size: 1.5rem;\n    }\n\n    span {\n        display: inline-block;\n        font-size: 0.875rem;\n        line-height: 1.5;\n        margin-left: 16px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        vertical-align: middle;\n    }\n}\n","//\n// Brand buttons\n//\n\n\n// Color variations\n\n@each $color, $value in $brand-colors {\n    .btn-#{$color} {\n        @include button-variant($value, $value);\n    }\n}\n","//\n// Card\n//\n\n\n.card-translucent {\n    background-color: rgba(18, 91, 152, 0.08);\n}\n","//\n// Profile card\n//\n\n.card-profile-image {\n    position: relative;\n\n    img {\n        max-width: 180px;\n        border-radius: $border-radius;\n        @extend .shadow;\n        transform: translate(-50%,-30%);\n        position: absolute;\n        left: 50%;\n        transition: $transition-base;\n\n        &:hover {\n            transform: translate(-50%, -33%);\n        }\n    }\n}\n\n.card-profile-stats {\n    padding: 1rem 0;\n\n    > div {\n        text-align: center;\n        margin-right: 1rem;\n        padding: .875rem;\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        .heading {\n            font-size: 1.1rem;\n            font-weight: bold;\n            display: block;\n        }\n        .description {\n            font-size: .875rem;\n            color: $gray-500;\n        }\n    }\n}\n\n.card-profile-actions {\n    padding: .875rem;\n}\n","//\n// Card with hover animations\n//\n\n.card-lift--hover {\n    &:hover {\n        transform: translateY(-20px);\n        @include transition($transition-base);\n    }\n}\n","//\n// Card stats\n//\n\n.card-stats {\n    .card-body {\n        padding: 1rem 1.5rem;\n    }\n\n    .card-status-bullet {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(50%, -50%);\n    }\n}\n","//\n// Chart\n//\n\n.chart {\n    position: relative;\n    height: $chart-height;\n}\n\n\n// Size variations\n\n.chart-sm {\n    height: $chart-height-sm;\n}\n\n\n// Legend\n\n.chart-legend {\n    display: flex;\n    justify-content: center;\n    margin-top: $chart-legend-margin-top;\n    font-size: $chart-legend-font-size;\n    text-align: center;\n    color: $chart-legend-color;\n}\n\n.chart-legend-item {\n    display: inline-flex;\n    align-items: center;\n\n    + .chart-legend-item {\n        margin-left: 1rem;\n    }\n}\n\n.chart-legend-indicator {\n    display: inline-block;\n    width: 0.5rem;\n    height: 0.5rem;\n    margin-right: 0.375rem;\n    border-radius: 50%;\n}\n\n\n// Tooltip\n\n#chart-tooltip {\n    z-index: 0;\n\n    .arrow {\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%) translateX(-.5rem);\n    }\n}\n\n\n// Chart info overlay\n\n.chart-info-overlay {\n  position: absolute;\n  top: 0;\n  left: 5%;\n  max-width: 350px;\n  padding: 20px;\n  z-index: 1;\n}\n","//\n// Close\n//\n\n.close {\n    @if $enable-transitions {\n        transition: $transition-base;\n    }\n    \n    &>span:not(.sr-only) {\n        background-color: $close-bg;\n        color: $close-color;\n        line-height: 17px;\n        height: 1.25rem;\n        width: 1.25rem;\n        border-radius: 50%;\n        font-size: 1.25rem;\n        display: block;\n        @if $enable-transitions {\n            transition: $transition-base;\n        }\n    }\n\n    &:hover,\n    &:focus {\n        background-color: $close-hover-bg;\n        color: $close-hover-color;\n        outline: none;\n\n        span:not(.sr-only) {\n            background-color: $close-hover-bg;\n        }\n    }\n}\n",".main-content {\n    position: relative;\n\n    // Navbar\n    .navbar-top {\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        z-index: 1;\n        background-color: transparent;\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n\n    // Container\n    .container-fluid {\n        @include media-breakpoint-up(md) {\n            padding-left: ($main-content-padding-x + calc($grid-gutter-width / 2)) !important;\n            padding-right: ($main-content-padding-x + calc($grid-gutter-width / 2)) !important;\n        }\n    }\n}\n\n\n// Offsets the main content depending on the sidebar positioning\n\n.navbar-vertical.navbar-expand {\n\n    @each $breakpoint,\n    $dimension in $grid-breakpoints {\n\n        &-#{$breakpoint} {\n\n            @include media-breakpoint-up(#{$breakpoint}) {\n\n                // Left\n                &.fixed-left + .main-content {\n                    margin-left: $navbar-vertical-width;\n                } // Right\n                &.fixed-right + .main-content {\n                    margin-right: $navbar-vertical-width;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom checkbox\n//\n\n.custom-checkbox {\n    .custom-control-input ~ .custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-checkbox-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom control\n// additional styles for custom checkboxes, radios and other\n//\n\n.custom-control-label {\n    // Background-color and (when enabled) gradient\n    &::before {\n        border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n        @if $enable-transitions {\n            transition: $input-transition;\n        }\n    }\n\n    span {\n        position: relative;\n        top: 2px;\n    }\n}\n\n.custom-control-label {\n    margin-bottom: 0;\n}\n\n\n// Alternative style\n\n.custom-control-alternative {\n    .custom-control-label {\n        // Background-color and (when enabled) gradient\n        &::before {\n            border: 0;\n            box-shadow: $input-alternative-box-shadow;\n        }\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    box-shadow: $input-focus-alternative-box-shadow;\n                }\n            }\n        }\n\n        &:active~.custom-control-label::before,\n        &:focus~.custom-control-label::before {\n            box-shadow: $input-alternative-box-shadow;\n        }\n    }\n}\n","//\n// Custom checkbox\n//\n\n.custom-checkbox {\n    .custom-control-input ~ .custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-checkbox-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom radio\n//\n\n.custom-radio {\n    .custom-control-input ~ .custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-radio-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom toggle\n//\n\n.custom-toggle {\n    position: relative;\n    display: inline-block;\n    width: $custom-toggle-width;\n    height: 1.5rem;\n\n    input {\n        display: none;\n\n        &:checked {\n             + .custom-toggle-slider {\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-checked-border-color;\n\n                &:before {\n                    background: $custom-toggle-checked-bg;\n                    transform: translateX(1.625rem);\n                }\n            }\n        }\n\n        &:disabled {\n            + .custom-toggle-slider {\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\n            }\n\n            &:checked {\n                + .custom-toggle-slider {\n                    border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\n\n                    &:before {\n                        background-color: lighten($custom-control-indicator-checked-bg, 10%);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.custom-toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: $custom-control-indicator-border-width solid $input-border-color;\n    border-radius: 34px !important;\n    background-color: transparent;\n\n\n    &:before {\n        position: absolute;\n        content: \"\";\n        height: 18px;\n        width: 18px;\n        left: 2px;\n        bottom: 2px;\n        border-radius: 50% !important;\n        background-color: $custom-toggle-slider-bg;\n        transition: $input-transition;\n    }\n}\n","//\n// Dropdown\n//\n\n// General styles\n\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n    display: inline-block;\n}\n\n.dropdown-menu {\n    min-width: 12rem;\n\n    .dropdown-item {\n        padding: .5rem 1rem;\n        font-size: $font-size-sm;\n        > i,\n        > svg {\n            margin-right: 1rem;\n            font-size: 1rem;\n            vertical-align: -17%;\n        }\n    }\n}\n\n.dropdown-header {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: $gray-100;\n    font-size: .625rem;\n    text-transform: uppercase;\n    font-weight: 700;\n}\n\n\n// Media components inside dropdown link\n\n.dropdown-menu {\n    a.media {\n\n        > div {\n            &:first-child {\n                line-height: 1;\n            }\n        }\n\n        p {\n            color: $gray-600;\n        }\n\n        &:hover {\n            .heading,\n            p {\n                color: theme-color(\"default\") !important;\n            }\n        }\n    }\n}\n\n\n// Size variations\n\n.dropdown-menu-sm {\n    min-width: 100px;\n    border: $border-radius-lg;\n}\n\n.dropdown-menu-lg {\n    min-width: 260px;\n    border-radius: $border-radius-lg;\n}\n\n.dropdown-menu-xl {\n    min-width: 450px;\n    border-radius: $border-radius-lg;\n}\n","//\n// Footer\n//\n\n\n// General styles\n\n.footer {\n    background: $footer-bg;\n    padding: $footer-padding-y $footer-padding-x;\n\n    .col-footer {\n        .heading {\n            color: $footer-heading-color;\n            letter-spacing: 0;\n            font-size: $footer-heading-font-size;\n            text-transform: uppercase;\n            font-weight: $font-weight-bold;\n            margin-bottom: 1rem;\n        }\n    }\n\n    .nav .nav-item .nav-link,\n    .footer-link {\n        color: $footer-link-color !important;\n\n        &:hover {\n            color: $footer-link-hover-color !important;\n        }\n    }\n\n    .list-unstyled li a {\n        display: inline-block;\n        padding: .125rem 0;\n        color: $footer-link-color;\n        font-size: $footer-link-font-size;\n\n        &:hover {\n            color: $footer-link-hover-color;\n        }\n    }\n\n    .copyright {\n        font-size: $font-size-sm;\n    }\n}\n\n\n// Dark footer\n\n.footer-dark {\n    .col-footer .heading {\n        color: $white;\n    }\n}\n\n\n// Footer nav used for copyright and some links, but not limited to this\n\n.nav-footer {\n    .nav-link {\n        font-size: $font-size-sm;\n    }\n\n    .nav-item:last-child {\n        .nav-link {\n            padding-right: 0;\n        }\n    }\n}\n\n\n// Footer with cards over\n\n.footer.has-cards {\n    overflow: hidden;\n    padding-top: 500px;\n    margin-top: -420px;\n    position: relative;\n    background: transparent;\n    pointer-events: none;\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 600px;\n        height: 2000px;\n        background: theme-color(\"secondary\");\n        transform: skew(0,-8deg);\n    }\n\n    .container {\n        pointer-events: auto;\n        position: relative;\n    }\n}\n","//\n// Forms\n//\n\n\n// Labels\n\n.form-control-label {\n    color: $gray-700;\n    font-size: $font-size-sm;\n    font-weight: $font-weight-bold;\n}\n\n\n// Text inputs\n\n.form-control {\n    font-size: $input-btn-font-size;\n\n    &:focus {\n        &::placeholder {\n            color: $input-focus-placeholder-color;\n        }\n    }\n}\n\n\n// Textarea\n\ntextarea[resize=\"none\"] {\n    resize: none!important;\n}\n\ntextarea[resize=\"both\"] {\n    resize: both!important;\n}\n\ntextarea[resize=\"vertical\"] {\n    resize: vertical!important;\n}\n\ntextarea[resize=\"horizontal\"] {\n    resize: horizontal!important;\n}\n\n\n// Form input variations\n\n// Muted input\n\n.form-control-muted {\n    background-color: $input-muted-bg;\n    border-color: $input-muted-bg;\n    box-shadow: none;\n\n    &:focus {\n        background-color: $input-focus-muted-bg;\n    }\n}\n\n\n// Alternative input\n\n.form-control-alternative {\n    box-shadow: $input-alternative-box-shadow;\n    border: 0;\n    transition: box-shadow .15s ease;\n\n    &:focus {\n        box-shadow: $input-focus-alternative-box-shadow;\n    }\n}\n\n// Size variations: Fixes to the bootstrap defaults\n\n.form-control-lg {\n    font-size: $font-size-base;\n}\n","//\n// Form validation\n//\n\n// Validation\n\n.has-success,\n.has-danger {\n    position: relative;\n\n    &:after, {\n        width: 19px;\n        height: 19px;\n        line-height: 19px;\n        text-align: center;\n        font-family: 'NucleoIcons';\n        display: inline-block;\n        position: absolute;\n        right: 15px;\n        top: 2px;\n        transform: translateY(50%);\n        border-radius: 50%;\n        font-size: 9px;\n        opacity: 1;\n    }\n}\n\n.has-success {\n    &:after {\n        content: \"\\ea26\";\n        color: daken($form-feedback-valid-color, 18%);\n        background-color: $form-feedback-valid-bg;\n    }\n    \n    .form-control {\n        background-color: $input-focus-bg;\n\n        &:focus {\n            border-color: $input-focus-border-color;\n        }\n\n\n        // Placeholder\n\n        &::placeholder {\n            color: $form-feedback-valid-color;\n        }\n    }\n}\n\n.has-danger {\n    &:after {\n        content: \"\\ea53\";\n        color: daken($form-feedback-invalid-color, 18%);\n        background-color: $form-feedback-invalid-bg;\n    }\n\n    .form-control {\n        background-color: $input-focus-bg;\n\n        &:focus {\n            border-color: $input-focus-border-color;\n        }\n\n        // Placeholder\n\n        &::placeholder {\n            color: $form-feedback-invalid-color;\n        }\n    }\n}\n","//\n// Input group\n//\n\n.input-group {\n\tbox-shadow: $input-box-shadow;\n\tborder-radius: $input-border-radius;\n\ttransition: $transition-base;\n\n\t.form-control {\n\t\tbox-shadow: none;\n\n\t\t&:not(:first-child) {\n\t\t    border-left: 0;\n\t\t    padding-left: 0;\n\t\t}\n\t\t&:not(:last-child) {\n\t\t\tborder-right: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n}\n\n.input-group-text {\n    transition: $input-transition;\n}\n\n\n// Alternative input groups related to .form-control-alternative\n\n\n.input-group-alternative {\n    box-shadow: $input-alternative-box-shadow;\n    border: 0;\n    transition: box-shadow .15s ease;\n\n    .form-control,\n    .input-group-text {\n        border: 0;\n        box-shadow: none;\n    }\n}\n\n.focused {\n\t.input-group-alternative {\n        box-shadow: $input-focus-alternative-box-shadow !important;\n    }\n}\n\n\n// .focus class is applied dinamycally from theme.js\n\n.focused {\n\t.input-group {\n\t\tbox-shadow: $input-focus-box-shadow;\n\t}\n\n\t.input-group-text {\n\t    color: $input-group-addon-focus-color;\n\t    background-color: $input-group-addon-focus-bg;\n\t    border-color: $input-group-addon-focus-border-color;\n\t}\n\n\t.form-control {\n\t\tborder-color: $input-group-addon-focus-border-color;\n\t}\n}\n","//\n// Header\n//\n\n.header {\n    position: relative;\n}\n","//\n// Icon\n//\n\n.icon {\n\twidth: $icon-size;\n\theight: $icon-size;\n\n\ti, svg {\n\t\tfont-size: $icon-size - .75;\n\t}\n\n    + .icon-text {\n    \tpadding-left: 1rem;\n    \twidth: calc(100% - #{$icon-size} - 1);\n    }\n}\n\n\n// Extra large icons\n\n.icon-xl {\n\twidth: $icon-size-xl;\n\theight: $icon-size-xl;\n\n\ti, svg {\n\t\tfont-size: $icon-size-xl - .75;\n\t}\n\n    + .icon-text {\n    \twidth: calc(100% - #{$icon-size-xl} - 1);\n    }\n}\n\n\n// Large icons\n\n.icon-lg {\n\twidth: $icon-size-lg;\n\theight: $icon-size-lg;\n\n\ti, svg {\n\t\tfont-size: $icon-size-lg - .75;\n\t}\n\n    + .icon-text {\n    \twidth: calc(100% - #{$icon-size-lg} - 1);\n    }\n}\n\n\n// Small icon\n\n.icon-sm {\n\twidth: $icon-size-sm;\n\theight: $icon-size-sm;\n\n\ti, svg {\n\t\tfont-size: $icon-size-sm - .75;\n\t}\n\n    + .icon-text {\n    \twidth: calc(100% - #{$icon-size-sm} - 1);\n    }\n}\n","//\n// Icon shape\n//\n\n\n.icon-shape {\n\tpadding: 12px;\n\ttext-align: center;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\n\n\ti, svg {\n\t\tfont-size: 1.25rem;\n\t}\n\n\t&.icon-lg {\n\t\ti, svg {\n\t\t\tfont-size: 1.625rem;\n\t\t}\n\t}\n\n\t&.icon-sm {\n\t\ti, svg {\n\t\t\tfont-size: .875rem;\n\t\t}\n\t}\n\n\tsvg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\n}\n\n@each $color, $value in $theme-colors {\n\t.icon-shape-#{$color} {\n\t\t@include icon-shape-variant(theme-color($color));\n\t}\n}\n","@mixin icon-shape-variant($color) {\n    color: saturate(darken($color, 10%), 10);\n    background-color: transparentize(lighten($color, 10%), .5);\n}","//\n// List group\n//\n\n\n// Space list items\n\n.list-group-space {\n    .list-group-item {\n        margin-bottom: 1.5rem;\n        @include border-radius($list-group-border-radius);\n    }\n}\n\n\n// Extended list group components\n\n.list-group-img {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 50%;\n    vertical-align: top;\n    margin: -.1rem 1.2rem 0 -.2rem;\n}\n\n.list-group-content {\n    flex: 1;\n    min-width: 0;\n\n    > p {\n       color: $gray-500;\n       line-height: 1.5;\n       margin: .2rem 0 0;\n   }\n}\n\n.list-group-heading {\n    font-size: $font-size-base;\n    color: $gray-800;\n\n    > small {\n       float: right;\n       color: $gray-500;\n       font-weight: 500;\n   }\n}\n","//\n// Map\n//\n\n.map-canvas {\n    position: relative;\n    width: 100%;\n    height: $map-height;\n    border-radius: $border-radius;\n}\n","//\n// Mask\n//\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    @include transition($transition-base);\n}\n","//\n// Modal\n//\n\n\n// Fluid modal\n\n.modal-fluid {\n    .modal-dialog {\n        margin-top: 0;\n        margin-bottom: 0;\n    }\n    .modal-content {\n        border-radius: 0;\n    }\n}\n\n\n// Background color variations\n\n@each $color, $value in $theme-colors {\n    .modal-#{$color} {\n        @include modal-variant($value);\n    }\n}\n","@mixin modal-variant($background) {\n\t.modal-title {\n\t\tcolor: color-yiq($background);\n\t}\n\t.modal-header,\n\t.modal-footer {\n\t\tborder-color: rgba(color-yiq($background), .075);\n\t}\n\t.modal-content {\n\t\tbackground-color: $background;\n\t\tcolor: color-yiq($background);\n\n\t\t.heading {\n\t\t\tcolor: color-yiq($background);\n\t\t}\n\t}\n\n\t.close { \n    \t&>span:not(.sr-only) {\n    \t\tcolor: $white;\n    \t}\n    }\n}","//\n// Nav\n//\n\n\n// Nav wrapper (container)\n\n// Nav wrapper\n.nav-wrapper {\n    padding: 1rem 0;\n    @include border-top-radius($card-border-radius);\n\n    + .card {\n        @include border-top-radius(0);\n        @include border-bottom-radius($card-border-radius);\n    }\n}\n\n\n// Nav links\n\n.nav-link {\n    color: $nav-link-color;\n\n    &:hover {\n        color: $nav-link-hover-color;\n    }\n\n    i.ni {\n        position: relative;\n        top: 2px;\n    }\n}\n\n@media (min-width: 992px){\n  .nav-item.active-pro {\n      position: absolute;\n      width: 100%;\n      bottom: 10px;\n      background:  $table-head-bg;\n  }\n}\n","//\n// Nav pills\n//\n\n\n// General styles\n\n.nav-pills {\n    .nav-item:not(:last-child) {\n        padding-right: $nav-pills-space-x;\n    }\n\n    .nav-link {\n    \tpadding: $nav-pills-padding-y $nav-pills-padding-x;\n        color: $nav-pills-link-color;\n        font-weight: 500;\n        font-size: $font-size-sm;\n        box-shadow: $nav-pills-box-shadow;\n        background-color: $nav-pills-bg;\n        transition: $transition-base;\n\n        &:hover {\n        \tcolor: $nav-pills-link-hover-color;\n        }\n    }\n\n    .nav-link.active,\n    .show > .nav-link {\n        color: $nav-pills-link-active-color;\n        background-color: $nav-pills-link-active-bg;\n    }\n\n    @include media-breakpoint-down(xs) {\n        .nav-item {\n            margin-bottom: $spacer;\n        }\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .nav-pills:not(.nav-pills-circle) {\n        .nav-item {\n            padding-right: 0;\n        }\n    }\n}\n\n\n// Rounded circle nav pills\n\n.nav-pills-circle {\n    .nav-link {\n        text-align: center;\n        height: 60px;\n        width: 60px;\n        padding: 0;\n        line-height: 60px;\n        border-radius: 50%;\n    }\n\n    .nav-link-icon {\n        i, svg {\n            font-size: 1rem;\n        }\n    }\n}\n","//\n// Navbar\n//\n\n\n// Navbar links\n\n.navbar-horizontal {\n    .navbar-nav {\n        .nav-link {\n            font-size: $navbar-nav-link-font-size;\n            font-weight: $navbar-nav-link-font-weight;\n            text-transform: $navbar-nav-link-text-transform;\n            letter-spacing: $navbar-nav-link-letter-spacing;\n            @include transition($navbar-transition);\n\n            .nav-link-inner--text {\n                margin-left: .25rem;\n            }\n        }\n    }\n\n\n    // Navbar brand (logo)\n\n    .navbar-brand {\n        font-size: $font-size-sm;\n        font-weight: 600;\n        text-transform: uppercase;\n        font-size: .875rem;\n        letter-spacing: .05px;\n\n        img {\n            height: 30px;\n        }\n    }\n\n    .navbar-dark {\n        .navbar-brand {\n            color: $white;\n        }\n    }\n\n    .navbar-light {\n        .navbar-brand {\n            color: $gray-800;\n        }\n    }\n\n    .navbar-nav {\n      .nav-item {\n        .media:not(:last-child){\n          margin-bottom: 1.5rem;\n        }\n      }\n    }\n\n    @include media-breakpoint-up(lg) {\n        .navbar-nav {\n            .nav-item {\n                margin-right: .5rem;\n\n                [data-toggle=\"dropdown\"]::after {\n                    transition: $transition-base;\n                }\n\n                &.show {\n                    [data-toggle=\"dropdown\"]::after {\n                        transform: rotate(180deg);\n                    }\n                }\n            }\n            .nav-link {\n                padding-top: $navbar-nav-link-padding-y;\n                padding-bottom: $navbar-nav-link-padding-y;\n                border-radius: $navbar-nav-link-border-radius;\n\n                i {\n                    margin-right: .625rem;\n                }\n            }\n\n            .nav-link-icon {\n                padding-left: .5rem !important;\n                padding-right: .5rem !important;\n                font-size: 1rem;\n                border-radius: $navbar-nav-link-border-radius;\n\n                i {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n\n\n    // Transparent navbar\n\n    .navbar-transparent {\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: 100;\n        background-color: transparent;\n        border: 0;\n        box-shadow: none;\n\n        .navbar-brand {\n            color: rgba(255, 255, 255, 1);\n        }\n\n        .navbar-toggler {\n            color: rgba(255, 255, 255, 1);\n        }\n\n        .navbar-toggler-icon {\n            background-image: $navbar-dark-toggler-icon-bg;\n        }\n    }\n\n    @include media-breakpoint-up(md) {\n        .navbar-transparent {\n            .navbar-nav {\n                .nav-link {\n                    color: $navbar-dark-color;\n\n                    @include hover-focus {\n                        color: $navbar-dark-hover-color;\n                    }\n\n                    &.disabled {\n                        color: $navbar-dark-disabled-color;\n                    }\n                }\n\n                .show > .nav-link,\n                .active > .nav-link,\n                .nav-link.show,\n                .nav-link.active {\n                    color: $navbar-dark-active-color;\n                }\n            }\n\n            .navbar-brand {\n                color: $navbar-dark-color;\n\n                @include hover-focus {\n                    color: $navbar-dark-color;\n                }\n            }\n        }\n    }\n}\n","//\n// Vertical navbar\n//\n\n\n// Vertical\n//\n// Creates a vertically aligned version of the navbar\n.navbar-vertical {\n    box-shadow: $navbar-vertical-box-shadow;\n    \n    .navbar {\n        border-width: 0 0 1px 0;\n        border-style: solid;\n    }\n\n\n    // Navbar light\n\n    .navbar-light {\n        background-color: $navbar-light-bg;\n        border-color: $navbar-light-border-color;\n    }\n\n\n    // Navbar brand\n\n    .navbar-brand {\n        margin-right: 0;\n    }\n\n    .navbar-brand-img,\n    .navbar-brand > img {\n        max-width: 100%;\n        max-height: 2rem;\n    }\n\n\n    // Navbar collapse\n\n    @include media-breakpoint-up(md) {\n        .navbar-collapse {\n            margin-left: -$navbar-padding-x;\n            margin-right: -$navbar-padding-x;\n            padding-left: $navbar-padding-x;\n            padding-right: $navbar-padding-x;\n\n            &:before {\n                content: '';\n                display: block;\n                margin: $navbar-padding-y (-$navbar-padding-x);\n            }\n        }\n    }\n\n\n\n    // Navbar navigaton\n\n    .navbar-nav {\n        margin-left: -$navbar-padding-x;\n        margin-right: -$navbar-padding-x;\n\n\n        // Navbar link\n\n        .nav-link {\n            padding-left: $navbar-padding-x;\n            padding-right: $navbar-padding-x;\n            font-size: $navbar-nav-link-font-size;\n\n            &.active {\n                position: relative;\n\n                &:before {\n                    content: '';\n                    position: absolute;\n                    left: 0;\n                    top: $nav-link-padding-y;\n                    bottom: $nav-link-padding-y;\n                    border-left: 2px solid $primary;\n                }\n            }\n\n\n            // Icon\n\n            > i {\n                min-width: $navbar-icon-min-width;\n                font-size: .9375rem;\n                line-height: ($font-size-base * $line-height-base);\n            }\n\n\n            // Dropdown\n\n            .dropdown-menu {\n                border: none;\n\n                .dropdown-menu {\n                    margin-left: calc($dropdown-item-padding-x / 2);\n                }\n            }\n        }\n    }\n\n\n    // Navbar navigation\n    .navbar-nav .nav-link {\n        display: flex;\n        align-items: center;\n    }\n\n    .navbar-nav .nav-link[data-toggle=\"collapse\"] {\n        &:after {\n            display: inline-block;\n            font-style: normal;\n            font-variant: normal;\n            text-rendering: auto;\n            -webkit-font-smoothing: antialiased;\n            font-family: 'Font Awesome 5 Free';\n            font-weight: 700;\n            content: \"\\f105\";\n            margin-left: auto;\n            color: $text-muted;\n            transition: $transition-base;\n        } // Expanded\n        &[aria-expanded=\"true\"] {\n\n            &:after {\n                transform: rotate(90deg);\n            }\n        }\n    }\n\n    // Second level\n    .navbar-nav .nav .nav-link {\n        padding-left: $navbar-padding-x + $navbar-icon-min-width;\n    }\n\n    // Third level\n    .navbar-nav .nav .nav .nav-link {\n        padding-left: $navbar-padding-x * 1.5 + $navbar-icon-min-width;\n    }\n\n\n    // Navbar heading\n    .navbar-heading {\n        padding-top: $nav-link-padding-y;\n        padding-bottom: $nav-link-padding-y;\n        font-size: $font-size-xs;\n        text-transform: uppercase;\n        letter-spacing: .04em;\n    }\n\n\n    // Expanded navbar specific styles\n    &.navbar-expand {\n        @each $breakpoint,\n        $dimension in $grid-breakpoints {\n\n            &-#{$breakpoint} {\n                @include media-breakpoint-up(#{$breakpoint}) {\n                    display: block;\n                    position: fixed;\n                    top: 0;\n                    bottom: 0;\n                    width: 100%;\n                    max-width: $navbar-vertical-width;\n                    padding-left: $navbar-vertical-padding-x;\n                    padding-right: $navbar-vertical-padding-x;\n\n                    overflow-y: auto;\n\n                    // Container\n                    >[class*=\"container\"] {\n                        flex-direction: column;\n                        align-items: stretch;\n                        min-height: 100%;\n                        padding-left: 0;\n                        padding-right: 0; // Target IE 10 & 11\n                        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n                            min-height: none;\n                            height: 100%;\n                        }\n                    }\n\n\n                    // Fixes the vertical navbar to the left\n                    &.fixed-left {\n                        left: 0;\n                        border-width: 0 1px 0 0;\n                    }\n\n\n                    // Fixed the vertical navbar to the right\n                    &.fixed-right {\n                        right: 0;\n                        border-width: 0 0 0 1px;\n                    }\n\n\n                    // Navbar collapse\n                    .navbar-collapse {\n                        flex: 1;\n                        display: flex;\n                        flex-direction: column;\n                        align-items: stretch;\n                        margin-left: -$navbar-vertical-padding-x;\n                        margin-right: -$navbar-vertical-padding-x;\n                        padding-left: $navbar-vertical-padding-x;\n                        padding-right: $navbar-vertical-padding-x;\n\n                        > * {\n                            min-width: 100%;\n                        }\n                    }\n\n\n                    // Navbar navigation\n                    .navbar-nav {\n                        flex-direction: column;\n                        margin-left: -$navbar-vertical-padding-x;\n                        margin-right: -$navbar-vertical-padding-x;\n                    }\n\n                    .navbar-nav .nav-link {\n                        padding: $navbar-vertical-nav-link-padding-y $navbar-vertical-nav-link-padding-x;\n\n                        &.active {\n                            &:before {\n                                top: $nav-link-padding-y;\n                                bottom: $nav-link-padding-y;\n                                left: 0;\n                                right: auto;\n                                border-left: 2px solid $primary;\n                                border-bottom: 0;\n                            }\n                        }\n                    }\n\n\n                    // Second level\n                    .navbar-nav .nav .nav-link {\n                        padding-left: $navbar-vertical-padding-x + $navbar-icon-min-width;\n                    }\n\n\n                    // Third level\n                    .navbar-nav .nav .nav .nav-link {\n                        padding-left: $navbar-vertical-padding-x * 1.5 + $navbar-icon-min-width;\n                    }\n\n                    // Navbar brand\n                    .navbar-brand {\n                        display: block;\n                        text-align: center;\n                        padding-top: (2rem - $navbar-padding-y);\n                        padding-bottom: (2rem - $navbar-padding-y);\n                    }\n\n                    .navbar-brand-img {\n                        max-height: 2.5rem;\n                    }\n\n                    // Navbar user\n                    .navbar-user {\n                        margin-left: -$navbar-vertical-padding-x;\n                        margin-right: -$navbar-vertical-padding-x;\n                        padding-top: $spacer;\n                        padding-bottom: $spacer - $navbar-padding-y;\n                        padding-left: $navbar-vertical-padding-x;\n                        padding-right: $navbar-vertical-padding-x;\n                        border-top: 1px solid $border-color;\n\n                        // Dropup menu\n                        .dropup .dropdown-menu {\n                            left: 50%;\n                            transform: translateX(-50%);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n","//\n// Navbar search\n//\n\n.navbar-search {\n    .input-group {\n        border-radius: $navbar-search-border-radius;\n        border: $navbar-search-border-width solid;\n        background-color: transparent;\n\n        .input-group-text {\n            background-color: transparent;\n            padding-left: 1rem;\n        }\n    }\n\n    .form-control {\n        width: $navbar-search-width;\n        background-color: transparent;\n    }\n}\n\n.navbar-search-dark {\n    .input-group {\n        border-color: $navbar-search-dark-border-color;\n    }\n\n    .input-group-text {\n        color: $navbar-search-dark-color;\n    }\n\n    .form-control {\n        color: $navbar-search-dark-focus-color;\n\n        &::placeholder {\n            color: $navbar-search-dark-color;\n        }\n    }\n\n    .focused {\n        .input-group {\n            border-color: $navbar-search-dark-focus-border-color;\n        }\n    }\n}\n\n.navbar-search-light {\n    .input-group {\n        border-color: $navbar-search-light-border-color;\n    }\n\n    .input-group-text {\n        color: $navbar-search-light-color;\n    }\n\n    .form-control {\n        color: $navbar-search-light-focus-color;\n\n        &::placeholder {\n            color: $navbar-search-light-color;\n        }\n    }\n\n    .focused {\n        .input-group {\n            border-color: $navbar-search-light-focus-border-color;\n        }\n    }\n}\n","// Dropdown menu\n\n@include media-breakpoint-up(md) {\n    .navbar {\n        .dropdown-menu {\n            opacity: 0;\n            pointer-events: none;\n            margin: 0;\n        }\n\n        .dropdown-menu-arrow {\n            &:before {\n                background: $dropdown-bg;\n                box-shadow: none;\n                content: '';\n                display: block;\n                height: 12px;\n                width: 12px;\n                left: 20px;\n                position: absolute;\n                bottom: 100%;\n                transform: rotate(-45deg) translateY(12px);\n                z-index: -5;\n                border-radius: 2px;\n            }\n        }\n\n        .dropdown-menu-right {\n            &:before {\n                right: 20px;\n                left: auto;\n            }\n        }\n\n        &:not(.navbar-nav-hover) {\n            .dropdown-menu {\n                &.show {\n                    opacity: 1;\n                    pointer-events: auto;\n                    animation: show-navbar-dropdown .25s ease forwards;\n                }\n\n                &.close {\n                    display: block;\n                    animation: hide-navbar-dropdown .15s ease backwards;\n                }\n            }\n        }\n\n        &.navbar-nav-hover {\n            .dropdown-menu {\n                opacity: 0;\n                display: block;\n                pointer-events: none;\n                transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n                transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n            }\n\n            .nav-item.dropdown:hover > .dropdown-menu {\n                display: block;\n                opacity: 1;\n                pointer-events: auto;\n                visibility: visible;\n                transform: translate(0, 0);\n                animation: none;\n            }\n        }\n\n        .dropdown-menu-inner {\n            position: relative;\n            padding: 1rem;\n        }\n\n\n        // Keyframes\n\n        @keyframes show-navbar-dropdown {\n            0% {\n                opacity: 0;\n                transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n                transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n            }\n\n            100% {\n                transform: translate(0, 0);\n                opacity: 1;\n            }\n        }\n\n        @keyframes hide-navbar-dropdown {\n            from {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n                transform: translate(0, 10px);\n            }\n        }\n    }\n}\n","//\n// Navabar collapse\n//\n\n// Collapse\n\n.navbar-collapse-header {\n    display: none;\n}\n\n@include media-breakpoint-down(sm) {\n    .navbar-nav {\n        .nav-link {\n            padding: .625rem 0;\n            color: theme-color(\"default\") !important;\n        }\n\n        .dropdown-menu {\n            box-shadow: none;\n            min-width: auto;\n\n            .media {\n                svg {\n                    width: 30px;\n                }\n            }\n        }\n    }\n\n    .navbar-collapse {\n        width: calc(100% - 1.4rem);\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 1050;\n        margin: .7rem;\n        overflow-y: auto;\n        height: auto !important;\n        opacity: 0;\n\n        .navbar-toggler {\n            width: 20px;\n            height: 20px;\n            position: relative;\n            cursor: pointer;\n            display: inline-block;\n            padding: 0;\n\n            span {\n                display: block;\n                position: absolute;\n                width: 100%;\n                height: 2px;\n                border-radius: 2px;\n                opacity: 1;\n                background: #283448;\n            }\n\n            :nth-child(1) {\n                transform: rotate(135deg);\n            }\n\n            :nth-child(2) {\n                transform: rotate(-135deg);\n            }\n        }\n\n        .navbar-collapse-header {\n            display: block;\n            padding-bottom: 1rem;\n            margin-bottom: 1rem;\n            border-bottom: 1px solid rgba(0, 0, 0, .1);\n        }\n\n        .collapse-brand {\n            img {\n                height: 36px;\n            }\n        }\n\n        .collapse-close {\n            text-align: right;\n        }\n    }\n\n    .navbar-collapse.collapsing,\n    .navbar-collapse.show {\n        padding: 1.5rem;\n        border-radius: $border-radius;\n        background: #FFF;\n        box-shadow: 0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1);\n        animation: show-navbar-collapse .2s ease forwards;\n    }\n\n    .navbar-collapse.collapsing-out {\n        animation: hide-navbar-collapse .2s ease forwards;\n    }\n}\n\n@keyframes show-navbar-collapse {\n    0% {\n        opacity: 0;\n        transform: scale(.95);\n        transform-origin: 100% 0;\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@keyframes hide-navbar-collapse {\n    from {\n        opacity: 1;\n        transform: scale(1);\n        transform-origin: 100% 0;\n    }\n\n    to {\n        opacity: 0;\n        transform: scale(.95);\n    }\n}\n","//\n// Pagination\n//\n\n\n.page-item {\n    &.active .page-link {\n        box-shadow: $pagination-active-box-shadow;\n    }\n\n    .page-link,\n    span {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0;\n        margin: 0 3px;\n        border-radius: 50% !important;\n        width: 36px;\n\t\theight: 36px;\n\t\tfont-size: $font-size-sm;\n    }\n}\n\n\n// Size variations\n\n.pagination-lg {\n    .page-item {\n        .page-link,\n        span {\n            width: 46px;\n            height: 46px;\n            line-height: 46px;\n        }\n    }\n}\n\n.pagination-sm {\n    .page-item {\n        .page-link,\n        span {\n            width: 30px;\n            height: 30px;\n            line-height: 30px;\n        }\n    }\n}\n","//\n// Popover\n//\n\n\n.popover {\n    border: 0;\n}\n\n.popover-header {\n\tfont-weight: $font-weight-bold;\n}\n\n\n// Alternative colors\n\n@each $color, $value in $theme-colors {\n    .popover-#{$color} {\n        @include popover-variant($value);\n    }\n}\n","@mixin popover-variant($background) {\n\n\tbackground-color: $background;\n\n\t.popover-header {\n\t\tbackground-color: $background;\n\t\tcolor: color-yiq($background);\n\t}\n\n\t.popover-body {\n\t\tcolor: color-yiq($background);\n\t}\n\t.popover-header{\n\t\tborder-color: rgba(color-yiq($background), .2);\n\t}\n\t&.bs-popover-top {\n\t\t.arrow::after {\n\t\t\tborder-top-color: $background;\n\t\t}\n\t}\n\t&.bs-popover-right {\n\t\t.arrow::after {\n\t\t\tborder-right-color: $background;\n\t\t}\n\t}\n\t&.bs-popover-bottom {\n\t\t.arrow::after {\n\t\t\tborder-bottom-color: $background;\n\t\t}\n\t}\n\t&.bs-popover-left {\n\t\t.arrow::after {\n\t\t\tborder-left-color: $background;\n\t\t}\n\t}\n}","//\n// Progress\n//\n\n\n// Progress container\n\n.progress-wrapper {\n    position: relative;\n    padding-top: 1.5rem;\n}\n\n\n// General styles\n\n.progress {\n    height: 8px;\n    margin-bottom: $spacer;\n    overflow: hidden;\n    border-radius: $border-radius-sm;\n    background-color: $progress-bg;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n\n    .sr-only {\n        width: auto;\n        height: 20px;\n        margin: 0 0 0 30px;\n        left: 0;\n        clip: auto;\n        line-height: 20px;\n        font-size: 13px;\n    }\n}\n\n\n// Progress inner elements\n\n.progress-heading {\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0 0 2px;\n    padding: 0;\n}\n\n.progress-bar {\n    box-shadow: none;\n    border-radius: 0;\n    height: auto;\n}\n\n.progress-info{\n    margin-bottom: .5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.progress-label {\n    span {\n        display: inline-block;\n        color: $primary;\n        font-size: .625rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        background: rgba($primary, .1);\n        padding: .25rem 1rem;\n        border-radius: 30px;\n    }\n}\n\n.progress-percentage {\n    text-align: right;\n    span {\n        display: inline-block;\n        color: $gray-600;\n        font-size: .875rem;\n        font-weight: 600;\n    }\n}\n","//\n// Separator\n// add svg on top or bottom of a section for a more stylish visual\n//\n\n\n.separator {\n    position: absolute;\n    top: auto;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 150px;\n    transform: translateZ(0);\n    overflow: hidden;\n    pointer-events: none;\n\n    svg {\n        position: absolute;\n        pointer-events: none;\n    }\n}\n\n.separator-top {\n    top: 0;\n    bottom: auto;\n\n    svg {\n        top: 0;\n    }\n}\n\n.separator-bottom {\n    top: auto;\n    bottom: 0;\n\n    svg {\n        bottom: 0;\n    }\n}\n\n.separator-inverse {\n    transform: rotate(180deg);\n}\n\n// Styles\n\n.separator-skew {\n    height: 60px;\n\n    @include media-breakpoint-up(xl) {\n        height: 70px;\n    }\n}\n","//\n// Table\n//\n\n\n// General styles\n\n.table {\n    thead th {\n        padding-top: $table-head-spacer-y;\n        padding-bottom: $table-head-spacer-y;\n        font-size: $table-head-font-size;\n        text-transform: $table-head-text-transform;\n        letter-spacing: $table-head-letter-spacing;\n        border-bottom: $table-border-width solid $table-border-color;\n    }\n\n    th {\n        font-weight: $table-head-font-weight;\n    }\n\n    td {\n        .progress {\n            height: 3px;\n            width: 120px;\n            margin: 0;\n        }\n    }\n\n    td,\n    th {\n        font-size: $table-body-font-size;\n        white-space: nowrap;\n    }\n\n\n    // Vetical align table content\n\n    &.align-items-center {\n        td,\n        th {\n            vertical-align: middle;\n        }\n    }\n\n\n   // Styles for dark table\n\n   .thead-dark {\n        th {\n            background-color: $table-dark-head-bg;\n            color: $table-dark-head-color;\n        }\n    }\n\n\n    // Styles for light table\n\n    .thead-light {\n        th {\n            background-color: $table-head-bg;\n            color: $table-head-color;\n        }\n    }\n}\n\n\n// Add transition for hover state\n\n.table-hover {\n    tr {\n        @include transition($transition-base);\n    }\n}\n\n\n// Flush tables\n\n.table-flush {\n    td,\n    th {\n        border-left: 0;\n        border-right: 0;\n    }\n\n    tbody {\n        tr {\n            &:first-child {\n                td,\n                th {\n                    border-top: 0;\n                }\n            }\n\n            &:last-child {\n                td,\n                th {\n                    border-bottom: 0;\n                }\n            }\n        }\n    }\n}\n\n\n// Tables inside cards\n\n.card {\n    .table {\n        margin-bottom: 0;\n\n        td,\n        th {\n            padding-left: $card-spacer-x;\n            padding-right: $card-spacer-x;\n        }\n    }\n}\n","//\n// Type\n//\n\n\n// Paragraphs\n\np {\n\tfont-size: $paragraph-font-size;\n\tfont-weight: $paragraph-font-weight;\n\tline-height: $paragraph-line-height;\n}\n\n.lead {\n\tfont-size: $lead-font-size;\n  \tfont-weight: $lead-font-weight;\n\tline-height: $paragraph-line-height;\n\tmargin-top: 1.5rem;\n\n\t+ .btn-wrapper {\n\t\tmargin-top: 3rem;\n\t}\n}\n\n.description {\n\tfont-size: $font-size-sm;\n}\n","//\n// Heading\n//\n\n\n// General styles\n\n.heading {\n\tletter-spacing: $heading-letter-spacing;\n\tfont-size: $heading-font-size;\n\ttext-transform: $heading-text-transform;\n\tfont-weight: $heading-font-weight;\n}\n\n\n// Heading variations\n\n.heading-small {\n\tpadding-top: .25rem;\n\tpadding-bottom: .25rem;\n\tfont-size: .75rem;\n\ttext-transform: uppercase;\n\tletter-spacing: .04em;\n}\n\n.heading-title {\n\tletter-spacing: $heading-title-letter-spacing;\n\tfont-size: $heading-title-font-size;\n\tfont-weight: $heading-title-font-weight;\n\ttext-transform: $heading-title-text-transform;\n}\n\n.heading-section {\n\tletter-spacing: $heading-section-letter-spacing;\n\tfont-size: $heading-section-font-size;\n\tfont-weight: $heading-section-font-weight;\n\ttext-transform: $heading-section-text-transform;\n\n\timg {\n\t\tdisplay: block;\n\t\twidth: 72px;\n\t\theight: 72px;\n\t\tmargin-bottom: 1.5rem;\n\t}\n\n\t&.text-center {\n\t\timg {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n}\n","//\n// Display\n//\n\n\n.display-1,\n.display-2,\n.display-3,\n.display-4 {\n\tspan {\n\t\tdisplay: block;\n\t\tfont-weight: $font-weight-light;\n\t}\n}\n","//\n// Article\n// \n\narticle {\n\th4:not(:first-child),\n\th5:not(:first-child) {\n\t\tmargin-top: 3rem;\n\t}\n\n\th4, h5 {\n\t\tmargin-bottom: 1.5rem;\n\t}\n\n\tfigure {\n\t\tmargin: 3rem 0;\n\t}\n\n\th5 + figure {\n\t\tmargin-top: 0;\n\t}\n}\n","//\n// Bootstrap datepicker\n//\n\n\n.datepicker {\n    border-radius: $datepicker-border-radius;\n\n    &-inline {\n        width: 220px;\n    }\n\n    direction: ltr;\n\n    &-rtl {\n        direction: rtl;\n        &.dropdown-menu {\n            left: auto;\n        }\n        table tr td span {\n            float: right;\n        }\n    }\n\n    &-dropdown {\n        top: 0;\n        left: 0;\n        padding: $datepicker-dropdown-padding;\n        @include box-shadow($dropdown-box-shadow);\n\n        &.datepicker-orient-left:before {\n            left: 6px;\n        }\n        &.datepicker-orient-left:after {\n            left: 7px;\n        }\n        &.datepicker-orient-right:before {\n            right: 6px;\n        }\n        &.datepicker-orient-right:after {\n            right: 7px;\n        }\n        &.datepicker-orient-bottom:before {\n            top: -7px;\n        }\n        &.datepicker-orient-bottom:after {\n            top: -6px;\n        }\n\n        &.datepicker-orient-top:before {\n            bottom: -7px;\n            border-bottom: 0;\n            border-top: 7px solid $datepicker-dropdown-border;\n        }\n\n        &.datepicker-orient-top:after {\n            bottom: -6px;\n            border-bottom: 0;\n            border-top: 6px solid $datepicker-dropdown-bg;\n        }\n    }\n\n    table {\n        margin: 0;\n        -webkit-touch-callout: none;\n        user-select: none;\n\n        tr {\n            td {\n                border-radius: $datepicker-cell-border-radius;\n            }\n\n            th {\n                border-radius: $datepicker-header-cell-border-radius;\n                font-weight: 500;\n            }\n\n            td,\n            th {\n                transition: $datepicker-cell-transition;\n                width: $datepicker-cell-width;\n                height: $datepicker-cell-height;\n                border: none;\n                text-align: center;\n                font-size: $font-size-sm;\n            }\n        }\n    }\n\n    // Inline display inside a table presents some problems with\n    // border and background colors.\n    .table-striped & table tr {\n        td,\n        th {\n            background-color: transparent;\n        }\n    }\n\n    table tr td {\n        &.old,\n        &.new {\n            color: $datepicker-disabled-old-new-color;\n        }\n\n        &.day:hover,\n        &.focused {\n            background: $datepicker-cell-hover-background;\n            cursor: pointer;\n        }\n\n        &.disabled,\n        &.disabled:hover {\n            background: none;\n            color: $datepicker-disabled-cell-color;\n            cursor: default;\n        }\n\n        &.highlighted {\n            border-radius: 0;\n\n            &.focused {\n                background: $datepicker-highlighted-bg\n            }\n\n            &.disabled,\n            &.disabled:active {\n                background: $datepicker-highlighted-bg;\n                color: $gray-400;\n            }\n        }\n\n        &.today {\n            background: lighten($datepicker-active-background, 45%);\n            &.focused {\n                background: lighten($gray-400, 58%);\n            }\n\n            &.disabled,\n            &.disabled:active {\n                background: lighten($gray-400, 58%);\n                color: $btn-link-disabled-color;\n            }\n        }\n\n        // Range selection\n        &.range {\n            background: $datepicker-range-background;\n            color: $datepicker-range-color;\n            border-radius: 0;\n\n            &.focused {\n                background: darken($datepicker-range-cell-focused-background, 3%);\n            }\n\n            &.disabled,\n            &.disabled:active,\n            &.day.disabled:hover {\n                background: darken($datepicker-active-background, 10%);\n                color: lighten($datepicker-active-background, 10%);\n            }\n        }\n\n        &.range.highlighted {\n            &.focused {\n                background: darken($datepicker-range-highlighted-bg, 10%);\n            }\n\n            &.disabled,\n            &.disabled:active {\n                background: $datepicker-range-highlighted-bg;\n                color: $datepicker-disabled-cell-color;\n            }\n        }\n\n        &.range.today {\n            &.disabled,\n            &.disabled:active {\n                background: $blue;\n                color: $white;\n            }\n        }\n\n        &.day.range-start {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n\n        &.day.range-end {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n        &.day.range-start.range-end {\n            border-radius: $datepicker-cell-border-radius;\n        }\n\n        &.selected,\n        &.selected.highlighted,\n        &.selected:hover,\n        &.selected.highlighted:hover,\n        &.day.range:hover {\n            background: $datepicker-active-background;\n            color: $datepicker-active-color;\n        }\n\n        &.active,\n        &.active.highlighted,\n        &.active:hover,\n        &.active.highlighted:hover {\n            background: $datepicker-active-background;\n            color: $datepicker-active-color;\n            box-shadow: $datepicker-active-box-shadow;\n        }\n\n        span {\n            display: block;\n            width: 23%;\n            height: 54px;\n            line-height: 54px;\n            float: left;\n            margin: 1%;\n            cursor: pointer;\n            border-radius: 4px;\n\n            &:hover,\n            &.focused {\n                background: $gray-200;\n            }\n\n            &.disabled,\n            &.disabled:hover {\n                background: none;\n                color: $datepicker-disabled-cell-color;\n                cursor: default;\n            }\n\n            &.active,\n            &.active:hover,\n            &.active.disabled,\n            &.active.disabled:hover {\n                text-shadow: 0 -1px 0 rgba(0, 0, 0, .25);\n            }\n\n            &.old,\n            &.new {\n                color: $btn-link-disabled-color;\n            }\n        }\n    }\n\n    .datepicker-switch {\n        width: 145px;\n    }\n\n    .datepicker-switch,\n    .prev,\n    .next,\n    tfoot tr th {\n        cursor: pointer;\n        &:hover {\n            background: $gray-200;\n        }\n    }\n\n    .prev,\n    .next {\n        &.disabled {\n            visibility: hidden;\n        }\n    }\n\n    // Basic styling for calendar-week cells\n    .cw {\n        font-size: 10px;\n        width: 12px;\n        padding: 0 2px 0 5px;\n        vertical-align: middle;\n    }\n}\n","/*! nouislider - 14.0.1 - 6/21/2019 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 18px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  left: -17px;\n  top: -6px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -17px;\n  left: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #FAFAFA;\n  border-radius: 4px;\n  border: 1px solid #D3D3D3;\n  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #FFF;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\n}\n.noUi-active {\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n}\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #E8E7E6;\n  left: 14px;\n  top: 6px;\n}\n.noUi-handle:after {\n  left: 17px;\n}\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n\n\n//  Custom styles\n\n.noUi-target {\n    background: $noui-target-bg;\n    border-radius: $noui-target-border-radius;\n    border: 0;\n    box-shadow: $noui-target-box-shadow;\n    margin: 15px 0;\n    cursor: pointer;\n}\n\n.noUi-horizontal {\n    height: $noui-target-thickness;\n}\n\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n    right: -10px;\n}\n\n.noUi-vertical {\n    width: $noui-target-thickness;\n}\n\n.noUi-connect {\n    background: theme-color(\"primary\");\n    box-shadow: none;\n}\n\n.noUi-handle {\n  &:after,&:before{\n    content: none;\n  }\n\n  &:focus{\n    outline: none;\n  }\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n    top: -$noui-target-thickness;\n    width: $noui-handle-width;\n    height: $noui-handle-width;\n    border-radius: 100%;\n    box-shadow: none;\n    cursor: pointer;\n    background-color: $noui-handle-bg;\n    border: $noui-handle-border;\n    transition: box-shadow .15s, transform .15s;\n}\n\n.noUi-horizontal .noUi-handle.noUi-active,\n.noUi-vertical .noUi-handle.noUi-active {\n    box-shadow: 0px 0px 0px 2px rgba($noui-handle-bg, 1);\n}\n\n.input-slider--cyan .noUi-connect {\n    background: $cyan;\n}\n\n\n/* Disabled state */\n\n[disabled] .noUi-connect,\n[disabled].noUi-connect {\n    background: $noui-slider-connect-disabled-bg;\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-origin {\n    cursor: not-allowed;\n}\n\n/* Range slider value labels */\n\n.range-slider-value {\n    font-size: $font-size-xs;\n    font-weight: 500;\n    background-color: rgba($dark, .7);\n    color: color-yiq($dark);\n    border-radius: 10px;\n    padding: .4em .8em .3em .85em;\n}\n\n.range-slider-wrapper .upper-info {\n    font-weight: 400;\n    margin-bottom: 5px;\n}\n\n.input-slider-value-output {\n    background: #333;\n    color: #fff;\n    padding: 4px 8px;\n    position: relative;\n    top: 12px;\n    font-size: 11px;\n    border-radius: 2px;\n}\n\n.input-slider-value-output:after {\n    bottom: 100%;\n    left: 10px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(136, 183, 213, 0);\n    border-bottom-color: #333;\n    border-width: 4px;\n    margin-left: -4px;\n}\n\n.input-slider-value-output.left:after {\n    left: 10px;\n    right: auto;\n}\n\n.input-slider-value-output.right:after {\n    right: 10px;\n    left: auto;\n}\n","//\n// Custom scrollbar\n//\n\n.scrollbar-inner {\n    height: 100%;\n\n    &:not(:hover) .scroll-element {\n        opacity: 0;\n    }\n\n    .scroll-element {\n        transition: opacity 300ms;\n        margin-right: 2px;\n\n        .scroll-bar,\n        .scroll-element_track {\n            transition: background-color 300ms;\n        }\n\n        .scroll-element_track {\n            background-color: transparent;\n        }\n    }\n\n    .scroll-element.scroll-y {\n        width: 3px;\n        right: 0;\n    }\n\n    .scroll-element.scroll-x {\n        height: 3px;\n        bottom: 0;\n    }\n}\n","//\n// Main navbar\n//\n.ct-navbar {\n    background-color: $ct-primary;\n    box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    \n    @include media-breakpoint-down(md) {\n        padding-right: .5rem;\n        padding-left: .5rem;\n\n        .navbar-nav-scroll {\n            max-width: 100%;\n            height: 2.5rem;\n            margin-top: .25rem;\n            overflow: hidden;\n            font-size: .875rem;\n\n            .navbar-nav {\n                padding-bottom: 2rem;\n                overflow-x: auto;\n                white-space: nowrap;\n                -webkit-overflow-scrolling: touch;\n            }\n        }\n    }\n\n    @include media-breakpoint-up(md) {\n        @supports (position: sticky) {\n            position: sticky;\n            top: 0;\n            z-index: 1071; // over everything in bootstrap\n        }\n    }\n\n    .navbar-nav {\n        .nav-link {\n            padding-right: .5rem;\n            padding-left: .5rem;\n            color: $ct-primary-light !important;\n\n            &.active,\n            &:hover {\n                color: #fff !important;\n                background-color: transparent !important;\n            }\n\n            &.active {\n                font-weight: 500;\n            }\n        }\n    }\n\n    .navbar-nav-svg {\n        display: inline-block;\n        width: 1rem;\n        height: 1rem;\n        vertical-align: text-top;\n    }\n\n    .dropdown-menu {\n        font-size: .875rem;\n    }\n\n    .dropdown-item.active {\n        font-weight: 500;\n        color: $gray-900;\n        background-color: transparent;\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23292b2c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");\n        background-repeat: no-repeat;\n        background-position: .4rem .87rem;\n        background-size: .75rem .75rem;\n        padding-left: 25px;\n    }\n}\n\n// Github corner\n.github-corner {\n    position: fixed;\n    right: 0;\n    z-index: 1080;\n\n    &:hover {\n        .octo-arm {\n            animation: octocat-wave 560ms ease-in-out\n        }\n    }\n\n    svg {\n        fill: $white;\n        color: $ct-primary;\n    }\n}\n\n@keyframes octocat-wave {\n    0%,\n    100% {\n        transform: rotate(0)\n    }\n    20%,\n    60% {\n        transform: rotate(-25deg)\n    }\n    40%,\n    80% {\n        transform: rotate(10deg)\n    }\n}\n","// Local docs variables\n$ct-primary:        theme-color(\"primary\") !default;\n$ct-primary-bright: lighten(saturate($ct-primary, 5%), 15%) !default;\n$ct-primary-light:  rgba(255, 255, 255, .9) !default;\n$ct-dark:          \t#2a2730 !default;\n$ct-download:      \t#ffe484 !default;\n$ct-info:          \t#5bc0de !default;\n$ct-warning:       \t#f0ad4e !default;\n$ct-danger:        \t#d9534f !default;\n\n$ct-sidebar-bg:\t#f5f7f9;\n$ct-sidebar-border-color: #e6ecf1;\n\n","// clipboard.js\n//\n// JS-based `Copy` buttons for code snippets.\n\n.ct-clipboard {\n  position: relative;\n  display: none;\n  float: right;\n\n  + .highlight {\n    margin-top: 0;\n  }\n}\n\n.btn-clipboard {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n  display: block;\n  padding: .25rem .5rem;\n  font-size: 75%;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  border-radius: .25rem;\n  color: #fff;\n  background-color: $ct-primary;\n\n  &:hover {\n    color: #fff;\n    background-color: darken($ct-primary, 10%);\n  }\n}\n\n@media (min-width: 768px) {\n  .ct-clipboard {\n    display: block;\n  }\n}\n","// stylelint-disable no-duplicate-selectors, selector-no-qualifying-type\n\n//\n// Grid examples\n//\n\n.ct-example-row {\n  .row {\n    > .col,\n    > [class^=\"col-\"] {\n      span {\n        display: block;\n        padding: .75rem;\n        color: rgb(57, 63, 73);\n        background-color: rgb(255, 255, 255);\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n        font-size: $font-size-sm;\n        border-radius: .25rem;\n        margin: 1rem 0;\n      }\n    }\n  }\n\n  .no-gutters {\n    > .col,\n    > [class^=\"col-\"] {\n      span {\n        border-radius: 0;\n      }\n    }\n  }\n\n  .flex-items-top,\n  .flex-items-middle,\n  .flex-items-bottom {\n    min-height: 6rem;\n    background-color: rgba(255, 0, 0, .1);\n  }\n}\n\n.ct-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, .1);\n\n  & + .row {\n    margin-top: 1rem;\n  }\n}\n\n.ct-highlight {\n  background-color: rgba($ct-primary, .15);\n  border: 1px solid rgba($ct-primary, .15);\n}\n\n// Grid mixins\n.example-container {\n  width: 800px;\n  @include make-container();\n}\n\n.example-row {\n  @include make-row();\n}\n\n.example-content-main {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(8);\n  }\n}\n\n.example-content-secondary {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(4);\n  }\n}\n\n\n//\n// Container illustrations\n//\n\n.ct-example-container {\n  min-width: 16rem;\n  max-width: 25rem;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-container-header {\n  height: 3rem;\n  margin-bottom: .5rem;\n  background-color: lighten($blue, 50%);\n  border-radius: .25rem;\n}\n\n.ct-example-container-sidebar {\n  float: right;\n  width: 4rem;\n  height: 8rem;\n  background-color: lighten($blue, 25%);\n  border-radius: .25rem;\n}\n\n.ct-example-container-body {\n  height: 8rem;\n  margin-right: 4.5rem;\n  background-color: lighten($ct-primary, 25%);\n  border-radius: .25rem;\n}\n\n.ct-example-container-fluid {\n  max-width: none;\n}\n\n\n//\n// Docs examples\n//\n\n.ct-example {\n  position: relative;\n  margin: 1rem -calc($grid-gutter-width / 2) 0;\n  @include clearfix();\n\n  @include media-breakpoint-up(sm) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  + .highlight,\n  + .clipboard + .highlight {\n    margin-top: 0;\n  }\n\n  + p {\n    margin-top: 2rem;\n  }\n\n  .pos-f-t {\n    position: relative;\n    margin: -1rem;\n\n    @include media-breakpoint-up(sm) {\n      margin: -1.5rem;\n    }\n  }\n\n  .custom-file-input:lang(es) ~ .custom-file-label::after {\n    content: \"Elegir\";\n  }\n\n  > .form-control {\n    + .form-control {\n      margin-top: .5rem;\n    }\n  }\n\n  > .nav + .nav,\n  > .alert + .alert,\n  > .navbar + .navbar,\n  > .progress + .progress,\n  > .progress + .btn,\n  .badge,\n  .btn {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n  }\n\n  .btn-group {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n    .btn {\n      margin: 0;\n    }\n  }\n\n  .alert {\n    margin: 0;\n\n    + .alert {\n      margin-top: 1.25rem;\n    }\n  }\n\n  .badge {\n    margin-right: .5rem;\n  }\n\n  > .dropdown-menu:first-child {\n    position: static;\n    display: block;\n  }\n\n  > .form-group:last-child {\n    margin-bottom: 0;\n  }\n\n  > .close {\n    float: none;\n  }\n}\n\n// Typography\n.ct-example-type {\n  .table {\n    .type-info {\n      color: #999;\n      vertical-align: middle;\n    }\n    td {\n      padding: 1rem 0;\n      border-color: #eee;\n    }\n    tr:first-child td {\n      border-top: 0;\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n// Contextual background colors\n.ct-example-bg-classes p {\n  padding: 1rem;\n}\n\n// Images\n.ct-example > img {\n  + img {\n    margin-left: .5rem;\n  }\n}\n\n// Buttons\n.ct-example {\n  > .btn-group {\n    margin-top: .25rem;\n    margin-bottom: .25rem;\n  }\n  > .btn-toolbar + .btn-toolbar {\n    margin-top: .5rem;\n  }\n}\n\n// Forms\n.ct-example-control-sizing select,\n.ct-example-control-sizing input[type=\"text\"] + input[type=\"text\"] {\n  margin-top: .5rem;\n}\n.ct-example-form .input-group {\n  margin-bottom: .5rem;\n}\n.ct-example > textarea.form-control {\n  resize: vertical;\n}\n\n// List groups\n.ct-example > .list-group {\n  max-width: 400px;\n}\n\n// Navbars\n.ct-example {\n  .fixed-top,\n  .sticky-top {\n    position: static;\n    margin: -1rem -1rem 1rem;\n  }\n  .fixed-bottom {\n    position: static;\n    margin: 1rem -1rem -1rem;\n  }\n\n  @include media-breakpoint-up(sm) {\n    .fixed-top,\n    .sticky-top {\n      margin: -1.5rem -1.5rem 1rem;\n    }\n    .fixed-bottom {\n      margin: 1rem -1.5rem -1.5rem;\n    }\n  }\n}\n\n// Pagination\n.ct-example .pagination {\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n}\n\n// Example modals\n.modal {\n  z-index: 1072;\n\n  .tooltip,\n  .popover {\n    z-index: 1073;\n  }\n}\n\n.modal-backdrop {\n  z-index: 1071;\n}\n\n.ct-example-modal {\n  background-color: #fafafa;\n\n  .modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n  }\n\n  .modal-dialog {\n    left: auto;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n\n// Example tabbable tabs\n.ct-example-tabs .nav-tabs {\n  margin-bottom: 1rem;\n}\n\n// Popovers\n.ct-example-popover-static {\n  padding-bottom: 1.5rem;\n  background-color: #f9f9f9;\n\n  .popover {\n    position: relative;\n    display: block;\n    float: left;\n    width: 260px;\n    margin: 1.25rem;\n  }\n}\n\n// Tooltips\n.tooltip-demo a {\n  white-space: nowrap;\n}\n\n.ct-example-tooltip-static .tooltip {\n  position: relative;\n  display: inline-block;\n  margin: 10px 20px;\n  opacity: 1;\n}\n\n// Scrollspy demo on fixed height div\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: .5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 350px;\n  overflow: auto;\n}\n\n.ct-example-border-utils {\n  [class^=\"border\"] {\n    display: inline-block;\n    width: 5rem;\n    height: 5rem;\n    margin: .25rem;\n    background-color: #f5f5f5;\n  }\n}\n\n.ct-example-border-utils-0 {\n  [class^=\"border\"] {\n    border: 1px solid $border-color;\n  }\n}\n\n//\n// Code snippets\n//\n\n.highlight {\n  padding: 0;\n  margin-top: 1rem;\n  //margin-bottom: 3rem;\n  //background-color: $gray-100;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  @include media-breakpoint-up(sm) {\n    padding: 0;\n  }\n}\n\n.ct-content .highlight {\n  margin-right: -calc($grid-gutter-width / 2);\n  margin-left: -calc($grid-gutter-width / 2);\n\n  @include media-breakpoint-up(sm) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n//\n// Component-Code tabs\n//\n\n.ct-example {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid $gray-200;\n\n  .tab-content {\n    .tab-example-result {\n        background-color: #f5f7f9;\n        border: 1px solid #e6ecf1;\n        padding: 1.25rem;\n        border-radius: .25rem;\n    }\n  }\n\n  .nav-tabs-code {\n    margin-bottom: .375rem;\n\n    .nav-link {\n      font-size: .875rem;\n\n      &:active,\n      &.active {\n        color: $ct-primary;\n      }\n    }\n  }\n}\n\n// Icon examples\n.icon-examples {\n  margin-top: 1rem;\n}\n.btn-icon-clipboard {\n  margin: 0px;\n  padding: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: rgb(57, 63, 73);\n  background-color: rgb(248, 249, 250);\n  border-radius: 4px;\n  border: 0px none;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: .5rem 0;\n\n  &:hover {\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n  }\n\n  > div {\n    align-items: center;\n    display: flex;\n  }\n\n  i {\n    box-sizing: content-box;\n    color: rgb(57, 63, 73);\n    vertical-align: middle;\n    font-size: 1.5rem;\n  }\n\n  span {\n    display: inline-block;\n    font-size: .875rem;\n    line-height: 1.5;\n    color: rgb(57, 63, 73);\n    margin-left: 16px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n  }\n}\n","code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    font-family: Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace;\n    font-size: 14px;\n    line-height: 1.375;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n    background: #f5f7ff;\n    color: #5e6687;\n    border-radius: .25rem;\n}\n\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n    text-shadow: none;\n    background: #dfe2f1;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n    text-shadow: none;\n    background: #dfe2f1;\n}\n\n\n/* Code blocks */\n\npre[class*=\"language-\"] {\n    padding: 1.25rem;\n    margin: 0;\n    overflow: auto;\n}\n\n\n/* Inline code */\n\n:not(pre)>code[class*=\"language-\"] {\n    padding: .1em;\n    border-radius: .3em;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n    color: #898ea4;\n}\n\n.token.punctuation {\n    color: #5e6687;\n}\n\n.token.namespace {\n    opacity: .7;\n}\n\n.token.operator,\n.token.boolean,\n.token.number {\n    color: #c76b29;\n}\n\n.token.property {\n    color: #c08b30;\n}\n\n.token.tag {\n    color: #3d8fd1;\n}\n\n.token.string {\n    color: #22a2c9;\n}\n\n.token.selector {\n    color: #6679cc;\n}\n\n.token.attr-name {\n    color: #c76b29;\n}\n\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n    color: #22a2c9;\n}\n\n.token.attr-value,\n.token.keyword,\n.token.control,\n.token.directive,\n.token.unit {\n    color: #ac9739;\n}\n\n.token.statement,\n.token.regex,\n.token.atrule {\n    color: #22a2c9;\n}\n\n.token.placeholder,\n.token.variable {\n    color: #3d8fd1;\n}\n\n.token.deleted {\n    text-decoration: line-through;\n}\n\n.token.inserted {\n    border-bottom: 1px dotted #202746;\n    text-decoration: none;\n}\n\n.token.italic {\n    font-style: italic;\n}\n\n.token.important,\n.token.bold {\n    font-weight: bold;\n}\n\n.token.important {\n    color: #c94922;\n}\n\n.token.entity {\n    cursor: help;\n}\n\npre>code.highlight {\n    outline: 0.4em solid #c94922;\n    outline-offset: .4em;\n}\n\n\n/* overrides color-values for the Line Numbers plugin\n * http://prismjs.com/plugins/line-numbers/\n */\n\n.line-numbers .line-numbers-rows {\n    border-right-color: #dfe2f1;\n}\n\n.line-numbers-rows>span:before {\n    color: #979db4;\n}\n\n\n/* overrides color-values for the Line Highlight plugin\n * http://prismjs.com/plugins/line-highlight/\n */\n\n.line-highlight {\n    background: rgba(107, 115, 148, 0.2);\n    background: -webkit-linear-gradient(left, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n    background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n}",".docs {\n    background: #FFF;\n\n    h6 {\n        font-size: 1rem;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.ct-content {\n    order: 1;\n\n    >h2[id],\n    >h3[id],\n    >h4[id] {\n        pointer-events: none;\n\n        >div,\n        >a {\n            pointer-events: auto;\n        }\n\n        &::before {\n            display: block;\n            height: 6rem;\n            margin-top: -6rem;\n            visibility: hidden;\n            content: \"\";\n        }\n    }\n\n    >table {\n        width: 100%;\n        max-width: 100%;\n        margin-bottom: 1rem;\n\n        @include media-breakpoint-down(md) {\n            display: block;\n            overflow-x: auto;\n            -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\n            &.table-bordered {\n                border: 0;\n            }\n        } // Cells\n        >thead,\n        >tbody,\n        >tfoot {\n            >tr {\n                >th,\n                >td {\n                    padding: $table-cell-padding;\n                    vertical-align: top;\n                    border: 1px solid $table-border-color;\n\n                    >p:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        } // Prevent breaking of code (e.g., Grunt tasks list)\n        td:first-child>code {\n            white-space: nowrap;\n        }\n    }\n}\n\n//\n// Docs sections\n//\n.ct-content {\n    >h2:not(:first-child) {\n        margin-top: 3rem;\n        font-size: 1.5rem;\n        font-weight: $font-weight-bold;\n    }\n\n    >h3 {\n        margin-top: 2.5rem;\n        font-size: 1.25rem;\n        font-weight: $font-weight-bold;\n    }\n\n    >ul li,\n    >ol li {\n        margin-bottom: .25rem;\n    }\n\n    @include media-breakpoint-up(lg) {\n        >ul,\n        >ol,\n        >p {\n            max-width: 80%;\n        }\n    }\n}\n\n.ct-page-title {\n    padding-left: 1.25rem;\n    border-left: 2px solid $ct-primary;\n    margin-bottom: 1.5rem;\n}\n\n.ct-title {\n    margin-top: 1rem;\n    margin-bottom: .5rem;\n    font-weight: 300;\n\n    @include media-breakpoint-up(sm) {\n        font-size: 1.5rem;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.ct-lead {\n    color: rgb(59, 69, 78);\n    font-weight: 500;\n\n    @include media-breakpoint-up(sm) {\n        max-width: 80%;\n        margin-bottom: 1rem;\n        font-size: .875rem;\n    }\n}\n\n.ct-text-purple {\n    color: $ct-primary;\n}\n\n.ct-text-purple-bright {\n    color: $ct-primary-bright;\n}\n\n// Docs code example tabs\n.ct-tabs-example {\n    .nav-link i {\n        margin-right: 5px;\n    }\n}\n\n// Color swatches\n.color-swatch {\n    margin: 1rem 0;\n    border-radius: .25rem;\n    background-color: #F4F5F7;\n}\n\n.color-swatch:after {\n    content: \" \";\n    display: table;\n    clear: both;\n}\n\n.color-swatch-header {\n    position: relative;\n    height: 0;\n    padding-bottom: 50%;\n    border-radius: .25rem .25rem 0 0;\n    border: 1px solid transparent;\n}\n\n.color-swatch-header.is-light {\n    border-color: #C1C7D0;\n}\n\n.color-swatch-header .pass-fail {\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n}\n\n.color-swatch-header .pass-fail-item-wrap {\n    position: relative;\n    float: left;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.color-swatch-header .pass-fail-item-group {\n    display: inline-block;\n    padding: 0 5px;\n}\n\n.color-swatch-header .pass-fail-item {\n    float: left;\n    display: inline-block;\n    text-align: center;\n    padding: 2px;\n}\n\n.color-swatch-header .pass-fail-item.white .example {\n    color: #fff;\n}\n\n.color-swatch-header .pass-fail-item.small .example {\n    font-size: 10px;\n}\n\n.color-swatch-header .pass-fail-item .lozenge {\n    font-size: 11px;\n    text-transform: uppercase;\n    font-weight: 600;\n    background: #000;\n    color: #fff;\n    padding: 2px 4px;\n    line-height: 10px;\n    border-radius: 4px;\n    letter-spacing: 0.05em;\n}\n\n.color-swatch-body {\n    position: relative;\n    left: 50%;\n    float: left;\n    padding: 10px 0;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.color-swatch-body .prop-item-wrap {\n    float: left;\n    padding: 0 15px;\n    min-width: 65px;\n}\n\n.color-swatch-body .prop-item {\n    padding: 15px 0;\n}\n\n.color-swatch-body .prop-item .label {\n    font-size: 11px;\n    color: #62748C;\n    text-transform: uppercase;\n    line-height: 16px;\n}\n\n.color-swatch-body .prop-item .value {\n    font-size: 14px;\n}\n\n.table-colors {\n    font-weight: 600;\n    font-size: 16px;\n    width: 100%;\n}\n\n.table-colors td,\n.table-colors:first-child td,\n.table-colors td:first-child,\n.table-colors:first-child td:first-child,\n.table-colors td:last-child,\n.table-colors:first-child td:last-child {\n    background: $ct-primary-light;\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    padding: 10px;\n}\n\n.table-colors tr:last-child td,\n.table-colors:first-child tr:last-child td {\n    border-bottom: none;\n}\n\n.table-colors td:nth-child(1),\n.table-colors:first-child td:nth-child(1) {\n    line-height: 40px;\n}\n\n.table-colors .swatch,\n.table-colors:first-child .swatch {\n    float: left;\n    height: 40px;\n    width: 40px;\n    margin-right: 20px;\n    display: inline-block;\n    border-radius: 4px;\n    border: 1px solid transparent;\n}\n\n.table-colors .swatch.is-light,\n.table-colors:first-child .swatch.is-light {\n    border-color: #C1C7D0;\n}\n\n.table-colors .lozenge,\n.table-colors:first-child .lozenge {\n    float: left;\n    margin: 5px 10px 0 0;\n    font-size: 10px;\n    display: inline-block;\n    text-transform: uppercase;\n    font-weight: 600;\n    background: #97A0AF;\n    color: #042A53;\n    padding: 2px 4px;\n    line-height: 10px;\n    border-radius: 4px;\n    letter-spacing: 0.05em;\n}\n","// stylelint-disable declaration-no-important\n//\n// Right side table of contents\n//\n.ct-toc {\n    @supports (position: sticky) {\n        position: sticky;\n        top: 4rem;\n        height: calc(100vh - 4rem);\n        overflow-y: auto;\n    }\n    order: 2;\n    padding-top: 2rem;\n    padding-bottom: 1.5rem;\n    font-size: .875rem;\n}\n\n.section-nav {\n    padding-left: 0;\n    border-left: 1px solid #eee;\n\n    ul {\n        padding-left: 1rem;\n\n        ul {\n            display: none;\n        }\n    }\n}\n\n.toc-entry {\n    display: block;\n    font-size: 1rem;\n\n    a {\n        display: block;\n        padding: .125rem 1.5rem;\n        color: #99979c;\n        font-size: 90%;\n\n        &:hover {\n            color: $blue;\n            text-decoration: none;\n        }\n    }\n}\n\n//\n// Left side navigation\n//\n.ct-sidebar {\n    order: 0; // background-color: #f5f2f9;\n    border-bottom: 1px solid $ct-sidebar-border-color;\n    background-color: $ct-sidebar-bg;\n\n    @include media-breakpoint-up(md) {\n        @supports (position: sticky) {\n            position: sticky;\n            top: 4rem;\n            z-index: 1000;\n            height: calc(100vh - 4rem);\n        }\n        border-right: 1px solid $ct-sidebar-border-color;\n    }\n\n    @include media-breakpoint-up(xl) {\n        flex: 0 1 320px;\n    }\n}\n\n.ct-links {\n    padding-top: 2rem;\n    padding-bottom: 1rem;\n    margin-right: -15px;\n    margin-left: -15px;\n\n    @include media-breakpoint-up(md) {\n        @supports (position: sticky) {\n            max-height: calc(100vh - 5rem);\n            overflow-y: auto;\n        }\n    } // Override collapse behaviors\n    @include media-breakpoint-up(md) {\n        display: block !important;\n    }\n}\n\n.ct-search {\n    position: relative; // To contain the Algolia search\n    padding: 1rem 15px;\n    margin-right: -15px;\n    margin-left: -15px;\n    border-bottom: 1px solid rgba(0, 0, 0, .05);\n\n    .form-control:focus {\n        border-color: $ct-primary-bright;\n        box-shadow: 0 0 0 3px rgba($ct-primary-bright, .25);\n    }\n}\n\n.ct-search-docs-toggle {\n    line-height: 1;\n    color: $gray-900;\n}\n\n.ct-sidenav {\n    display: none;\n}\n\n.ct-toc-link {\n    display: block;\n    padding: .25rem 1.5rem;\n    font-weight: 600;\n    font-size: .875rem;\n    color: #0d2b3e;\n\n    &:hover {\n        color: rgba(0, 0, 0, .85);\n        text-decoration: none;\n    }\n}\n\n.ct-toc-item {\n    &.active {\n        margin-bottom: 1rem;\n\n        &:not(:first-child) {\n            margin-top: 1rem;\n        }\n\n        >.ct-toc-link {\n            color: rgba(0, 0, 0, .85);\n\n            &:hover {\n                background-color: transparent;\n            }\n        }\n\n        >.ct-sidenav {\n            display: block;\n        }\n    }\n}\n\n// All levels of nav\n.ct-sidebar .nav>li>a {\n    display: block;\n    padding: .25rem 1.5rem;\n    font-size: 84%;\n    color: #4c555a;\n}\n\n.ct-sidebar .nav>li>a:hover {\n    color: rgba(0, 0, 0, .85);\n    text-decoration: none;\n    background-color: transparent;\n}\n\n.ct-sidebar .nav>.active>a {\n    font-weight: 500;\n    color: #0099e5;\n    background-color: transparent;\n    padding-left: 2rem;\n    position: relative;\n\n    &:before {\n        content: '';\n        position: absolute;\n        height: 16px;\n        width: 2px;\n        background-color: #0099e5;\n        top: 50%;\n        left: 1.5rem;\n        transform: translateY(-50%);\n    }\n}\n\n.ct-sidebar .nav>.active:hover>a {\n    color: #0099e5\n}\n\n\n.scrollbar-inner {\n    height: 100%;\n\n    &:not(:hover) .scroll-element {\n        opacity: 0;\n    }\n\n    .scroll-element {\n        transition: opacity 300ms;\n        margin-right: 2px;\n\n        .scroll-bar,\n        .scroll-element_track {\n            transition: background-color 300ms;\n        }\n\n        .scroll-element_track {\n            background-color: transparent;\n        }\n    }\n\n    .scroll-element.scroll-y {\n        width: 3px;\n        right: 0;\n    }\n\n    .scroll-element.scroll-x {\n        height: 3px;\n        bottom: 0;\n    }\n}\n","//\n// Footer\n//\n.ct-footer {\n    font-size: 85%;\n    text-align: center;\n    background-color: #f7f7f7;\n\n    a {\n        font-weight: 500;\n        color: $gray-700;\n\n        &:hover,\n        &:focus {\n            color: $link-color;\n        }\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n    @include media-breakpoint-up(sm) {\n        text-align: left;\n    }\n}\n\n.ct-footer-links {\n    padding-left: 0;\n    margin-bottom: 1rem;\n\n    li {\n        display: inline-block;\n\n        +li {\n            margin-left: 1rem;\n        }\n    }\n}","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  padding: 20px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: .375rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n\n  &:before {\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: -5px;\n    left: 10px;\n    right: auto;\n    color: #ffffff;\n    border-bottom: 0.4em solid;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n  }\n  &:after {\n    border-bottom: 0.4em solid #ffffff;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: -5px;\n    left: 10px;\n  }\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  visibility: hidden;\n  position: relative;\n  &:before {\n    visibility: visible;\n    width: 100%;\n    height: 100%;\n    border-radius: 3px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font: normal normal normal 1em/1 \"Nucleo\";\n    font-size: 18px;\n    content: \"\\EA5E\";\n  }\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  font-size: .875rem;\n  width: 36px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover,\n  &.start-date,\n  &.end-date,\n  &.middle-date,\n  &.start-date:hover,\n  &.end-date:hover,\n  &.middle-date:hover {\n    background-color: $info !important;\n    color: $white !important;\n  }\n  &.start-date{\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  &.middle-date{\n    border-radius: 0;\n  }\n  &.end-date{\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      font-size: 12px;\n      font-weight: inherit;\n      padding-bottom: 5px;\n      padding-top: 10px;\n      font-weight: 300;\n      font-size: .875rem;\n      width: 20px;\n      height: 20px;\n    }\n    .rdtDay {\n      color: $gray-700;\n      font-size: .875rem;\n      &.rdtOld,\n      &.rdtNew {\n        color: $gray-500;\n        font-weight: 300;\n      }\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover,\n.rdtPicker .rdtTimeToggle:hover:before {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker tr .dow {\n  width: 14.2857%;\n  border-bottom: none;\n  font-size: .875rem;\n  width: 36px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;font-weight: 500;\n  border-radius: .375rem;\n}\n.rdtPicker th.rdtSwitch {\n  font-weight: 500;\n  border-radius: .375rem;\n  font-size: .875rem;\n  width: 145px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: .875rem;\n  width: 36px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;\n  border-radius: .375rem;\n  cursor: pointer;\n}\n\n.rdtPicker {\n  .dow,\n  th.rdtSwitch,\n  th.rdtNext,\n  th.rdtPrev,\n  .rdtTimeToggle {\n    color: $gray-700;\n  }\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: inherit;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $info;\n      border-radius: 50%;\n      border: 1px solid $info;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $gray-500;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive,\n    &.start-date,\n    &.end-date,\n    &.middle-date {\n      background-color: $info !important;\n      color: $white;\n    }\n  }\n}\n.input-group .input-group-prepend + .rdt .form-control{\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group .input-group-prepend + .rdt .form-control{\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rdt:not(:last-child) .form-control{\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-group .rdt {\n  width: 1%;\n  margin-bottom: 0;\n  flex: 1 1 auto;\n}\n",".btn{\n  .btn-inner--icon{\n    margin-right: 4px;\n  }\n}\n.btn + .btn {\n  margin-left: 4px;\n}\n","button:focus, :focus {\n  outline: none;\n}\n","@keyframes show-navbar-dropdown {\n  0% {\n    opacity: 0;\n    transition: visibility 0.25s, opacity 0.25s;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n",".navbar .collapsing .navbar-toggler{\n  pointer-events: none;\n}\n.navbar .nav-item .nav-link-icon.nav-link i{\n  margin-right: 4px;\n}\n",".table {\n  .avatar-group .avatar\n  {\n    margin-right: 4px;\n  }\n  .badge i{\n    margin-right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
